/* ##########################################################################
   DIE SCHNITTSTELLE: `mo:konfig` mit Gedaechtnis

   Der Konfigurator meldet jede Aenderung als CustomEvent `mo:konfig`. Vorschau,
   Aufmass-Skizze und Schrittleiste haengen sich daran.

   🔴 DAS PROBLEM, DAS DIESER BLOCK LOEST — zweimal draufgetreten:
   Ein reines `addEventListener` verpasst das ERSTE Ereignis, wenn der eigene
   Block hinter dem Konfigurator steht. Am 22.08.2026 traf es erst die Vorschau
   (blieb beim Laden aus, sprang erst beim ersten Klick an), dann die
   Schrittleiste (entstand ueberhaupt nicht).

   Die Notloesung war beide Male, den Block nach oben zu schieben. Das haelt
   nicht: Jeder neue Block muesste die Reihenfolge kennen, und eine Datei, in
   der die Reihenfolge Bedeutung traegt, geht beim naechsten Umbau kaputt.

   ⭐ STATTDESSEN: Der letzte Stand bleibt liegen. `moKonfig.horchen(fn)` ruft
   die Funktion sofort nach, wenn schon etwas gemeldet wurde. Damit ist die
   Reihenfolge in dieser Datei gleichgueltig.
   ########################################################################## */
/* ##########################################################################
   VOLLBILD - eine Anzeige fuer alles

   Gebraucht an zwei Stellen: der Lupenknopf auf den Optionskacheln und der
   Klick auf die Aufmass-Skizze. Beide zeigen dasselbe - ein Bild, gross,
   ueber der Seite - also gibt es auch nur eine Umsetzung.

   ⚠️ WARUM NICHT DIE SHOPWEITE BILDLUPE AUS custom.js:
   Die ist per `data-mo-lupe-aus` an unseren Rastern abgeschaltet, und das aus
   gutem Grund - sie greift ab 90x90 px Anzeigegroesse und wuerde bei einem
   Klick auf die Kachel gleichzeitig auswaehlen UND das Vollbild oeffnen.
   Hier oeffnet nur der Lupenknopf, die Kachel selbst waehlt weiterhin aus.

   ⚠️ Die Adresse wird auf 1600 px hochgesetzt, aber `&width=` skaliert
   NICHT hoch: Ist das Original kleiner, kommt das Original. Kein Schaden, nur
   kein Gewinn ([[image-url-skaliert-nicht-hoch]]).
   ########################################################################## */
window.moVollbild = window.moVollbild || (function () {
  'use strict';
  var schicht = null, bild = null, text = null, bildRahmen = null, masse = null;

  function bauen() {
    if (schicht) return;
    schicht = document.createElement('div');
    schicht.className = 'mo-vollbild';
    /* 🔴 27.08.2026: DAS VERSTECKEN DARF NICHT AM CSS HAENGEN.

       Bis hierher stand das Verstecken allein in `mo-konfigurator.css`:
           .mo-vollbild{ display:none }
           .mo-vollbild.mo-vollbild-an{ display:flex }
       Fehlt diese Datei fuer einen Moment — sie laedt als normales
       <link rel="stylesheet">, kann also verzoegert oder im Theme-Editor
       kurz weg sein —, faellt `display` auf `block` zurueck. Zusammen mit
       `position:fixed; inset:0` liegt das Vollbild dann ueber der ganzen
       Seite, und das Mass-SVG darin nimmt mit `width:100%` deren volle
       Breite an.

       Nachgestellt im Arbeitstheme (alle Stylesheets abgeschaltet): das
       Vollbild misst 1099 x 2646 px, das SVG darin 1099 px — die Bemassung
       laeuft quer ueber den Fliesstext. Genau das hatte Stefan im Bild.

       Inline gesetzt sticht es jede Stylesheet-Regel und ueberlebt deren
       Fehlen. `zeigen()` und `schliessen()` fuehren den Wert mit. */
    schicht.style.display = 'none';
    schicht.setAttribute('role', 'dialog');
    schicht.setAttribute('aria-label', 'Bild vergroessert');

    var kasten = document.createElement('div');
    kasten.className = 'mo-vollbild-kasten';

    bild = document.createElement('img');
    bild.alt = '';
    text = document.createElement('div');
    text.className = 'mo-vollbild-text';

    var zu = document.createElement('button');
    zu.type = 'button';
    zu.className = 'mo-vollbild-zu';
    zu.setAttribute('aria-label', 'Schliessen');
    zu.textContent = '\u00d7';
    zu.addEventListener('click', schliessen);

    /* Das Bild bekommt einen eigenen Rahmen: Er nimmt genau dessen Groesse
       an, und das Mass-SVG kann sich mit `width:100%` darueberlegen. Am
       Kasten selbst ginge das nicht — dort steht auch die Beschriftung. */
    bildRahmen = document.createElement('div');
    bildRahmen.className = 'mo-vollbild-bild';
    bildRahmen.appendChild(bild);

    kasten.appendChild(zu);
    kasten.appendChild(bildRahmen);
    kasten.appendChild(text);
    schicht.appendChild(kasten);

    // Klick auf den Grund schliesst, Klick ins Bild nicht.
    schicht.addEventListener('click', function (ev) {
      if (ev.target === schicht) schliessen();
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') schliessen();
    });
    document.body.appendChild(schicht);
  }

  function gross(url) {
    if (!url) return url;
    if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(url)) return url;
    return url.replace(/([?&]width=)\d+/, '$1' + 1600);
  }

  function schliessen() {
    if (schicht) {
      schicht.classList.remove('mo-vollbild-an');
      schicht.style.display = 'none';
    }
    /* ⭐ Den Klon wegraeumen, nicht nur verstecken. Was nicht im DOM liegt,
       kann auch bei fehlendem CSS nicht falsch dargestellt werden — und der
       naechste `zeigen()`-Aufruf baut ihn ohnehin neu. */
    if (masse) { masse.remove(); masse = null; }
    document.documentElement.style.overflow = '';
  }

  return {
    /* `svgQuelle` ist freiwillig: Wer nur ein Bild zeigen will, ruft weiter
       mit zwei Argumenten auf (die Farbkacheln tun das). */
    zeigen: function (url, beschriftung, svgQuelle) {
      if (!url) return;
      bauen();
      bild.src = gross(url);
      bild.alt = beschriftung || '';

      /* 🔴 Das Mass-SVG mitnehmen — sonst stehen im Vollbild leere Felder.
         KLONEN, nicht verschieben: sonst fehlt es in der kleinen Skizze. */
      if (masse) { masse.remove(); masse = null; }
      if (svgQuelle && svgQuelle.cloneNode) {
        masse = svgQuelle.cloneNode(true);
        masse.setAttribute('class', 'mo-masslinien mo-vollbild-masse');
        bildRahmen.appendChild(masse);
      }
      text.textContent = beschriftung || '';
      // Inline mitfuehren — die Klasse allein reicht nicht mehr, seit
      // `display:none` inline steht (das sticht die Stylesheet-Regel).
      schicht.style.display = 'flex';
      schicht.classList.add('mo-vollbild-an');
      // Die Seite dahinter still halten - sonst scrollt sie unter dem
      // Vollbild weiter, und beim Schliessen steht man woanders.
      document.documentElement.style.overflow = 'hidden';
    },
    schliessen: schliessen
  };
})();

window.moKonfig = window.moKonfig || (function () {
  'use strict';
  var letzter = null;

  return {
    // Vom Konfigurator-Kern aufgerufen: meldet und merkt sich den Stand.
    melden: function (detail) {
      letzter = detail;
      document.dispatchEvent(new CustomEvent('mo:konfig', { detail: detail }));
    },
    // Von allen Zusatzbloecken aufgerufen statt addEventListener.
    horchen: function (fn) {
      document.addEventListener('mo:konfig', fn);
      // ⚠️ Nachreichen in einem eigenen Durchgang, nicht sofort: Der aufrufende
      // Block ist mitten in seiner eigenen Einrichtung und haette sonst seine
      // eigenen Variablen noch nicht gesetzt.
      if (letzter) {
        var stand = letzter;
        setTimeout(function () { fn({ detail: stand }); }, 0);
      }
    }
  };
})();

/* 🔴 REIHENFOLGE IST WESENTLICH.
   Der Vorschau-Block MUSS vor dem Konfigurator-IIFE stehen. Stand er dahinter,
   war sein `addEventListener('mo:konfig')` erst registriert, NACHDEM der
   Konfigurator sein erstes Ereignis schon gefeuert hatte — die Vorschau blieb
   beim Laden aus und sprang erst beim ersten Klick an. Am 22.08.2026 gemessen.
*/
/* ##########################################################################
   DIE BEFESTIGUNGSART - EINE STELLE FUER FUENF FRAGEN

   🔴 31.08.2026: `mo-config-stangen.json` hat seit dem 26.08. keine Option
   `Befestigung` mehr (auf Stefans Ansage entfernt). Damit war
   `zustand['Befestigung']` bei Nova 30/31 immer `undefined` und der Rueckfall
   auf "Auf der Außenwand" der DAUERZUSTAND - nicht der Notnagel, als der er
   gedacht war.

   Gemessen: Nova 31 ist ein LAIBUNGS-Gitter (an den Produktbildern selbst
   angesehen: FG31_v2.png zeigt die Laschen innen an den Wangen, FG30_v2.png
   auf dem Putz daneben), bekam aber die Aussenwand-Zeichnung. Und weil
   `istLaibung()` denselben Schalter liest, stand auf beiden Seiten
   "Fensterbreite + 140 mm" - in der Laibung wird aber ABGEZOGEN.

   ⭐ DIE VORGABE KOMMT AUS DEM METAFELD `custom.befestigungsart`, das
   `main-product.liquid` als `data-befestigungsart` ausliefert. Reihenfolge:

       1. Auswahl im Konfigurator  (wo es sie gibt - Fenstergitter, Balkone)
       2. Vorgabe aus dem Metafeld (wo die Auswahl entfernt wurde - Stangen)
       3. "Auf der Außenwand"      (echter Rueckfall)

   ⚠️ WARUM HIER OBEN UND NICHT ZWEIMAL LOKAL: Die fuenf Fundstellen liegen in
   ZWEI verschiedenen IIFEs (Motor, Aufmass-Vorschau). Zwei Kopien liefen
   frueher oder spaeter auseinander - genau der Fehler, der am 31.08. schon
   einmal aufgetreten ist, als `empfehlung()` filterte und `infoZeigen()`
   nicht. Deshalb eine Nabe, im Muster von `moKonfig` und `moVollbild`.
   ########################################################################## */
window.moBefestigungsArt = window.moBefestigungsArt || function (zustand) {
  'use strict';
  var GUELTIG = ['In der Laibung', 'Auf der Außenwand'];

  // 1. Was der Kunde gewaehlt hat, sticht immer.
  if (zustand && GUELTIG.indexOf(zustand['Befestigung']) > -1) {
    return zustand['Befestigung'];
  }
  // 2. Vorgabe des Produkts.
  var t = document.querySelector('[data-mo-metafelder]');
  var vorgabe = t && t.dataset.befestigungsart;
  if (GUELTIG.indexOf(vorgabe) > -1) return vorgabe;

  // 3. Rueckfall - jetzt wieder das, was er sein soll.
  return 'Auf der Außenwand';
};

/* ##########################################################################
   LIVE-VORSCHAU — angehaengt, nicht eingebunden.

   Der Konfigurator laedt sich selbst nach (main-product.liquid, data-js-url)
   und kennt genau EINE JS-Datei. Eine zweite einzubinden hiesse, das Liquid
   anzufassen — dafuer gibt es keinen Grund, und es spart eine Anfrage.
   Der Block ist ein eigenstaendiges IIFE und jederzeit herausloesbar.

   ⭐ WARUM KEIN CANVAS:
   LPO zeichnet bei jeder Aenderung alle Ebenen ueber Fabric.js (89 KB) neu und
   fordert dabei die komplette Bildliste erneut an — am 22.08.2026 gemessen:
   ueber 70 Anfragen je Durchgang. Die Masse standen erst nach ~15 s im Bild.

   Die Farbebenen sind DECKENDE Vollszenen (Fenster samt Gitter, 1200x1200
   bzw. 1500x1500). Es genuegt also, das richtige Bild zu zeigen — kein
   Uebereinanderzeichnen. Ein src-Tausch kostet keine Rechenzeit.

   ⭐ WOHER DIE BILDER KOMMEN:
   Aus den Shopify-Produktmedien, nach demselben Namensschema wie LPOs
   imgTemplate (aus dessen Auslieferung ausgelesen):
       Aussenwand_{Oberflaeche}   ->  Aussenwand_RAL_7016
       Laibung_{Oberflaeche}      ->  Laibung_Feuerverzinkt

   🔴 Shopify haengt bei Namensgleichheit eine UUID an
   (Aussenwand_RAL_7016_d5ddf566-1219-....jpg). Deshalb wird mit
   "beginnt mit" verglichen, nie auf Gleichheit.

   Am 22.08.2026 an FG 01 und FG 09 geprueft: je 11 Oberflaechen x
   2 Befestigungsarten = 22 fertige Ebenenbilder. Nichts hochzuladen.
   ########################################################################## */
(function () {
  'use strict';

  var WURZEL = document.querySelector('[data-mo-konfigurator]');
  if (!WURZEL) return;

  // Genau die Schreibweisen aus mo-config-fenstergitter.json.
  var OPT_BEFESTIGUNG = 'Befestigung';
  var OPT_OBERFLAECHE = 'Oberfläche';

  var VORSILBE = {
    'Auf der Außenwand': 'Aussenwand_',
    'In der Laibung': 'Laibung_'
  };

  var medien = null;
  var zielBild = null;
  var originalSrc = null;
  var letzteUrl = '';
  var vorgeladen = false;
  var letzterZustand = null;
  var startZustand = null;

  // Position 1 der Galerie — dieselbe Stelle, an der LPO seine Vorschau ablegte
  // (previewSelector .product__media-wrapper, previewPosition afterbegin).
  function bildSuchen() {
    var kandidaten = [
      '.product__media-wrapper .product__media-item:first-child img',
      '.product__media-wrapper .product__media img',
      '.product__media-list .product__media-item:first-child img'
    ];
    for (var i = 0; i < kandidaten.length; i++) {
      var el = document.querySelector(kandidaten[i]);
      if (el) return el;
    }
    return null;
  }

  // Ueber den oeffentlichen .js-Endpunkt statt ueber Liquid — so bleibt die
  // Vorschau in dieser Datei und das Theme muss nicht angefasst werden.
  function medienLaden() {
    var handle = (WURZEL.getAttribute('data-produkt-handle') || '').trim();
    if (!handle) {
      var m = location.pathname.match(/\/products\/([^\/?#]+)/);
      handle = m ? m[1] : '';
    }
    if (!handle) return Promise.resolve([]);

    // ⚠️ NICHT `force-cache`. Kommt ein Bild am Produkt dazu, liefert der
    // Cache weiter die alte Medienliste — die Vorschau findet das neue Bild
    // dann nicht und faellt aufs Originalbild zurueck. Am 22.08.2026 genau so
    // passiert, nachdem 20 Ebenenbilder ans Testprodukt kamen.
    // `default` respektiert Shopifys eigene Cache-Kopfzeilen.
    return fetch('/products/' + handle + '.js', { cache: 'default' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.media) return [];
        return p.media.map(function (m) {
          return { datei: (m.src || '').split('/').pop().split('?')[0], src: m.src };
        });
      })
      .catch(function (e) {
        console.warn('[mo-vorschau] Medien nicht ladbar:', e);
        return [];
      });
  }

  function dateiVorsilbe(zustand) {
    var bef = zustand[OPT_BEFESTIGUNG];
    var ober = zustand[OPT_OBERFLAECHE];
    if (!bef || !ober) return null;
    var vor = VORSILBE[bef];
    if (!vor) return null;
    // "RAL 7016" -> "RAL_7016"; Shopify ersetzt Leerzeichen durch Unterstrich.
    return vor + String(ober).replace(/\s+/g, '_');
  }

  function bildFinden(vorsilbe) {
    if (!vorsilbe || !medien) return null;
    for (var i = 0; i < medien.length; i++) {
      if (medien[i].datei.indexOf(vorsilbe) === 0) return medien[i].src;
    }
    return null;
  }

  // ⭐ Shopify skaliert selbst — man muss es nur verlangen.
  // Am 22.08.2026 gemessen: dieselbe Kachel ohne Parameter 67 KB, mit
  // `&width=200` nur 4,7 KB. Die Datei zu verkleinern bringt dagegen NICHTS
  // (das Original wurde sogar groesser ausgeliefert). Der Hebel ist die
  // Adresse, nicht die Datei.
  function passendeBreite() {
    // 🔴 Das Bild selbst taugt frueh nicht als Massstab: beim ersten Lauf ist
    // es erst 11 px breit, weil das Layout noch nicht steht. Dann kaeme
    // width=400 heraus und das Galeriebild waere sichtbar unscharf.
    // Deshalb den CONTAINER messen und erst als letztes auf 800 zurueckfallen.
    var b = 0;
    var box = zielBild.closest('.product__media-wrapper, .product__media-item, .product__media');
    if (box) b = box.getBoundingClientRect().width;
    if (b < 80) b = zielBild.getBoundingClientRect().width;
    if (b < 80) b = 800;                       // Layout noch nicht da
    b = b * (window.devicePixelRatio || 1);
    // auf 100er aufrunden: weniger Fassungen = besserer Cache
    return Math.min(Math.max(Math.ceil(b / 100) * 100, 600), 1600);
  }

  function skaliert(url) {
    if (!url || /[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + passendeBreite();
  }

  function setzen(url) {
    // Liegt die Aufmasszeichnung im Bild, nicht dazwischenfunken. Der Merker
    // wird vom Aufmass-Block gesetzt, siehe dort.
    if (window.moKonfig && window.moKonfig.bildGesperrt) return;
    // ⚠️ srcset MUSS mit weg. Bleibt es stehen, gewinnt es gegen src und der
    // Browser zeigt weiter das alte Bild — die Vorschau wirkt tot.
    zielBild.removeAttribute('srcset');
    zielBild.removeAttribute('data-srcset');
    zielBild.src = skaliert(url);

    // MO 24.08.2026: Die Theme-Galerie zeigt immer nur das Slide mit
    // .is-active. Steht der Kunde auf einem anderen Bild, tauschten wir hier
    // ins Leere - geaendert wird Slide 0, sichtbar bleibt seins. Also die
    // Galerie mitnehmen. setActiveMedia ist Dawns eigene Methode: sie setzt
    // die Klasse, markiert die Miniatur und scrollt sie in den Blick.
    var moSlide = zielBild.closest('.product__media-item');
    var moGalerie = document.querySelector('media-gallery');
    if (moSlide && moGalerie && typeof moGalerie.setActiveMedia === 'function' &&
        !moSlide.classList.contains('is-active')) {
      moGalerie.setActiveMedia(moSlide.dataset.mediaId, false);
    }

    // MO 24.08.2026: Die Miniatur unter dem Bild gehoert zum selben Medium
    // und muss mitziehen - sonst zeigt die Leiste weiter das Originalmotiv,
    // waehrend oben das konfigurierte Gitter steht.
    // ⚠️ srcset auch hier weg, sonst gewinnt es gegen src (dieselbe Falle
    // wie beim grossen Bild). Und eine eigene, kleine Breite: die Miniatur
    // wird mit 62 px gezeigt, 200 deckt auch dreifache Pixeldichte.
    if (moSlide && moSlide.dataset.mediaId) {
      var moMini = document.querySelector(
        '.thumbnail-list__item[data-target="' + moSlide.dataset.mediaId + '"] img');
      if (moMini) {
        var moMiniUrl = /[?&]width=/.test(url)
          ? url.replace(/([?&])width=\d+/, '$1width=200')
          : url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=200';
        moMini.removeAttribute('srcset');
        moMini.removeAttribute('data-srcset');
        moMini.src = moMiniUrl;
      }
    }
  }

  function zeigen(zustand) {
    if (!zielBild || !medien) return;
    var url = bildFinden(dateiVorsilbe(zustand));
    if (!url) {
      // Keine passende Ebene: lieber das Originalbild als eine Luecke.
      if (originalSrc && letzteUrl !== originalSrc) {
        setzen(originalSrc);
        letzteUrl = originalSrc;
      }
      return;
    }
    if (url === letzteUrl) return;
    setzen(url);
    letzteUrl = url;
  }

  // 🔴 NICHT beim Laden vorladen.
  // Am 22.08.2026 gemessen: Beim reinen Seitenaufruf — bevor der Kunde
  // irgendetwas angeklickt hat — waren die zwei vorgeladenen Bilder mit
  // 486 KB von 844 KB **58 % der gesamten Bildlast**. Dabei waehlt der Kunde
  // die zweite Befestigungsart oft nie und die Farbe vielleicht auch nicht.
  //
  // Deshalb: Die Gegenseite wird erst geholt, wenn der Kunde ZUM ERSTEN MAL
  // etwas umstellt. Dann ist klar, dass er wirklich konfiguriert.
  // 🔴 KEIN VORLADEN. Bis 22.08.2026 wurden hier die beiden Befestigungsarten
  // der Startfarbe im Voraus geholt. Das kostete Ladelast fuer Bilder, die die
  // meisten Kunden nie sehen: Der Standard ist Feuerverzinkt, und wer die
  // Farbe wechselt, tut das Sekunden spaeter — nicht in der Ladephase, wo
  // jedes Byte gegen den ersten Bildaufbau konkurriert.
  //
  // Das Nachladen beim ersten Klick kostet rund 250 ms. Neben der Rechenzeit
  // von 10 ms faellt das auf, ist aber allemal besser, als jedem Besucher
  // Bilder aufzudraengen, die er nicht anschaut.
  function vorladen(/* zustand */) { /* absichtlich leer — siehe oben */ }

  window.moKonfig.horchen(function (ev) {
    if (!ev.detail || !ev.detail.zustand) return;
    var z = ev.detail.zustand;
    if (!medien) { letzterZustand = z; return; }

    /* Nur tauschen, wenn sich gegenueber dem Startzustand etwas geaendert hat.
       Der Konfigurator meldet `mo:konfig` auch fuer Dinge, die das Bild nicht
       betreffen - Masse, Menge, Anmerkung. Ohne diese Sperre haette der erste
       Tastendruck im Massfeld das LCP-Bild ausgetauscht und den Fehler von
       oben nur um zwei Sekunden verschoben. */
    /* ⚠️ NUR solange der Kunde noch gar nichts umgestellt hat (`vorgeladen`
       ist dann noch false). Danach muss auch der Startzustand wieder gezeigt
       werden - sonst bleibt beim Zurueckwechseln auf Feuerverzinkt oder von
       Laibung auf Aussenwand das alte Bild stehen. Am 24.08.2026 von Stefan
       gemeldet und nachgestellt. */
    if (!vorgeladen && startZustand && JSON.stringify(z) === startZustand) return;

    zeigen(z);
    // Erst wenn der Kunde tatsaechlich etwas umgestellt hat, lohnt Vorladen.
    if (!vorgeladen && startZustand && JSON.stringify(z) !== startZustand) {
      vorladen(z);
      vorgeladen = true;
    }
  });

  // ---------- Ebenenbilder aus der Galerie nehmen -----------------------
  // Die 22 Ebenenbilder (Aussenwand_*/Laibung_*) sind Arbeitsmaterial fuer die
  // Vorschau, keine Produktbilder. Ungefiltert blaehen sie die Galerie auf 30
  // sichtbare Kacheln auf (am 22.08.2026 an FG 01 gezaehlt: 23 davon Ebenen).
  //
  // LPO hatte das Problem nicht, weil es die Theme-Galerie komplett durch eine
  // eigene ersetzt und dabei filtert (siehe lpo-galerie-ersetzt-theme-galerie).
  // Wir lassen die Theme-Galerie stehen und raeumen nur auf.
  //
  // 🔴 MUSS vor dem ersten Bildtausch laufen. Danach traegt das Zielbild selbst
  // einen Aussenwand_-Namen und wuerde sich selbst ausblenden.
  function galerieAufraeumen(ziel) {
    var weg = 0;
    document.querySelectorAll('.product__media-item, .thumbnail-list__item')
      .forEach(function (el) {
        if (ziel && (el === ziel || el.contains(ziel))) return;   // Vorschau bleibt
        var img = el.querySelector('img');
        if (!img) return;
        var datei = (img.getAttribute('src') || '').split('/').pop().split('?')[0];
        if (/^(Aussenwand_|Laibung_)/.test(datei)) {
          el.style.display = 'none';
          weg++;
        }
      });
    return weg;
  }

  medienLaden().then(function (liste) {
    medien = liste;
    zielBild = bildSuchen();
    if (!zielBild) {
      console.warn('[mo-vorschau] Kein Galeriebild gefunden — Vorschau bleibt aus.');
      return;
    }
    originalSrc = zielBild.getAttribute('src');
    galerieAufraeumen(zielBild.closest('.product__media-item, .thumbnail-list__item'));
    if (letzterZustand) {
      /* 🔴 HIER WIRD NICHT GETAUSCHT - das war der LCP-Killer.

         Bis zum 23.08.2026 stand hier `zeigen(letzterZustand)`. Damit ersetzte
         die Vorschau das fertige Galeriebild durch ein Ebenenbild, das erst in
         diesem Moment angefordert wurde. Lighthouse mass daraufhin genau
         dieses Bild als groesstes Element der Seite: **LCP 17,3 s** - obwohl
         das Galeriebild mit `fetchpriority="high"` laengst nach 664 ms da war.

         Der Tausch bringt in diesem Augenblick auch nichts: Der Kunde hat
         nichts gewaehlt, gezeigt wuerde die Standardausfuehrung - also genau
         das, was auf dem Produktfoto ohnehin zu sehen ist.

         Die Vorschau springt jetzt beim ersten echten Umstellen an (siehe
         `horchen` weiter oben). Dann ist das Bild die Antwort auf eine
         Handlung, und LCP ist laengst gemessen.

         ⭐ Nebenwirkung, die keine ist: Wer nichts umstellt, laedt das
         Ebenenbild gar nicht mehr - dieselbe Ueberlegung wie beim Vorladen,
         das am 22.08.2026 aus demselben Grund abgeschaltet wurde. */
      startZustand = JSON.stringify(letzterZustand);
    }
  });
})();


(function(){
  'use strict';

  var CFG      = JSON.parse(document.getElementById('mo-config').textContent);

  /* ⭐ GRUNDOBERFLAECHE AUS DEM THEME — 01.09.2026

     Der Block traegt `data-mo-oberflaeche`. Steht dort `kalt`, heisst die
     erste Kachel „Kaltverzinkt" statt „Feuerverzinkt" — Beschriftung,
     Erklaertext UND der Wert, der in die Bestellung geht.

     🔴 Die Bild-URL wird ZUERST abgefangen. Sie traegt den Dateinamen
     `a_I41E_Feuerverzinkt_nur_Text_…png`; ein blinder Textersatz machte
     daraus eine URL, die es nicht gibt, und die Kachel bliebe leer.

     Fehlt das Ersatzbild, bleibt die alte Kachel stehen und wir sagen es in
     der Konsole — lieber sichtbar falsch als still falsch. */
  (function grundoberflaeche(){
    var wz = document.querySelector('[data-mo-konfigurator]');
    var ob = wz && wz.getAttribute('data-mo-oberflaeche');
    if (!ob || ob === 'feuer') return;
    var bild = (wz.getAttribute('data-mo-oberflaeche-bild') || '').trim();
    var traf = false, bildOffen = false;
    (function geh(o){
      if (Array.isArray(o)) { o.forEach(geh); return; }
      if (!o || typeof o !== 'object') return;
      Object.keys(o).forEach(function(k){
        var v = o[k];
        if (typeof v !== 'string') { geh(v); return; }
        if (!/feuerverzinkt/i.test(v)) return;
        if (k === 'img' || /^https?:|^\/\//.test(v)) {
          if (bild) { o[k] = bild; traf = true; } else { bildOffen = true; }
          return;
        }
        o[k] = v.replace(/Feuerverzinkt/g, 'Kaltverzinkt')
                .replace(/feuerverzinkt/g, 'kaltverzinkt');
        traf = true;
      });
    })(CFG);
    if (bildOffen) {
      console.warn('[mo-konfigurator] Grundoberflaeche steht auf "' + ob +
        '", aber es ist kein Kachelbild hinterlegt — die Kachel zeigt weiter ' +
        '"Feuerverzinkt". Im Theme-Editor unter "Kachelbild fuer Kaltverzinkt" setzen.');
    }
    if (!traf) {
      console.warn('[mo-konfigurator] Grundoberflaeche "' + ob + '" gewaehlt, ' +
        'aber diese Config nennt nirgends "Feuerverzinkt" — nichts umbenannt.');
    }
  })();

  /* ⭐ WELCHE BEFESTIGUNGSMITTEL ANBIETEN — 01.09.2026

     `data-mo-befestigung`: alle | ohne_sichs | nur_sichs. Franzoesische
     Balkone haben keine Sicherheitsschrauben, Handlaeufe nur diese.

     🔴 Es wird nur die AUSWAHL gefiltert. Der Wert steht 15-mal in der
     Balkon-Config, auch in Folgeoptionen und Preisformeln — die bleiben
     unangetastet, damit nichts still auseinanderlaeuft.

     🔴 Faellt der Vorgabewert weg, ruecken wir ihn auf den ersten
     verbliebenen nach. Sonst stuende die Option ohne gueltigen Stand da. */
  (function befestigungAuswahl(){
    var wz = document.querySelector('[data-mo-konfigurator]');
    var wahl = wz && wz.getAttribute('data-mo-befestigung');
    if (!wahl || wahl === 'alle') return;
    var SICHS = 'Sicherheitsschrauben';
    var behalten = function(v){
      var name = String(v && (v.value != null ? v.value : v.text) || '');
      if (/^Ohne/i.test(name)) return true;              // immer anbieten
      if (wahl === 'ohne_sichs') return name !== SICHS;
      if (wahl === 'nur_sichs') return name === SICHS;
      return true;
    };
    var getroffen = 0;
    (function geh(o){
      if (Array.isArray(o)) { o.forEach(geh); return; }
      if (!o || typeof o !== 'object') return;
      if (o.name === 'Befestigungsmittel' && Array.isArray(o.values)) {
        var vorher = o.values.length;
        o.values = o.values.filter(behalten);
        if (o.values.length !== vorher) getroffen++;
        var da = o.values.some(function(v){
          return String(v.value != null ? v.value : v.text) === String(o.value);
        });
        if (!da && o.values.length) {
          o.value = o.values[0].value != null ? o.values[0].value : o.values[0].text;
        }
      }
      Object.keys(o).forEach(function(k){ geh(o[k]); });
    })(CFG);
    if (!getroffen) {
      console.warn('[mo-konfigurator] Befestigungs-Auswahl "' + wahl +
        '" gesetzt, aber keine Option "Befestigungsmittel" gefunden oder ' +
        'nichts zu filtern.');
    }
  })();

  /* ⭐ HALBER SATZ BEI ZWEI BEFESTIGUNGSPUNKTEN — 02.09.2026

     `data-mo-punkte`: 4 (Vorgabe) | 2

     Stefan: „2er satz die hälfte auch bei den anderen befestigungsmitteln
     machen irgendwie schaltbar das nicht alles kaputt geht." Eine
     Fensterstange haengt an zwei Punkten, ein Fenstergitter an vier — die
     Saetze sind aber fuer vier kalkuliert.

     ⭐ Die CONFIGS bleiben unberuehrt. Sie tragen weiter die Vier-Punkt-Preise;
     halbiert wird erst hier. Ein zurueckgedrehter Schalter stellt damit den
     alten Zustand vollstaendig her — nichts geht kaputt.

     🔴 Getroffen wird NUR, was an `Befestigungsmittel` haengt: die Gruppen,
     deren `conditions` dieses Feld nennen, samt ihrem ganzen Teilbaum. Die
     Oberflaeche liegt in `Farbauswahl` und behaelt ihre -5,00 EUR. An dieser
     Trennung haengt alles. */
  (function befestigungPunkte(){
    var wz = document.querySelector('[data-mo-konfigurator]');
    var p  = wz && wz.getAttribute('data-mo-punkte');
    if (p !== '2') return;                       // Vorgabe 4: nichts tun

    var geaendert = 0;

    /* Halbiert jeden Preis in diesem Teilbaum. Gerundet auf ganze Cent —
       ohne das kaeme aus 38.5/2 im Fliesskomma spaeter ein Rest. */
    function halbiere(o){
      if (Array.isArray(o)) { o.forEach(halbiere); return; }
      if (!o || typeof o !== 'object') return;
      (o.values || []).forEach(function(v){
        if (v && typeof v.price === 'number' && v.price) {
          v.price = Math.round(v.price * 50) / 100;
          geaendert++;
        }
      });
      Object.keys(o).forEach(function(k){ halbiere(o[k]); });
    }

    (function suche(o){
      if (Array.isArray(o)) { o.forEach(suche); return; }
      if (!o || typeof o !== 'object') return;
      var c = o.conditions;
      var trifft = Array.isArray(c) && c.some(function(b){
        return b && String(b.field) === 'Befestigungsmittel';
      });
      if (trifft) { halbiere(o); return; }       // Teilbaum erledigt
      Object.keys(o).forEach(function(k){ suche(o[k]); });
    })(CFG);

    /* ⭐ 2er-BILDER — 02.09.2026. Traegt ein Wert ein `img2`, wird es bei zwei
       Punkten anstelle von `img` gezeigt.

       ⭐ Fail-safe in die richtige Richtung: Ein fehlendes 2er-Bild kostet nur
       Genauigkeit in der Abbildung, ein geratener Dateiname die ganze Kachel.
       Deshalb wird NIE ein Name gebildet, sondern nur genommen, was dasteht. */
    var ohneZweier = 0;
    (function bilder(o){
      if (Array.isArray(o)) { o.forEach(bilder); return; }
      if (!o || typeof o !== 'object') return;
      var c = o.conditions;
      var inBef = Array.isArray(c) && c.some(function(b){
        return b && String(b.field) === 'Befestigungsmittel';
      });
      if (inBef) {
        (function tief(x){
          if (Array.isArray(x)) { x.forEach(tief); return; }
          if (!x || typeof x !== 'object') return;
          (x.values || []).forEach(function(v){
            if (!v || !v.img) return;
            if (v.img2) { v.img = v.img2; }
            else if (v.price) { ohneZweier++; }
          });
          Object.keys(x).forEach(function(k){ tief(x[k]); });
        })(o);
        return;
      }
      Object.keys(o).forEach(function(k){ bilder(o[k]); });
    })(CFG);

    /* 🔴 Der Hinweis gilt nur, solange MINDESTENS EINE sichtbare Kachel beim
       4er-Bild bleibt. Haben alle ihr 2er-Bild, waere der Satz falsch — und
       ein Hinweis, der auf nichts mehr zutrifft, ist schlimmer als keiner. */
    if (ohneZweier === 0) {
      console.info('[mo-konfigurator] Alle Befestigungskacheln haben ein ' +
        '2er-Bild — Hinweis entfaellt.');
    }
    (function hinweis(o){
      if (ohneZweier === 0) return;
      if (Array.isArray(o)) { o.forEach(hinweis); return; }
      if (!o || typeof o !== 'object') return;
      if (String(o.name) === 'Befestigungsmittel') {
        o.params = o.params || {};
        if (!o.params.moHinweis) {
          /* 🔴 Genau bleiben: Die Sicherheitsschrauben haben seit dem
             02.09.2026 ein eigenes 2er-Bild, die Montagesaetze noch nicht.
             Ein pauschales „die Abbildungen" waere ab jetzt falsch. */
          o.params.moHinweis = 'Für Ihre zwei Befestigungspunkte: halber Satz, '
            + 'halber Preis. Bei den Montagesätzen zeigt die Abbildung noch '
            + 'den vollen Satz für vier Punkte.';
        }
        return;
      }
      Object.keys(o).forEach(function(k){ hinweis(o[k]); });
    })(CFG);

    console.info('[mo-konfigurator] Zwei Befestigungspunkte: ' + geaendert +
      ' Preis(e) halbiert.');
  })();

  /* ⭐ ERWEITERTE OBERFLAECHEN FREISCHALTEN — 01.09.2026

     `data-mo-oberflaechen-plus`: ja | nein (aus `custom.oberflaechen_erweitert`).

     Die 2K-Epoxid-Zinkstaubgrundierung steht in der Config, wird aber nur
     angeboten, wenn das Produkt sie freigibt. Heute sind das Nova 30 und
     Nova 31.

     ⚠️ Seit 02.09.2026 kostet sie -5,00 EUR (Abschlag statt Aufpreis), weil
     sie im eigenen Haus aufgetragen wird. Der Grund fuer die Sperre ist
     damit ein anderer als am 01.09.: nicht mehr „kostenlos", sondern eine
     Lieferzeitzusage von 5–7 Werktagen, die nicht jedes Produkt halten kann.

     🔴 Wie bei `befestigungAuswahl()`: NUR die Auswahl wird gefiltert.
     Preisformeln und Folgeoptionen bleiben stehen, damit nichts still
     auseinanderlaeuft.

     🔴 Faellt der ausgewaehlte Wert weg, ruecken wir auf den ersten
     verbliebenen nach - sonst stuende die Option ohne gueltigen Stand da. */
  (function oberflaechenAuswahl(){
    var wz = document.querySelector('[data-mo-konfigurator]');
    var frei = wz && wz.getAttribute('data-mo-oberflaechen-plus');
    if (frei === 'ja') return;                       // freigegeben: nichts tun

    /* 🔴 „Kaltverzinkt" ist hier RAUS (02.09.2026). Die Kachel gibt es
       nicht mehr — sie war dasselbe Verfahren wie 2K-Epoxid, nur anders
       benannt. Stuende sie noch im Muster, traefe sie kuenftig die ERSTE
       Kachel: `grundoberflaeche()` laeuft vorher und macht bei
       `data-mo-oberflaeche="kalt"` aus „Feuerverzinkt" ein
       „Kaltverzinkt". Der Filter loeschte dann die Grundoberflaeche und
       das Produkt haette gar keine. */
    var ZUSATZ = /^2K-Epoxid/i;
    var getroffen = 0, entfernt = 0;
    (function geh(o){
      if (Array.isArray(o)) { o.forEach(geh); return; }
      if (!o || typeof o !== 'object') return;
      if (/^Oberfl/i.test(String(o.name || '')) && Array.isArray(o.values)) {
        var vorher = o.values.length;
        o.values = o.values.filter(function(v){
          return !ZUSATZ.test(String(v && (v.value != null ? v.value : v.text) || ''));
        });
        if (o.values.length !== vorher) {
          getroffen++;
          entfernt += vorher - o.values.length;
          var da = o.values.some(function(v){
            return String(v.value != null ? v.value : v.text) === String(o.value);
          });
          if (!da && o.values.length) {
            o.value = o.values[0].value != null ? o.values[0].value : o.values[0].text;
          }
        }
      }
      Object.keys(o).forEach(function(k){ geh(o[k]); });
    })(CFG);
    if (entfernt) {
      console.info('[mo-konfigurator] ' + entfernt + ' erweiterte Oberflaeche(n) ' +
        'ausgeblendet — `custom.oberflaechen_erweitert` steht nicht auf true.');
    }
  })();

  /* ⭐ BEFESTIGUNGSART FEST VORGEBEN — 01.09.2026

     `data-mo-befestigungsart`: wahl | aussenwand | laibung.

     ⭐ Ausgeblendet wird ueber eine nie erfuellbare BEDINGUNG, nicht durch
     Loeschen der Gruppe. Der Motor belegt `zustand` aus `o.value`, bevor er
     Bedingungen prueft — der Wert bleibt also erhalten und geht weiter in
     Preis, Zeichnung und Bestellzeile ein. Die Gruppe verschwindet nur aus
     der Anzeige.

     🔴 `o.value` wird mitgesetzt: Ohne Auswahl entscheidet allein er, was
     bestellt wird. Sonst stuende im Theme „Laibung" und in der Bestellung
     weiter „Auf der Aussenwand". */
  (function befestigungsartFest(){
    var wz = document.querySelector('[data-mo-konfigurator]');
    var wahl = wz && wz.getAttribute('data-mo-befestigungsart');
    if (!wahl || wahl === 'wahl') return;
    var ZIEL = { aussenwand: 'Auf der Au\u00dfenwand', laibung: 'In der Laibung' }[wahl];
    if (!ZIEL) return;
    var gesetzt = false;
    (function geh(o){
      if (Array.isArray(o)) { o.forEach(geh); return; }
      if (!o || typeof o !== 'object') return;
      if (o.name === 'Befestigung' && Array.isArray(o.values)) {
        var da = o.values.some(function(v){ return v.value === ZIEL; });
        if (da) {
          /* 🔴 NICHT ueber eine unerfuellbare Bedingung ausblenden — am
             01.09.2026 gemessen und verworfen: Der weitergereichte Zustand
             enthaelt NUR sichtbare Optionen. `Befestigung` fiel damit ganz
             heraus, `moBefestigungsArt(zustand)` fiel auf die Vorgabe zurueck,
             und die Skizze zeigte „Auf der Aussenwand", waehrend im Theme
             „Laibung" stand. Die Vorbelegung in `zustand[o.name] = o.value`
             gilt nur INTERN, nicht fuer das, was Skizze und Preis sehen.

             Stattdessen bleibt die Option sichtbar und behaelt genau einen
             Wert. Damit steht sie im Zustand, die Skizze folgt, und zu
             waehlen gibt es nichts mehr. */
          o.values = o.values.filter(function(v){ return v.value === ZIEL; });
          o.value = ZIEL;
          gesetzt = true;
        } else {
          console.warn('[mo-konfigurator] Befestigungsart "' + ZIEL +
            '" steht nicht in dieser Config — Auswahl bleibt sichtbar.');
        }
      }
      if (o.options) geh(o.options);
    })(CFG.options);
    if (!gesetzt) {
      console.warn('[mo-konfigurator] Befestigungsart "' + wahl + '" gesetzt, ' +
        'aber diese Config hat keine Option "Befestigung" — nichts getan.');
    }
  })();

  var zustand  = Object.create(null);   // Optionsname -> Wert
  var masse    = { x:'', y:'' };
  var menge    = 1;
  var skizzeDatei = null;          // die echte Datei, nicht nur ihr Name
  var skizze   = '';                    // Dateiname der hochgeladenen Skizze                     // ⭐ Anzahl, wie bei LPO mit − / +
  var anmerkung= '';
  var offen    = 0;                     // welcher Schritt ist aufgeklappt

  var euro = function(n){
    return n.toLocaleString('de-DE',{style:'currency',currency:'EUR'});
  };

  /* ---------- Config einlesen ---------------------------------------- */
  // Wir interessieren uns nur für das, was der Kunde sieht. value-formula,
  // upload-lift, quantity und price-summary lassen wir in v0.1 links liegen.
  var UEBERGANGEN = ['value-formula','price-summary'];

  function alleOptionen(liste, raus){
    raus = raus || [];
    (liste||[]).forEach(function(o){
      if(!o || typeof o !== 'object') return;
      raus.push(o);
      if(o.options) alleOptionen(o.options, raus);
    });
    return raus;
  }
  var FLACH = alleOptionen(CFG.options);

  /* ⭐ ZUSATZ-JS AUS DER CONFIG (16.09.2026, zuerst gebaut am 31.08.)

     Eine Config kann mit `zusatzJs` eigene Dateien aus assets/ nachladen —
     einen Namen oder eine Liste. Der Motor laedt sie und tut sonst NICHTS;
     was die Datei tut, entscheidet sie selbst (die Balkon-Zeichnung haengt
     sich ueber `moKonfig.horchen()` ein). Damit braucht ein neuer
     Konfigurator keinen weiteren Eingriff in diese Datei.

     Nur die Balkon-Config traegt den Schluessel. Fuer alle anderen ist dieser
     Block ein `return` in der ersten Zeile.

     🔴 Der ?v=-Stempel kommt von der CONFIG, nicht von mo-konfigurator.js.
     Sonst liefert die CDN lautlos die alte Zeichnung, wenn nur sie neu ist —
     am 26.08. und 31.08.2026 gemessen. Wer die Zeichnung aendert, laedt die
     Config mit hoch.

     Der Dateiname wird geprueft (nur Buchstaben, Ziffern, Punkt, Minus,
     Unterstrich, Endung .js): Ein Wert, der in ein <script src> wandert, geht
     nicht ungeprueft durch. */
  (function zusatzJsHolen(){
    var liste = CFG && CFG.zusatzJs;
    if (!liste) return;
    if (!Array.isArray(liste)) liste = [liste];
    var tun = function(){
      var wz = document.querySelector('[data-mo-konfigurator]');
      var js = (wz && wz.getAttribute('data-js-url')) || '';
      if (!js) return;
      var cfg = (wz && wz.getAttribute('data-config-url')) || '';
      var stempel = (cfg.split('?')[1] || '').split('&')
                      .filter(function(p){ return /^v=/.test(p); })[0] || '';
      liste.forEach(function(datei){
        if (!/^[\w.-]+\.js$/.test(String(datei))) {
          console.error('[mo-konfigurator] zusatzJs abgelehnt: ' + datei);
          return;
        }
        if (document.querySelector('script[data-mo-zusatz="' + datei + '"]')) return;
        var sc = document.createElement('script');
        sc.setAttribute('data-mo-zusatz', datei);
        sc.src = js.split('?')[0].replace(/mo-konfigurator\.js/, datei) +
                 (stempel ? '?' + stempel : '');
        sc.onerror = function(){
          console.error('[mo-konfigurator] ' + datei + ' nicht erreichbar'); };
        document.body.appendChild(sc);
      });
    };
    if (document.body) tun();
    else document.addEventListener('DOMContentLoaded', tun);
  })();

  // Vorgabewerte setzen — das ist der Zustand, mit dem der Kunde startet
  FLACH.forEach(function(o){
    if(UEBERGANGEN.indexOf(o.type) > -1) return;
    if(o.value) zustand[o.name] = o.value;
  });

  /* ---------- Bedingungen -------------------------------------------- */
  // Format aus der Config: {data:"options", field:"<Name>", operator:"equals", value:"<Wert>"}
  // conditionMode 1 = alle Bedingungen müssen zutreffen.
  /* Eine Bedingung auf ein MASSFELD - unsere Erweiterung, die LPO nicht kennt.

     LPOs eigene `conditions` vergleichen nur Optionswerte auf Gleichheit
     (`equals` / `not_equals`). Eine Regel wie "erst ab 1400 mm Hoehe" laesst
     sich damit nicht ausdruecken.

     Statt sie in den Code zu schreiben, steht sie in der Config:

         "moMassbedingung": { "feld": "y", "ab": 1400 }

     Damit bleibt sie dort, wo die uebrigen Regeln auch stehen. Ein anderes
     Gitter mit anderer Schwelle braucht keine Codeaenderung, und wer die
     Config liest, sieht die Regel - im Code wuerde sie niemand vermuten.

     `feld` ist 'x' oder 'y' wie in den Massfeldern, `ab` die Untergrenze
     einschliesslich. `bis` geht ebenso, beides zusammen ergibt ein Fenster. */
  function massbedingungErfuellt(o){
    var m = o.moMassbedingung;
    if(!m) return true;
    var wert = parseFloat(String((masse && masse[m.feld]) || '').replace(',', '.'));
    // Ohne Eingabe ist die Bedingung NICHT erfuellt. Das ist Absicht: Die
    // Laschenwahl soll erst auftauchen, wenn die Hoehe bekannt ist - sonst
    // muesste der Kunde ueber etwas entscheiden, das er noch nicht kennt.
    if(!isFinite(wert)) return false;
    if(m.ab  != null && wert <  m.ab)  return false;
    if(m.bis != null && wert >  m.bis) return false;
    return true;
  }

  function bedingungenErfuellt(o){
    if(!massbedingungErfuellt(o)) return false;
    var c = o.conditions;
    if(!c || !c.length) return true;
    return c.every(function(b){
      if(b.data !== 'options') return true;          // andere Datenquellen: v0.1 ignoriert sie
      var ist = zustand[b.field];
      /* 🔴 16.09.2026: Kommaliste = „einer von diesen". Vorher exakter
         Vergleich — „Befestigung unten" der beiden Treppen-Configs
         (Wert „Aufschrauben,Einbetonieren") erschien dadurch nie. Ein Wert
         ohne Komma ergibt eine Liste mit genau sich selbst, das Verhalten
         aller uebrigen Bedingungen bleibt unveraendert. */
      var drin = (ist === b.value);
      /* Die Liste greift NUR, wenn der Wert wirklich ein Komma traegt, und
         vergleicht streng wie bisher. Damit bleibt jede Bedingung ohne Komma
         exakt beim alten Ergebnis — auch fuer einen leeren oder nicht
         gesetzten Zustand. */
      if(!drin && typeof b.value === 'string' && b.value.indexOf(',') > -1){
        drin = b.value.split(',').map(function(t){ return t.trim(); })
                 .indexOf(ist) > -1;
      }
      if(b.operator === 'equals')     return drin;
      if(b.operator === 'not_equals') return !drin;
      return true;
    });
  }

  /* ---------- Spitzenform nur bei Produkten, die welche haben ----------

     Der Wert kommt aus dem Produkt-Metafeld `custom.hat_spitzen` und steht
     als `data-hat-spitzen` am Traeger. Drei Zustaende, absichtlich:

       true       das Produkt hat Spitzen  -> Option zeigen
       false      es hat keine             -> Option WEG
       unbekannt  Metafeld nicht gepflegt  -> Option zeigen (Rueckfall)

     🔴 Der Rueckfall ist Absicht: Ein ungepflegtes Metafeld darf keine
     Option verschlucken. Verschwinden soll sie nur, wenn jemand aktiv
     `false` gesetzt hat. Am 24.08.2026 gemessen: alle 15 Konfigurator-Gitter
     haben das Feld gesetzt, der Rueckfall greift dort also gar nicht.

     ⚠️ EINMAL lesen, nicht bei jedem Aufruf. `sichtbar()` laeuft fuer jede
     Option bei jedem Neuzeichnen - ein `querySelector` darin waere genau die
     Sorte Kleinvieh, die die Produktseite frueher langsam gemacht hat. */
  var HAT_SPITZEN = null;
  function spitzenErlaubt(o){
    var name = String((o && (o.name || o.label)) || '');
    if(!/spitzen/i.test(name)) return true;         // andere Optionen: unberuehrt
    if(HAT_SPITZEN === null){
      var traeger = document.querySelector('[data-mo-metafelder]');
      HAT_SPITZEN = (traeger && traeger.dataset.hatSpitzen) || 'unbekannt';
    }
    return HAT_SPITZEN !== 'false';
  }

  // Eine Option zählt nur, wenn sie selbst UND jeder Vorfahre sichtbar ist.
  /* ⭐ Vierte Stellung `aus`: der ganze Befestigungs-Schritt entfaellt.
     Woertlich aus 2.09.3.1 BETA uebernommen (Stefan, 01.09.2026:
     „strikt wie in BETA machen!"). Am Handlauf sind es damit 4 Schritte
     statt 5 — Handlaeufe brauchen andere Befestigungsmittel als Gitter.

     🔴 Erkannt wird NICHT ueber eine Namensliste — die veraltet. Sondern
     ueber die Abhaengigkeit, die schon in der Config steht:
       · die Option „Befestigungsmittel" selbst (und damit ihre Gruppe)
       · alles, dessen `conditions` auf dieses Feld zeigt
     Wer eine fuenfte Wandart ergaenzt, muss hier nichts nachtragen. */
  var BEF_AUS = null;
  function befestigungErlaubt(o){
    if (BEF_AUS === null) {
      var wzB = document.querySelector('[data-mo-konfigurator]');
      BEF_AUS = !!(wzB && wzB.getAttribute('data-mo-befestigung') === 'aus');
    }
    if (!BEF_AUS) return true;                    // Vorgabe: alles zeigen
    if (!o) return true;
    if (String(o.name || '') === 'Befestigungsmittel') return false;
    var b = o.conditions;
    if (b && b.length) {
      for (var i = 0; i < b.length; i++) {
        if (b[i] && String(b[i].field || '') === 'Befestigungsmittel') return false;
      }
    }
    return true;
  }

  function sichtbar(o){
    if(!spitzenErlaubt(o)) return false;
    if(!befestigungErlaubt(o)) return false;
    if(!bedingungenErfuellt(o)) return false;
    var v = elternVon(o);
    while(v){ if(!bedingungenErfuellt(v)) return false; v = elternVon(v); }
    return true;
  }
  var ELTERN = new Map();
  (function bau(liste, eltern){
    (liste||[]).forEach(function(o){
      if(!o || typeof o !== 'object') return;
      if(eltern) ELTERN.set(o, eltern);
      if(o.options) bau(o.options, o);
    });
  })(CFG.options, null);
  function elternVon(o){ return ELTERN.get(o) || null; }

  /* ---------- Preis --------------------------------------------------- */
  // Im Theme kommen Preis und Faktor vom Produkt, in dieser Testdatei aus den
  // Spielfeldern oben. Beides wird unterstützt: Feld schlägt Attribut.
  var WURZEL = document.querySelector('[data-mo-konfigurator]');

  function variantenpreisCent(){
    var feld = document.getElementById('mo-vp');
    if(feld) return Math.round(parseFloat(feld.value || '0') * 100);
    return parseInt((WURZEL && WURZEL.getAttribute('data-variantenpreis-cent')) || '0', 10);
  }

  // 🔴 Es darf genau EIN [data-preis-faktor] im DOM stehen — main-product.liquid
  // liefert ihn auf Produktseiten bereits. Nur anlegen, wenn wirklich keiner da ist.
  (function faktorSicherstellen(){
    if(document.querySelector('[data-preis-faktor]')) return;
    var wert = (WURZEL && WURZEL.getAttribute('data-mo-faktor')) || '';
    if(!wert) return;
    var d = document.createElement('div');
    d.setAttribute('data-preis-faktor', wert);
    d.hidden = true;
    document.body.appendChild(d);
  })();

  // Die Umgebung, die LPO seinen Formeln bereitstellt. Genau diese drei Zugänge
  // benutzen die Formeln in der Config — mehr braucht es nicht.
  function umgebung(){
    return {
      variant: function(){ return { price: variantenpreisCent() }; },
      // options.controller('Maße') liefert das Maßfeld mit .x und .y
      controller: function(name){
        var o = FLACH.find(function(k){ return k.name === name; });
        if(o && o.type === 'dimension'){
          return { x: parseFloat(masse.x) || 0, y: parseFloat(masse.y) || 0 };
        }
        return { value: zustand[name] || '' };
      },
      // options.value('Satz_Standard') liefert den versteckten Rechensatz.
      // 🔴 Der steht in params.valueFormula, NICHT in value — value ist leer.
      value: function(name){
        var o = FLACH.find(function(k){ return k.name === name; });
        if(o && o.type === 'value-formula') return (o.params && o.params.valueFormula) || '';
        return zustand[name] || '';
      }
    };
  }

  // Die Maß-Formel steht als JS-Quelltext in der Config. Wir führen sie
  // unverändert aus — samt DOM-Knoten mit data-preis-faktor, den sie sucht.
  /* SPERRGRUND - warum massPreis() gerade `null` liefert, im Klartext.
     Stefan am 26.08.2026: „der Hinweis sollte da rein."
     Vorher stand ueber dem Kaufknopf immer „(Maße fehlen)" - auch dann, wenn
     das Feld gefuellt und der Wert nur zu gross war. Der Kunde suchte dann ein
     leeres Feld, das es nicht gab. Die Variable lebt in derselben IIFE wie
     massPreis() und rechne() (geprueft: kein `})();` dazwischen). */
  var MASS_GRUND = '';

  function massPreis(){
    /* ⭐ Das SICHTBARE Massfeld, nicht das erste. Der Wandhandlauf hat drei
       (Masze oben / unten / beidseitig), je Bauform genau eines sichtbar.
       `find` nahm immer „Masze oben" — bei Bauform „Oben und unten
       abgewinkelt" also Grenzen und Formel eines Feldes, das der Kunde nicht
       sieht. Bei einem einzigen Massfeld ist beides dasselbe: die
       Fenstergitter aendern sich dadurch nicht. */
    var dim = FLACH.filter(function(o){ return o.type === 'dimension' && sichtbar(o); })[0]
           || FLACH.find(function(o){ return o.type === 'dimension'; });
    /* 🔴 `masse` und `zustand` sind zwei Welten (siehe moMasseAusZustand).
       Die Bruecke lief bisher nur beim Zeichnen — beim ersten Aufbau mit
       Vorgabewerten blieb `masse` leer und der Preis stand auf „–".
       Nur AUFFUELLEN, niemals ueberschreiben: sonst schlaege ein alter
       Zustandswert eine frische Eingabe. */
    if (!(parseFloat(masse.x) > 0)) { try { moMasseAusZustand(); } catch(e){} }
    MASS_GRUND = '';
    if(!dim || !dim.params || !dim.params.priceFormula) return null;
    var nurX = !!dim.params.onlyX;
    var x = parseFloat(masse.x), y = parseFloat(masse.y);
    var pp = dim.params;
    /* Die Beschriftung kommt aus der Config - beim Handlauf „Länge:", beim
       Gitter „Befestigungsabstand:". Der Doppelpunkt muss weg, sonst steht
       „Länge: höchstens 6000 mm" da. */
    var lx = String(pp.labelX || 'Breite').replace(/\s*:\s*$/, '');
    var ly = String(pp.labelY || 'Höhe').replace(/\s*:\s*$/, '');
    if(!(x > 0)){ MASS_GRUND = lx + ' fehlt'; return null; }
    if(!nurX && !(y > 0)){ MASS_GRUND = ly + ' fehlt'; return null; }

    /* EINGABESPERRE - Masse AUSSERHALB der Grenzen ergeben keinen Preis.
       Stefan am 26.08.2026 mit Warenkorb-Screenshot: 45.000 mm
       Befestigungsabstand, 5.532,29 EUR, Kaufknopf aktiv. Die Fehlermeldung
       unter dem Feld gab es schon - sie sperrte nur nichts.
       Hier ist die richtige Stelle: massPreis() === null schaltet in einem
       Zug den Preis auf Strich UND den Kaufknopf ab. */
    if(pp.minX && x < parseFloat(pp.minX)){ MASS_GRUND = lx + ' mindestens ' + moMitEinheit(pp.minX); return null; }
    if(pp.maxX && x > parseFloat(pp.maxX)){ MASS_GRUND = lx + ' höchstens ' + moMitEinheit(pp.maxX); return null; }
    if(!nurX){
      if(pp.minY && y < parseFloat(pp.minY)){ MASS_GRUND = ly + ' mindestens ' + moMitEinheit(pp.minY); return null; }
      if(pp.maxY && y > parseFloat(pp.maxY)){ MASS_GRUND = ly + ' höchstens ' + moMitEinheit(pp.maxY); return null; }
    }
    /* Bei `onlyX` gibt es keine Flaeche - `area` traegt dann die Laenge.
       Die Stangen-Formel rechnet ohnehin nur mit x, das schadet ihr nicht. */
    if(nurX) y = 0;
    try{
      var fn = new Function('options','area','x','y','width','height', dim.params.priceFormula);
      var wert = fn(umgebung(), nurX ? x : x*y, x, y, x, y);
      return (typeof wert === 'number' && isFinite(wert)) ? wert : null;
    }catch(e){
      console.error('Maßformel aus der Config warf:', e);
      return null;
    }
  }

  // Ein Wert kostet entweder fest (price, priceType 1) oder nach Formel
  // (priceFormula, priceType 4) — die Farbkacheln rechnen nach Quadratmeter.
  function wertPreis(w){
    if(w.priceFormula){
      try{
        var fn = new Function('options', w.priceFormula);
        var r = fn(umgebung());
        return (typeof r === 'number' && isFinite(r)) ? r : 0;
      }catch(e){
        console.error('Wertformel aus der Config warf:', e);
        return 0;
      }
    }
    return w.price || 0;
  }

  function aufpreise(){
    var raus = [];
    FLACH.forEach(function(o){
      if(UEBERGANGEN.indexOf(o.type) > -1) return;
      if(!sichtbar(o)) return;
      /* ⭐ Freie Zahlenfelder haben keine `values` und fielen deshalb aus der
         Aufstellung - auf der Treppenseite fehlten damit Stufenhoehe und
         Auftritt, obwohl beide die Fertigung bestimmen. Sie tragen nie einen
         Aufpreis, stehen also als „inkl." da, genau wie die Befestigungsart.
         Gefunden am 31.08.2026 an der gerenderten Seite. */
      if(o.type === 'number'){
        if(o.params && o.params.exclude) return;
        var zahl = zustand[o.name];
        if(zahl === undefined || zahl === null || zahl === '') return;
        raus.push({ gruppe: zeilenName(o), name: String(zahl), preis: 0 });
        return;
      }
      if(!o.values) return;
      /* Wegweiser fuehren nur zum Ziel und gehoeren nicht in die
         Aufstellung — genau wie im Warenkorb. Ohne diese Zeile stuende
         "Befestigungsmittel: Lochstein" direkt neben "Montagesatz je
         Gitter: Lochstein ungedaemmt" und laese sich wie eine Dopplung. */
      if(o.params && o.params.exclude) return;
      var gewaehlt = zustand[o.name];
      if(!gewaehlt) return;
      var w = o.values.find(function(v){ return v.value === gewaehlt; });
      if(!w) return;
      var p = wertPreis(w);
      /* Die Beschriftung, unter der der Kunde gewaehlt hat — dieselbe
         Funktion, die auch den Warenkorb beschriftet. Sonst heisst die
         Wahl in der Preisbox anders als auf der Bestellung.

         Leer, wenn Name und Wert dasselbe sagen: eine Zeile
         "Sicherheitsschraube / Sicherheitsschraube 105 mm" hilft niemandem. */
      var wt = w.text || w.value;
      var nm = zeilenName(o);
      /* ⭐ Auch OHNE Aufpreis auflisten — Stefan am 25.08.2026: die
         Befestigungsart ("In der Laibung") stand bisher nirgends in der
         Aufstellung, obwohl sie die Bestellung mitbestimmt. */
      raus.push({ gruppe:(nm && nm !== wt) ? nm : '', name:wt, preis:p });
    });
    return raus;
  }

  function rechne(){
    var grund = massPreis();
    var zeilen = [];
    var summe = 0;

    /* 🔴 „Gitter nach Maß“ stand hier fest verdrahtet - auch ueber einem
       franzoesischen Balkon, einer Stange und einem Handlauf. Die Bezeichnung
       kommt jetzt aus der Config (`params.preisGruppe` am Massfeld); fehlt
       sie, bleibt es beim Gitter, damit sich die Fenstergitter nicht aendern. */
    var dimZ = FLACH.find(function(o){ return o.type === 'dimension'; });
    var pGrp = (dimZ && dimZ.params && dimZ.params.preisGruppe) || 'Gitter nach Maß';
    var nurXZ = !!(dimZ && dimZ.params && dimZ.params.onlyX);

    if(grund === null){
      /* Der Grund steht jetzt im Klartext da, statt pauschal „(Maße fehlen)".
         MASS_GRUND wird in massPreis() gesetzt - siehe dort. */
      zeilen.push({ name: pGrp.replace(/ nach Maß$/, '') + ' (' + (MASS_GRUND || 'Maße fehlen') + ')', preis:null });
    }else{
      /* Die Masse gehoeren an den Posten, den sie bestimmen. Damit wird die
         Grundzeile eine ganz normale benannte Zeile und bekommt dieselbe
         Darstellung wie alle anderen. */
      /* ⭐ 27.09.2026 (Balkon L-/U-Form): Rechnet die Massformel mit weiteren
         Laengen (Schenkel), stand hier bisher nur die Front — „3000 × 1000 mm"
         ueber dem Preis fuer 5700 mm. `params.laengenZusatz` am Massfeld nennt
         die Optionen, deren Werte zur Laenge zaehlen; sichtbare mit Wert kommen
         dazu: „5700 × 1000 mm (3000 + 1500 + 1200)". Ohne den Parameter bleibt
         die Zeile genau wie vorher (alle anderen Configs). */
      var zusatzL = (dimZ && dimZ.params && dimZ.params.laengenZusatz) || [];
      var teileL = [];
      zusatzL.forEach(function(n){
        var oz = FLACH.find(function(k){ return k.name === n; });
        var v = parseFloat(zustand[n]);
        if (oz && sichtbar(oz) && v > 0) teileL.push(v);
      });
      var xText = moAnzeige(masse.x);
      if (teileL.length) {
        xText = moAnzeige((parseFloat(masse.x) || 0) +
                          teileL.reduce(function(a, b){ return a + b; }, 0));
      }
      zeilen.push({ gruppe: pGrp,
                    name: nurXZ ? moMitEinheit(masse.x)
                                : (xText + ' × ' +
                                   (moAnzeige(masse.y) || '—') + moEinheitText() +
                                   (teileL.length ? ' (' + [moAnzeige(masse.x)]
                                     .concat(teileL.map(moAnzeige)).join(' + ') + ')' : '')),
                    preis:grund });
      summe += grund;
    }
    aufpreise().forEach(function(a){ zeilen.push(a); summe += a.preis; });

    /* 🔴 04.10.2026: NIE WENIGER ANZEIGEN, ALS DER WARENKORB VERLANGT.

       Der Warenkorb rechnet Variantenpreis + `_cl_options_price`, und LPOs
       Cart Transform kann nur AUFSCHLAGEN: Ein negativer Aufpreis wird zu 0.
       Lag die Summe unter dem Variantenpreis, zeigte die Seite zu wenig -
       gemessen im LIVE: Fensterstange Nova 30 bei 200 mm 5,66 EUR (mit 2K
       0,66), Warenkorb 28,32; Handlauf gerade 100 mm 50,00 statt 80,00;
       Fenstergitter am Mindestmass mit 2K-Grundierung 5 EUR zu wenig.
       Stefan: Seite zeigt ehrlich den Warenkorbpreis (Variante a). Die
       Differenz steht als eigene Zeile da, damit die Aufstellung aufgeht;
       `_cl_options_price` wird dadurch 0 statt negativ. */
    var weg0 = (WURZEL && WURZEL.getAttribute('data-preisweg')) || 'lpo';
    var vpCent0 = variantenpreisCent();
    if (grund !== null && weg0 === 'lpo' && vpCent0 > 0 && Math.round(summe * 100) < vpCent0) {
      var fehlt0 = (vpCent0 - Math.round(summe * 100)) / 100;
      zeilen.push({ name: 'Mindestpreis je Stück', preis: fehlt0 });
      summe += fehlt0;
    }
    return { zeilen:zeilen, summe:summe, vollstaendig:grund !== null };
  }

  /* ---------- Warenkorb-Eigenschaften --------------------------------- */
  // Nachgebaut nach dem, was an den echten Bestellungen #1004–#1010 steht.
  /* Wie eine Option in Warenkorb und Bestellbestaetigung heisst.

     🔴 DER MONTAGESATZ BRAUCHT EINEN EINDEUTIGEN NAMEN.

     In der Config heissen die Saetze nach dem Wandaufbau, dem sie folgen -
     "Aussenwand ungedaemmt", "Lochstein zweischalig". Im Warenkorb stand dann:

         Aussenwand ungedaemmt:  Vollstein / Beton ungedaemmt

     Das liest sich beim Packen wie EIN Satz. Tatsaechlich gilt der Aufpreis je
     Stueck, bei Menge 5 gehen also fuenf mit (am 22.08.2026 am echten
     Warenkorb nachgerechnet: 5 x 33,50 EUR stecken in 5 x 402,29 EUR).

     "Montagesatz je Stueck" macht das eindeutig - und zwar mengenunabhaengig.
     (Hiess bis zum 01.09.2026 "je Gitter" - falsch, sobald ein Handlauf oder
     ein Gelaender denselben Motor benutzt.)
     Die tatsaechliche Zahl hineinzuschreiben ("5 x ...") waere gefaehrlich:
     Aendert jemand die Menge spaeter im Warenkorb, bliebe die alte Zahl stehen
     und die Kommissionierung packte falsch.

     Erkannt wird an der Beschriftung "Befestigung fuer ..." - so heissen alle
     Satzoptionen in allen Configs. Wer eine neue anlegt, sollte sich daran
     halten; sonst faellt sie hier durch und behaelt ihren Rohnamen. */
  function zeilenName(o){
    var label = String(o.label || '');
    if (/^Befestigung f\u00fcr\b/i.test(label)) return 'Montagesatz je St\u00fcck';
    /* 🔴 SONST DIE BESCHRIFTUNG, NICHT DEN INTERNEN NAMEN.

       Die `name`-Felder der Config sind Arbeitsbezeichnungen und teils
       irrefuehrend. Im Warenkorb stand deshalb:

           Aussenwand Vollstein:   Vollstein ungedaemmt
           Aussenwand ungedaemmt:  Vollstein / Beton ungedaemmt

       Beide heissen in Wahrheit anders - "Wandaufbau" und "Befestigung fuer
       Vollstein / Beton ungedaemmt". Die erste Zeile liest sich, als staende
       dort zweimal dasselbe; die zweite nennt eine Aussenwand, obwohl es um
       den Montagesatz geht. Wer die Bestellung bearbeitet, muss raten.

       Das Label ist die Bezeichnung, die der Kunde beim Konfigurieren gesehen
       hat - genau die gehoert auf den Beleg.

       ⚠ Ohne Label bleibt es beim Namen: lieber eine sperrige Bezeichnung
       als eine leere. */
    return label.replace(/:$/, '').trim() || o.name;
  }

  function eigenschaften(){
    var e = {};
    var dim = FLACH.find(function(o){ return o.type === 'dimension'; });

    // 🔴 Der Marker, an dem unsere Cart-Transform-Function unsere Zeilen erkennt.
    // Cart Transforms wirken shopweit — ohne ihn wuerde die Function auch auf
    // LPO-Zeilen im Live-Theme greifen, denn LPO setzt _Maße_x/_Maße_y genauso.
    // Ohne diesen Marker fasst die Function die Zeile nicht an.
    e['_mo_konf'] = '1';

    e['_Maße_x'] = masse.x || '';
    e['_Maße_y'] = masse.y || '';

    /* Die Wegweiser sammeln, statt sie nur zu verwerfen - siehe unten. */
    var wegweiser = [];

    FLACH.forEach(function(o){
      if(UEBERGANGEN.indexOf(o.type) > -1) return;
      if(!sichtbar(o)) return;                       // ausgeblendet = wird nicht übertragen

      /* ⭐ `exclude` aus der Config: Die Option fuehrt den Kunden nur zum
         Ziel und gehoert nicht in die Bestellung.

         In der Fenstergitter-Config sind das "Befestigungsmittel:" und die
         beiden "Wandaufbau:"-Schritte. Die Werkstatt braucht den konkreten
         Montagesatz ("Befestigung fuer Lochstein gedaemmt"), nicht den
         Klickpfad dorthin - die Zieloptionen tragen `exclude: false`. */
      if(o.params && o.params.exclude){
        if(zustand[o.name]) wegweiser.push(o);
        return;
      }
      if(o.type === 'dimension'){
        if(masse.x){
          var t = (o.params && o.params.valueTemplate) || '{x} × {y}';
          /* 🔴 02.10.2026: IN DER LAIBUNG HEISST DAS MASS "GITTERBREITE".
             zeichneMasse() beschriftet das Feld dort mit `labelXLaibung`
             (lichtes Mass minus 5-10 mm). Der feste `valueTemplate` schrieb aber
             weiter "Befestigungsabstand=..." in die Bestellung - dieselbe Zahl
             unter zwei Namen, und Werkstatt, Bestellmail und PDF-Rechnung lesen
             den Namen. Stefan am 02.10.2026: in der Laibung "Gitterbreite=... mm".
             Getauscht wird nur das Wort aus `labelX`, nur wenn es im Template
             steht, und ueber dieselbe Weiche wie am Feld (istLaibung()).
             `_Maße_x`/`_Maße_y` bleiben unberuehrt - davon lebt ?mo-bearbeiten=. */
          var lbPar = o.params || {};
          if (lbPar.labelXLaibung && lbPar.labelX && istLaibung()) {
            var lbAlt = String(lbPar.labelX).replace(/:$/, '').trim();
            var lbNeu = String(lbPar.labelXLaibung).replace(/:$/, '').trim();
            var lbPos = lbAlt ? t.indexOf(lbAlt) : -1;
            if (lbNeu && lbPos > -1) t = t.slice(0, lbPos) + lbNeu + t.slice(lbPos + lbAlt.length);
          }
          e[o.name] = t.replace('{x}', masse.x).replace('{y}', masse.y || '—');
        }
        return;
      }
      if(o.type === 'text'){ if(anmerkung) e[o.name] = anmerkung; return; }
      if(zustand[o.name]) e[zeilenName(o)] = zustand[o.name];
    });

    /* 🔴 SACKGASSEN NACHTRAGEN: Waehlt jemand "Ohne Befestigungsmittel",
       endet der Zweig beim Wegweiser - es folgt keine Zieloption mehr. Ohne
       diese Zeilen stuende in der Bestellung dann GAR NICHTS ueber die
       Befestigung, und niemand koennte unterscheiden, ob bewusst ohne
       bestellt wurde oder ob unterwegs etwas verlorenging.

       Nachgetragen wird nur, was der Zweig nicht schon anders gesagt hat:
       Steht die Zeile bereits (weil eine Zieloption gewaehlt wurde), bleibt
       der Wegweiser stumm. */
    wegweiser.forEach(function(o){
      var zeile = zeilenName(o);
      if (e[zeile]) return;                          // Ziel hat schon geantwortet
      if (zeile === 'Montagesatz je St\u00fcck' || /Befestigungsmittel/i.test(o.name)) {
        if (!e['Montagesatz je St\u00fcck']) e['Montagesatz je St\u00fcck'] = zustand[o.name];
      }
    });

    if (skizze) e['Skizze'] = skizze;

    var r = rechne();
    var grund = massPreis();

    // 🔴 DER UMSCHALTER zwischen den beiden Preiswegen.
    //
    // "lpo"   — der Aufpreis geht als _cl_options_price mit, LPOs Function
    //           macht daraus den Warenkorbpreis. Der Weg, der heute live läuft.
    // "eigen" — das Feld bleibt weg, damit UNSERE Function rechnen darf. Sie
    //           überspringt jede Zeile, die LPOs Marker trägt (Sicherung 2) —
    //           sonst würden zwei Functions dieselbe Zeile anfassen.
    //
    // Am 22.08.2026 im Test Shop nachgewiesen: Mit dem Feld bleibt der
    // Warenkorb bei 188,00 €, ohne rechnet unsere Function korrekt.
    var weg = (WURZEL && WURZEL.getAttribute('data-preisweg')) || 'lpo';
    if(grund !== null && weg === 'lpo'){
      e['_cl_options_price'] = String(Math.round((r.summe * 100) - variantenpreisCent()));
    }

    /* Die Lieferzusage der Seite mitgeben (28.09.2026, siehe
       moLieferzeitZusage). VOR `_cl_options_json`, damit sie auch an der
       Position der Bestellung steht — nachlesbar, was beim Kauf zugesagt
       war. */
    var lzZusage = moLieferzeitZusage();
    if (lzZusage) e['_mo_lieferzeit'] = lzZusage;

    /* 🔴 DER BAUPLAN FUER DIE POSITIONSZEILE — belegt am 27.08.2026.

       LPOs Cart-Transform macht aus unserer Zeile ein Buendel. Die Angaben
       bleiben dabei an der ELTERNZEILE; die eigentliche Position bekommt nur
       `_cl_options_group`. Genau die Position lesen aber alle aus, die die
       Bestellung spaeter zeigen: die Bestellbestaetigung, Order Printer Pro
       und `pruefe-bestellungen.js`. An #1013 stand deshalb ueberall nur die
       Artikelnummer.

       Die Function baut die Positionszeile aus `_cl_options_json`. Gemessen
       im Arbeitstheme 2.09.2: ohne das Feld traegt die Position nur
       `_cl_options_group`, mit dem Feld genau die Schluessel, die darin
       stehen. Auf den Preis wirkt es nicht — der kommt weiter allein aus
       `_cl_options_price`.

       ⚠️ Die VOLLE Fassung mitgeben, nicht nur die sichtbaren Felder:
       `pruefe-bestellungen.js` sucht `_cl_options_price` und die Masse an der
       POSITION, nicht an der Gruppe. */
    e['_cl_options_json'] = JSON.stringify(e);
    return e;
  }

  /* ---------- Zeichnen ------------------------------------------------ */
  function h(tag, attrs, kinder){
    var el = document.createElement(tag);
    Object.keys(attrs||{}).forEach(function(k){
      if(k === 'class') el.className = attrs[k];
      else if(k === 'html') el.innerHTML = attrs[k];
      else if(k.slice(0,2) === 'on') el.addEventListener(k.slice(2), attrs[k]);
      else if(attrs[k] !== null && attrs[k] !== undefined) el.setAttribute(k, attrs[k]);
    });
    (kinder||[]).forEach(function(k){ if(k) el.appendChild(k); });
    return el;
  }

  /* ⭐ 03.10.2026 (INP Treppen, Teil 2): Text nur schreiben, wenn er sich
     aendert. Jede Zuweisung an `textContent` tauscht den Textknoten aus — eine
     Mutation fuer Shopifys Pixel-Skript und Clarity, auch wenn danach dasselbe
     dasteht. Die Preisanzeigen liefen so bei jeder Eingabe. */
  function moText(el, wert){
    wert = wert == null ? '' : String(wert);
    var k = el.firstChild;
    if (k ? (k === el.lastChild && k.nodeType === 3 && k.data === wert) : wert === '') return;
    el.textContent = wert;
  }

  /* ---------- Bilder in der Groesse holen, in der sie gezeigt werden ----
     🔴 Der groesste Einzelposten der Produktseite waren die Optionskacheln:
     22 Bilder, 747 KB — weil sie die rohe Adresse aus der Config nahmen,
     ganz ohne `width`. Shopify liefert dann die Vollversion.

     Am 22.08.2026 an derselben Datei gemessen:
       ohne width      67,0 KB
       &width=200       4,7 KB      <- Faktor 14
       &width=300       7,8 KB

     ⚠️ Die Datei selbst zu verkleinern bringt NICHTS — gegengeprueft: Ein auf
     800 px gerechnetes Original lieferte sogar 76 statt 67 KB aus, weil
     Shopifys WebP-Encoder aus dem groesseren Original mehr herausholt. Der
     einzige Hebel ist dieser Parameter.

     ⚠️ `&width=` skaliert NICHT hoch. Ist das Original kleiner als der Wert,
     kommt das Original — kein Schaden, aber auch kein Gewinn. */
  /* ---------- Befestigungskacheln kommen aus dem METAFELD ---------------

     🔴 Gefunden am 24.08.2026: Der Konfigurator hat `data-befestigung-bild-*`
     nie gelesen und stattdessen `v.img` aus der Config genommen. Dort stehen
     fest verdrahtete FG-01-Bilder — Atlas 02 zeigte deshalb ein Rautengitter,
     obwohl seine eigenen Kacheln im Shop liegen.

     Reihenfolge: **Metafeld sticht, Config faengt auf** — dieselbe Kette wie
     bei der Aufmass-Skizze und bei LPO.

     ⚠️ Der Wert wird EINMAL gelesen und gemerkt. Der Kachelbau laeuft bei
     jedem Neuzeichnen ueber alle Werte; ein `querySelector` darin waere genau
     die Sorte Kleinvieh, die die Produktseite frueher langsam gemacht hat.

     ⚠️ Geschluessel wird ueber ein MUSTER im Wert, nicht ueber Gleichheit:
     Die Configs schreiben mal „Auf der Außenwand", mal „Auf der Aussenwand". */
  /* ---------- Bilder aus den METAOBJEKTEN  (24.08.2026) -----------------

     Gepflegt im Admin: Inhalte > Metaobjekte > Konfigurator-Bild.
     `snippets/mo-konfig-bilder.liquid` legt sie als JSON in die Seite.

     ⭐ Shopweit, nicht je Produkt — deshalb genau richtig fuer Spitzen,
     Oberflaechen und Befestigungsmittel, die in JEDER Config gleich sind.
     Gemessen: 70 % der Bilder liegen schon bei zwei Configs doppelt.

     ⚠️ Der Schluessel wird aus dem Wert GERECHNET, nicht gepflegt:
        „Spitze 1"          -> spitze-1
        „Auf der Außenwand" -> auf-der-aussenwand
     Wer ein Metaobjekt anlegt, muss diese Schreibweise treffen. */
  var META_BILD = null;
  var UMLAUTE = { 'ä':'ae', 'ö':'oe', 'ü':'ue', 'ß':'ss' };

  function metaSchluessel(v){
    return String((v && (v.value || v.text)) || '')
      .toLowerCase()
      .replace(/[äöüß]/g, function(z){ return UMLAUTE[z]; })
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function metaBild(v){
    if (META_BILD === null) {
      var el = document.getElementById('mo-konfig-bilder');
      /* 🔴 NICHT merken, wenn das Element fehlt. Diese Datei laedt `async`,
         das Woerterbuch steht im HTML weiter unten — laeuft das Skript zu
         frueh, waere ein gemerktes `{}` eine Sperre auf Dauer. Ohne Element
         also einfach nichts liefern und beim naechsten Zeichnen erneut
         nachsehen; `zeichne()` laeuft bei jedem `mo:konfig`. */
      if (!el) return null;
      try { META_BILD = JSON.parse(el.textContent); }
      catch (e) { console.warn('[mo-konfigurator] Metaobjekt-Bilder unlesbar:', e); META_BILD = {}; }
    }
    var e2 = META_BILD[metaSchluessel(v)];
    return (e2 && e2.bild) || null;
  }

  /* ⭐ `img: "asset:mo-kachel-….svg"` zeigt auf eine Datei im `assets/`-Ordner
     DIESES Themes. Damit ist jede Kachel eine Datei, die sich im Theme-Editor
     austauschen laesst — Stefan am 31.08.2026: „die bilder ersetzbar oder
     bearbeitbar waere nicht ganz verkehrt."

     Die Basis kommt aus `data-js-url` (die Adresse dieser Datei), dieselbe
     Quelle, aus der auch die Zusatzdateien nachgeladen werden. So bleibt der
     Export in ein anderes Theme heil: Eine fest eingetragene
     `/cdn/shop/t/76/assets/…`-Adresse traegt die Themenummer und waere dort
     tot, die hier gebildete zeigt immer auf das Theme, das gerade laeuft.

     🔴 Der Stempel kommt von der CONFIG, nicht vom Bild: Wer eine Kachel
     austauscht, muss den `_hinweis` in der Config anfassen, sonst liefert das
     CDN die alte weiter aus. Dieselbe Falle wie bei der Skizze. */
  var ASSET_BASIS = null;
  function assetBild(img){
    if (!img || String(img).slice(0, 6) !== 'asset:') return null;
    if (ASSET_BASIS === null) {
      var wzA = document.querySelector('[data-mo-konfigurator]');
      var jsA = (wzA && wzA.getAttribute('data-js-url')) || '';
      var cfgA = (wzA && wzA.getAttribute('data-config-url')) || '';
      var stempel = (cfgA.split('?')[1] || '').split('&')
                      .filter(function(p){ return /^v=/.test(p); })[0] || '';
      ASSET_BASIS = jsA
        ? { pfad: jsA.split('?')[0].replace(/[^\/]+$/, ''), v: stempel }
        : { pfad: '', v: '' };
    }
    if (!ASSET_BASIS.pfad) return null;
    return ASSET_BASIS.pfad + String(img).slice(6) +
           (ASSET_BASIS.v ? '?' + ASSET_BASIS.v : '');
  }

  /* ⭐ EIGENE KACHELBILDER AUS DEM THEME-EDITOR (01.09.2026)

     Stefan: „wie ersetze ich komfortabel diese Bilder?" — bis hierher gar
     nicht: Die Kacheln lagen als SVG im Theme, tauschen hiess Quelltext
     ersetzen. Jetzt legt er in der Produktseite einen Block an, tippt Option
     und Wert und zieht ein Bild hinein.

     Die Zuordnung laeuft ueber Option + Wert, also ueber genau die Texte, die
     der Kunde auch sieht. Ein Tippfehler heisst deshalb: das eigene Bild
     greift nicht — nie ein kaputtes Bild.

     Nur die Bloecke DIESER Produktvorlage stehen im Attribut. Ein Bild am
     Wandhandlauf taucht am Fenstergitter nicht auf; die Vorlagen fuehren
     getrennte Blocklisten. */
  var THEME_BILDER = {}, THEME_ROH = null;
  function themeBild(o, v){
    /* 🔴 Der ROHWERT entscheidet, nicht ein einmaliges „schon gelesen“.
       Im Theme-Editor rendert Shopify die Section bei jeder Aenderung neu;
       ein einmal gemerktes Ergebnis zeigte dort ewig das alte Bild — also
       ausgerechnet dort, wo die Bilder getauscht werden. Der Vergleich
       kostet eine Zeichenkette je Kachel, geparst wird nur bei Aenderung. */
    var wzT = document.querySelector('[data-mo-konfigurator]');
    var rohT = (wzT && wzT.getAttribute('data-mo-kachelbilder')) || '';
    if (rohT !== THEME_ROH) {
      THEME_ROH = rohT;
      THEME_BILDER = {};
      try {
        if (rohT) JSON.parse(rohT).forEach(function(e){
          if (e && e.o && e.w && e.u) THEME_BILDER[e.o + '\u0000' + e.w] = e.u;
        });
      } catch (e) {
        /* Kaputtes Attribut darf den Konfigurator nicht anhalten. */
        console.warn('[mo-konfigurator] Kachelbilder unlesbar', e);
      }
    }
    if (!o || !v) return null;
    return THEME_BILDER[String(o.name) + '\u0000' + String(v.value)] || null;
  }

  var BEF_BILD = null;
  function befestigungBild(o, v){
    if(!o || !/^befestigung(sart)?$/i.test(String(o.name || ''))) return null;
    if(BEF_BILD === null){
      var tr = document.querySelector('[data-mo-metafelder]');
      BEF_BILD = {
        aussen:  (tr && tr.dataset.befestigungBildAussenwand) || '',
        laibung: (tr && tr.dataset.befestigungBildLaibung)    || ''
      };
    }
    var k = String((v && (v.value || v.text)) || '');
    if(/laibung/i.test(k))          return BEF_BILD.laibung || null;
    if(/au(ss|ß)enwand/i.test(k)) return BEF_BILD.aussen  || null;
    return null;
  }

  function bildKlein(url, breite){
    if(!url) return url;
    if(/[?&]width=/.test(url)) return url;          // schon gesetzt: nicht anfassen
    if(!/cdn\.shopify\.com|\/cdn\/shop\//.test(url)) return url;  // fremde Quelle
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + breite;
  }

  /* Zieht den Farbklarnamen aus dem Bilddateinamen.

       a_qOrZ_RAL_9005_Tiefschwarz_400x250_db34ed24-...png  ->  "Tiefschwarz"
       a_59m8_ral-7021-schwarzgrau-400x250.png              ->  "Schwarzgrau"
       a_VdWp_DB_703_Eisenglimmer_ohne_Streifen_400x250...  ->  "Eisenglimmer"
       a_I41E_Feuerverzinkt_nur_Text_400x250...             ->  ""  (nichts uebrig)
       a_9EVV_Lochstein.png                                 ->  ""  (kein Zusatz)

     Warum aus dem Dateinamen und nicht aus einer Liste im Code:
     Eine Liste muesste bei jeder neuen Farbe nachgepflegt werden - und wer die
     Farbe anlegt, arbeitet in Shopify, nicht in dieser Datei. Der Dateiname
     traegt den Namen ohnehin schon.

     RAL 7021 taenzelt aus der Reihe: kleingeschrieben, Bindestriche statt
     Unterstriche, kein UUID-Anhang. Deshalb wird auf beides normalisiert und
     ohne Ruecksicht auf Gross- und Kleinschreibung verglichen. Wer hier ueber
     ein starres Namensmuster geht, verliert genau diese eine.
     Am 22.08.2026 gegen alle elf Oberflaechen geprueft. */
  var TONMUELL = /(nur|text|ohne|streifen|mit|neu|final|kopie|v\d+)/gi;

  /* Dateinamen tragen keine Umlaute. Die Rueckfuehrung laeuft ueber eine Liste,
     NICHT ueber eine Regel: "ue -> ü" machte aus Feuerrot "Fürrot", und
     "ss -> ß" trifft Eisenglimmer nicht, wohl aber jeden kuenftigen Namen mit
     echtem Doppel-s. Bei elf Farben ist die Liste kuerzer als jede Regel, die
     sicher waere. */
  var TONSCHREIBWEISE = {
    'Reinweiss': 'Reinweiß',
    'Moosgruen': 'Moosgrün'
  };

  function klarname(wert, bildUrl){
    if(!wert || !bildUrl) return '';
    var name = bildUrl.split('?')[0].split('/').pop();
    try { name = decodeURIComponent(name); } catch(e) {}
    name = name.replace(/\.[a-z0-9]+$/i, '')          // Endung
               .replace(/^a_[A-Za-z0-9]{4}_/, '')      // LPO-Praefix a_qOrZ_
               .replace(/[_-]+/g, ' ')                 // beide Trenner
               .replace(/\s*\d+x\d+.*$/i, '')         // ab "400x250" alles weg
               .trim();
    // Den Wert selbst abziehen - uebrig bleibt der Klarname.
    var w = String(wert).replace(/[_-]+/g, ' ').trim();
    if(name.toLowerCase().indexOf(w.toLowerCase()) === 0) name = name.slice(w.length);
    name = name.replace(TONMUELL, ' ').replace(/\s+/g, ' ').trim();
    // Nur ein einzelnes Wort gilt als Farbname. "Eisenglimmer ohne Streifen"
    // ist nach dem Muellfilter "Eisenglimmer"; bliebe mehr stehen, waere es
    // eher eine Dateibeschreibung als ein Ton.
    if(!name || name.indexOf(' ') > -1) return '';
    if(name.length < 3 || name.length > 24) return '';
    if(/\d/.test(name)) return '';
    name = name.charAt(0).toUpperCase() + name.slice(1);
    return TONSCHREIBWEISE[name] || name;
  }

  /* ⭐ DIE KACHELGROESSE STEHT IN DER CONFIG, nicht im Code.
     Drei Angaben je Option steuern die Darstellung — alle drei fuehrt LPO
     bereits, wir haben sie bisher nur nicht ausgewertet:

       size: 'large' | 'small'   Kachelgroesse
       shape: 'rect'             Bild im Querformat statt quadratisch
       imgTooltip: true          grosses Bild beim Ueberfliegen mit der Maus

     🔴 LPOS EIGENE MASSE SIND INKONSISTENT — nicht nachbauen.
     Am 22.08.2026 im Live-Theme gemessen: dieselbe Klasse `cl-po--large`
     liefert 68x68 (Befestigungsart, 2 Kacheln), 150x150 (Spitzenform, 4) und
     157x98 (Farbauswahl, 11). Und `small` (115x115) faellt GROESSER aus als
     `large` bei zwei Kacheln. Ursache: LPO setzt keine Groesse, sondern laesst
     einen Flex-Behaelter streuen. Wir setzen stattdessen ein Raster mit fester
     Mindestbreite — gleiche Absicht, verlaessliches Ergebnis. */
  /* Legt ein Kachelbild an und meldet sein Seitenverhaeltnis ans Raster -
     aber nur EINMAL je Gruppe: Alle Kacheln einer Gruppe sollen gleich hoch
     stehen, und das erste Bild gibt das Mass vor. Kaeme jedes Bild zum Zug,
     spraenge die Zeilenhoehe beim Nachladen. */
  function bildMitFormat(raster, attr){
    var el = h('img', attr);
    el.addEventListener('load', function(){
      if(raster.dataset.moFormat) return;              // schon gesetzt
      if(!el.naturalWidth || !el.naturalHeight) return;
      var v = el.naturalWidth / el.naturalHeight;
      raster.dataset.moFormat = String(v);
      raster.style.setProperty('--mo-kachel-format', v.toFixed(3));

      if(v < 2) return;
      // Flache Bilder duerfen breiter stehen - der 230-px-Deckel ist fuer
      // hochformatige Kacheln gedacht.
      raster.classList.add('mo-kacheln-breit');

      /* Und sie brauchen eine groessere Quelle. Beim Zeichnen war das Format
         noch unbekannt, deshalb stand dort 460 px - bei jetzt 522 px Anzeige
         waere das Bild leicht hochskaliert und auf Retina sichtbar weich.
         Genau der eingebrannte Text leidet zuerst darunter.

         Der zweite Abruf kostet nichts Nennenswertes: Es sind ein bis fuenf
         Bilder je Gruppe, und nur bei den flachen Formaten. */
      requestAnimationFrame(function(){
        raster.querySelectorAll('img').forEach(function(bild){
          var breit = Math.round(bild.getBoundingClientRect().width * 2);
          if(!breit) return;
          var neu = bild.src.replace(/([?&]width=)\d+/, '$1' + breit);
          if(neu !== bild.src) bild.src = neu;
        });
      });
    }, { once: true });
    return el;
  }

  /* Eine Pflichtoption mit nur EINER Moeglichkeit waehlt sich selbst.

     \U0001F534 DER FALL, DER DAS NOETIG MACHT:
     "Befestigung fuer Lochstein ungedaemmt" hat genau eine Kachel und ist
     Pflicht - der Kunde MUSS auf etwas klicken, das alternativlos ist. Am
     23.08.2026 bin ich beim Testen selbst darauf hereingefallen: Wandaufbau
     gewaehlt, weiter geklickt, und die 38,50 EUR fuer den Montagesatz fehlten
     stillschweigend im Preis. Wer den Schritt uebersieht, bestellt ein Gitter
     ohne Befestigung.

     \u26a0\ufe0f NUR bei genau einer Moeglichkeit und nur bei Pflichtoptionen.
     Bei zwei Wahlmoeglichkeiten waere eine Vorauswahl eine Entscheidung, die
     dem Kunden gehoert - und bei freiwilligen Optionen erst recht.

     \u26a0\ufe0f Die Auswahl wird NUR gesetzt, nicht neu gezeichnet. `zeichne()`
     ruft diese Funktion selbst auf; ein Neuzeichnen von hier aus liefe im
     Kreis. Der Wert steht im Zustand, und der naechste regulaere Durchgang
     zeigt ihn an. */
  function selbstwahl(o){
    if (!o.required) return;
    if (zustand[o.name]) return;                       // schon gewaehlt
    var werte = (o.values || []).filter(function(v){ return v && v.value; });
    if (werte.length !== 1) return;
    zustand[o.name] = werte[0].value;
  }

  /* Welche Kachellisten stehen offen? Muss ausserhalb der Zeichenfunktion
     leben: `zeichne()` laeuft bei jeder Massaenderung neu, und ohne dieses
     Gedaechtnis klappte die Farbliste beim Tippen im Massfeld wieder zu. */
  var offeneListen = {};

  /* Ab wann wird eingeklappt, und wie viele bleiben stehen.
     11 Farben minus 4 sichtbare = "Weitere Farben (7)", genau wie bei LPO. */
  var KACHEL_SICHTBAR = 4;
  /* 🔴 24.08.2026, Stefan: "Farbe weitere erstmal wegmachen und alle
     anzeigen." Der Aufklapper ist damit AUS - alle Werte stehen offen da.
     Zum Zurueckholen: wieder auf 6 setzen. Die ganze Aufklapp-Mechanik
     darunter bleibt unangetastet und greift dann sofort wieder. */
  var KACHEL_AB       = 9999;

  /* Die Auswahl - eine Stelle fuer Kacheln UND Radios.

     Sie lag vorher doppelt im Code. Beim Einbau von `toggle` haette das
     bedeutet, dass Abwaehlen an einer Stelle geht und an der anderen nicht. */
  function waehle(o, wert){
    /* ⚠️ `p` wird HIER geholt, nicht uebergeben. zeichneKacheln() hat ein
       eigenes `var p = o.params || {}`, zeichneRadios() nicht - als `waehle`
       das noch als Parameter nahm, waere jeder Radio-Klick auf einen
       ReferenceError gelaufen. `node --check` faellt das nicht auf: Es prueft
       Syntax, keine Namensaufloesung. */
    var p = o.params || {};

    /* ⭐ Ab hier fuehrt der Kunde die Halteranzahl selbst — siehe
       halterNachfuehren(). Ohne diese Notiz haette `zeichne()` seine Wahl
       sofort wieder ueberschrieben. */
    if (p.halterAuto) HALTER_SELBST = true;

    if (p.toggle && !o.required && zustand[o.name] === wert) {
      delete zustand[o.name];                 // nochmal geklickt = zurueckgenommen
    } else {
      zustand[o.name] = wert;
    }
    aufraeumen(); zeichne();
  }

  function zeichneKacheln(o){
    selbstwahl(o);
    var p = o.params || {};
    var gross = p.size === 'large';
    var lupe  = p.imgTooltip === true;
    /* DAS FORMAT KOMMT VOM BILD, NICHT AUS DER CONFIG.

       `shape: 'rect'` kennt nur zwei Zustaende - quadratisch oder 400/250. Die
       Montagesets sind aber 900 x 327, also 2,75:1. In beiden Rahmen blieb der
       groesste Teil der Hoehe grau, und das Bild wurde entsprechend klein: bei
       212 px Kachelbreite gerade 77 px hoch. Auf den Sets steht eine
       Stueckliste - die war so nicht zu lesen.

       Deshalb misst das erste geladene Bild der Gruppe sein eigenes Verhaeltnis
       und gibt es als CSS-Variable an das Raster weiter. Alle Kacheln der
       Gruppe folgen ihm, damit sie gleich hoch bleiben.

       Ab 2:1 gilt die Gruppe als "breit" und darf mehr Platz einnehmen - sonst
       waere eine einzeln stehende Kachel weiterhin auf 230 px gedeckelt, und
       das ist bei einem so flachen Bild die falsche Beschraenkung. */
    var raster = h('div', {
      class: 'mo-kacheln' + (gross ? ' mo-kacheln-gross' : '') +
             (p.shape === 'rect' ? ' mo-kacheln-quer' : ''),
      // ⚠️ Notbremse fuer die shopweite Bildlupe aus custom.js. Die greift ab
      // 90x90 px Anzeigegroesse — grosse Kacheln liegen darueber, und dann
      // wuerde ein Klick gleichzeitig auswaehlen UND das Vollbild oeffnen.
      'data-mo-lupe-aus': ''
    });
    (o.values||[]).forEach(function(v){
      var an = zustand[o.name] === v.value;
      /* Metafeld sticht, Config faengt auf — siehe befestigungBild() oben. */
      var vBild = themeBild(o, v) || befestigungBild(o, v) || metaBild(v) ||
                  assetBild(v.img) || v.img;
      var kinder = [];
      if(vBild) kinder.push(bildMitFormat(raster, {
        // Anzeigebreite x2,6 (Retina + Reserve). Nicht die Datei verkleinern,
        // sondern `&width=` setzen — siehe bildKlein() oben.
        /* Anzeigebreite x2 (Retina). Nicht die Datei verkleinern, sondern
           `&width=` setzen - siehe bildKlein() oben.

           Angehoben am 22.08.2026 zusammen mit den Kachelgroessen: Die Kacheln
           sind jetzt bis 300 px (gross) bzw. 230 px (klein) breit, 420/240
           waeren dort schon unter Retina. Auf den Montagesets steht Text -
           genau der wird als erstes matschig. */
        src: bildKlein(vBild, gross ? 600 : 460),
        alt: v.text || v.value,
        loading: 'lazy', decoding: 'async'
      }));
      // ⭐ Der Auswahlpunkt oben rechts — bei LPO das deutlichste Zeichen dafuer,
      // was gewaehlt ist. Reines Markup, die Darstellung macht das CSS.
      kinder.push(h('span', {class:'mo-kp' + (an ? ' mo-kp-an' : '')},
        [document.createTextNode(an ? '✓' : '')]));
      /* ⭐ Vorteils-Etikett aus `v.vorteil` — Stefan, 02.09.2026:
         „-5 € vorteile in ein ausrufe zeichen". Es sitzt UEBER dem
         Namen, damit der Blick es vor der Wahl trifft. */
      if (v.vorteil) {
        kinder.push(h('div', {class:'mo-kachel-vorteil'}, [
          h('span', {class:'mo-kachel-vorteil-zeichen'},
            [document.createTextNode('!')]),
          document.createTextNode(String(v.vorteil))
        ]));
      }
      kinder.push(h('div', {class:'mo-kachel-text'}, [document.createTextNode(v.text || v.value)]));
      // Klarname unter die Farbnummer: "RAL 7016" allein sagt einem Kunden
      // nichts, "Anthrazitgrau" schon. Kommt aus dem Bilddateinamen, nicht aus
      // einer Tabelle im Code - eine neue Farbe bringt ihren Namen selbst mit.
      var ton = klarname(v.text || v.value, v.img);
      if (ton) kinder.push(h('div', {class:'mo-kachel-ton'}, [document.createTextNode(ton)]));
      // Preisfeld immer anlegen, auch leer — nurPreisNeu() schreibt es später fort,
      // wenn sich die Maße ändern. Sonst müsste beim Tippen neu gezeichnet werden,
      // und das Maßfeld verlöre bei jedem Zeichen den Fokus.
      var preisEl = h('div', {class:'mo-kachel-preis'});
      kinder.push(preisEl);
      var knopf = h('button', {
        class:'mo-kachel' + (an ? ' mo-an' : ''), type:'button',
        onclick: function(){ waehle(o, v.value); }
      }, kinder);
      // Die grosse Fassung fuer die Hover-Lupe. Nur hinterlegen, nicht laden —
      // der Lupenblock holt sie erst beim Ueberfliegen.
      if(lupe && vBild) knopf.setAttribute('data-mo-gross', bildKlein(vBild, 900));

      /* Der Lupenknopf - wie LPOs `.cl-po--zoom-btn`. Er sitzt UNTEN LINKS,
         nicht oben rechts: dort steht schon der Auswahlpunkt.

         Warum ein eigener Knopf und nicht der Klick auf die Kachel: Die Kachel
         waehlt aus. Ein Klick, der beides tut, macht die Auswahl unbedienbar -
         genau daran ist die shopweite Bildlupe hier gescheitert.

         ⚠️ Bei LPO verdeckte die 38-px-Lupe kleine Kacheln fast vollstaendig
         ([[lpo-swatch-lupe-und-commit]]). Deshalb hier 26 px und halb
         durchscheinend, bis die Maus darueber faehrt. */
      if(vBild){
        var lupenKnopf = h('span', {
          'class': 'mo-kachel-lupe', role: 'button', tabindex: '0',
          'aria-label': 'Bild vergroessern: ' + (v.text || v.value),
          onclick: function(ev){
            ev.preventDefault(); ev.stopPropagation();   // nicht mit auswaehlen
            window.moVollbild.zeigen(bildKlein(vBild, 1600), v.text || v.value);
          },
          onkeydown: function(ev){
            if(ev.key !== 'Enter' && ev.key !== ' ') return;
            ev.preventDefault(); ev.stopPropagation();
            window.moVollbild.zeigen(bildKlein(vBild, 1600), v.text || v.value);
          }
        }, [document.createTextNode('\u2315')]);
        knopf.appendChild(lupenKnopf);
      }
      knopf.__wert = v;
      knopf.__preisEl = preisEl;
      knopf.__optParams = o.params || {};
      raster.appendChild(knopf);
    });

    /* WENIGE KACHELN BLEIBEN IN EINER REIHE.

       Ohne das entscheidet allein die Mindestbreite, wie viele Spalten
       entstehen - und bei drei Kacheln a 300 px auf 777 px Raster passen nur
       zwei nebeneinander. Die dritte stand allein in Zeile zwei, was aussieht
       wie ein Fehler und die Gruppe unnoetig hoch macht.

       Bis vier Kacheln wird die Spaltenzahl deshalb fest vorgegeben. Darueber
       nicht: Elf Farbkacheln in einer Zeile waeren 60 px breit.

       Die Variable wird nur GESETZT - ob sie greift, entscheidet das CSS.
       Auf dem Handy ueberschreibt eine Media Query sie wieder. */
    var anzahl = raster.children.length;
    if (anzahl >= 2 && anzahl <= 4) {
      raster.style.setProperty('--mo-spalten', anzahl);
    }

    /* VIELE KACHELN WERDEN KOMPAKTER.

       Die elf Farben brauchen nicht dieselbe Kachelgroesse wie die zwei
       Befestigungsarten: Eine Farbflaeche ist auf einen Blick erfasst, ein
       Montageset mit Stueckliste nicht. Bei `size: large` bekamen sie 190 px
       Mindestbreite und damit drei Reihen a 300 px Hoehe - das schob alles
       Weitere weit nach unten.

       Ab sechs Kacheln gilt deshalb LPOs Mass: 140 px Mindestbreite, was bei
       777 px Raster fuenf Spalten a 148 px ergibt. LPO selbst zeigte die
       Farben mit 157 px - am 22.08.2026 im Live-Theme gemessen. */
    if (anzahl >= 6) raster.classList.add('mo-kacheln-viele');

    /* ------------------------------------------------------------------
       AUFKLAPPER - "Weitere Farben (7)"

       Ab KACHEL_AB Werten bleiben KACHEL_SICHTBAR stehen, der Rest wartet
       hinter einem Knopf. Bei elf Farben also 4 + "Weitere Farben (7)",
       genau wie bei LPO.

       Zwei Dinge, die nicht offensichtlich sind:

       ⭐ Sitzt die AUSWAHL unter den Versteckten, geht die Liste von selbst
       auf - wer RAL 3000 gewaehlt und neu geladen hat, muss seine Farbe
       sehen und nicht einen zugeklappten Kasten.

       ⚠️ Der Knopf zeichnet NICHT neu, er nimmt nur eine Klasse weg. Ein
       `zeichne()` koennte den Fokus aus dem Massfeld reissen - genau der
       Fehler, der am 23.08.2026 aus "1000" ein "0001" gemacht hat.
       ------------------------------------------------------------------ */
    if (anzahl >= KACHEL_AB) {
      var werte = (o.values || []);
      var gewaehltIndex = -1;
      for (var wi = 0; wi < werte.length; wi++) {
        if (zustand[o.name] === werte[wi].value) { gewaehltIndex = wi; break; }
      }
      var offen = !!offeneListen[o.name] || gewaehltIndex >= KACHEL_SICHTBAR;
      var versteckt = anzahl - KACHEL_SICHTBAR;

      if (!offen) {
        for (var ki = KACHEL_SICHTBAR; ki < raster.children.length; ki++) {
          raster.children[ki].classList.add('mo-kachel-zu');
        }
      }

      /* "Farben" oder "Optionen" - die Beschriftung folgt dem Optionstyp,
         nicht einer festen Liste im Code. */
      var wort = /color/i.test(o.type || '') ? 'Farben' : 'Optionen';
      var mehr = h('button', {
        class: 'mo-mehr', type: 'button',
        'aria-expanded': offen ? 'true' : 'false',
        onclick: function (ev) {
          var knopf = ev.currentTarget;
          var auf = knopf.getAttribute('aria-expanded') !== 'true';
          offeneListen[o.name] = auf;
          [].forEach.call(raster.children, function (kind, idx) {
            if (idx >= KACHEL_SICHTBAR) kind.classList.toggle('mo-kachel-zu', !auf);
          });
          knopf.setAttribute('aria-expanded', auf ? 'true' : 'false');
          knopf.textContent = auf ? 'Weniger anzeigen' : ('Weitere ' + wort + ' (' + versteckt + ')');
        }
      }, [document.createTextNode(offen ? 'Weniger anzeigen' : ('Weitere ' + wort + ' (' + versteckt + ')'))]);

      var huelle = h('div', {class: 'mo-kacheln-huelle'}, [raster, mehr]);
      return huelle;
    }

    return raster;
  }

  function zeichneRadios(o){
    var box = h('div', {class:'mo-radios'});
    (o.values||[]).forEach(function(v){
      box.appendChild(h('button', {
        class:'mo-radio' + (zustand[o.name] === v.value ? ' mo-an' : ''), type:'button',
        onclick: function(){ waehle(o, v.value); }
      }, [document.createTextNode(v.text || v.value)]));
    });
    return box;
  }

  // ⭐ Die Massfelder folgen jetzt der Config statt fester Texte.
  // LPO liest dafuer diese params, wir haben sie bisher ignoriert:
  //   labelX/labelY   "Befestigungsabstand:" / "Hoehe:"   (wir zeigten "Breite / Abstand (mm)")
  //   addonX/addonY   "mm"  — Einheit hinter dem Feld
  //   minX/maxX/minY/maxY   Grenzen JE ACHSE (wir pruefen bisher beide gegen maxX)
  //   minXKey/maxXKey/minYKey/maxYKey   die Hinweistexte darunter
  //   numberSteps     Schrittweite der Pfeiltasten
  function zeichneAuswahl(o){
    var feld = h('select', {
      class:'mo-auswahl',
      'data-mo-feld': o.name,
      onchange: function(ev){ waehle(o, ev.target.value); }
    });
    /* Leerzeile nur bei Pflichtfeldern ohne Vorgabe - sonst stuende dort eine
       Wahl, die der Kunde nie getroffen hat. */
    if(!zustand[o.name]){
      feld.appendChild(h('option', {value:''}, [document.createTextNode(
        (o.params && o.params.placeholder) || 'Bitte wählen')]));
    }
    (o.values||[]).forEach(function(v){
      var e = h('option', {value:v.value}, [document.createTextNode(v.text || v.value)]);
      if(zustand[o.name] === v.value) e.selected = true;
      feld.appendChild(e);
    });
    return feld;
  }

  /* ⭐ number = freies Zahlenfeld mit Grenzen aus der Config.
     Es traegt bewusst die Klasse `mo-massfeld` mit: Damit sieht es aus wie die
     Maszfelder daneben und erbt deren 13 CSS-Regeln, ohne eine einzige neue.

     🔴 KEIN zeichne() beim Tippen, nur nurPreisNeu() - sonst baut sich das
     Feld unter dem Cursor neu auf und der Fokus ist nach jeder Ziffer weg.
     Dieselbe Falle wie bei den Maszfeldern. Erst beim Verlassen (change)
     wird neu gezeichnet, denn dann koennen Bedingungen umschlagen. */
  function zeichneZahl(o){
    var p = o.params || {};
    var attr = {
      type:'number', class:'mo-massfeld mo-zahlfeld', 'data-mo-feld': o.name,
      placeholder: p.placeholder || '',
      oninput: function(ev){
        var w = ev.target.value;
        if(w === '') delete zustand[o.name]; else zustand[o.name] = w;
        nurPreisNeu();
      },
      onchange: function(){ aufraeumen(); nurPreisNeu(); umbauNachFokus(zeichne); }   // 01.10.2026, siehe umbauNachFokus
    };
    if(p.min != null)        attr.min  = String(p.min);
    if(p.max != null)        attr.max  = String(p.max);
    if(p.numberStep != null) attr.step = String(p.numberStep);
    var feld = h('input', attr);
    feld.value = zustand[o.name] == null ? '' : String(zustand[o.name]);
    var zeile = h('div', {class:'mo-zahlzeile'}, [feld]);
    /* ⚠️ KEIN zweites Kaestchen mit dem Bereich. Am 31.08.2026 an der Seite
       gesehen: Die Config gibt den Bereich bereits als Platzhalter mit
       ("50 – 300"), und der steht IM Feld - er verschwindet beim Tippen.
       Ein Kaestchen daneben wiederholt dieselbe Angabe und bleibt stehen.
       Nur wenn die Config keinen Platzhalter nennt, springt es ein. */
    if(!p.placeholder && p.min != null && p.max != null){
      zeile.appendChild(h('span', {class:'mo-einheit'}, [
        document.createTextNode(p.min + ' – ' + p.max)]));
    }
    return zeile;
  }

  // ⭐ Die Massfelder folgen jetzt der Config statt fester Texte.
  // LPO liest dafuer diese params, wir haben sie bisher ignoriert:
  //   labelX/labelY   "Befestigungsabstand:" / "Hoehe:"   (wir zeigten "Breite / Abstand (mm)")
  //   addonX/addonY   "mm"  — Einheit hinter dem Feld
  //   minX/maxX/minY/maxY   Grenzen JE ACHSE (wir pruefen bisher beide gegen maxX)
  //   minXKey/maxXKey/minYKey/maxYKey   die Hinweistexte darunter
  //   numberSteps     Schrittweite der Pfeiltasten
  function schrittKnopf(zeichen, tun){
    return h('button', {
      type:'button', 'class':'mo-massfeld-knopf', tabindex:'-1',
      'aria-hidden':'true',          // reine Bedienhilfe, das Feld traegt den Wert
      onclick: tun
    }, [document.createTextNode(zeichen)]);
  }

  /* Verstellt ein Massfeld um einen Schritt und haelt sich dabei an die
     Grenzen aus der Config. Ohne die Deckelung liesse sich per Dauerklick
     ueber maxX hinausfahren - der Preis rechnete weiter, die Fehlermeldung
     erschiene erst beim Kaufversuch. */
  /* ═══ EINHEITEN-UMSCHALTER mm/cm (24.08.2026, zum Ausprobieren) ═══

     Stefan: "viele Kunden haben einen Zollstock mit cm drauf."

     🔴 GERECHNET WIRD IMMER IN MILLIMETERN. masse.x/masse.y tragen mm, und
     damit auch der Warenkorb-Eintrag und die Fertigung. cm ist ausschliesslich
     Anzeige - beim Tippen wird sofort zurueckgerechnet.

     ⚠️ Die Gefahr dabei: Wer auf cm steht und aus Gewohnheit "1100" tippt,
     meint 1100 mm, bekaeme aber 11000 mm. Das faengt die Grenzpruefung ab
     (max 2200), aber nur, WEIL die Grenzen gesetzt sind. Eine Config ohne
     minX/maxX haette diesen Schutz nicht.

     ZUM ABSCHALTEN: MO_EINHEIT_UMSCHALTER auf false. Dann ist alles wie
     vorher, in mm, und der Schalter erscheint nicht. */
  var MO_EINHEIT_UMSCHALTER = true;

  var moEinheit = 'mm';
  try {
    if (localStorage.getItem('mo-einheit') === 'cm') moEinheit = 'cm';
  } catch(e){}

  function moTeiler(){
    return (MO_EINHEIT_UMSCHALTER && moEinheit === 'cm') ? 10 : 1;
  }

  /* 🔴 31.08.2026: JEDE Massangabe folgt der gewaehlten Einheit.

     Stefan mit Screenshot: In der Skizze stand "Befestigungsabstand: 120 cm",
     in der Preisaufstellung darunter "Stange nach Mass: 1200 mm". Zwei
     Einheiten auf einer Seite.

     Die Schritt-Zusammenfassung machte es laengst richtig - der Kommentar
     dort sagt sogar warum. Vier andere Stellen standen fest auf mm:
     die Preisaufstellung und drei Fehlermeldungen. Letztere sind der
     Stolperstein aus der CLAUDE.md: "hoechstens 500 mm" bei eingetippten 500.

     ⚠️ NUR ANZEIGE. Der Warenkorb bekommt die Masse getrennt ueber
     `properties['_Masse_x']` und traegt weiterhin Millimeter - die Fertigung
     sieht unveraendert mm. */
  function moEinheitText(){
    return moTeiler() === 10 ? ' cm' : ' mm';
  }
  function moMitEinheit(mm){
    var a = moAnzeige(mm);
    return a === '' ? '' : a + moEinheitText();
  }
  // mm -> Anzeige. In cm sind Nachkommastellen noetig (1105 mm = 110,5 cm),
  // deshalb hier NICHT runden.
  function moAnzeige(mm){
    if(mm === '' || mm == null) return '';
    var z = parseFloat(String(mm).replace(',', '.'));
    if(!isFinite(z)) return '';
    return moTeiler() === 1 ? String(Math.round(z)) : String(z / 10);
  }
  // Anzeige -> mm. Immer auf ganze Millimeter runden, feiner wird nicht gefertigt.
  function moNachMm(wert){
    if(wert === '' || wert == null) return '';
    var z = parseFloat(String(wert).replace(',', '.'));
    if(!isFinite(z)) return '';
    return String(Math.round(z * moTeiler()));
  }
  // Grenzwerte fuer die Anzeige umrechnen
  function moGrenze(v){
    var z = parseFloat(v);
    if(!isFinite(z)) return v;
    return moTeiler() === 1 ? z : z / 10;
  }

  function stellen(a, feld, um){
    var jetzt = parseFloat(String(masse[a.feld]).replace(',', '.'));
    if(!isFinite(jetzt)) jetzt = parseFloat(a.min) || 0;
    var neu = jetzt + um;
    var min = parseFloat(a.min), max = parseFloat(a.max);
    if(isFinite(min) && neu < min) neu = min;
    if(isFinite(max) && neu > max) neu = max;
    masse[a.feld] = String(Math.round(neu));
    // Das Feld zeigt die gewaehlte Einheit, masse[] bleibt in mm.
    feld.value = moAnzeige(masse[a.feld]);
    // Auch hier verzoegert: Wer mehrfach auf + tippt, soll nicht nach jedem
    // Klick ein neu gebautes Formular unter dem Finger haben.
    nurPreisNeu(); koepfeNachziehen();
    massUmbauSpaeter();
  }

  /* Die Massempfehlung - aus dem info-Text der Option, nicht aus dem Code.

     \U0001F534 AUSSENWAND UND LAIBUNG BRAUCHEN VERSCHIEDENE TEXTE.
     Aussen wird ZUGERECHNET (Fensterbreite + 140 mm, rund 70 je Seite), in der
     Laibung wird ABGEZOGEN (lichtes Mass minus 5-10 mm). Wer beides mit einem
     Satz abdeckt, schickt die Haelfte der Kunden mit dem falschen Mass los.

     Der info-Text traegt beide Faelle als `.mo-t-aussen` und `.mo-t-laibung`,
     darin je ein `.mo-t-tipp`. Genau dieselbe Quelle nutzt der Erklaerkasten -
     eine zweite Stelle fuer dieselbe Zahl laeuft frueher oder spaeter
     auseinander.

     \u26a0\ufe0f DER ZUSCHLAG IST JE BAUART VERSCHIEDEN: Fenstergitter 140/70 mm,
     Franzoesischer Balkon 160/80 mm. Am 23.08.2026 war genau das der Fehler -
     die Texte kamen aus der Balkon-Config, und in der Laibung stand woertlich
     "damit der Balkon in die Oeffnung passt". Deshalb NIE einen dieser Texte
     von Hand hierher kopieren.

     \u26a0\ufe0f Das Beispiel (`.mo-t-beispiel`) bleibt dem Erklaerkasten vorbehalten -
     unter dem Feld ist Platz fuer eine Zeile, nicht fuer einen Absatz. */
  /* ⭐ 31.08.2026: EINE Stelle entscheidet ueber die Befestigungsart.

     Vorher stand der Vergleich nur hier - der Erklaerkasten verliess sich
     stattdessen auf eine CSS-Klasse, die niemand mehr setzt. Ergebnis: unter
     dem Feld stand "lichtes Mass minus 5-10 mm", im Kasten "Fensterbreite +
     140 mm". Zwei Anweisungen auf derselben Seite, eine davon falsch.

     Jetzt lesen beide dieselbe Funktion. Sie koennen nicht mehr
     auseinanderlaufen - genau das, was der Kommentar oben seit jeher
     verlangt. */
  function istLaibung(){
    return window.moBefestigungsArt(zustand) === 'In der Laibung';
  }

  /* 🔴 31.08.2026: DER INFO-TEXT LIEGT NICHT IMMER AM SELBEN ORT.

     Beim verzinkten Gitter steht er auf der Option selbst - neben `name`,
     `label` und `type`. Beim Edelstahl-Gitter steht er eine Ebene tiefer in
     `params`, zwischen `addonX`, `maxX` und `priceFormula`.

     Weil hier nur `o.info` gelesen wurde, hatte das Edelstahl-Gitter WEDER
     den "i"-Knopf NOCH die Empfehlungszeile unter dem Feld - beide haengen
     an dieser einen Quelle. Gemessen: 0 von 3 Info-Knoepfen, und eine
     127-px-Luecke in der linken Spalte, wo beim verzinkten Gitter der
     Empfehlungskasten (448 x 77 px) steht.

     Der Text war die ganze Zeit da: 2.539 Zeichen mit beiden Lage-Bloecken.
     Er wurde nur nie gefunden.

     ⚠️ Nicht die Config angleichen, sondern hier beide Orte lesen: Die
     Configs stammen aus verschiedenen Baujahren, und eine davon umzubauen
     hiesse, jede kuenftige ebenfalls anzufassen. */
  function infoText(o){
    if (!o) return '';
    return o.info || (o.params && o.params.info) || '';
  }

  function empfehlung(o){
    var quelle = infoText(o);
    if(!quelle) return '';
    var laibung = istLaibung();

    // Der info-Text ist HTML aus unserer eigenen Config. Er wird in ein
    // losgeloestes Element geparst - nichts davon landet dabei im Dokument.
    var hilf = document.createElement('div');
    hilf.innerHTML = quelle;
    var bereich = hilf.querySelector(laibung ? '.mo-t-laibung' : '.mo-t-aussen');
    if(!bereich) return '';
    var tipp = bereich.querySelector('.mo-t-tipp');
    if(!tipp) return '';

    var beispiel = tipp.querySelector('.mo-t-beispiel');
    if(beispiel) beispiel.remove();

    /* Mobil ist "Empfohlener Befestigungsabstand:" allein zwei Zeilen lang.
       GEKUERZT WIRD NUR DAS LABEL, NIE DIE ZAHL - die kommt weiterhin
       ausschliesslich aus der Config. Der Kasten steht direkt unter dem
       gleichnamigen Feld, der Bezug ist also ohnehin da. */
    if(window.matchMedia && window.matchMedia('(max-width: 749px)').matches){
      var kopf = tipp.querySelector('strong');
      if(kopf && /^Empfohlener\s+Befestigungsabstand:?$/.test(kopf.textContent.trim())){
        kopf.textContent = 'Empfehlung:';
      }
    }
    return tipp.innerHTML.replace(/<br\s*\/?>\s*$/i, '').trim();
  }

  /* FESTE MASSE ALS AUSWAHL statt Zahlenfeld.

     25.08.2026, Stefans Vorgabe fuer die franzoesischen Balkone: Die Hoehe
     gibt es dort nur in 950 / 1000 / 1050 / 1100 mm - ein freies Zahlenfeld
     laedt zu Massen ein, die wir gar nicht bauen. LPO hatte an dieser Stelle
     ein Dropdown.

     Geschaltet wird es allein ueber die Config: steht dort `werteY` (oder
     `werteX`) mit einer Liste, wird ein <select> gezeichnet, sonst bleibt
     alles wie bisher. Damit aendert sich fuer Fenstergitter, Tore und
     Handlaeufe nichts.

     Der Wert bleibt in mm in `masse[]` - Preis, Skizze und Beschriftung
     rechnen unveraendert weiter. Nur die Beschriftung der Eintraege folgt
     dem mm/cm-Umschalter. */
  function wahlFeld(a, werte){
    /* VORBELEGT MIT DEM KLEINSTEN MASS.

       25.08.2026, Stefan: "950 vorauswählen". Ein leerer Eintrag "bitte
       wählen" ist bei vier festen Werten unnoetig - er zwingt zu einem
       Klick, der nichts entscheidet, und laesst Preis und Skizze so lange
       auf "… mm" stehen. Vorbelegt zeigt die Skizze sofort ein echtes Mass.

       Nur setzen, wenn noch nichts gewaehlt ist: `zeichne()` laeuft bei
       jeder Aenderung erneut, eine Vorbelegung ohne diese Pruefung wuerde
       die Wahl des Kunden bei jedem Neuzeichnen zurueckwerfen. */
    /* 🔴 EIN WERT AUSSERHALB DER LISTE MUSS EINRASTEN.

       Steht in `masse[]` eine Zahl, die es im Dropdown nicht gibt (aus einer
       aelteren Konfiguration, einem Warenkorb-Link oder weil das Feld frueher
       frei war), zeigt das <select> gar nichts an — `selectedIndex` ist -1 —
       waehrend intern weiter mit dem alten Wert gerechnet wird. Am 25.08.2026
       nachgestellt: 860 gesetzt, Feld leer, Preis rechnete mit 860.

       Deshalb: fremde Werte auf den naechstgelegenen erlaubten ziehen. */
    var jetzt = parseFloat(String(masse[a.feld]).replace(',', '.'));
    if(!isFinite(jetzt) || jetzt <= 0){
      masse[a.feld] = String(werte[0]);
    } else if(werte.indexOf(jetzt) < 0 && werte.map(String).indexOf(String(jetzt)) < 0){
      var naechster = werte[0], abstand = Math.abs(jetzt - werte[0]);
      werte.forEach(function(w){
        var d = Math.abs(jetzt - w);
        if(d < abstand){ abstand = d; naechster = w; }
      });
      masse[a.feld] = String(naechster);
    }

    var feld = h('select', {
      'class':'mo-massfeld mo-massfeld-wahl', 'data-achse': a.feld,
      onchange: function(ev){
        masse[a.feld] = ev.target.value;
        nurPreisNeu(); koepfeNachziehen();
        // Kein Debounce noetig: eine Auswahl ist EIN Ereignis, kein Tippen.
        neuZeichnenWennNoetig();
      }
    }, []);
    werte.forEach(function(w){
      var op = h('option', {value:String(w)},
        [document.createTextNode(moAnzeige(w) + ' ' + moEinheit)]);
      if(String(masse[a.feld]) === String(w)) op.selected = true;
      feld.appendChild(op);
    });
    return feld;
  }

  function zeichneMasse(o){
    var p = o.params || {};
    var achsen = [
      /* 🔴 31.08.2026: DAS LABEL FOLGT DER BEFESTIGUNGSART.
         In der Laibung sitzt das Gitter ZWISCHEN den Wangen - das Mass ist
         dort kleiner als die Oeffnung (lichtes Mass minus 5-10 mm) und heisst
         nicht "Befestigungsabstand". Bisher stand in beiden Arten derselbe
         Text, waehrend die Empfehlungszeile darunter schon richtig rechnete:
         zwei widersprechende Angaben auf derselben Seite.
         `labelXLaibung` ist optional - fehlt es, bleibt alles wie bisher. */
      { feld:'x',
        label: (window.moBefestigungsArt(zustand) === 'In der Laibung' &&
                p.labelXLaibung) || p.labelX || 'Breite',
        einheit: p.addonX || '',
        min: p.minX, max: p.maxX, hinweise: [p.minXKey, p.maxXKey] },
      { feld:'y', label: p.labelY || 'Höhe',  einheit: p.addonY || '',
        min: p.minY, max: p.maxY, hinweise: [p.minYKey, p.maxYKey] }
    ];

    /* ⭐ `onlyX` aus der Config: das Bauteil hat NUR EIN Mass.

       Eine Fensterstange (Nova 30/31) hat einen Befestigungsabstand und sonst
       nichts; ein Wandhandlauf hat eine Laenge. Bis 26.08.2026 wertete der
       Eigenbau die Eigenschaft nicht aus - beide Konfiguratoren zeigten
       deshalb ZWEI Massfelder und verlangten eine Hoehe, die es nicht gibt.

       Die Eigenschaft wirkt an fuenf Stellen; hier faellt das Feld weg, in
       massPreis() der y-Zwang, in wasFehlt() die Pflichtpruefung, in der
       Preiszeile das „× —“ und in der Skizze die Hoehenmasslinie. */
    if (p.onlyX) achsen = achsen.slice(0, 1);

    var box = h('div', {class:'mo-masse'});

    /* SCHRITTWEITE: `numberSteps` ist ein SCHALTER, keine Zahl.

       Bisher stand `step: p.numberSteps` im Feld - das schrieb `step="true"`
       hinein, was ungueltig ist und vom Browser verworfen wird. In LPO schaltet
       die Angabe die Minus-/Plus-Tasten ein; die Schrittweite hiesse
       `numberStep` und steht in keiner unserer Configs.

       10 mm ist das sinnvolle Mass fuer Fenstergitter: 1 mm braucht bei 2200 mm
       Spanne zu viele Klicks, 50 mm trifft kein Aufmass. */
    var schritt = parseFloat(p.numberStep) || 10;

    achsen.forEach(function(a){
      /* DER PLATZHALTER DARF NICHT WIE EINE EINGABE AUSSEHEN.

         Aus der Config kommt "300 - 2200". Das steht im leeren Feld wie ein
         eingetragener Wert - und wiederholt dazu die Grenzen, die seit dem
         22.08. eine Zeile tiefer ohnehin dastehen.

         Stattdessen ein Beispielmass aus der Mitte des zulaessigen Bereichs,
         auf 100 gerundet: "z. B. 1200". Das ist als Vorschlag zu erkennen und
         zeigt gleich, in welcher Groessenordnung gedacht wird.

         Der Config-Platzhalter bleibt der Rueckfall - fehlen die Grenzen,
         gibt es nichts zu rechnen. */
      var beispiel = (function(){
        var von = parseFloat(a.min), bis = parseFloat(a.max);
        if(!isFinite(von) || !isFinite(bis)) return p.placeholder || '';
        return 'z. B. ' + moGrenze(Math.round((von + bis) / 2 / 100) * 100);
      })();

      // Liste aus der Config? Dann Auswahl statt freier Eingabe.
      var festeWerte = p['werte' + a.feld.toUpperCase()];
      if(!Array.isArray(festeWerte) || !festeWerte.length) festeWerte = null;

      var eingabe = festeWerte ? wahlFeld(a, festeWerte) : h('input', {
        type:'number', 'class':'mo-massfeld', 'data-achse': a.feld,
        value: moAnzeige(masse[a.feld]), placeholder:beispiel,
        min: moGrenze(a.min || '0'), max: a.max ? moGrenze(a.max) : '',
        step: schritt / moTeiler(),
        // Erst pruefen, ob die Eingabe eine Option ein- oder ausblendet. Nur
        // dann neu zeichnen - sonst genuegt der Preis.
        onblur: function(){
          // Feld verlassen - jetzt darf umgebaut werden.
          if (umbauUhr) { clearTimeout(umbauUhr); umbauUhr = null; }
          /* 🔴 01.10.2026: NICHT sofort umbauen. Wer von der Breite direkt auf die
             Hoehe tippt, loest dieses blur aus, waehrend der Finger noch auf dem
             Hoehenfeld liegt. Ein Umbau jetzt ersetzt das Feld unter dem Finger -
             der Fokus fiel auf <body>, mobil ging die Tastatur zu, die Hoehe kam nie
             an (Stefan, Handtest Atlas 38; nachgestellt mit alle_artikel.mjs). */
          /* Der ZUSTAND wird sofort bereinigt (Vorauswahl ab Schwellen, z. B. Laschen
             ab 1400 mm) - tippt der Kunde direkt auf den Kaufknopf, gilt er schon.
             Nur der Umbau des Formulars wartet. */
          aufraeumen(); nurPreisNeu(); koepfeNachziehen();
          umbauNachFokus(neuZeichnenWennNoetig);
        },
        oninput: function(ev){
          // 🔴 Zurueck nach mm, BEVOR gerechnet wird.
          masse[a.feld] = moNachMm(ev.target.value);
          /* 🔴 NIE MITTEN IM TIPPEN NEU ZEICHNEN.

             Vorher lief `neuZeichnenWennNoetig()` bei JEDEM Zeichen. Sobald
             es einmal ansprang, baute `zeichne()` das Feld neu - und der Fokus
             war weg. Am 23.08.2026 mit echten Tastendruecken nachgestellt:
             "1", "0", "0" getippt, Feld danach LEER, Fokus auf dem Seitenrumpf.
             Die zweite und dritte Ziffer landeten nirgends.

             Das Neuzeichnen wartet jetzt, bis der Kunde eine halbe Sekunde
             nicht getippt hat. Der Preis laeuft unverzoegert mit - nur der
             Umbau des Formulars wartet. */
          nurPreisNeu();
          massUmbauSpaeter();
        }
      });

      // Die Einheit steht als eigenes Element neben dem Feld, nicht im Label —
      // so bleibt sie beim Tippen sichtbar.
      var feldzeile = h('div', {class:'mo-masse-feld'}, []);

      /* Minus und Plus wie bei LPO. Sie rahmen das Feld links und rechts ein.
         Auf dem Handy sind sie der eigentliche Nutzen - dort ist die
         Zahlentastatur umstaendlicher als zwei Tipper. */
      if(p.numberSteps && !festeWerte){
        feldzeile.appendChild(schrittKnopf('\u2212', function(){
          stellen(a, eingabe, -schritt);
        }));
      }
      feldzeile.appendChild(eingabe);
      if(p.numberSteps && !festeWerte){
        feldzeile.appendChild(schrittKnopf('+', function(){
          stellen(a, eingabe, schritt);
        }));
      }
      box.appendChild(h('div', {}, [
        h('label', {}, [document.createTextNode((a.label||'').replace(/:$/, ''))]),
        feldzeile
      ]));
    });
    var wrap = h('div', {}, [box]);

    /* Der Umschalter sitzt UEBER den Feldern, damit die Einheit gelesen wird,
       bevor jemand tippt. Die Wahl bleibt ueber localStorage erhalten - wer in
       cm denkt, denkt auch beim naechsten Gitter so. */
    if(MO_EINHEIT_UMSCHALTER){
      // Aussehen einmalig einhaengen, Marker gegen Mehrfachanlage.
      if(!document.getElementById('mo-einheit-stil')){
        var stil = document.createElement('style');
        stil.id = 'mo-einheit-stil';
        stil.textContent =
          '.mo-einheit-wahl{display:flex;align-items:center;gap:6px;margin:0 0 10px}' +
          '.mo-einheit-text{font-size:13px;color:#5a6472;margin-right:2px}' +
          '.mo-einheit-knopf{min-width:44px;min-height:32px;padding:4px 12px;' +
            'border:1px solid #c9d2dd;background:#fff;border-radius:6px;' +
            'font:inherit;font-size:13px;color:#2f3a45;cursor:pointer;' +
            'line-height:1.2}' +
          '.mo-einheit-knopf:hover{border-color:#8c99a8}' +
          // Aktiver Knopf in #cb4f0a statt #ea5b0b (03.09.2026): Weiss auf
          // #ea5b0b hat 3,5:1, bei 13 px verlangt WCAG AA 4,5:1 - gemessen
          // am "mm"-Knopf bei 375 px. #cb4f0a (4,50:1) ist ohnehin die
          // Aktiv-Farbe des Konfigurators: .mo-kp-an, .mo-haken-an,
          // .mo-sl-punkt-an in mo-konfigurator.css tragen dieselbe.
          '.mo-einheit-knopf.mo-an{background:#cb4f0a;border-color:#cb4f0a;' +
            'color:#fff;font-weight:600}';
        document.head.appendChild(stil);
      }
      var wahl = h('div', {'class':'mo-einheit-wahl'}, [
        h('span', {'class':'mo-einheit-text'}, [document.createTextNode('Maßeinheit:')])
      ]);
      ['mm','cm'].forEach(function(e){
        wahl.appendChild(h('button', {
          type:'button',
          'class':'mo-einheit-knopf' + (moEinheit === e ? ' mo-an' : ''),
          'aria-pressed': moEinheit === e ? 'true' : 'false',
          onclick: function(){
            if(moEinheit === e) return;
            moEinheit = e;
            try { localStorage.setItem('mo-einheit', e); } catch(err){}
            // Neu zeichnen ist hier richtig: Feldwerte, Grenzen, Schrittweite
            // UND die Hinweiszeile aendern sich gemeinsam.
            zeichne();
          }
        }, [document.createTextNode(e)]));
      });
      wrap.insertBefore(wahl, wrap.firstChild);
    }

    /* Die Grenzen als EINE Zeile je Achse.

       Die Config fuehrt vier einzelne Hinweise (minXKey, maxXKey, minYKey,
       maxYKey), und jeder traegt den vollen Namen. Aneinandergereiht stand da:

         "Befestigungsabstand mind. 300mm · Befestigungsabstand max. 2200mm ·
          Höhe mind. 300mm · Höhe max. 2200mm"

       Zweimal derselbe Name je Achse, vier Angaben fuer zwei Zahlenpaare.
       Zusammengefasst: "Befestigungsabstand 300–2200 mm · Höhe 300–2200 mm".

       Die Config-Texte bleiben der Rueckfall: Fehlen die Zahlen (min/max nicht
       gesetzt), werden sie wie bisher aneinandergereiht - lieber die alte
       Doppelung als gar kein Hinweis. */
    var teile = [];
    achsen.forEach(function(a){
      var von = parseFloat(a.min), bis = parseFloat(a.max);
      if(isFinite(von) && isFinite(bis)){
        teile.push((a.label||a.feld).replace(/:$/, '') + ' ' +
                   moGrenze(von) + '–' + moGrenze(bis) + ' ' +
                   (moTeiler() === 10 ? 'cm' : (a.einheit || 'mm')));
      } else {
        a.hinweise.forEach(function(t){ if(t) teile.push(t); });
      }
    });
    if(teile.length){
      wrap.appendChild(h('div', {class:'mo-hinweis'},
        [document.createTextNode(teile.join(' · '))]));
    }

    var rat = empfehlung(o);
    if(rat){
      var kasten = h('div', {class:'mo-empfehlung'}, []);
      kasten.innerHTML = rat;
      wrap.appendChild(kasten);
    }

    /* ⭐ HINWEISE, DIE ERST AB EINEM MASS GELTEN  (26.08.2026)

       `params.hinweisAb` ist eine Liste [{ab: 1900, text: "<strong>…"}].
       Beim Wandhandlauf steht dort die Teilung: Ueber 1.900 mm wird das Paket
       mit den 10 cm Verpackungszuschlag laenger als 2,00 m, und darueber
       schliesst GLS die Befoerderung aus (Angebot S. 15, 60 EUR Aufwands-
       pauschale). Der Kunde kann daran nichts aendern — deshalb ein HINWEIS
       und keine Auswahl. Belegt in Produkte_V4_BETA.xlsx, Blatt
       „Versandkosten GLS" Zeilen 71/72/79/80.

       Der Text ist HTML aus unserer eigenen Config, wie schon bei `info`. */
    var abListe = (o.params && o.params.hinweisAb) || [];
    if (abListe.length) {
      var xJetzt = parseFloat(masse.x) || 0;
      abListe.forEach(function (hw) {
        if (!hw || !hw.text) return;
        if (!(xJetzt >= (parseFloat(hw.ab) || 0))) return;

        /* ⭐ `{teile}` im Text wird durch die STUECKZAHL ersetzt (26.08.2026).

           Stefan: „Handläufe bei 5000mm 3 Teile.“ Gerechnet wie in der
           Preisliste (Blatt Versandkosten GLS, Zeile 71):

               Teile = AUFRUNDEN(Laenge / Stuecklaenge)

           Bei 1.900 mm Stuecklaenge: 1.900 -> 1 Teil, 3.800 -> 2, 5.000 -> 3,
           6.000 -> 4. ⚠️ Genau 1.900 ergibt NOCH KEINE Teilung — deshalb
           steht `ab` in der Config auf 1901. */
        var text = hw.text;
        if (text.indexOf('{teile}') > -1) {
          var stueck = parseFloat(hw.stueck) || 1900;
          var teile = Math.max(1, Math.ceil(xJetzt / stueck));
          text = text.replace(/\{teile\}/g, String(teile));
        }

        var k = h('div', {class:'mo-empfehlung mo-hinweis-ab'}, []);
        k.innerHTML = text;
        wrap.appendChild(k);
      });
    }

    // 🔴 Grenzen JE ACHSE pruefen. Vorher lief die Hoehe gegen maxX — bei
    // unterschiedlichen Grenzen (Config hat minY 300, maxY 2200) haette das
    // falsch gemeldet oder gar nicht.
    var fehler = [];
    achsen.forEach(function(a){
      var wert = parseFloat(masse[a.feld]);
      if(!masse[a.feld]) return;
      if(!(wert > 0)) { fehler.push((a.label||a.feld) + ': bitte eine Zahl eingeben.'); return; }
      /* ⚠️ `a.einheit` kommt aus der Config (`addonX`) und steht dort fest auf
         "mm". Bei cm-Anzeige gaebe das "hoechstens 2500 mm", waehrend im Feld
         250 steht - liest sich wie ein Rechenfehler. Grenze und Einheit
         zusammen umrechnen. */
      if(a.min && wert < a.min) fehler.push((a.label||a.feld).replace(/:$/,'') + ' mindestens ' + moMitEinheit(a.min));
      if(a.max && wert > a.max) fehler.push((a.label||a.feld).replace(/:$/,'') + ' höchstens ' + moMitEinheit(a.max));
    });
    if(fehler.length){
      wrap.appendChild(h('div', {class:'mo-fehler'}, [document.createTextNode(fehler.join(' · '))]));
    }
    return wrap;
  }

  // ⭐ Anzahl mit − / + wie bei LPO. Der Typ `quantity` steht in der Config,
  // wurde bisher aber uebersprungen — deshalb fehlte das Feld ganz.
  function zeichneMenge(o){
    var zeigen = function(){
      var f = document.getElementById('mo-menge');
      if (f) f.value = String(menge);
    };
    var minus = h('button', {class:'mo-menge-knopf', type:'button', 'aria-label':'weniger',
      onclick: function(){ if(menge > 1){ menge--; zeigen(); nurPreisNeu(); } }}, [document.createTextNode('−')]);
    var feld = h('input', {id:'mo-menge', class:'mo-menge-feld', type:'number', min:'1', value:String(menge),
      oninput: function(ev){ var v = parseInt(ev.target.value, 10); menge = (v > 0) ? v : 1; nurPreisNeu(); }});
    var plus = h('button', {class:'mo-menge-knopf', type:'button', 'aria-label':'mehr',
      onclick: function(){ menge++; zeigen(); nurPreisNeu(); }}, [document.createTextNode('+')]);
    return h('div', {class:'mo-menge'}, [minus, feld, plus]);
  }

  // ⭐ Datei-Upload wie LPOs "Skizze hochladen (optional)".
  // 🔴 Die Datei geht NICHT ueber /cart/add.js mit — Shopify nimmt Dateien nur
  // ueber ein echtes Formular an. Bis der Kaufweg darauf umgestellt ist, merken
  // wir uns nur den Dateinamen als Warenkorb-Eigenschaft, damit die Bestellung
  // wenigstens den Hinweis traegt.
  function zeichneUpload(o){
    var feld = h('input', {type:'file', id:'mo-datei', class:'mo-datei',
      accept:(o.params && o.params.accept) || 'image/*,.pdf',
      onchange: function(ev){
        var f = ev.target.files && ev.target.files[0];
        skizze = f ? f.name : '';
        /* \U0001F534 DIE DATEI SELBST MERKEN, NICHT NUR DEN NAMEN.
           Bis zum 23.08.2026 stand in der Bestellung "Skizze: grundriss.pdf",
           und die Datei lag nirgends. Wer danach suchte, fand nichts. */
        skizzeDatei = f || null;

        /* Shopify nimmt Dateien bis 20 MB an. Darueber antwortet /cart/add.js
           mit einem Fehler, den der Kunde erst nach dem Kaufklick saehe -
           deshalb schon hier pruefen. */
        if (f && f.size > 20 * 1024 * 1024) {
          skizze = ''; skizzeDatei = null;
          ev.target.value = '';
          var w = document.getElementById('mo-datei-text');
          if (w) w.textContent = 'Datei zu gro\u00df (max. 20 MB) \u2014 bitte kleiner w\u00e4hlen';
          return;
        }

        var t = document.getElementById('mo-datei-text');
        if (t) t.textContent = f ? f.name : 'Datei auswählen oder hierher ziehen';
        nurPreisNeu();
      }});
    var text = h('span', {id:'mo-datei-text'}, [document.createTextNode('Datei auswählen oder hierher ziehen')]);
    var flaeche = h('label', {class:'mo-datei-flaeche', for:'mo-datei'}, [text]);
    return h('div', {}, [feld, flaeche]);
  }

  /* Das Info-Zeichen neben einer Beschriftung. Klick oeffnet den Erklaertext.

     ⚠️ DER TEXT IST HTML UND BRINGT SEINE EIGENEN FARBEN MIT.
     Die drei info-Texte stammen aus LPOs Auslieferung und sind auf deren
     dunklen Tooltip gerechnet: `color:#ffffff`, teils `background:#000`. Auf
     hellem Grund waere weiss auf weiss. Deshalb ist der Kasten hier ebenfalls
     dunkel - nicht aus Geschmack, sondern weil die Texte es voraussetzen.

     Warum innerHTML vertretbar ist: Die Quelle ist unsere eigene Config im
     Theme-Asset-Ordner, kein Kunden- oder Fremdinhalt. Wer sie aendern kann,
     kann ohnehin das Theme aendern.

     Warum Klick und nicht Ueberfliegen: Der Masstext ist 2.494 Zeichen lang und
     traegt ein Bild - das laesst sich nicht im Vorbeifahren lesen, und auf dem
     Handy gibt es kein Ueberfliegen. */
  function infoKnopf(html, titel){
    var knopf = h('button', {
      type: 'button', class: 'mo-info',
      'aria-label': 'Hinweise zu ' + titel,
      onclick: function(ev){
        ev.preventDefault(); ev.stopPropagation();   // nicht den Schritt zuklappen
        infoZeigen(html, titel);
      }
    }, [document.createTextNode('i')]);
    return knopf;
  }

  var infoKasten = null;
  function infoZeigen(html, titel){
    if(!infoKasten){
      infoKasten = h('div', {class:'mo-info-schicht', onclick: function(ev){
        // Klick auf den Grund schliesst - Klick in den Kasten nicht.
        if(ev.target === infoKasten) infoKasten.classList.remove('mo-info-an');
      }}, []);
      document.body.appendChild(infoKasten);
      document.addEventListener('keydown', function(ev){
        if(ev.key === 'Escape' && infoKasten) infoKasten.classList.remove('mo-info-an');
      });
    }
    infoKasten.textContent = '';
    var kasten = h('div', {class:'mo-info-kasten'}, [
      h('button', {type:'button', class:'mo-info-zu', 'aria-label':'Schliessen',
        onclick: function(){ infoKasten.classList.remove('mo-info-an'); }},
        [document.createTextNode('×')])
    ]);
    var inhalt = h('div', {class:'mo-info-text'}, []);
    inhalt.innerHTML = html;

    /* 🔴 31.08.2026: DER ERKLAERKASTEN MUSS DER BEFESTIGUNGSART FOLGEN.

       Stefan an FG 01, Befestigung "In der Laibung": Der Kasten zeigte
       "Fensterbreite + 140 mm" - den AUSSENWAND-Text. Bei beiden Arten
       gemessen: `.mo-t-aussen` stand immer auf `display:block`,
       `.mo-t-laibung` immer auf `none`.

       Umgeschaltet wurde per CSS in `custom.css` ueber `html.mo-bef-laibung`.
       Diese Klasse setzt NIEMAND mehr - sie kam aus LPO, und LPO ist aus.
       Gemessen: <html class="js mo-konfigurator-aktiv">; in dieser Datei
       kommt der Name 0-mal vor.

       Was der Kunde in der Laibung las: +140 mm statt lichtes Mass minus
       5-10 mm. Bei 1000 mm Fenster 145-150 mm zu breit - das Gitter passt
       nicht in die Oeffnung, und bei Massanfertigung gibt es kein
       Widerrufsrecht.

       ⭐ ENTFERNEN statt verstecken: Bliebe der falsche Block im DOM,
       haenge die Anzeige weiter an `custom.css`. Und der richtige bekommt
       sein `display` INLINE - die Grundregel
       `.mass-tooltip .mo-t-laibung{display:none}` wuerde ihn sonst weiter
       ausblenden und der Kasten waere LEER. Verstecken gehoert nie allein in
       eine externe Datei; dasselbe hatten wir beim Vollbild.

       ⚠️ Nur wenn BEIDE Bloecke da sind. Farbauswahl und
       Befestigungsmittel tragen keine - dort bleibt der Text unveraendert. */
    var aussenBlock  = inhalt.querySelector('.mo-t-aussen');
    var laibungBlock = inhalt.querySelector('.mo-t-laibung');
    if (aussenBlock && laibungBlock) {
      var inLaibung = istLaibung();
      var wegDamit  = inLaibung ? aussenBlock : laibungBlock;
      var bleibtDa  = inLaibung ? laibungBlock : aussenBlock;
      wegDamit.remove();
      bleibtDa.style.display = 'block';
    }

    /* 🔴 LPOS EIGENEN SCHLIESSER AUS DEM HTML WERFEN.

       Der info-Text bringt `<button class="mo-t-close">` mit - LPOs Tooltip
       hatte einen eigenen. Am 23.08.2026 gemessen: Er landet mit 44x44 px
       genau ueber unserem (34x34) und faengt jeden echten Klick ab.
       `elementFromPoint` auf die Mitte unseres Knopfes lieferte `mo-t-close`.

       Sein Handler schliesst LPOs Tooltip, nicht unseren Kasten - der Kunde
       haette auf ein totes Kreuz geklickt. Dass mein Test trotzdem gruen war,
       lag nur daran, dass er `zu.click()` direkt aufrief statt auf die
       Bildschirmstelle zu zielen.

       ⚠️ MERKSATZ: Fremdes HTML bringt fremde Bedienelemente mit. Beim
       Einbetten pruefen, was da an Knoepfen mitkommt - nicht nur, wie der
       Text aussieht. */
    var fremdeSchliesser = inhalt.querySelectorAll('.mo-t-close, .cl-po--tooltip-close');
    for (var f = 0; f < fremdeSchliesser.length; f++) fremdeSchliesser[f].remove();

    kasten.appendChild(inhalt);

    /* Die Aufmasszeichnung dazu - aber nur, wo es eine gibt.

       \u2b50 SIE WIRD AUS DEM DOM GEHOLT, nicht neu ermittelt. Die Skizze steht
       ohnehin im selben Schritt, ihre Adresse ist also schon aufgeloest: mit
       Metafeld-Vorrang, richtiger Befestigungsart und passender Breite. Sie
       hier ein zweites Mal zu bestimmen hiesse, dieselbe Kette zu doppeln -
       und beim naechsten Umbau laufen die zwei Stellen auseinander.

       Der Browser laedt das Bild nicht erneut: Es ist dieselbe Adresse, die
       zwei Zentimeter weiter rechts schon haengt.

       \u26a0\ufe0f Nur die MASSE-Option hat eine Skizze. Bei Spitzenform oder
       Farbauswahl findet die Suche nichts und der Kasten bleibt reiner Text -
       genau richtig, dort gibt es nichts zu zeigen. */
    /* 🔴 27.08.2026: DIE MASSLINIEN MUESSEN MIT.

       Stefan: „wenn ich hier was anklicke auch das aufmaßbild einblenden."
       Bisher wurde nur das `<img>` kopiert — der Kasten zeigte also das
       NACKTE Render ohne „Befestigungsabstand" und „Höhe". Genau das stand
       seit dem 25.08. offen: „hier sollten die bilder mit bezeichnung stehen".

       Die Skizze besteht aus DREI Teilen: `<img>`, das Mass-SVG darueber und
       die Bildunterschrift. Deshalb wird jetzt die ganze `<figure>` geklont —
       so greift dieselbe Ueberlagerungs-CSS (`.mo-skizze{position:relative}`
       plus `svg.mo-masslinien{position:absolute}`) ohne eine Zeile Extra-Logik.

       ⚠️ KLONEN, nicht verschieben — sonst fehlt die Skizze daneben im Schritt.
       Dasselbe macht `moVollbild.zeigen()` mit dem SVG.
       ⚠️ Der Klon darf nicht klickbar aussehen: `cursor:zoom-in` steht an
       `.mo-skizze`, im Kasten IST das Bild aber schon gross. */
    var skizzeQuelle = document.querySelector('.mo-skizze');
    var skizzenBild = skizzeQuelle && skizzeQuelle.querySelector('img');
    if (skizzenBild && skizzenBild.src) {
      var klon = skizzeQuelle.cloneNode(true);
      /* 03.09.2026: Die Bildstaffel (srcset/sizes) aus zeichneSkizze gilt fuer
         die 250 px im Schritt. Hier steht das Bild bis 420 px breit (im Raster
         ab 900 px bis 380) — mit `sizes` 250px waehlte der Browser bei DPR 2 die
         640er Stufe fuer 760 noetige Pixel. Ohne Staffel gilt `src` (800/1400)
         wie bisher. */
      var klonBild = klon.querySelector('img');
      if (klonBild) { klonBild.removeAttribute('srcset'); klonBild.removeAttribute('sizes'); }
      klon.className = 'mo-skizze mo-info-skizze';
      klon.style.cursor = 'default';
      klon.removeAttribute('id');

      // Den Zusatz "zum Vergroessern klicken" weglassen - hier IST es gross.
      var kBu = klon.querySelector('figcaption');
      if (kBu) {
        var reiner = kBu.textContent.split('\u2014')[0].trim();
        if (reiner) { kBu.textContent = reiner; } else { kBu.remove(); }
      }
      kasten.appendChild(klon);
    }
    infoKasten.appendChild(kasten);
    infoKasten.classList.add('mo-info-an');
  }

  /* Der Hinweis unter der Preisbox. Steht in der Config an der Option
     price-summary, die wir sonst ueberspringen - LPO zeigt sie als eigene
     Box, wir haben eine eigene. Der Text muss trotzdem mit.

     ⚠️ Der Rueckfalltext ist bewusst gesetzt und nicht leer: Fehlt die
     Angabe in einer Config, darf die Pflichtangabe nicht stillschweigend
     verschwinden. Lieber der allgemeine Satz als gar keiner. */
  function preisFussText(){
    var alle = [];
    (function geh(opts){
      (opts || []).forEach(function(o){
        if(o && o.params && o.params.summaryTemplate) alle.push(o.params.summaryTemplate);
        if(o && o.options) geh(o.options);
      });
    })(CFG.options);
    return alle[0] || 'Alle Preise inkl. MwSt. · zzgl. Versandkosten';
  }

  /* ⭐ KONTAKTKASTEN und PFLICHTHINWEIS — 01.09.2026

     Stefan, mit Screenshot des Maß-Schritts: „Bei rückfragen — whats app oder
     per telefon (Kontaktbutton) einfügen" und „Kostenlose Freigabezeichnung
     – zur überprüfung". Beim Befestigungsmittel dasselbe: „Whats app kontakt
     oder telefonkontakt bei unsicher bzgl der befestigung?"

     Der Maßschritt ist die Stelle, an der ein Kunde abspringt: Er soll auf
     den Millimeter genau bestellen, was danach für ihn allein gefertigt wird
     — ohne Widerrufsrecht. Wer dort unsicher ist und keinen Ausweg sieht,
     schließt den Tab. Der Kasten IST der Ausweg.

     ⭐ Beide Bausteine hängen an einem CONFIG-Feld, nicht am Motor:

         "params": { "moKontakt": true }                Kasten, Vorgabetexte
         "params": { "moKontakt": { "titel": "…" } }    Texte ersetzen
         "params": { "moHinweis": "Bitte wählen …" }   Hinweis ÜBER der Wahl

     Ein neuer Schritt mit Kontaktkasten ist damit EINE Zeile in der Config.
     Dreimal denselben Kasten in den Motor zu löten wäre der Weg, der heute
     schon zweimal Zeit gekostet hat (Oberflächen in sechs Configs einzeln,
     Handlaufenden an fünf Stellen).

     ⚠️ Die Nummern: Telefon 02295 9026013, WhatsApp seit 05.10.2026 auf Stefans
     Handy 0159 01488152 (Stefan: „Whatsapp nummer auf meine wechseln“; davor
     9026013, bis 26.09. die 011). Beides je Config überschreibbar. */
  var MO_KONTAKT_STD = {
    titel:  'Unsicher? Fragen Sie uns — kostenlos.',
    text:   'Ein Foto Ihrer Situation genügt. Wir sagen Ihnen, was zu messen ist.',
    tel:    '02295 9026013',
    wa:     'https://wa.me/4915901488152',
    zusatz: ''
  };

  /* Aus '02295 9026013' wird '+4922959026013'. Ohne die führende Null —
     mit ihr wählt kein Handy im Ausland die Nummer richtig. */
  function moTelLink(nr){
    var z = String(nr || '').replace(/[^0-9+]/g, '');
    if (z.charAt(0) === '+') return 'tel:' + z;
    return 'tel:+49' + z.replace(/^0+/, '');
  }

  /* ⭐ Der Kontaktkasten ist im Theme schaltbar — 01.09.2026

     Stefan, mit Markierung um den Kasten: „dieses Feld macht sind schaltbar
     im theme zu machen."

     Vier Stellungen in `block.settings.kontakt_kasten`, am Traeger als
     `data-mo-kontakt`:

       beide        (Vorgabe)  ueberall, wo die Config einen Kasten vorsieht
       nur_masse               nur am Maszfeld
       ohne_masse              ueberall auszer am Maszfeld
       aus                     nirgends

     🔴 FAIL-OPEN wie `befestigungErlaubt()`: Fehlt das Attribut oder steht
     ein unbekannter Wert darin, wird der Kasten GEZEIGT. Ein vergessener
     Schalter darf dem Kunden nicht den Weg zur Rueckfrage nehmen — bei
     Maszanfertigung ohne Widerrufsrecht ist das die teuerste Richtung.

     ⚠️ Unterschieden wird ueber `o.type === 'dimension'`, also ueber den ORT,
     nicht ueber den Schrittnamen. Kommt spaeter ein dritter Kasten dazu
     (etwa an der Oberflaeche), faellt er unter „ohne_masse" — deshalb heiszt
     die Stellung so und nicht „nur Befestigung".

     ⚠️ EINMAL lesen, nicht bei jedem Aufruf: `zeichneOption()` laeuft fuer
     jede Option bei jedem Neuzeichnen. Gleiche Bauart wie `BEF_AUS`. */
  var KONTAKT_WAHL = null;
  function kontaktErlaubt(o){
    if (KONTAKT_WAHL === null) {
      var wzK = document.querySelector('[data-mo-konfigurator]');
      KONTAKT_WAHL = (wzK && wzK.getAttribute('data-mo-kontakt')) || 'beide';
    }
    if (KONTAKT_WAHL === 'aus') return false;
    var istMass = !!(o && o.type === 'dimension');
    if (KONTAKT_WAHL === 'nur_masse')  return istMass;
    if (KONTAKT_WAHL === 'ohne_masse') return !istMass;
    return true;                                  // 'beide' und alles Unbekannte
  }

  /* ⭐ MENGE ZEIGEN, NICHT NUR DEN PREIS — 02.09.2026

     Stefan: „und komuizieren die menge der schrauben transparenz fuer den
     Kunden."

     An der Kachel stand nur „Universaldübel + Edelstahlschraube A4 +27,00 €".
     Warum es bei 5 m 27 € sind und bei 1,5 m 9 €, war nicht zu sehen — der
     Kunde musste es glauben. Jetzt steht die Rechnung da.

     Vorbild ist der Teilungshinweis (`hinweisAb` mit `{teile}`): derselbe
     Gedanke, dieselbe Optik.

     🔴 Gerechnet wird mit `halterSoll()` — der Funktion, die der Motor fuer
     die Halteranzahl ohnehin hat. Keine zweite Regel im Code.

     ⚠️ Die Preisformel steht als TEXT in der Config und kann `halterSoll()`
     nicht aufrufen; sie traegt ihre eigene Kopie der Regel. Das Werkzeug
     `patch_mengenhinweis.py` vergleicht beide und bricht ab, wenn sie
     auseinanderlaufen. */
  function moMengeText(o){
    var m = o && o.params && o.params.moMenge;
    if (!m || !m.text) return null;
    var x = parseFloat(masse.x);
    if (!(x > 0)) return null;
    var halter = halterSoll({ grund: m.grund, abDrei: m.abDrei,
                              abstand: m.abstand }, x);
    if (halter === null) return null;
    var je = parseInt(m.jeHalter, 10) || 1;
    return String(m.text)
      .replace(/\{halter\}/g,   String(halter))
      .replace(/\{jeHalter\}/g, String(je))
      .replace(/\{punkte\}/g,   String(halter * je));
  }

  /* ⭐ EIGENE LIEFERZEIT JE OBERFLAECHE — 02.09.2026

     Stefan: „Lieferzeit reduzieren lieferzeit 5-7 Tage." Kaltverzinkt wird im
     eigenen Haus aufgetragen, das Tauchbad geht ausser Haus — die Fristen
     unterscheiden sich deutlich (live gemessen: 28–30 Werktage).

     🔴 Die Angabe steht AUSSERHALB des Konfigurators, im Liquid-Block
     `mo_lieferzeit` als `.mo-lz-wert` und `.mo-la-zeit`. Der Motor greift
     dort hinein — derselbe Weg wie `galerieAufBefestigung()` in die Galerie.

     🔴 DER URZUSTAND WIRD GEMERKT. Ohne das bliebe „5–7 Werktage" stehen,
     wenn der Kunde zurueck auf Feuerverzinkt wechselt. Er bekaeme damit eine
     Frist zugesagt, die fuers Tauchbad nicht gilt — bei Massanfertigung ohne
     Widerrufsrecht die teuerste Sorte Fehler. */
  var LZ_URZUSTAND = null;

  /* ⭐ ZUSCHLAG AUF DIE FRIST — 01.10.2026

     Stefan: Traeger auch ausserhalb des Lagers anbieten, „aber Lieferzeiten
     pruefen". Ein Profil, das erst beim Haendler bestellt wird, verlaengert
     JEDE Frist — die der Oberflaeche genauso wie den Urzustand („Roh").
     Ein Wert kann deshalb `lieferzeitPlus` (Werktage) tragen; er ersetzt die
     Frist nicht, sondern schlaegt auf beide Grenzen auf. Bei mehreren gilt
     der groesste Zuschlag. */
  function moLieferzeitPlus(){
    var plus = 0;
    FLACH.forEach(function(o){
      if (!o.values || !zustand[o.name]) return;
      o.values.forEach(function(v){
        if (v.lieferzeitPlus && String(v.value) === String(zustand[o.name])) {
          plus = Math.max(plus, parseInt(v.lieferzeitPlus, 10) || 0);
        }
      });
    });
    return plus;
  }

  function moLzAufschlag(text, plus){
    if (!plus || !text) return text;
    return String(text).replace(/(\d+)(\s*[–-]\s*)(\d+)|(\d+)/, function(m, a, strich, b, einzeln){
      if (einzeln) return String(+einzeln + plus);
      return (+a + plus) + strich + (+b + plus);
    });
  }

  function moLieferzeitSetzen(text, plus){
    /* 🔴 NUR das markierte Element — live gemessen am 02.09.2026:
       `.mo-la-zeit` traegt auch den Schritt „Lieferung 2–3 Arbeitstage",
       `.mo-lz-wert` je nach Betriebsart auch Versandzeit, Lieferdatum
       und Lagerdauer. Das Liquid setzt `data-mo-frist` an die eine
       Angabe, die die Fertigung meint.
       Fehlt die Marke, wird NICHTS geaendert — bei einer Fristzusage
       ohne Widerrufsrecht ist Schweigen richtig und Raten falsch. */
    var ziele = document.querySelectorAll('[data-mo-frist]');
    if (!ziele.length) return;
    if (LZ_URZUSTAND === null) {
      LZ_URZUSTAND = [];
      Array.prototype.forEach.call(ziele, function(e){
        LZ_URZUSTAND.push(e.textContent);
      });
    }
    Array.prototype.forEach.call(ziele, function(e, i){
      e.textContent = moLzAufschlag(text || LZ_URZUSTAND[i] || e.textContent, plus || 0);
    });
  }

  /* Welche Lieferzeit gilt gerade? Die Oberflaechenwahl entscheidet; bringt
     der gewaehlte Wert keine eigene mit, gilt wieder die des Produkts. */
  function moLieferzeitEigene(){
    var eigene = null;
    FLACH.forEach(function(o){
      if (!o.values || !zustand[o.name]) return;
      o.values.forEach(function(v){
        if (v.lieferzeit && String(v.value) === String(zustand[o.name])) {
          eigene = String(v.lieferzeit);
        }
      });
    });
    return eigene;
  }

  function moLieferzeitNachfuehren(){
    moLieferzeitSetzen(moLieferzeitEigene(), moLieferzeitPlus());
  }

  /* ⭐ DIE ZUSAGE GEHT MIT IN DEN WARENKORB — 28.09.2026

     Schublade und /cart lasen nur das Produkt-Metafeld `custom.lieferzeit`.
     Nach der Wahl von RAL 9010 sagte die Seite „35–40 Werktage“, der Korb
     darunter „28–30 Werktage“ — bei Massanfertigung ohne Widerrufsrecht
     genau der Widerspruch, den niemand haben will.

     Mitgegeben wird, was die Seite beim Klick auf „In den Warenkorb“ zeigt:
     die Frist der gewaehlten Oberflaeche, sonst der Urzustand des
     Liquid-Blocks (das Metafeld, ohne Metafeld der Regler der Vorlage —
     so beim Traeger „Roh“ mit 8–10 Werktagen). Liefert keins von beiden
     etwas, bleibt das Feld weg; dann zeigt der Korb wie bisher das
     Metafeld oder nichts. Versteckt (`_`); angezeigt wird es von
     snippets/cart-drawer.liquid und sections/main-cart-items.liquid. */
  function moLieferzeitZusage(){
    var eigene = moLieferzeitEigene(), plus = moLieferzeitPlus();
    if (eigene) return moLzAufschlag(eigene, plus);
    /* Sonst der Urzustand. Die Marke kann an zwei Stellen stehen; es gilt
       die Zeile „Fertigung: …“ der Kaufbox (`.mo-lz-wert`), die
       Ablaufleiste (`.mo-la-zeit`) nur, wenn es die Zeile nicht gibt. */
    var ziele = document.querySelectorAll('[data-mo-frist]');
    if (!ziele.length) return null;
    var i = 0;
    for (var k = 0; k < ziele.length; k++) {
      if (ziele[k].classList.contains('mo-lz-wert')) { i = k; break; }
    }
    var ur = (LZ_URZUSTAND && LZ_URZUSTAND.length > i) ? LZ_URZUSTAND[i]
                                                       : ziele[i].textContent;
    ur = String(ur || '').trim();
    return ur ? moLzAufschlag(ur, plus) : null;
  }

  function moKontaktKasten(q){
    var k = {}, s;
    for (s in MO_KONTAKT_STD) if (MO_KONTAKT_STD.hasOwnProperty(s)) k[s] = MO_KONTAKT_STD[s];
    if (q && typeof q === 'object') for (s in q) if (q.hasOwnProperty(s)) k[s] = q[s];

    var knoepfe = [];
    if (k.wa) knoepfe.push(h('a', {
      class: 'mo-kontakt-knopf mo-kontakt-wa', href: k.wa,
      target: '_blank', rel: 'noopener',
      'aria-label': 'Per WhatsApp fragen'
    }, [document.createTextNode('Per WhatsApp fragen')]));
    if (k.tel) knoepfe.push(h('a', {
      class: 'mo-kontakt-knopf mo-kontakt-tel', href: moTelLink(k.tel),
      'aria-label': 'Anrufen: ' + k.tel
    }, [document.createTextNode(k.tel)]));

    var kinder = [];
    if (k.titel) kinder.push(h('div', {class:'mo-kontakt-titel'}, [document.createTextNode(k.titel)]));
    if (k.text)  kinder.push(h('div', {class:'mo-kontakt-text'},  [document.createTextNode(k.text)]));
    if (knoepfe.length) kinder.push(h('div', {class:'mo-kontakt-knoepfe'}, knoepfe));
    if (k.zusatz) kinder.push(h('div', {class:'mo-kontakt-zusatz'}, [document.createTextNode(k.zusatz)]));
    return kinder.length ? h('div', {class:'mo-kontakt'}, kinder) : null;
  }

  function moHinweisKasten(text){
    if (!text) return null;
    return h('div', {class:'mo-pflichthinweis'}, [document.createTextNode(String(text))]);
  }

  function zeichneOption(o){
    if(UEBERGANGEN.indexOf(o.type) > -1) return null;
    if(!sichtbar(o)) return null;
    var kinder = [];
    var titel = (o.label || o.name || '').replace(/:$/, '');
    var beschriftung = [
      document.createTextNode(titel),
      o.required ? h('span', {class:'mo-pflicht'}, [document.createTextNode(' *')]) : null
    ];
    // Das Info-Zeichen sitzt IM Label, direkt hinter dem Titel - so wie bei LPO.
    // ⭐ Ueber `infoText`, damit auch Configs gefunden werden, die den Text
    //    in `params` tragen (Edelstahl-Gitter, 31.08.2026).
    var iText = infoText(o);
    if(iText) beschriftung.push(infoKnopf(iText, titel));
    kinder.push(h('label', {class:'mo-label'}, beschriftung));
    /* Der Pflichthinweis steht ÜBER der Auswahl — er sagt, was zu TUN
       ist. Unter den Kacheln hätte ihn niemand gelesen, bevor er
       geklickt hat. */
    var moHw = moHinweisKasten((o.params && o.params.moHinweis) || o.moHinweis);
    if (moHw) kinder.push(moHw);
    var moIstKachel = false;
    if(o.type === 'quantity')                             kinder.push(zeichneMenge(o));
    else if(o.type === 'upload-lift')                     kinder.push(zeichneUpload(o));
    else if(o.type === 'dimension')                       kinder.push(zeichneMasse(o));
    else if(o.type === 'radio' || o.type === 'select')    kinder.push(zeichneRadios(o));
    /* 🔴 Beide Zweige MUESSEN vor dem `o.values`-Zweig weiter unten stehen.
       Ein `dropdown` bringt values mit und landete dort bisher als Kachelfeld -
       bei 15 Treppenstufen also 15 Kacheln. Ein `number` hat gar keine values
       und fiel durch bis `return null`: Das Feld fehlte ersatzlos.
       Aus 2.09.3.1 geholt am 01.09.2026 — gemessen: Treppengelaender zeigte
       nur 2 von 6 Feldern und zeichnete keine Skizze. */
    else if(o.type === 'dropdown')                       kinder.push(zeichneAuswahl(o));
    else if(o.type === 'number')                         kinder.push(zeichneZahl(o));
    else if(o.type === 'text'){
      kinder.push(h('textarea', {
        class:'mo-text', placeholder:(o.params && o.params.placeholder) || '',
        oninput: function(ev){ anmerkung = ev.target.value; nurPreisNeu(); }
      }));
      kinder[kinder.length-1].value = anmerkung;
    }
    /* 🔴 Gemerkt fuer den Kontaktkasten weiter unten: Eine Kachelauswahl
       verteilt sich ueber die ganze Breite (`repeat(N, minmax(0,1fr))`).
       Was ein Kasten daneben belegt, fehlt den Kacheln sofort — am
       02.09.2026 gemessen: 113 px je Kachel statt 200. Massfelder sind
       das Gegenteil, sie lassen rechts Platz frei. */
    else if(o.values && o.values.length){ moIstKachel = true;
                                          kinder.push(zeichneKacheln(o)); }
    else return null;
    // Der Hinweistext steht UNTER der Auswahl - er erklaert die Folgen der
    // Wahl ("Bei einer beschichteten Oberflaeche wird zunaechst verzinkt ..."),
    // gehoert also hinter das, worauf er sich bezieht. Nur Text, kein HTML.
    if(o.help) kinder.push(h('div', {class:'mo-help'}, [document.createTextNode(o.help)]));
    /* Die Mengenangabe gehört zwischen Hilfetext und Kontaktkasten:
       erst was die Wahl bedeutet, dann der Ausweg, wenn es unklar bleibt. */
    var moMg = moMengeText(o);
    if (moMg) {
      var mgEl = h('div', {class:'mo-empfehlung mo-satzmenge'}, []);
      mgEl.innerHTML = moMg;
      kinder.push(mgEl);
    }
    /* Der Kontaktkasten steht UNTER der Auswahl: Er ist der Ausweg für
       den, der nicht weiterkommt — und der kommt erst zur Sprache,
       wenn das Feld überhaupt da ist. */
    var moKk = kontaktErlaubt(o) && ((o.params && o.params.moKontakt) || o.moKontakt);
    /* `mo-opt-neben` haengte den Kasten am 02.09.2026 auf breiten Schirmen
       NEBEN die Eingabe. Stefan am 03.09.2026: „das andere rueckgaengig
       machen" — der Kasten gehoert ueberall nach unten, beides zugleich geht
       nicht. Die Klasse wird deshalb nicht mehr vergeben; ihre CSS-Regel
       steht noch da, greift aber nie mehr. */
    var moOptKlasse = 'mo-opt';
    if (moKk) {
      var el = moKontaktKasten(moKk);
      if (el) {
        kinder.push(el);
        /* Stefan, 02.09.2026: „kleiner machen unter die schrauben."
           Bei Kacheln bleibt der Kasten UNTER der Auswahl und legt sich
           dort waagerecht — Text links, Knoepfe rechts. Senkrecht waere
           er ueber die volle Breite ein 210 px hoher Block, also
           groesser statt kleiner. */
        if (moIstKachel) el.className = 'mo-kontakt mo-kontakt-flach';
      }
    }
    /* 🔴 `data-mo-opt` traegt den CONFIG-NAMEN der Option ans Element.
       Ohne ihn suchte zumFehlerSpringen() ueber den sichtbaren Text - und traf
       nicht: Die Laschen-Option heisst in der Config `Laschen`, im DOM aber
       „Befestigungslaschen" (ihr `label` ist leer, die Beschriftung kommt aus
       der Gruppe). Am 26.08.2026 gemessen: Klick auf den Kaufknopf ohne
       Laschenwahl -> Meldung erschien, aber scrollY blieb ueber 4 Sekunden 0
       und `mo-opt-fehlt` wurde nie gesetzt. Der Kunde sah nichts. */
    return h('div', {class: moOptKlasse, 'data-mo-opt': String(o.name || '')}, kinder);
  }

  // Ein „Schritt" ist eine Gruppe der obersten Ebene, die gerade sichtbar ist
  // und mindestens eine sichtbare Option enthält.
  function schritte(){
    return (CFG.options||[]).filter(function(o){
      if(o.type !== 'group') return false;
      if(!sichtbar(o)) return false;
      return alleOptionen(o.options).some(function(k){
        return UEBERGANGEN.indexOf(k.type) === -1 && sichtbar(k) && (k.values || k.type === 'dimension' || k.type === 'text');
      });
    });
  }

  function wahlText(gruppe){
    var teile = [];
    /* 05.10.2026 (Berta): Fehlt das Pflichtmaß, bleiben auch die ZAHLENFELDER
       aus dem Kopf. Anlass: Die Eckwinkel des Balkons haben seit heute die
       Vorgabe 90 (Stefan: „immer vorausgefüllt 90 grad") — vor dem ersten Maß
       stand im Kopf „Maße 90 · 90" in Rot, das liest sich wie eingetragene
       Maße. Ohne das Hauptmaß haben Zahlen keinen Bezug; dann kommt
       „Maße eintragen" aus `offenText()`. Auswahlen (Kacheln) bleiben stehen.
       Geprüft an allen 72 Configs in 2.11.3: Nur der Balkon hat ein leeres
       Pflichtmaß neben einem vorbelegten Zahlenfeld. */
    var ohneMass = offenText(gruppe) === 'Maße eintragen';
    alleOptionen(gruppe.options).forEach(function(o){
      if(UEBERGANGEN.indexOf(o.type) > -1 || !sichtbar(o)) return;
      if(ohneMass && o.type === 'number') return;
      // Die Zusammenfassung folgt der gewaehlten Einheit - sonst stehen im
      // selben Schritt oben "110 cm" und im Kopf "1100 mm".
      /* 🔴 `dimension` IMMER hier abfangen, auch ohne eingetragenes Maß.

         Bis 01.09.2026 lautete die Bedingung `o.type === 'dimension' &&
         masse.x`. War kein Maß eingetragen, fiel die Option in den
         `else`-Zweig — und der Wert einer `dimension` ist dort ein OBJEKT
         (`{x: '', y: ''}`). `join(' · ')` machte daraus `[object Object]`.

         Am Wandhandlauf gemessen: im Schrittkopf stand
         „[object Object] · 6 · 180 · 290 · 32". Für den Kunden sieht das aus
         wie ein kaputter Shop, und zwar genau im Maß-Schritt.

         Fehlt das Maß, gehört gar nichts in die Zusammenfassung — den
         Hinweis „Maße eintragen" liefert `offenText()`. */
      if(o.type === 'dimension') {
        if (masse.x) teile.push(
          moAnzeige(masse.x) + (masse.y ? ' × ' + moAnzeige(masse.y) : '') +
          (moTeiler() === 10 ? ' cm' : ' mm'));
      }
      /* Zweiter Riegel: Was kein Text ist, gehört nicht in eine Textzeile.
         Ein künftiger Optionstyp mit Objektwert erzeugt sonst denselben
         Fehler an derselben Stelle. */
      else if(zustand[o.name] && typeof zustand[o.name] !== 'object') {
        teile.push(zustand[o.name]);
      }
    });
    return teile.join(' · ');
  }

  /* Was im Schrittkopf steht, solange ein Pflichtfeld fehlt.
     Unterschieden wird zwischen Eintragen (Maße) und Auswaehlen (Kacheln) —
     „Bitte auswählen" an einem Zahlenfeld waere eine falsche Aufforderung. */
  /* ---------- Bild der getroffenen Wahl fuer den Schrittkopf ----------
     Stefan am 24.08.: „symbole einfügen farblich, kleine Farbscala".
     Genommen wird das Bild des GEWAEHLTEN Werts - bei der Farbe ist das der
     Ton selbst, bei Befestigung und Spitzenform die Miniatur.

     ⚠️ Gleiche Rangfolge wie in der Kachelschleife: Metafeld sticht,
     Metaobjekt faengt auf, Config zuletzt. Sonst zeigte der Kopf etwas
     anderes als der Schritt darunter. */
  /* Nur die FARBWAHL bekommt ein Symbol — den Faecher. Stefan am 24.08.:
     „den rest wieder raus sieht irgendwie nicht gut aus." Die Wahl als
     Miniatur in JEDEM Kopf war zu unruhig. */
  var MO_KOPFSYMBOL = true;

  /* Traegt die Gruppe die Oberflaechenwahl? Nur dort sitzt der Farbname IM
     Bild, und nur dort muss der Ausschnitt am Text vorbei. */
  function istFarbwahl(gruppe){
    return alleOptionen(gruppe.options).some(function(o){
      return /ober(fläche|flaeche)|farbe/i.test(String(o.name || ''));
    });
  }

  function offenText(gruppe){
    var mass = alleOptionen(gruppe.options).some(function(o){
      return o.type === 'dimension' && o.required && sichtbar(o) &&
             !(parseFloat(masse.x) > 0);
    });
    return mass ? 'Maße eintragen' : 'Bitte auswählen';
  }

  function gruppeFertig(gruppe){
    return alleOptionen(gruppe.options).every(function(o){
      if(UEBERGANGEN.indexOf(o.type) > -1 || !sichtbar(o) || !o.required) return true;
      if(o.type === 'dimension'){
        /* 🔴 EINGABESPERRE. Bis 26.08.2026 stand hier nur `masse.x > 0` — ein
           Mass ausserhalb der Grenzen galt damit als fertig, der Kaufknopf
           blieb aktiv und der Kunde konnte bestellen. Stefan hatte einen
           Warenkorb mit 45.000 mm Befestigungsabstand und 5.532,29 €.
           Die Fehlermeldung darunter gab es schon, sie sperrte nur nichts.
           Auch die HOEHE wurde nie geprueft. */
        var p = o.params || {};
        var x = parseFloat(masse.x), y = parseFloat(masse.y);
        if(!(x > 0)) return false;
        if(p.minX && x < parseFloat(p.minX)) return false;
        if(p.maxX && x > parseFloat(p.maxX)) return false;
        if(p.onlyX) return true;              // Handlauf/Stange: nur EIN Mass
        if(!(y > 0)) return false;
        if(p.minY && y < parseFloat(p.minY)) return false;
        if(p.maxY && y > parseFloat(p.maxY)) return false;
        return true;
      }
      /* 🔴 GELD (16.09.2026): Ein Pflicht-Zahlenfeld galt als fertig, sobald
         IRGENDETWAS darin stand. Die Grenzen aus der Config standen am
         Eingabefeld, sperrten aber nichts — Stufenhoehe 9999 oder ein
         Balkonschenkel von 99.999 mm waren bestellbar, und der Preis rechnete
         damit. Dieselbe Pruefung wie beim Massfeld darueber. */
      if(o.type === 'number') return grenzeZahl(o);
      return !!zustand[o.name];
    });
  }

  /* Liegt der Wert eines Zahlenfelds in seinen Grenzen? Leer oder unlesbar
     ist NICHT in den Grenzen. Komma wird als Dezimalzeichen angenommen. */
  function grenzeZahl(o){
    var p = o.params || {};
    var roh = zustand[o.name];
    if(roh == null || roh === '') return false;
    var z = parseFloat(String(roh).replace(',', '.'));
    if(!isFinite(z)) return false;
    if(p.min != null && p.min !== '' && z < parseFloat(p.min)) return false;
    if(p.max != null && p.max !== '' && z > parseFloat(p.max)) return false;
    return true;
  }

  /* ⭐ Nach JEDEM Zeichnen Bescheid geben. Die Feldschicht richtet daraufhin
     ihre Felder neu aus: `#mo-schritte` wird komplett neu gebaut, die Skizze
     ist danach ein ANDERES Element — ein gemerkter Knoten waere sofort
     veraltet ([[felder-in-der-zeichnung-fallen]], Falle 3).
     Nur wenn es die Schicht ueberhaupt gibt; sonst ist es ein Ereignis, das
     niemand hoert. */
  /* Die Lieferzeit haengt an der Oberflaechenwahl und wird deshalb nach
     jedem Zeichnen nachgezogen — wie die Skizze darunter. */
  function moLzMelden(){
    try { moLieferzeitNachfuehren(); } catch (e) {}
  }

  function moHlMelden(){
    moLzMelden();
    if (!window.MO_HL_FELDER_V3) return;
    try { moZustandAusMasse(); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('mo:hl')); } catch (e) {}
  }

  // Wenn eine Bedingung eine Option unsichtbar macht, muss ihr Wert weg —
  // sonst schleppt der Warenkorb Angaben mit, die niemand mehr gewählt hat.
  function aufraeumen(){
    FLACH.forEach(function(o){
      /* 🔴 `o.values` allein liess Zahlenfelder aus - die haben keine. Die
         Pfostenhoehe waere im Warenkorb stehen geblieben, obwohl der Kunde von
         seitlicher Montage auf Aufschrauben gewechselt ist. Aus 2.09.3.1
         geholt am 01.09.2026. */
      var hatWert = o.values || o.type === 'number' || o.type === 'dropdown';
      if (!hatWert) return;
      var sicht = sichtbar(o);
      if (zustand[o.name] && !sicht) {
        delete zustand[o.name];
      } else if (sicht && !WAR_SICHTBAR[o.name] &&
                 (zustand[o.name] == null || zustand[o.name] === '') &&
                 o.value != null && o.value !== '') {
        /* 🔴 GEGENRICHTUNG. Die Zeile darueber raeumt den Wert weg, sobald die
           Bedingung nicht mehr gilt — richtig, sonst stuende im Warenkorb ein
           Auslaufmasz fuer einen Handlauf ohne unteren Auslauf.

           Es fehlte der Rueckweg: Wird die Option wieder sichtbar, war ihr
           Vorgabewert mit weggeraeumt. Am 31.08.2026 beim Wechsel auf „Oben und
           unten abgewinkelt" gesehen — Masz E blieb leer, der Schritt „Masze"
           verlor seinen Haken, und `required: true` machte das Produkt damit
           unbestellbar.

           Nur beim UEBERGANG unsichtbar -> sichtbar, nicht bei jedem Leerstand:
           sonst koennte niemand ein Feld leeren, um neu zu tippen. */
        zustand[o.name] = o.value;
      }
      WAR_SICHTBAR[o.name] = sicht;
    });
  }
  /* Sichtbarkeitsstand der letzten Runde — siehe aufraeumen(). */
  var WAR_SICHTBAR = {};

  // ⭐ Der Schrittname kommt aus `params.collapseLabel` der Config — dort steht
  // die Kundensprache ("Maße", "Befestigungsart"). Der technische `name` heisst
  // "Schritt_Masse" und ergab nach unserem Ersetzen "Masse" statt "Maße".
  function schrittTitel(g){
    var p = g.params || {};
    if (p.collapseLabel) return p.collapseLabel;
    if (g.label) return g.label;
    return (g.name || '').replace(/^Schritt_/, '').replace(/_/g, ' ');
  }

  /* Welche Schritte beim letzten Zeichnen dastanden - fuer die Erkennung,
     ob durch eine Auswahl ein neuer dazugekommen ist. */
  var LETZTE_SCHRITTE = null;

  /* Beim Tippen ins Massfeld laeuft bewusst KEIN zeichne(), sondern nur
     nurPreisNeu() - sonst baut sich das Feld unter dem Cursor neu auf und der
     Fokus ist nach jeder Ziffer weg.

     Seit es Bedingungen auf Massfelder gibt (moMassbedingung), reicht das
     nicht mehr: Die Laschenwahl soll ab 1400 mm Hoehe erscheinen, und ohne
     Neuzeichnen taucht sie nie auf.

     Loesung: nach jeder Eingabe pruefen, ob sich die Menge der sichtbaren
     Optionen ueberhaupt geaendert hat. Das ist bei fast jedem Tastendruck
     NICHT der Fall - dann bleibt alles stehen. Nur beim Ueberschreiten einer
     Schwelle wird neu gezeichnet, und dabei kehrt der Fokus samt
     Cursorposition ins selbe Feld zurueck. */
  function sichtSignatur(){
    var teile = [];
    (function geh(liste){
      (liste || []).forEach(function(o){
        if(!o || typeof o !== 'object') return;
        if(o.name && sichtbar(o)) teile.push(o.name);
        if(o.options) geh(o.options);
      });
    })(CFG.options);

    /* ⭐ MASSABHAENGIGES GEHOERT IN DIE SIGNATUR  (26.08.2026)

       Bis hierher zaehlte nur, WELCHE Optionen sichtbar sind. Zwei Dinge
       haengen aber am eingetippten Mass, ohne eine Option ein- oder
       auszublenden:

         · die Halteranzahl (2 bis 1.600 mm, dann 3, je Meter einer mehr)
         · der Hinweis „ab 1,90 m liefern wir geteilt"

       Ohne Eintrag hier blieb beides stehen, bis der Kunde irgendwo klickte —
       beim Tippen von 1.500 auf 1.700 wechselte die Zahl nicht.

       ⚠️ Nur die SCHWELLE aufnehmen, nicht das Mass selbst. Sonst zeichnete
       der Konfigurator bei jeder Ziffer neu; `neuZeichnenWennNoetig()` rettet
       zwar den Fokus, aber der Aufwand waere bei jedem Tastendruck faellig. */
    FLACH.forEach(function(o){
      var p = o.params || {};
      if (p.halterAuto) {
        teile.push('#h' + halterSoll(p.halterAuto, parseFloat(masse.x)));
      }

      /* 🔴 AUCH DIE BILDWAHL GEHOERT HIER HIN  (26.08.2026)

         Solange die Halteranzahl eine eigene Option war, kam die Schwelle
         ueber `#h` in die Signatur — und die Bildstaffel lief zufaellig mit.
         Nachdem die Option auf Stefans Wunsch entfallen ist, fehlte sie: das
         Bild wechselte erst beim naechsten Klick, bei 5.400 mm stand noch die
         5-Halter-Zeichnung statt der mit sechs. */
      if (p.bildAb) {
        var xb = parseFloat(masse.x) || 0, datei = '';
        p.bildAb.forEach(function(b){
          if (b && xb >= (parseFloat(b.ab) || 0)) datei = b.datei || '';
        });
        teile.push('#b' + datei);
      }
      /* 🔴 Auch die MENGE haengt am Mass. Ohne diesen Eintrag bliebe
         die Angabe 6 Dübel stehen, wenn aus 1.500 mm 3.000 mm werden —
         dieselbe Falle wie bei Halteranzahl und Bildwahl darueber. */
      if (p.moMenge) {
        teile.push('#m' + halterSoll({ grund: p.moMenge.grund,
                                       abDrei: p.moMenge.abDrei,
                                       abstand: p.moMenge.abstand },
                                     parseFloat(masse.x)));
      }
      if (p.hinweisAb) {
        var x = parseFloat(masse.x) || 0;
        p.hinweisAb.forEach(function(hw, i){
          if (x >= (parseFloat(hw.ab) || 0)) {
            /* Die STUECKZAHL mit aufnehmen — sonst bliebe „2 Teile“ stehen,
               wenn aus 3.800 mm ein 3.900er wird. */
            var st = parseFloat(hw.stueck) || 0;
            teile.push('#a' + i + (st ? 't' + Math.ceil(x / st) : ''));
          }
        });
      }
    });

    /* ⭐ 04.10.2026: AUCH DIE MASSGRENZEN GEHOEREN IN DIE SIGNATUR.

       Der rote Hinweis „… höchstens 5600 mm“ entsteht nur in zeichneMasse(),
       also beim Umbau. Ob ein Mass innerhalb der Grenzen liegt, stand nicht
       in der Signatur: erst 6000 eingetippt, dann auf 3000 korrigiert - der
       Preis stimmte, der Hinweis blieb rot stehen (Preispruefung Tore
       04.10.2026). Umgekehrt erschien er nie, wenn erst ein gueltiges Mass
       stand. Nur der ZUSTAND (<, >, n) zaehlt, nicht das Mass selbst. */
    FLACH.forEach(function(o){
      if (!o || o.type !== 'dimension' || !sichtbar(o)) return;
      var p = o.params || {};
      (p.onlyX ? ['x'] : ['x', 'y']).forEach(function(f){
        if (!masse[f]) return;
        var w = parseFloat(masse[f]), F = f.toUpperCase();
        var mn = parseFloat(p['min' + F]), mx = parseFloat(p['max' + F]);
        var s = !(w > 0) ? 'n' : (isFinite(mn) && w < mn) ? '<' : (isFinite(mx) && w > mx) ? '>' : '';
        if (s) teile.push('#g' + f + s);
      });
    });

    return teile.join('|');
  }

  var LETZTE_SICHT = null;

  /* Wartet eine Tippause ab, bevor das Formular umgebaut wird.

     500 ms sind der uebliche Wert fuer "der Nutzer hat aufgehoert zu tippen" -
     kurz genug, dass die Laschenwahl gefuehlt sofort erscheint, lang genug,
     dass niemand beim Eintippen einer vierstelligen Zahl unterbrochen wird. */
  var umbauUhr = null;
  /* ⭐ 01.10.2026: Umbau erst, wenn der Fokus gelandet ist.
     Ein blur/change feuert, BEVOR das naechste Feld den Fokus hat. Erst im naechsten
     Durchgang (setTimeout 0) steht fest, wohin der Kunde getippt hat. Ist es wieder
     ein Mass- oder Zahlenfeld, wartet der Umbau auf DESSEN blur - so wie der
     500-ms-Takt unten nie umbaut, solange der Cursor in einem Massfeld steht.
     Alles andere (Kachel, Kaufknopf, freie Flaeche) baut wie bisher sofort um. */
  function umbauNachFokus(fn){
    setTimeout(function(){
      var a = document.activeElement;
      if (a && a.classList && a.classList.contains('mo-massfeld') && document.contains(a)) {
        a.addEventListener('blur', function(){ umbauNachFokus(fn); }, { once: true });
        return;
      }
      fn();
    }, 0);
  }

  function massUmbauSpaeter(){
    if (umbauUhr) clearTimeout(umbauUhr);
    umbauUhr = setTimeout(function(){
      umbauUhr = null;
      /* 🔴 NICHT UMBAUEN, SOLANGE DER CURSOR IM FELD STEHT.

         Die Verzoegerung allein reichte nicht: Wer langsam tippt, ueberschreitet
         die halbe Sekunde zwischen zwei Ziffern, und mitten in der Zahl wurde
         doch neu gebaut. Am 23.08.2026 gemessen - "1", "0", "0", "0" ergab
         "0001": Die Nullen landeten VOR der Eins, weil der Cursor nach dem
         Neuaufbau am Feldanfang stand.

         Wer noch im Feld steht, ist noch nicht fertig. Der Umbau wartet auf
         `blur` - dort steht er unten. */
      var a = document.activeElement;
      if (a && a.classList && a.classList.contains('mo-massfeld')) return;
      neuZeichnenWennNoetig();
    }, 500);
  }

  function neuZeichnenWennNoetig(){
    var jetzt = sichtSignatur();
    if(jetzt === LETZTE_SICHT) return false;
    LETZTE_SICHT = jetzt;

    // Fokus merken: welches Feld, und wo steht der Cursor darin?
    var aktiv = document.activeElement;
    var achse = null, pos = null;
    if(aktiv && aktiv.classList && aktiv.classList.contains('mo-massfeld')){
      achse = aktiv.getAttribute('data-achse');
      try { pos = aktiv.selectionStart; } catch(e) {}
    }

    /* 🔴 Zustand VOR dem Zeichnen nachziehen.

       `aufraeumen()` haelt Zustand und Sichtbarkeit im Gleichschritt: Wird
       eine Option unsichtbar, faellt ihr Wert weg; wird sie wieder sichtbar,
       kommt der Vorgabewert zurueck. Gerufen wurde es bisher nur beim Start
       und nach einem Klick (`waehle()`) — NICHT hier.

       Am 01.09.2026 am lebenden Ferro 09 gemessen: Bei 1600 mm Hoehe
       erschien die Laschenwahl, aber KEINE Kachel war markiert, und der
       Maszschritt behielt „Noch offen". Erst irgendein Klick anderswo
       holte die Vorauswahl nach.

       Die Gegenrichtung war ebenso offen: Faellt die Hoehe unter 1400 mm,
       blieb der Laschenwert im Zustand stehen und konnte in den Warenkorb
       wandern.

       ⚠️ VOR `zeichne()`, nicht danach — sonst waere der Zustand zwar
       richtig, das eben gezeichnete Formular aber noch das alte. */
    aufraeumen();
    zeichne();

    if(achse){
      var neu = document.querySelector('.mo-massfeld[data-achse="' + achse + '"]');
      if(neu){
        neu.focus();
        /* ⚠️ CURSOR ANS ENDE - `setSelectionRange` kann das hier nicht.

           Bei `type="number"` liefert `selectionStart` null und
           `setSelectionRange` wirft; der Cursor bleibt am Feldanfang, und die
           naechste Ziffer landet VOR der bisherigen Eingabe.

           Den Wert neu zuzuweisen setzt den Cursor ans Ende - der einzige Weg,
           der bei Zahlenfeldern in allen Browsern greift. */
        var w = neu.value; neu.value = ''; neu.value = w;
        // Cursor an dieselbe Stelle. Ohne das springt er ans Feldende - was
        // beim Korrigieren einer Ziffer in der Mitte stoert.
        if(pos != null){ try { neu.setSelectionRange(pos, pos); } catch(e) {} }
      }
    }
    return true;
  }

  /* ⭐ HALTERANZAHL FOLGT DER LAENGE  (26.08.2026)

     Stefan: „halter 3stk ab 1600 mm … oder auswaehlbar machen optional?" —
     entschieden fuer BEIDES: Der Konfigurator setzt die noetige Zahl selbst,
     wer mehr braucht (weicher Untergrund, Putztraeger), stockt auf. Weniger
     als noetig laesst sich nicht waehlen; die Werte darunter kosten dasselbe.

     Regel aus `params.halterAuto`:
         bis `abDrei`      -> `grund` Stueck            (2 bis 1.600 mm)
         darueber          -> 3, danach je `abstand` einer mehr
                              (1.600 = 3, 2.600 = 4, 3.600 = 5 …)

     ⚠️ Sobald der Kunde selbst waehlt, wird nicht mehr nachgefuehrt — sonst
     saesse seine Eingabe bei der naechsten Ziffer im Massfeld wieder fest. */
  var HALTER_SELBST = false;

  function halterSoll(p, x){
    if (!(x > 0)) return null;
    var grund   = parseInt(p.grund, 10)   || 2;
    var abDrei  = parseFloat(p.abDrei)    || 1600;
    var abstand = parseFloat(p.abstand)   || 1000;
    if (x < abDrei) return grund;
    return (grund + 1) + Math.floor((x - abDrei) / abstand);
  }

  function halterNachfuehren(){
    var o = FLACH.find(function(k){ return k.params && k.params.halterAuto; });
    if (!o) return;
    var soll = halterSoll(o.params.halterAuto, parseFloat(masse.x));
    if (soll === null) return;

    /* Der Kunde darf nie WENIGER haben als noetig — auch nicht, wenn er
       vorher bei kurzer Laenge 2 gewaehlt und dann verlaengert hat. */
    var ist = parseInt(zustand[o.name], 10);
    if (HALTER_SELBST && isFinite(ist) && ist >= soll) return;
    zustand[o.name] = String(soll);
  }

  /* ⭐ WELCHE ZEICHNUNG GILT? — Ansage ueber das DOM  (26.08.2026)

     Der Wandhandlauf hat drei Aufmass-Zeichnungen: zwei Halter (bis 1.600 mm),
     drei (bis 1.900) und die geteilte Fassung mit vier (darueber). Die Auswahl
     steht in `params.bildAb` am Massfeld.

     🔴 Die Skizze liegt in einer EIGENEN IIFE und kennt die Config nicht
     (siehe konfigurator-iife-grenzen). Der Dateiname geht deshalb als
     Attribut `data-mo-skizzenbild` ans Wurzelelement — derselbe Kniff wie bei
     der Masseinheit. */
  /* ⭐ Zeichnet die Handlauf-Skizze in einen vorhandenen .mo-skizze-Kasten.
     Der Zeichencode selbst steht in assets/mo-hl-skizze.js — erzeugt aus
     handlauf/test-handlauf-skizze.html, damit Test und Shop nicht
     auseinanderlaufen. Fehlt die Datei, passiert nichts (kein Absturz). */
  function skizzenbildNachfuehren(){
    var wurzel = document.querySelector('[data-mo-konfigurator]');
    if (!wurzel) return;
    var dim = FLACH.find(function(k){
      return k.type === 'dimension' && k.params && k.params.bildAb;
    });
    var treffer = '';
    if (dim) {
      var x = parseFloat(masse.x) || 0;
      dim.params.bildAb.forEach(function(b){
        if (b && x >= (parseFloat(b.ab) || 0)) treffer = b.datei || '';
      });
    }
    if (treffer) wurzel.setAttribute('data-mo-skizzenbild', treffer);
    else         wurzel.removeAttribute('data-mo-skizzenbild');

    /* ⭐ Gezeichnete Skizze statt Foto — greift NUR, wenn die Config es ansagt
       (`params.skizzeZeichnen` am Massfeld). Fenstergitter und Balkone
       behalten ihre gerenderten Bilder samt RAHMEN_JE_BILD.
       Das Mass wandert als Attribut mit, weil die Skizzen-IIFE die Config
       nicht kennt — derselbe Kniff wie oben beim Dateinamen. */
    var gez = FLACH.find(function(k){
      return k.type === 'dimension' && k.params && k.params.skizzeZeichnen;
    });
    if (gez) {
      var gz = gez.params.skizzeZeichnen || {};
      wurzel.setAttribute('data-mo-skizze-zeichnen', gz.art || 'handlauf');
      wurzel.setAttribute('data-mo-skizze-mass', String(parseFloat(masse.x) || 0));
      if (gz.groesse) wurzel.setAttribute('data-mo-skizze-groesse', String(gz.groesse));
      /* ⭐ Felder wahlweise UNTER die Zeichnung — Stefan am 31.08.2026.
         Geschaltet in der CONFIG, nicht im Theme-Schema: `main-product.liquid`
         liegt bei 94 % des Grössenlimits, und die Wahl gehört ohnehin zum
         Konfigurator, nicht zum Theme. Das CSS dreht daraufhin die Reihenfolge
         im Raster (`order:-1` an der Skizze). */
      if (gz.felderUnten) wurzel.setAttribute('data-mo-felder-unten', 'ja');
      else wurzel.removeAttribute('data-mo-felder-unten');
      /* Vergroessern abschaltbar. Ohne Angabe bleibt es an. */
      if (gz.vollbild === false) wurzel.setAttribute('data-mo-vollbild', 'aus');
      else wurzel.removeAttribute('data-mo-vollbild');
      /* Vergroessern abschaltbar. Ohne Angabe bleibt es an. */
      if (gz.vollbild === false) wurzel.setAttribute('data-mo-vollbild', 'aus');
      else wurzel.removeAttribute('data-mo-vollbild');
      /* Wandart der Zeichnung: putz | studio | warm | anthrazit.
         Ohne Angabe waehlt die Zeichnung selbst `studio` — ruhig genug,
         dass die Bemassung lesbar bleibt. */
      if (gz.wand) wurzel.setAttribute('data-mo-skizze-wand', String(gz.wand));
      else wurzel.removeAttribute('data-mo-skizze-wand');
      /* Raeumliche Ansicht unter der Bemassung. Ohne Angabe aus. */
      if (gz.dreiD) wurzel.setAttribute('data-mo-3d', 'ja');
      else wurzel.removeAttribute('data-mo-3d');
      /* Felder unter der Zeichnung verbergen — sie stehen dort ein zweites
         Mal, seit die Masze IN der Zeichnung eingetragen werden. */
      if (gz.felderVerbergen) wurzel.setAttribute('data-mo-felder-weg', 'ja');
      else wurzel.removeAttribute('data-mo-felder-weg');

      /* ⭐ TREPPE: acht Werte statt einer Laenge.

         Die Skizzen-IIFE sieht weder `zustand` noch `FLACH` — sie kennt die
         Config nicht. Beim Wandhandlauf genuegte deshalb ein Zahl-Attribut;
         eine Treppe braucht Stufenzahl, A, B, C, D, beide Befestigungsarten,
         Hoehe und Fuellung. Also wandert alles als JSON hinueber.

         🔴 NUR SICHTBARE Optionen. Der Zustand behaelt den Wert einer Option,
         die eine Bedingung inzwischen ausgeblendet hat — ungeprueft gelesen
         zeichnete die Skizze unten eine Fussplatte, obwohl seitliche Montage
         bestellt ist. Dieselbe Regel wie in der Warenkorb-Schleife. */
      if ((gz.art || '') === 'treppe') {
        var sw = function (name) {
          var o = FLACH.find(function (k) { return k.name === name; });
          if (!o || !sichtbar(o)) return null;
          var v = zustand[name];
          return (v === undefined || v === '') ? null : v;
        };
        var zahl = function (name) { return parseInt(sw(name), 10) || 0; };
        var werte = {
          stufen: sw('Treppenstufen'),
          A: zahl('Stufenhöhe'), B: zahl('Auftritt'),
          C: parseFloat(masse.x) || 0, D: parseFloat(masse.y) || 0,
          Hoben: zahl('Pfostenhöhe oben'), Toben: zahl('Wandabstand oben'),
          Hunten: zahl('Pfostenhöhe unten'), Tunten: zahl('Wandabstand unten'),
          befOben: sw('Befestigung oben'),
          // Bei seitlicher Montage oben traegt die andere Option den Wert unten.
          befUnten: sw('Befestigung unten') || sw('Befestigung unten seitlich'),
          // Nur das Gelaender fuehrt diese beiden.
          hoehe: zahl('Geländerhöhe'), fuellung: sw('Füllung'),
          // 23.09.2026: fuer die raeumliche Ansicht — Gelaender oder Handlauf?
          gelaender: FLACH.some(function (k) { return k.name === 'Füllung'; })
        };
        try { wurzel.setAttribute('data-mo-skizze-werte', JSON.stringify(werte)); }
        catch (e) { wurzel.removeAttribute('data-mo-skizze-werte'); }
      } else if ((gz.art || '') === 'handlauf-v3') {
        /* ⭐ Wandhandlauf abgewinkelt. Die Config fuehrt DREI Massfelder
           („Masze oben/unten/beidseitig"); je nach Bauform ist genau eines
           sichtbar. `masse` traegt immer nur das zuletzt bediente — deshalb
           wird hier die SICHTBARE dimension-Option gesucht und deren Wert
           genommen. Wer stumpf `masse.x` nimmt, zeichnet nach einem
           Bauformwechsel die Masze der alten Form. */
        var sv = function (name) {
          var o = FLACH.find(function (k) { return k.name === name; });
          if (!o || !sichtbar(o)) return null;
          var v = zustand[name];
          return (v === undefined || v === '') ? null : v;
        };
        var dimSicht = FLACH.filter(function (k) {
          return k.type === 'dimension' && sichtbar(k);
        })[0];
        var mw = (dimSicht && zustand[dimSicht.name]) || {};
        var wv = parseFloat(sv('Neigungswinkel in Grad'));
        var zv = function (n) { var v = parseFloat(sv(n)); return isFinite(v) ? v : 0; };
        var hw = {
          bauform: sv('Bauform') || 'Oben abgewinkelt',
          C: parseFloat(mw.x) || parseFloat(masse.x) || 0,
          D: parseFloat(mw.y) || parseFloat(masse.y) || 0,
          E: zv('Auslauf unten'),
          winkel: (wv >= 0 && wv <= 60) ? wv : null,
          durchmesser: sv('Rohrdurchmesser') || '\u00d8 42,4 mm',
          stufen: zv('Treppenstufen'),
          steigung: zv('Stufenh\u00f6he'),
          auftritt: zv('Auftritt')
        };
        try { wurzel.setAttribute('data-mo-skizze-werte', JSON.stringify(hw)); }
        catch (e) { wurzel.removeAttribute('data-mo-skizze-werte'); }
      } else {
        wurzel.removeAttribute('data-mo-skizze-werte');
      }
    } else {
      wurzel.removeAttribute('data-mo-skizze-zeichnen');
      wurzel.removeAttribute('data-mo-skizze-mass');
      wurzel.removeAttribute('data-mo-skizze-groesse');
      wurzel.removeAttribute('data-mo-skizze-werte');
      wurzel.removeAttribute('data-mo-felder-unten');
    }
  }

  /* ⭐ DIE BRUECKE zur Feldschicht (`mo-hl-felder.js`). Sie sitzt als HTML
     ueber dem SVG und laesst den Kunden die Masse dort eintragen, wo sie in
     der Zeichnung stehen — Stefans Vorschlag vom 24.08.2026.

     🔴 `zustand` geht als DIESELBE Referenz hinaus, nicht als Kopie. Eine
     Kopie waere wirkungslos: Die Schicht schriebe ins Leere und der Kunde
     saehe Eingaben, die nirgends ankommen.

     Warum nicht ueber `waehle()`: Die Schicht schreibt Massfelder, also
     {x,y}-Objekte einer dimension-Option. `waehle()` ist fuer Wertelisten
     gebaut und reicht ein Massobjekt nicht durch. Gleich danach ruft die
     Schicht `zeichnen()` — das raeumt auf, rechnet den Preis und baut die
     Schritte neu. Der Zustand ist also nie laenger als einen Wimpernschlag
     am Motor vorbei veraendert. */
  /* 🔴 ZWEI WELTEN, die zusammenmuessen. Der Motor haelt die Masze in einer
     EIGENEN Variablen `masse = {x,y}` — daraus rechnen Preisformel, Skizze und
     Beschriftung. Die Feldschicht kennt die nicht; sie schreibt dorthin, wo
     LPO die Masze fuehrt: `zustand['Maße oben'] = {x,y}`.

     Ohne Uebersetzung stand der Wert im Feld, `masse` blieb leer und der Preis
     zeigte weiter „–". Genau so am 31.08.2026 gemessen: Feld 3000, Summe „–".

     Deshalb uebersetzt die Bruecke in BEIDE Richtungen:
       hinein  (`zeichnen`)      zustand -> masse, vor dem Rechnen
       hinaus  (`moHlMelden`)    masse -> zustand, nach dem Zeichnen,
                                 damit die Felder den Motorwert zeigen. */
  function moMasseAusZustand(){
    var dim = FLACH.filter(function(k){ return k.type === 'dimension' && sichtbar(k); })[0];
    if (!dim) return;
    var m = zustand[dim.name];
    if (!m || typeof m !== 'object') return;
    if (m.x != null && m.x !== '') masse.x = String(m.x);
    if (m.y != null && m.y !== '') masse.y = String(m.y);
  }
  function moZustandAusMasse(){
    var dim = FLACH.filter(function(k){ return k.type === 'dimension' && sichtbar(k); })[0];
    if (!dim) return;
    var m = zustand[dim.name];
    if (!m || typeof m !== 'object') m = {};
    var neu = { x: m.x, y: m.y };
    if (masse.x !== '') neu.x = masse.x;
    if (masse.y !== '') neu.y = masse.y;
    zustand[dim.name] = neu;
  }

  window.MO_HL = {
    zustand: zustand,
    zeichnen: function(){ moMasseAusZustand(); zeichne(); }
  };

  /* ⭐ 03.10.2026 (INP Treppen, Teil 2, Berta): NUR ERSETZEN, WAS SICH AENDERT.

     Bis hierher leerte `zeichne()` den Schrittbereich und baute ihn komplett
     neu — an der Treppe rund 470 Knoten raus und wieder rein, bei JEDER
     Eingabe, nach einer Masseingabe zweimal (Feld-Commit ueber
     `MO_HL.zeichnen` + Klick; der zweite Lauf bleibt noetig, er traegt
     zustand -> masse fuer den Preis). Jeder eingefuegte Knoten kostet Stil und
     Layout, Shopifys Pixel-Skript misst ihn mit getBoundingClientRect
     („advanced DOM events" der Clarity-App), und clarity.js schreibt ihn mit.

     Jetzt wird weiter ALLES gebaut wie bisher — Vorauswahl, Einrasten der
     Masse, jede Nebenwirkung der Zeichenfunktionen bleibt —, nur losgeloest.
     Danach wird je Schritt verglichen, Kopf und Koerper getrennt, ueber den
     Abdruck ihres Markups beim Bauen. Gleich: das stehende Element bleibt,
     samt allem, was andere Bloecke spaeter hineingehaengt haben (Skizze,
     Raumbild, Kontaktkasten-Umzug, Bildformat der Kacheln). Anders: ersetzen,
     genau wie vorher.

     🔴 Was NICHT im Markup steht, wird eigens verglichen:
       · Feldwerte (`value`, `selected` werden als Eigenschaft gesetzt, der
         Startwert der Massfelder steht als Attribut). Weicht nur ein Wert ab,
         wird er nachgetragen.
       · Der Fokus: Steht er in einem Teil, wird der Teil wie bisher ersetzt —
         sonst bliebe z. B. eine Auswahlliste nach der Wahl fokussiert stehen.
       · Was die Aufmass-Skizze von aussen liest (Befestigungsart, Bildwahl,
         Schalter am Wurzelelement): zaehlt zum Abdruck des Koerpers mit dem
         Massfeld.
     🔴 Der Koerper MIT der Aufmass-Skizze bleibt nur bei der Treppe stehen.
       `einsetzen()` frischt eine stehende Skizze nur auf; ein frischer Kasten
       wird dagegen losgeloest gezeichnet (misst 0) und bekommt danach Lupe,
       Bildunterschrift, Fusszeile. Fuer die Treppe ist das nachgebildet
       (`__moWieNeu`, siehe einsetzen), fuer Foto-Skizze und Wandhandlauf nicht —
       dort wird der Koerper wie bisher ersetzt.
     ⚠️ Aendert sich die Klasse eines Schritts (auf/zu, fertig), wird sein Kopf
     immer ersetzt: So laeuft keine CSS-Animation an, die es beim Neubau nie
     gab. Der Koerper darf bleiben — dort haengt die teure Skizze. */
  var MO_FELDER_SEL = 'input,select,textarea';

  function moSkizzenUmfeld(){
    var wz = document.querySelector('[data-mo-konfigurator]');
    var t = [window.moBefestigungsArt(zustand),
             Object.prototype.hasOwnProperty.call(zustand, 'Befestigung') ? 'b' : ''];
    ['data-mo-skizzenbild', 'data-mo-skizze-zeichnen', 'data-mo-skizze-groesse',
     'data-mo-skizze-wand', 'data-mo-3d', 'data-mo-felder-weg', 'data-mo-felder-unten',
     'data-mo-vollbild'].forEach(function(a){ t.push(wz ? wz.getAttribute(a) : ''); });
    return t.join('|');
  }

  function moSkizzeStehenLassen(){
    var wz = document.querySelector('[data-mo-konfigurator]');
    return !!(wz && wz.getAttribute('data-mo-skizze-zeichnen') === 'treppe');
  }

  function moAbdruck(el){
    /* Der Startwert eines Eingabefelds zaehlt als Feldwert (wird
       nachgetragen), nicht als Bauunterschied. */
    var s = el.outerHTML.replace(/(<input\b[^>]*?) value="[^"]*"/g, '$1');
    if (el.querySelector('.mo-massfeld')) s += '\u0001' + moSkizzenUmfeld();
    return s;
  }

  /* Die Feldliste wird beim BAUEN gemerkt: Spaeter haengen andere Bloecke
     eigene Felder hinein (Regler des Raumbilds), die zaehlen nicht mit. */
  function moMerken(el, abdruck){
    el.__moAbdruck = abdruck;
    el.__moFelder = Array.prototype.slice.call(el.querySelectorAll(MO_FELDER_SEL));
  }

  /* Darf das stehende Element bleiben? Abweichende Feldwerte werden dabei
     nachgetragen, damit es dem frisch gebauten in allem gleicht. */
  function moDarfBleiben(alt, neu, abdruck){
    if (!alt || alt.__moAbdruck !== abdruck) return false;
    var fa = alt.__moFelder || [], fn = neu.querySelectorAll(MO_FELDER_SEL);
    if (fa.length !== fn.length) return false;
    var i, a, b;
    for (i = 0; i < fa.length; i++) {
      a = fa[i]; b = fn[i];
      if (!alt.contains(a) || a.tagName !== b.tagName || a.type !== b.type ||
          a.checked !== b.checked) return false;
      if (a.value !== b.value && a.type === 'file') return false;
    }
    /* Bildformat einer Kachelgruppe: Es misst das ZUERST geladene Bild (siehe
       bildMitFormat). Nach einem Neubau ist das immer das erste Bild der
       Gruppe — alles liegt im Speicher —, beim Seitenaufruf aber das schnellste
       aus dem Netz (Balkon, Befestigungsmittel: 1,0 oder 1,6). Steht ein
       anderes Format da, als das erste Bild ergibt, wird ersetzt wie bisher;
       danach stimmt es und bleibt stehen. */
    moBilderAnstossen(alt);
    var raster = alt.querySelectorAll('.mo-kacheln');
    for (i = 0; i < raster.length; i++) {
      var erstes = raster[i].querySelector('img');
      if (erstes && erstes.complete && erstes.naturalWidth && erstes.naturalHeight &&
          raster[i].dataset.moFormat !== String(erstes.naturalWidth / erstes.naturalHeight)) return false;
    }
    for (i = 0; i < fa.length; i++) {
      a = fa[i]; b = fn[i];
      if (a.tagName === 'INPUT' && a.type !== 'file') {
        var start = b.getAttribute('value');
        if (a.getAttribute('value') !== start) {
          if (start === null) a.removeAttribute('value'); else a.setAttribute('value', start);
        }
      }
      if (a.value !== b.value) a.value = b.value;
    }
    return true;
  }

  /* Kachelbilder sind `loading=lazy`. Wer beim ersten Bau noch nicht im
     Speicher lag, bleibt in einem zugeklappten Schritt ungeladen — der Neubau
     holte sie bisher bei jedem Klick frisch, und ein Bild aus dem Speicher ist
     sofort da (samt Bildformat der Kachel). Ein stehendes Bild wird deshalb
     EINMAL angestossen, in derselben Reihenfolge wie `h()` baut: erst `src`,
     dann `loading`. Liegt die Datei im Speicher, ist es da wie nach dem
     Neubau, sonst bleibt es beim Nachladen. */
  function moBilderAnstossen(el){
    var b = el.getElementsByTagName('img');
    for (var i = 0; i < b.length; i++) {
      if (b[i].complete || b[i].__moAngestossen) continue;
      b[i].__moAngestossen = true;
      var q = b[i].getAttribute('src'), lz = b[i].getAttribute('loading');
      if (!q) continue;
      /* Was hinter `loading` steht (decoding), kommt danach wieder dahinter —
         das Markup bleibt Zeichen fuer Zeichen das des Neubaus. */
      var hinten = [], seit = false;
      for (var a = 0; a < b[i].attributes.length; a++) {
        var at = b[i].attributes[a];
        if (seit) hinten.push([at.name, at.value]);
        if (at.name === 'loading') seit = true;
      }
      if (lz !== null) b[i].removeAttribute('loading');
      b[i].setAttribute('src', q);
      if (lz !== null) b[i].setAttribute('loading', lz);
      for (var h2 = 0; h2 < hinten.length; h2++) {
        b[i].removeAttribute(hinten[h2][0]);
        b[i].setAttribute(hinten[h2][0], hinten[h2][1]);
      }
    }
  }

  /* Gibt true zurueck, wenn das stehende Element geblieben ist. */
  function moTeilAbgleichen(eltern, alt, neu, erzwingen){
    var abdruck = moAbdruck(neu);
    var fokus = document.activeElement;
    var fokusDrin = !!(fokus && fokus !== document.body && alt.contains(fokus));
    if (!erzwingen && !fokusDrin && moDarfBleiben(alt, neu, abdruck)) return true;
    eltern.replaceChild(neu, alt);
    moMerken(neu, abdruck);
    return false;
  }

  function moSchritteAbgleichen(ziel, neu){
    var alt = Array.prototype.slice.call(ziel.children);
    var skizzeBleibt = moSkizzeStehenLassen();
    neu.forEach(function(n, k){
      var a = alt[k];
      var schritt = n.classList.contains('mo-schritt') && n.children.length === 2;
      if (a && schritt && a.__moSchritt && a.children.length === 2) {
        var kopfA = a.children[0], koerperA = a.children[1];
        var kopfN = n.children[0], koerperN = n.children[1];
        var klasseNeu = a.className !== n.className;
        if (klasseNeu) a.className = n.className;
        moTeilAbgleichen(a, kopfA, kopfN, klasseNeu);
        var mitSkizze = !!koerperN.querySelector('.mo-massfeld');
        if (moTeilAbgleichen(a, koerperA, koerperN, mitSkizze && !skizzeBleibt) && mitSkizze) {
          koerperA.__moWieNeu = true;           // einsetzen() behandelt ihn wie frisch gebaut
        }
        return;
      }
      if (a && !schritt && a.__moLose) {
        n.__moLose = true;
        moTeilAbgleichen(ziel, a, n, !!n.querySelector('.mo-massfeld') && !skizzeBleibt);
        return;
      }
      var abdruecke = schritt ? [moAbdruck(n.children[0]), moAbdruck(n.children[1])]
                              : [moAbdruck(n)];
      if (a) ziel.replaceChild(n, a); else ziel.appendChild(n);
      if (schritt) {
        n.__moSchritt = true;
        moMerken(n.children[0], abdruecke[0]);
        moMerken(n.children[1], abdruecke[1]);
      } else {
        n.__moLose = true;
        moMerken(n, abdruecke[0]);
      }
    });
    for (var k = neu.length; k < alt.length; k++) {
      if (alt[k].parentNode === ziel) ziel.removeChild(alt[k]);
    }
  }

  function zeichne(){
    halterNachfuehren();
    skizzenbildNachfuehren();
    var ziel = document.getElementById('mo-schritte');
    var neu = [];                 // losgeloest gebaut, danach moSchritteAbgleichen()
    var liste = schritte();

    /* Ein Schritt, der durch die letzte Auswahl NEU erschienen ist, klappt auf.

       Der Fall: Wer bei "Befestigungsmittel" den Lochstein waehlt, blendet
       damit den Schritt "Lochstein - Wandaufbau" ein. Der stand bisher
       zugeklappt darunter und sah aus wie erledigt - dabei ist er die direkte
       Rueckfrage zur eben getroffenen Wahl.

       Verglichen wird ueber den NAMEN, nicht ueber den Index: Kommt ein Schritt
       in der Mitte dazu, verschieben sich alle folgenden Indizes, und ein
       Indexvergleich wuerde jeden davon fuer neu halten.

       Beim allerersten Zeichnen bleibt es bei Schritt 1 - dort ist alles neu. */
    var namen = liste.map(function(g){ return g.name || g.label || ''; });
    if (LETZTE_SCHRITTE) {
      for (var n = 0; n < namen.length; n++) {
        if (LETZTE_SCHRITTE.indexOf(namen[n]) === -1) { offen = n; break; }
      }
    }
    LETZTE_SCHRITTE = namen;

    if(offen >= liste.length) offen = liste.length - 1;

    liste.forEach(function(g, i){
      var koerper = h('div', {class:'mo-schritt-koerper'});
      alleOptionen(g.options).forEach(function(o){
        var el = zeichneOption(o);
        if(el) koerper.appendChild(el);
      });
      var fertig = gruppeFertig(g);
      var kopf = h('button', {
        class:'mo-schritt-kopf', type:'button',
        onclick: function(){ offen = (offen === i ? -1 : i); zeichne(); }
      }, [
        // ⭐ Aufbau wie LPO: Nummer links, Titel daneben, die getroffene Wahl
        // DARUNTER (nicht rechts), Haken rechts aussen. Vorher stand die Wahl
        // rechts in der Kopfzeile und wurde auf schmalen Spalten abgeschnitten.
        h('span', {class:'mo-nr'}, [document.createTextNode(String(i+1))]),
        h('span', {class:'mo-schritt-text'}, [
          h('span', {class:'mo-schritt-titel'}, [document.createTextNode(schrittTitel(g))]),
          /* Fehlt ein Pflichtfeld, steht hier der rote Hinweis statt der
             (leeren) Wahl — Stefan am 24.08.: „in Rot bitte maß eintragen". */
          h('span', {class:'mo-schritt-wahl' + (fertig ? '' : ' mo-wahl-offen')},
            [document.createTextNode(fertig ? wahlText(g) : (wahlText(g) || offenText(g)))])
        ]),
        /* Farbfaecher — NUR bei der Farbwahl, sonst faellt die Spalte auf 0.
           Das Bild steckt als SVG im CSS: kein Netzabruf, immer scharf. */
        h('span', {
          'class': 'mo-kopfsymbol' +
                   (MO_KOPFSYMBOL && istFarbwahl(g) ? ' mo-kopfsymbol-farbe' : ''),
          'aria-hidden': 'true'
        }, []),
        h('span', {class:'mo-haken' + (fertig ? ' mo-haken-an' : '')},
          [document.createTextNode(fertig ? '✓' : '')])
      ]);
      kopf.__gruppe = g;   // fuer koepfeNachziehen() (04.10.2026)
      neu.push(h('div', {
        class:'mo-schritt' + (i === offen ? '' : ' mo-zu') + (fertig ? ' mo-kfertig' : '')
      }, [kopf, koerper]));
    });

    // ⭐ Optionen AUSSERHALB der Schritt-Gruppen — bei LPO stehen sie unter den
    // Schritten: "Sonstige Anmerkungen", "Skizze hochladen", "Anzahl".
    // Vorher fielen sie durch, weil schritte() nur Gruppen liefert.
    loseOptionen().forEach(function(o){
      var el = zeichneOption(o);
      if (el) { el.classList.add('mo-lose'); neu.push(el); }
    });
    moSchritteAbgleichen(ziel, neu);

    nurPreisNeu();
    moHlMelden();
  }

  // Alles auf oberster Ebene, was keine Gruppe ist und dargestellt werden kann.
  function loseOptionen(){
    return (CFG.options || []).filter(function(o){
      if (!o || o.type === 'group') return false;
      if (UEBERGANGEN.indexOf(o.type) > -1) return false;
      return sichtbar(o);
    });
  }

  /* ---------- Preis im Theme spiegeln ---------------------------------- */
  // Der Kunde sieht den Variantenpreis an zwei Stellen: in der klebenden
  // Kaufleiste oben und im Produktkopf. Beide muessen dem Konfigurator folgen —
  // sonst stehen 188,00 € und der konfigurierte Preis gleichzeitig auf der Seite.
  //
  // 🔴 Auf dieser Seite gibt es 14 Elemente mit dem Variantenpreis, davon 80
  // `.price-item` in Produktkacheln (.card-information) der Empfehlungen.
  // Die zeigen die Preise ANDERER Produkte und duerfen sich nie aendern.
  // Deshalb nur diese zwei Container, plus Sicherheitsnetz gegen Kacheln.
  var PREIS_ZIELE = '.product-sticky-price, .price--large';

  function preisSpiegeln(text){
    document.querySelectorAll(PREIS_ZIELE).forEach(function(box){
      if(box.closest('.card-information')) return;
      box.querySelectorAll('.price-item').forEach(function(el){
        if(el.getAttribute('data-mo-original') === null){
          el.setAttribute('data-mo-original', el.textContent);
        }
        moText(el, text);
      });
    });
  }

  function preisZuruecksetzen(){
    document.querySelectorAll('[data-mo-original]').forEach(function(el){
      moText(el, el.getAttribute('data-mo-original'));
    });
  }

  /* ⭐ 04.10.2026: SCHRITTKOEPFE NACH EINER MASSEINGABE NACHZIEHEN.

     Die Wahl im Kopf („3000 × 1200 mm“) entsteht in zeichne(). Eine Mass-
     eingabe baut aber nur um, wenn sich die Sichtsignatur aendert - sonst
     stand im Kopf weiter das alte Mass (Preispruefung Tore 04.10.2026).
     Hier nur Text, Rot-Markierung und Haken angleichen, kein Umbau. */
  function koepfeNachziehen(){
    document.querySelectorAll('.mo-schritt-kopf').forEach(function(k){
      var g = k.__gruppe;
      if (!g) return;
      var fertig = gruppeFertig(g);
      var w = k.querySelector('.mo-schritt-wahl');
      if (w) {
        var text = fertig ? wahlText(g) : (wahlText(g) || offenText(g));
        if (w.textContent !== text) w.textContent = text;
        w.classList.toggle('mo-wahl-offen', !fertig);
      }
      var hk = k.querySelector('.mo-haken');
      if (hk) {
        hk.classList.toggle('mo-haken-an', fertig);
        if (hk.textContent !== (fertig ? '✓' : '')) hk.textContent = fertig ? '✓' : '';
      }
    });
  }

  function nurPreisNeu(){
    // Kachelpreise fortschreiben — die Farbkacheln hängen an den Maßen
    document.querySelectorAll('.mo-kachel').forEach(function(k){
      if(!k.__wert || !k.__preisEl) return;
      var p = wertPreis(k.__wert);
      // ⭐ `params.priceTemplate` der Option bestimmt die Schreibweise
      // (in der Fenstergitter-Config: "+ {price}"). Ohne die Vorlage bliebe
      // es beim fest verdrahteten "+ ".
      var vorlage = (k.__optParams && k.__optParams.priceTemplate) || '+ {price}';
      /* 🔴 Negativer Preis braucht eine eigene Schreibweise. Die Vorlage
         lautet '+ {price}'; bei -5 stuende dort „+ -5,00 €". Ein Abschlag
         wird als Vorteil formuliert, nicht als Rechenzeichen. */
      moText(k.__preisEl, !p ? ''
        : (p < 0 ? euro(-p) + ' günstiger'
                 : vorlage.replace('{price}', euro(p))));
    });

    var r = rechne();
    var zeilen = document.getElementById('mo-preiszeilen');
    /* ⭐ 03.10.2026 (INP Treppen, Teil 2): losgeloest bauen und nur bei einem
       Unterschied tauschen — ein Klick auf einen Schrittkopf aendert keinen
       Preis, baute die Zeilen (40–80 Knoten) aber jedes Mal neu. */
    var zeilenNeu = document.createElement('div');
    r.zeilen.forEach(function(z){
      /* Der Name steht KLEIN UEBER dem Wert, nicht davor — Stefan am
         25.08.2026, Variante B. Einzeilig mit Doppelpunkt braeche mobil um:
         die laengste Zeile im Shop hat 64 Zeichen, neben den Preis passen 36.

         `h()` wirft `null`-Kinder weg, die Bedingung darf also direkt in die
         Liste. Die Grundpreiszeile ("Gitter nach Mass") hat keine Gruppe und
         bleibt damit unveraendert einzeilig. */
      var links = h('span', {}, [
        z.gruppe ? h('small', {class:'mo-zeile-gruppe'}, [document.createTextNode(z.gruppe)]) : null,
        document.createTextNode(z.name)
      ]);
      zeilenNeu.appendChild(h('div', {class:'mo-zeile' + (z.gruppe ? ' mo-zeile-benannt' : '')}, [
        links,
        /* 0 EUR heisst "inkl." — ein Nullbetrag laedt zur Rueckfrage ein.
           Leiser gesetzt als die echten Betraege (`mo-zeile-frei`). */
        h('span', z.preis ? {} : {class:'mo-zeile-frei'},
          [document.createTextNode(z.preis === null ? '–' : (z.preis ? euro(z.preis) : 'inkl.'))])
      ]));
    });
    if (zeilen.innerHTML !== zeilenNeu.innerHTML) {
      zeilen.textContent = '';
      while (zeilenNeu.firstChild) zeilen.appendChild(zeilenNeu.firstChild);
    }
    // Alle Ausgabefelder sind optional — die Section blendet je nach
    // Einstellung welche aus. Fehlt eines, darf das nichts kaputtmachen.
    function setz(id, wert){ var el = document.getElementById(id); if(el) moText(el, wert); }

    /* DIE ANZAHL GEHOERT IN DIE PREISBOX.

       Bis 22.08.2026 stand bei Anzahl 4 dieselbe Zahl wie bei Anzahl 1.
       Technisch war das richtig - `quantity` geht an /cart/add.js, und LPOs
       Function setzt `fixedPricePerUnit`, der Aufpreis gilt also je Stueck.
       Nur sah man es nicht: 509,31 EUR liest sich als Gesamtpreis, obwohl im
       Warenkorb das Vierfache landet.

       Deshalb jetzt zwei Zeilen: Was ein Stueck kostet, und was alle kosten.
       Bei Anzahl 1 bleibt die Stueckzeile leer - dort waere sie nur Rauschen.

       Wichtig fuer die Montagesaetze: Sie stecken als Aufpreis IM Stueckpreis
       ([[versandstaffel-stueckzaehler]] - 1 Bauteil = 1 Satz). Vier Gitter
       ziehen damit vier Saetze nach sich, ohne dass hier etwas zu rechnen
       waere. Wer die Saetze je aus dem Stueckpreis herausloest, muss sie hier
       eigens multiplizieren. */
    var gesamt = r.summe * menge;
    var txt = r.vollstaendig ? euro(gesamt) : '–';

    setz('mo-gesamt', txt);
    setz('mo-gesamt-mobil', txt);
    setz('mo-netto', r.vollstaendig ? euro(gesamt / 1.19) : '–');
    setz('mo-stueck', (r.vollstaendig && menge > 1)
      ? menge + ' × ' + euro(r.summe) + ' je Stück'
      : '');
    // Pflichtangabe nach PAngV, Text aus der Config (`summaryTemplate` der
    // Option vom Typ price-summary). Der Konfigurator zeigt einen Preis an,
    // also muss der Hinweis auf MwSt. und Versandkosten daneben stehen -
    // dass er weiter unten im Theme noch einmal auftaucht, genuegt nicht.
    setz('mo-preis-fuss', preisFussText());
    var kaufen = document.getElementById('mo-kaufen');
    if(kaufen) kaufen.disabled = !r.vollstaendig;
    /* 🔴 Der KLEBENDE Knopf des Themes muss denselben Zustand tragen.
       Er wurde bisher nur beim Klick umgeleitet, sah aber immer aktiv aus —
       der Kunde klickte auf einen leuchtenden Knopf und es scrollte bloss.
       Stefan am 01.09.2026: „wir haben das 10x angesprochen." */
    klebeknopfSpiegeln(!r.vollstaendig);

    // Solange keine Maße stehen, gilt der Variantenpreis des Themes.
    // Der Theme-Preis oben zeigt bewusst den STUECKPREIS: Shopify verrechnet
    // die Menge selbst, und der Variantenpreis ist dort immer ein Stueckpreis.
    if(r.vollstaendig) preisSpiegeln(euro(r.summe)); else preisZuruecksetzen();
    // Preiszeile ueber dem Produktbild (Masse aus dem Link, 02.10.2026)
    urlPreisZeigen(r);

    /* 🔴 DAS SKIZZEN-MASS MUSS MIT — 27.08.2026.

       Gemessen am Wandhandlauf: Feld 140, Skizze weiter „Länge: 120 mm", auch
       nach 700 ms. Die GEZEICHNETE Skizze liest ihr Mass aus
       `data-mo-skizze-mass`, und das setzt nur `skizzenbildNachfuehren()` —
       bis hierher allein aus `zeichne()` heraus.

       Beim Druck auf + oder − laeuft aber kein `zeichne()`: `stellen()` ruft
       `nurPreisNeu()` und `massUmbauSpaeter()`, und letzteres bricht ab, sobald
       `sichtSignatur()` gleich bleibt. Die Signatur traegt bewusst nur die
       SCHWELLEN, nicht das Mass (siehe die Notiz dort) — 120 auf 140
       ueberschreitet keine, also blieb das Attribut stehen.

       ⚠️ VOR `melden()`, nicht danach: Der Horcher liest genau das Attribut,
       das dieser Aufruf setzt. Andersherum zeichnete er den Stand von vorher.

       ⚠️ Kostet nichts: Die Funktion setzt vier Attribute und baut kein DOM.
       Das teure Neuzeichnen bleibt weiter der halben Sekunde in
       `massUmbauSpaeter()` vorbehalten. */
    skizzenbildNachfuehren();

    // ⭐ Der Haken für die Live-Vorschau (mo-vorschau.js) und alles Weitere,
    // was auf den Zustand reagieren soll. MUSS hier stehen, nicht am Ende der
    // Funktion: unten kehrt sie bei fehlendem Kontrollkasten früh zurück
    // (`if(!pre) return`), das Ereignis käme dann im Theme nie an.
    window.moKonfig.melden({
      zustand: zustand, masse: masse, summe: r.summe, vollstaendig: r.vollstaendig
    });

    var e = eigenschaften();
    var pre = document.getElementById('mo-cartjson');
    if(!pre) return;                     // Kontrollkasten ausgeschaltet
    pre.textContent = '';
    Object.keys(e).forEach(function(k){
      var kl = h('span', {class:'k'}, [document.createTextNode(k)]);
      pre.appendChild(kl);
      pre.appendChild(document.createTextNode(': '));
      pre.appendChild(h('span', {class:'t'}, [document.createTextNode(e[k])]));
      pre.appendChild(document.createTextNode('\n'));
    });
  }

  /* ---------- Stellschrauben und Kaufknopf ---------------------------- */
  // 🔴 Die Spielfelder gibt es NUR in der Testdatei. Im Theme fehlen sie —
  // ein ungeprüftes addEventListener wirft dort und verhindert das Zeichnen.
  var vpFeld = document.getElementById('mo-vp');
  if(vpFeld) vpFeld.addEventListener('input', nurPreisNeu);

  var faktorFeld = document.getElementById('mo-faktor');
  if(faktorFeld) faktorFeld.addEventListener('input', function(ev){
    var traeger = document.querySelector('[data-preis-faktor]');
    if(traeger) traeger.setAttribute('data-preis-faktor', ev.target.value);
    nurPreisNeu();
  });

  /* Was fehlt noch? Liefert die Meldungen zu allen offenen Pflichtfeldern.

     \U0001F534 BIS ZUM 23.08.2026 WURDE BEIM KAUFKLICK GAR NICHTS GEPRUEFT.
     Der Knopf war zwar gesperrt, solange die Masse fehlten - eine fehlende
     Pflichtauswahl fiel aber durch. Die Bestellung waere ohne sie
     durchgelaufen.

     \u2b50 Die Meldung kommt aus der Config (`validationMsg`), nicht aus dem
     Code: "Bitte waehlen Sie eine Befestigung aus - oder 'Ohne', falls Sie
     eigene Schrauben verwenden." Das ist praeziser als jedes allgemeine
     "Bitte ausfuellen", und wer sie aendern will, aendert die Config. */
  function wasFehlt(){
    var offen = [];
    FLACH.forEach(function(o){
      if (!o.required) return;
      if (UEBERGANGEN.indexOf(o.type) > -1) return;
      if (!sichtbar(o)) return;                        // ausgeblendet zaehlt nicht

      var fehlt = (o.type === 'dimension')
        ? (!masse.x || (!(o.params && o.params.onlyX) && !masse.y))
        : !zustand[o.name];
      var p = o.params || {};
      /* 🔴 16.09.2026: Ein Zahlenfeld ausserhalb seiner Grenzen ist NICHT
         fertig — sonst ginge ein Balkonschenkel von 99.999 mm fuer 7.403,63 EUR
         in den Warenkorb (gemessen). Eigene Meldung mit dem erlaubten Bereich,
         damit der Kunde nicht ein leeres Feld sucht, das es nicht gibt. */
      if (!fehlt && o.type === 'number' && !grenzeZahl(o)) {
        var bereich = (p.min != null && p.max != null)
          ? 'bitte einen Wert von ' + p.min + ' bis ' + p.max + ' eintragen.'
          : 'bitte eine g\u00fcltige Zahl eintragen.';
        offen.push({
          option: o,
          text: '\u201e' + String(o.label || o.name).replace(/:$/, '') + '\u201c: ' + bereich
        });
        return;
      }
      if (!fehlt) return;

      offen.push({
        option: o,
        text: p.validationMsg ||
              ('Bitte treffen Sie eine Auswahl bei \u201e' +
               String(o.label || o.name).replace(/:$/, '') + '\u201c.')
      });
    });
    return offen;
  }

  /* Springt zur ersten offenen Pflichtangabe und klappt ihren Schritt auf.
     Eine Meldung allein hilft nicht, wenn das Feld drei Schritte weiter oben
     zugeklappt liegt. */
  function zumFehlerSpringen(o){
    /* ⭐ Erst ueber den Config-Namen suchen - das ist der einzige Schluessel,
       der zwischen Config und DOM sicher gleich ist. Der Textvergleich bleibt
       als Rueckfall fuer Elemente, die noch kein `data-mo-opt` tragen. */
    var ziel = null;
    if (o && o.name) ziel = document.querySelector('.mo-opt[data-mo-opt="' +
                              String(o.name).replace(/"/g, '\\"') + '"]');
    if (!ziel) {
      var alle = document.querySelectorAll('.mo-opt');
      for (var i = 0; i < alle.length; i++) {
        var lab = ((alle[i].querySelector('.mo-label') || {}).textContent || '')
                    .trim().replace(/\s*\*?\s*i?$/, '').trim();
        if (lab === String(o.label || o.name).replace(/:$/, '').trim()) { ziel = alle[i]; break; }
      }
    }
    if (!ziel) return;

    /* 🔴 DAS AUFKLAPPEN ZEICHNET DIE OPTION NEU. Wer danach auf dem alten
       Element scrollt, scrollt auf einem Knoten, der nicht mehr im Dokument
       haengt - es passiert nichts. Am 26.08.2026 genau so gemessen:
       `scrollIntoView` von Hand aufgerufen sprang auf 1729, aus dieser
       Funktion heraus blieb scrollY vier Sekunden lang 0.
       Deshalb: aufklappen, kurz warten, Ziel NEU suchen, dann erst scrollen. */
    var schritt = ziel.closest('.mo-schritt');
    var musstAufklappen = !!(schritt && schritt.classList.contains('mo-zu'));
    if (musstAufklappen) {
      var kopf = schritt.querySelector('.mo-schritt-kopf');
      if (kopf) kopf.click();
    }

    var name = o && o.name ? String(o.name) : '';
    setTimeout(function(){
      var el = name ? document.querySelector('.mo-opt[data-mo-opt="' +
                        name.replace(/"/g, '\\"') + '"]') : null;
      if (!el || !document.contains(el)) el = document.contains(ziel) ? ziel : null;
      if (!el) return;
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el.classList.add('mo-opt-fehlt');
      setTimeout(function(){ el.classList.remove('mo-opt-fehlt'); }, 2400);
    }, musstAufklappen ? 320 : 0);
  }

  /* ======================================================================
     EINE WARENKORBPOSITION NACHTRAEGLICH BEARBEITEN

     Der Warenkorb zeigt an Konfigurator-Positionen "Masse oder Ausstattung
     aendern". Der Link fuehrt hierher zurueck, mit `?mo-bearbeiten=<Zeile>`.

     \u2b50 PAGESPEED: Der Block kostet im Normalfall NICHTS. Ohne die Variable
     steigt er in der ersten Zeile aus - kein `/cart.js`-Abruf, kein
     DOM-Zugriff. Nur wer wirklich bearbeitet, zahlt den einen Abruf.

     \u26a0\ufe0f DIE DATEI LAESST SICH NICHT ZURUECKLEGEN. Im Warenkorb steht eine
     CDN-Adresse, kein File-Objekt - und ein `<input type="file">` laesst sich
     aus Sicherheitsgruenden nicht per Skript fuellen. Die vorhandene Skizze
     wird deshalb angezeigt und beim Speichern uebernommen, solange der Kunde
     keine neue waehlt.
     ====================================================================== */
  var bearbeiteZeile = null;
  var bearbeiteKey = null;         // der Schluessel der Position, die ersetzt wird

  (function bearbeitenVorbereiten(){
    var m = location.search.match(/[?&]mo-bearbeiten=(\d+)/);
    if (!m) return;                                   // Normalfall: nichts tun
    bearbeiteZeile = parseInt(m[1], 10);

    fetch('/cart.js', { cache: 'no-store' })
      .then(function (a) { return a.ok ? a.json() : null; })
      .then(function (c) {
        var pos = c && c.items && c.items[bearbeiteZeile - 1];
        if (!pos || !pos.properties) { bearbeiteZeile = null; return; }

        /* 🔴 23.09.2026 (Sicherheitspruefung): GEHOERT DIE ZEILE ZU DIESEM
           PRODUKT? Der Link traegt nur eine Nummer. Hat sich der Warenkorb
           seither verschoben — zweiter Reiter, eine Zeile geloescht, alter
           Link aus dem Verlauf —, laege an Nummer N eine FREMDE Position. Sie
           wuerde hier geladen und beim Speichern ueber ihren `key` GELOESCHT:
           Warenkorb [Fenstergitter, Balkon], Balkonseite mit ?mo-bearbeiten=1
           -> Gitterwerte im Balkon, nach dem Klick ist das Gitter weg.
           Verglichen wird der Produkt-Handle aus der Adresse (gilt auch bei
           mehreren Varianten), ersatzweise die Variante. */
        var hierHandle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
        try { hierHandle = hierHandle && decodeURIComponent(hierHandle); } catch (e) {}
        var hierVariante = WURZEL && WURZEL.getAttribute('data-varianten-id');
        var fremd = hierHandle ? (!!pos.handle && pos.handle !== hierHandle)
                               : (!!hierVariante && String(pos.variant_id) !== String(hierVariante));
        if (fremd) {
          console.warn('[mo-konfigurator] Bearbeiten: Zeile ' + bearbeiteZeile +
                       ' gehoert zu einem anderen Produkt — nichts geladen, nichts geloescht.');
          bearbeiteZeile = null;
          return;
        }

        /* 🔴 DEN SCHLUESSEL MERKEN, NICHT DIE ZEILENNUMMER.

           Erster Anlauf loeschte ueber `line: <Nummer>`. Das ging schief:
           Shopify sortiert den Warenkorb nach dem Anlegen neu, und die alte
           Nummer traf danach die FRISCH angelegte Zeile. Ergebnis am
           23.08.2026 gemessen: eine Position mit den ALTEN Werten - die
           Aenderung war spurlos weg, und es sah aus, als haette es geklappt.

           Der `key` bleibt an seiner Position kleben, egal wie umsortiert
           wird. */
        bearbeiteKey = pos.key || null;

        var p = pos.properties;

        /* Die Masse kommen aus den `_`-Feldern, nicht aus dem Anzeigetext.
           `Masse: Befestigungsabstand=1200 mm x Hoehe=900 mm` muesste man
           zerlegen und haengt an der Formulierung; `_Masse_x` ist die Zahl. */
        /* 🔴 23.09.2026: ganze Millimeter, mindestens 1. „5e-324" aus einer
           manipulierten Zeile war positiv und kam ungerundet in den Zustand —
           die Balkonzeichnung lief damit in eine Endlosschleife. */
        var mmAus = function (v) {
          var n = Math.round(parseFloat(v));
          return (isFinite(n) && n >= 1) ? String(n) : null;
        };
        if (mmAus(p['_Ma\u00dfe_x'])) masse.x = mmAus(p['_Ma\u00dfe_x']);
        if (mmAus(p['_Ma\u00dfe_y'])) masse.y = mmAus(p['_Ma\u00dfe_y']);

        /* Die uebrigen Eigenschaften zurueck in den Zustand. Der Warenkorb
           traegt die BESCHRIFTUNG als Schluessel (seit 23.08.), der Zustand
           aber den internen Namen - deshalb ueber zeilenName() zuordnen
           statt direkt. */
        FLACH.forEach(function (o) {
          if (!o.name) return;
          var schluessel = zeilenName(o);
          if (p[schluessel] != null && p[schluessel] !== '') {
            /* 🔴 23.09.2026: nur uebernehmen, was die Config KENNT. Eine
               Auswahl muss einer ihrer Werte sein — „Glas " mit Leerzeichen
               bestand sonst die Pflichtpruefung (die fragt nur „nicht leer"),
               brachte aber keinen Aufpreis. Ein Zahlenfeld nimmt nur eine
               schlichte Zahl — „1,5e3" las die Grenzpruefung als 1500, die
               Preisformel als 1. Was nicht passt, bleibt leer; die
               Pflichtpruefung verlangt es dann neu. */
            var wert = p[schluessel];
            if (o.values && o.values.length) {
              var bekannt = o.values.some(function (v) { return v && v.value === wert; });
              if (!bekannt) return;
            } else if (o.type === 'number') {
              if (!/^\d+([.,]\d+)?$/.test(String(wert).trim())) return;
            }
            zustand[o.name] = wert;
          }
        });

        if (p['Sonstige Anmerkungen']) anmerkung = p['Sonstige Anmerkungen'];
        if (p['Skizze']) skizze = String(p['Skizze']).split('/').pop();
        if (pos.quantity) menge = pos.quantity;

        LETZTE_SICHT = null;      // Sichtbarkeit neu bestimmen
        zeichne();
        hinweisBearbeiten();
      })
      .catch(function () { bearbeiteZeile = null; });
  })();

  /* Ein deutlicher Hinweis, dass hier eine vorhandene Position geaendert wird
     und nicht eine zweite entsteht. Ohne ihn legt der Kunde im Zweifel ein
     zweites Gitter an. */
  function hinweisBearbeiten(){
    if (!bearbeiteZeile) return;
    var wurzel = document.querySelector('[data-mo-konfigurator]');
    if (!wurzel || document.getElementById('mo-bearbeiten-hinweis')) return;

    var kasten = h('div', {class:'mo-bearbeiten-hinweis', id:'mo-bearbeiten-hinweis'}, [
      document.createTextNode('Sie \u00e4ndern eine Position aus Ihrem Warenkorb. ')
    ]);
    var abbrechen = h('a', {href: location.pathname, class:'mo-bearbeiten-ab'},
      [document.createTextNode('Abbrechen')]);
    kasten.appendChild(abbrechen);
    wurzel.insertBefore(kasten, wurzel.firstChild);

    var knopf = document.getElementById('mo-kaufen');
    if (knopf) knopf.textContent = '\u00c4nderung \u00fcbernehmen';
  }

  /* ⭐ WARENKORB-SCHUBLADE STATT SEITENWECHSEL — 01.09.2026

     Stefan: „Der soll immer kommen wenn wir was in den warenkorb machen —
     nicht die warenkorb seite sondern der slider." Und: „conversionstark".

     Ein Seitenwechsel reisst den Kunden aus dem Konfigurator. Die Schublade
     legt sich darueber: Er sieht seine Position und kann weiterkonfigurieren
     oder zur Kasse — ohne Kontextverlust.

     🔴 `cart_type` stand im Theme laengst auf `drawer`. Das Problem war nicht
     die Einstellung, sondern dieser eigene Kaufweg: Er ging am Ende hart auf
     `/cart`.

     🔴 Ohne `sections` im Aufruf liefert Shopify kein gerendertes Markup —
     die Schublade haette nichts anzuzeigen. Nur `open()` zu rufen genuegt
     also nicht. So macht es auch `product-form.js` des Themes. */
  function moWarenkorbZiel(){
    return document.querySelector('cart-drawer')
        || document.querySelector('cart-notification');
  }

  function moSektionenAnhaengen(setze){
    var ziel = moWarenkorbZiel();
    if (!ziel || typeof ziel.getSectionsToRender !== 'function') return;
    try {
      var ids = ziel.getSectionsToRender().map(function(a){ return a.id; });
      setze('sections', ids.join(','));
      setze('sections_url', window.location.pathname);
      if (typeof ziel.setActiveElement === 'function') {
        ziel.setActiveElement(document.activeElement);
      }
    } catch (e) {
      console.warn('[mo-konfigurator] Abschnitte nicht anzuhaengen', e);
    }
  }

  function moWarenkorbZeigen(antwort){
    var ziel = moWarenkorbZiel();
    /* 🔴 Rueckfall behalten: Fehlt die Schublade oder scheitert das Rendern,
       fuehrt der Weg weiter auf /cart. Ein Kunde darf nie danebenstehen,
       weil ein Theme-Element fehlt. */
    if (!ziel || !antwort || !antwort.sections ||
        typeof ziel.renderContents !== 'function') {
      setTimeout(function(){ window.location.href = '/cart'; }, 600);
      return;
    }
    try {
      /* 🔴 NICHT selbst `open()` rufen. `renderContents()` tut das am Ende
         schon (cart-drawer.js:63, cart-notification.js). Ein zweiter Aufruf
         setzt einen zweiten `transitionend`-Horcher und trappt den Fokus ein
         zweites Mal — wer mit der Tastatur bedient, kommt daraus schlecht
         wieder heraus. */
      ziel.renderContents(antwort);

      /* 🔴 Die AEUSSERE `is-empty` abraeumen. `renderContents()` entfernt nur
         die innere an `.drawer__inner`. Bleibt die aeussere stehen, trappt
         `open()` den Fokus auf `.drawer__inner-empty` (cart-drawer.js:34):
         Die Schublade geht auf und meldet „Einkaufswagen leer", obwohl gerade
         etwas hineingelegt wurde. So macht es auch product-form.js. */
      if (ziel.classList.contains('is-empty')) ziel.classList.remove('is-empty');
    } catch (e) {
      console.warn('[mo-konfigurator] Schublade nicht zu oeffnen', e);
      setTimeout(function(){ window.location.href = '/cart'; }, 600);
    }
  }

  var kaufKnopf = document.getElementById('mo-kaufen');

  /* ---------- Was noch offen ist, UNTER dem Kaufknopf ----------------

     Bewusst NEUTRAL, nicht rot: Der Kunde hat nichts falsch gemacht, er ist
     nur noch nicht fertig. Der rote Kasten `#mo-kauffehler` bleibt fuer den
     Fall, dass jemand trotzdem klickt — dann ist es eine Antwort auf eine
     Handlung und darf deutlicher ausfallen.

     ⭐ Gezeigt werden nur die NAMEN der offenen Angaben, nicht die vollen
     Saetze aus `wasFehlt()`. Bei drei offenen Punkten stuenden dort sonst
     drei Zeilen Fliesstext unter dem Knopf. */
  (function(){
    if (!kaufKnopf || !kaufKnopf.parentNode) return;
    var hinweis = document.createElement('div');
    hinweis.className = 'mo-offen';
    hinweis.hidden = true;
    kaufKnopf.parentNode.insertBefore(hinweis, kaufKnopf.nextSibling);

    function auffrischen(){
      var offen = wasFehlt();
      /* ⭐ 27.09.2026: Der rote Kasten vom letzten Klick (#mo-kauffehler) geht
         mit - er nennt nur noch, was WIRKLICH fehlt, und verschwindet, sobald
         alles da ist. Vorher stand „Bitte treffen Sie eine Auswahl bei Winkel …"
         weiter unter dem Knopf, obwohl die Winkel eingetragen waren (gemessen
         am Balkon, U-Form). */
      var kf = document.getElementById('mo-kauffehler');
      if (kf && !kf.hidden) {
        kf.textContent = '';
        offen.forEach(function(f){
          var z = document.createElement('div');
          z.textContent = f.text;
          kf.appendChild(z);
        });
        if (!offen.length) kf.hidden = true;
      }
      if (!offen.length) { hinweis.hidden = true; hinweis.textContent = ''; return; }
      var namen = offen.map(function(f){
        return String((f.option && (f.option.label || f.option.name)) || '')
               .replace(/:$/, '').trim();
      }).filter(Boolean);
      hinweis.textContent = 'Noch offen: ' + namen.join(' \u00b7 ');
      hinweis.hidden = false;
    }

    /* `mo:konfig` feuert bei jeder Aenderung - Auswahl, Mass, Menge. Ein
       eigener Beobachter waere hier reine Doppelung. */
    document.addEventListener('mo:konfig', auffrischen);
    auffrischen();
  })();
  if(kaufKnopf) kaufKnopf.addEventListener('click', function(){
    var offen = wasFehlt();
    if (offen.length) {
      var kasten = document.getElementById('mo-kauffehler');
      if (kasten) {
        kasten.textContent = '';
        offen.forEach(function(f){
          var z = document.createElement('div');
          z.textContent = f.text;
          kasten.appendChild(z);
        });
        kasten.hidden = false;
      }
      zumFehlerSpringen(offen[0].option);
      return;                                          // nichts absenden
    }
    var kasten = document.getElementById('mo-kauffehler');
    if (kasten) { kasten.hidden = true; kasten.textContent = ''; }

    var e = eigenschaften();
    var variante = WURZEL && WURZEL.getAttribute('data-varianten-id');

    // Ohne Varianten-ID (Testdatei) nur zeigen, was ginge.
    if(!variante){
      console.log('Das ginge an /cart/add.js:', { quantity:menge, properties:e });
      alert('Testlauf — nichts wurde gesendet.\n\n' +
            Object.keys(e).map(function(k){ return k + ': ' + e[k]; }).join('\n'));
      return;
    }

    kaufKnopf.disabled = true;
    var alterText = kaufKnopf.textContent;
    kaufKnopf.textContent = 'Wird hinzugefügt …';

    /* \u2b50 MIT DATEI GEHT NUR FormData, OHNE DATEI IST JSON EINFACHER.

       Shopify nimmt Datei-Eigenschaften ausschliesslich als
       `multipart/form-data` entgegen - JSON kann keine Binaerdaten tragen.
       FormData setzt den Content-Type samt `boundary` selbst; ihn von Hand zu
       setzen zerstoert die Nachricht.

       \u26a0\ufe0f Der Feldname MUSS `properties[...]` lauten. Ohne die Klammern
       landet der Wert als Formularfeld statt als Zeilen-Eigenschaft und
       taucht in der Bestellung nirgends auf.

       \u26a0\ufe0f FormData kennt kein `items[]` wie die JSON-Form - eine
       FormData-Anfrage legt immer GENAU EINE Zeile an. Fuer uns kein Verlust:
       Der Konfigurator kauft ohnehin ein Produkt auf einmal. */
    var anfrage;
    if (skizzeDatei) {
      var fd = new FormData();
      fd.append('id', String(variante));
      fd.append('quantity', String(menge));
      /* 🔴 'Skizze' UEBERSPRINGEN - sie kommt gleich als echte Datei.

         `eigenschaften()` setzt `e['Skizze']` auf den Dateinamen; das stammt
         aus der Zeit, als nur der Name mitging. Ohne dieses `return` stuende
         der Schluessel ZWEIMAL in der Nutzlast - einmal als Text, einmal als
         Datei. Am 23.08.2026 an der abgefangenen Anfrage gesehen:

             properties[Skizze]=aufmass-test.pdf
             properties[Skizze]=[DATEI aufmass-test.pdf, 38 B]

         Welcher Wert dann in der Bestellung landet, ist nirgends zugesichert.
         Gewinnt der Text, ist die Datei wieder weg - genau der Fehler, der
         am selben Tag behoben wurde. */
      Object.keys(e).forEach(function (k) {
        if (k === 'Skizze') return;
        fd.append('properties[' + k + ']', e[k]);
      });
      fd.append('properties[Skizze]', skizzeDatei, skizzeDatei.name);
      /* Die Abschnitte mitbestellen, sonst hat die Schublade nichts zu zeigen. */
      moSektionenAnhaengen(function(name, wert){ fd.append(name, wert); });
      anfrage = fetch('/cart/add.js', { method: 'POST', body: fd });
    } else {
      var nutzlast = { items: [{ id: Number(variante), quantity: menge, properties: e }] };
      /* Die Abschnitte mitbestellen, sonst hat die Schublade nichts zu zeigen. */
      moSektionenAnhaengen(function(name, wert){
        if (name === 'sections') nutzlast.sections = wert;
        else if (name === 'sections_url') nutzlast.sections_url = wert;
      });
      anfrage = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(nutzlast)
      });
    }
    anfrage
    /* \U0001F534 ERST ANLEGEN, DANN DIE ALTE ENTFERNEN - nie umgekehrt.

       Shopify kann eine Zeile nicht umschreiben. Wer zuerst loescht und das
       Anlegen scheitert, steht ohne Position da: Der Kunde hat seine
       Konfiguration verloren, obwohl er nur etwas aendern wollte.

       In dieser Reihenfolge ist der schlimmste Fall zwei Zeilen - aergerlich,
       aber reparabel, und der Kunde sieht es sofort. */
    .then(function (r) {
      if (r.ok && bearbeiteKey) {
        return fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: bearbeiteKey, quantity: 0 })
        }).then(function () { bearbeiteKey = null; bearbeiteZeile = null; return r; });
      }
      return r;
    })
    .then(function(r){
      if(!r.ok) return r.text().then(function(t){ throw new Error(t.slice(0,200)); });
      return r.json();
    })
    .then(function(antwort){
      kaufKnopf.textContent = '✓ Im Warenkorb';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      moWarenkorbZeigen(antwort);
    })
    .catch(function(err){
      console.error('[mo-konfigurator] Warenkorb:', err);
      kaufKnopf.textContent = alterText;
      kaufKnopf.disabled = false;
      alert('Das hat nicht geklappt. Bitte noch einmal versuchen.');
    });
  });

  /* ⭐ MASSE AUS DEM LINK — 02.10.2026

     Stefan (Google-Chat): „ich brauche den echten Preis in der Anzeige! dann
     müssen wir den konfigurator bearbeiten." Die Suchanzeige nennt einen echten
     Preis („Fenstergitter 1200 x 1000 mm | 320,09 €"). Wer klickt, landet auf

         /products/fenstergitter-02?breite=1200&hoehe=1000

     und sieht den Preis sofort, ohne Maße einzutippen. Optional dazu
     &befestigung=aussen oder &befestigung=laibung.

     ⭐ DERSELBE WEG WIE BEIM BEARBEITEN AUS DEM WARENKORB (bearbeitenVorbereiten):
     Die Werte gehen in `masse` (und `zustand`), das erste zeichne() gleich unten
     baut daraus alles - Preis oben und im Preiskasten, Haken am Schritt „Maße",
     Kaufknopf frei, Skizze, Warenkorbzeile `_Maße_x`/`_Maße_y`. Wer tippt und das
     Feld verlässt, landet bei genau diesem aufraeumen() + zeichne().

     🔴 ALLES ODER NICHTS. Übernommen wird nur, wenn
       · main-product es freischaltet (`data-mo-url-masse`, erstmal nur die
         Fenstergitter-Configs, wie mo-bild-felder),
       · kein ?mo-bearbeiten= dabei ist (das Bearbeiten gewinnt),
       · breite UND hoehe ganze Millimeter sind (nur Ziffern, keine Einheit),
       · es genau EIN sichtbares Maßfeld mit Breite und Höhe gibt, ohne
         gezeichnete Skizze (Treppe und Handlauf haben eigene Felder), und
       · beide Werte in dessen Grenzen aus der Config liegen (Fenstergitter
         300–2200 mm) bzw. in seiner festen Werteliste stehen.
     Sonst bleibt die Seite genau wie ohne Link. NIE auf die Grenze kappen: ein
     Preis für ein anderes Maß als in der Anzeige wäre schlimmer als keiner.
     Die Befestigung wirkt nur, wenn die Config den Wert anbietet - bei fest
     eingestellter Befestigungsart (`data-mo-befestigungsart`) bleibt sie stehen. */
  var URL_MASSE = null;

  (function urlMasseUebernehmen(){
    if (!WURZEL || !WURZEL.hasAttribute('data-mo-url-masse')) return;
    var q;
    try { q = new URLSearchParams(location.search); } catch (e) { return; }
    var bx = q.get('breite'), by = q.get('hoehe');
    if (bx === null && by === null) return;                  // Normalfall: nichts tun
    var ganz = /^[1-9][0-9]{0,4}$/;
    if (q.has('mo-bearbeiten') || !ganz.test(bx || '') || !ganz.test(by || '')) {
      console.info('[mo-konfigurator] Maße im Link ignoriert.');
      return;
    }
    /* Die Befestigung ZUERST: Sie kann bestimmen, welches Maßfeld sichtbar ist. */
    var befVorher = zustand['Befestigung'];
    var befWert = { aussen: 'Auf der Außenwand', laibung: 'In der Laibung' }[q.get('befestigung')];
    var befOpt = befWert ? FLACH.filter(function(o){ return o.name === 'Befestigung'; })[0] : null;
    if (befOpt && (befOpt.values || []).some(function(v){ return v && v.value === befWert; })) {
      zustand['Befestigung'] = befWert;
    }
    var dims = FLACH.filter(function(o){ return o.type === 'dimension' && sichtbar(o); });
    var p = (dims.length === 1 && dims[0].params) || null;
    var x = parseInt(bx, 10), y = parseInt(by, 10);
    function passt(w, min, max, liste){
      if (Array.isArray(liste) && liste.length) return liste.map(Number).indexOf(w) > -1;
      if (min == null || min === '' || max == null || max === '') return false;  // ohne Grenzen nie
      return w >= parseFloat(min) && w <= parseFloat(max);
    }
    if (!p || p.onlyX || p.skizzeZeichnen ||
        !passt(x, p.minX, p.maxX, p.werteX) || !passt(y, p.minY, p.maxY, p.werteY)) {
      if (befVorher === undefined) delete zustand['Befestigung'];
      else zustand['Befestigung'] = befVorher;
      console.info('[mo-konfigurator] Maße im Link ignoriert (außerhalb der Grenzen).');
      return;
    }
    masse.x = String(x);
    masse.y = String(y);
    URL_MASSE = { x: masse.x, y: masse.y };
  })();

  /* Die Preiszeile über dem Produktbild (`#mo-url-preis`, main-product). Ein
     Inline-Skript dort deckt sie beim ersten Malen der Seite auf und trägt das
     Maß aus dem Link ein - der Platz steht also, bevor dieser Motor läuft, und
     nichts springt, wenn hier der Preis dazukommt (CLS). Sie folgt jeder
     späteren Änderung der Maße; ohne gültiges Maß steht dort nur das Maß, nie
     ein alter Preis. Hat der Motor den Link verworfen, verschwindet sie. */
  function urlPreisZeigen(r){
    var leiste = document.getElementById('mo-url-preis');
    if (!leiste || leiste.hidden) return;
    if (!URL_MASSE) { leiste.hidden = true; return; }
    var da = !!r.vollstaendig;
    var mass = leiste.querySelector('.mo-url-preis-mass');
    var betrag = leiste.querySelector('.mo-url-preis-betrag');
    if (mass) mass.textContent = (moAnzeige(masse.x) || '–') + ' × ' +
      (moAnzeige(masse.y) || '–') + moEinheitText() + (da ? ': ' : '');
    if (betrag) betrag.textContent = da ? euro(r.summe) : '';
    leiste.classList.toggle('mo-url-preis-da', da);
  }

  aufraeumen();
  zeichne();
})();

/* ##########################################################################
   AUFMASS-SKIZZE im Schritt "Masse"

   Zeigt neben den Massfeldern die passende Zeichnung. Sie folgt der
   Befestigungsart: Aussenwand oder Laibung.

   ⭐ WOHER DIE BILDER KOMMEN:
   Aus dem versteckten Traeger `[data-mo-metafelder]`, den main-product.liquid
   aus den Produkt-Metafeldern fuellt:
       data-aufmass-bild-aussenwand   ->  FG01_Aufmass_Aussenwand_v2.jpg
       data-aufmass-bild-laibung      ->  FG01_Aufmass_Laibung_v2.jpg
   Das Metafeld sticht, ein Standardwert aus den Block-Einstellungen faengt auf
   — dieselbe Kette wie bei LPO.

   🔴 MUSS NACH JEDEM `mo:konfig` NEU EINGESETZT WERDEN.
   `zeichne()` baut den Schrittkoerper jedes Mal von Grund auf neu
   (`ziel.textContent = ''`). Eine einmal eingehaengte Skizze waere beim
   naechsten Klick spurlos weg.

   ⚠️ Die Adresse wird NICHT umgeschrieben (auch die Breite nicht). Sie ist im
   Traeger bereits fertig skaliert; ein zweiter Parameter liesse den Browser
   dasselbe Bild ein zweites Mal holen.
   ########################################################################## */
(function () {
  'use strict';

  /* 🔴 DER TRAEGER WIRD SPAETER GESUCHT, NICHT BEIM SKRIPTSTART.

     Gefunden am 26.08.2026, weil beim franzoesischen Balkon die Aufmass-Skizze
     fehlte — mal ja, mal nein. Gemessen im ausgelieferten HTML:

         mo-konfigurator.js      Position 343.824
         data-mo-metafelder      Position 393.529   ← 50.000 Zeichen SPAETER

     Das Skript laedt mit `async` und laeuft, sobald es da ist. Stand der
     Parser dann noch vor Position 393.529, war `TRAEGER` null, `BILD` leer —
     und die Skizze erschien nie. Ein Wettlauf, der auf ALLEN Produktseiten
     lauerte (Abstand 45.000 bis 72.500 Zeichen); dass er nur beim Balkon
     auffiel, war Zufall.

     ⚠️ `data-mo-konfigurator` steht nur 750 Zeichen nach dem Skript — deshalb
     liefen Schrittleiste, Preisbox und Kacheln unauffaellig weiter. Wer hier
     etwas aendert, pruefe die Lage im HTML, nicht im fertigen DOM.

     Dasselbe Muster nutzen META_BILD und BEF_BILD weiter oben schon. */
  var BILD_CACHE = null;

  function bilder() {
    if (BILD_CACHE) return BILD_CACHE;
    var t = document.querySelector('[data-mo-metafelder]');
    if (!t) return { 'Auf der Außenwand': '', 'In der Laibung': '' };
    BILD_CACHE = {
      'Auf der Außenwand': t.dataset.aufmassBildAussenwand || '',
      'In der Laibung':     t.dataset.aufmassBildLaibung   || ''
    };
    return BILD_CACHE;
  }

  /* ⭐ ZWEITE QUELLE: DIE PRODUKTMEDIEN.

     Die Aufmasszeichnungen liegen jetzt als Produktmedien im Shop - genau wie
     die Farbebenen, "im Hintergrund": Der Galeriefilter in main-product.liquid
     laesst sie nicht in die Bilderleiste, der Konfigurator holt sie sich.

         FG_gerahmt_Aufmass_Aussenwand_v2.jpg
         FG_gerahmt_Aufmass_Laibung_v2.jpg

     Der Vorteil gegenueber dem Metafeld: Ein neues Produkt braucht nur die
     beiden Bilder. Niemand muss daran denken, zusaetzlich zwei Metafelder zu
     fuellen - und eine vergessene Zeichnung faellt sofort auf, weil sie in
     den Medien fehlt statt still auf einen leeren Feldwert zu zeigen.

     Erkannt wird am Dateinamen: "Aufmass" plus die Befestigungsart. Der
     alt-Text traegt dieselbe Angabe im Klartext und dient als Rueckfall -
     er wird beim Hochladen mitgepflegt.

     REIHENFOLGE DER QUELLEN: Metafeld sticht, Medien fangen auf.
     Wer fuer ein Produkt eine abweichende Zeichnung braucht, setzt das
     Metafeld; wer keins setzt, bekommt die Zeichnung aus den Medien.

     ⚠ `cache: 'default'` und nicht `force-cache`: Nach dem Nachruesten neuer
     Medien liefert force-cache die alte Liste, und die Zeichnung bleibt weg. */
  var MEDIENQUELLE = null;

  function medienLaden(){
    if (MEDIENQUELLE) return MEDIENQUELLE;
    var wurzel = document.querySelector('[data-mo-konfigurator]');
    var handle = (wurzel && wurzel.dataset.produktHandle) ||
                 (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    if (!handle) { MEDIENQUELLE = Promise.resolve({}); return MEDIENQUELLE; }

    MEDIENQUELLE = fetch('/products/' + handle + '.js', { cache: 'default' })
      .then(function (a) { return a.ok ? a.json() : null; })
      .then(function (p) {
        var treffer = {};
        (p && p.media || []).forEach(function (m) {
          var name = decodeURIComponent((m.src || '').split('?')[0].split('/').pop());
          var text = name + ' ' + (m.alt || '');
          if (!/aufma(ss|ß)/i.test(text)) return;
          if (/laibung/i.test(text))                       treffer['In der Laibung']      = m.src;
          else if (/aussenwand|außenwand/i.test(text))     treffer['Auf der Außenwand'] = m.src;
        });
        return treffer;
      })
      .catch(function () { return {}; });
    return MEDIENQUELLE;
  }

  function masseSchritt() {
    /* ⭐ Ueber das MASSFELD suchen, nicht ueber die Ueberschrift.

       Bis 26.08.2026 stand hier /^(Masse|Maße)$/ — der Wandhandlauf nennt
       seinen Schritt aber „Länge" und bekam deshalb gar keine Skizze. Der
       Titel kommt aus der Config (`collapseLabel`) und darf frei gewaehlt
       werden; ein Feld mit der Klasse `mo-massfeld` gibt es dagegen in jedem
       Konfigurator, egal wie der Schritt heisst. */
    /* 🔴 NUR INNERHALB DER KONFIGURATOR-HUELLE suchen.

       `document.querySelector('.mo-massfeld')` griffe auf die ganze Seite zu.
       Auf Kollektionsseiten sitzt derselbe Klassenname im Schnellkonfigurator
       der Produktkachel (siehe schnellkonfigurator-in-kachel); ein Treffer
       dort haette die Skizze in einen fremden Container gesetzt. */
    var huelle = document.querySelector('.mo-huelle');
    var feld = huelle ? huelle.querySelector('.mo-massfeld') : null;
    var schritt = (feld && feld.closest) ? feld.closest('.mo-schritt') : null;
    if (schritt && (!huelle || huelle.contains(schritt))) return schritt;

    /* Rueckfall, solange das Feld noch nicht gezeichnet ist. */
    var alle = document.querySelectorAll('.mo-schritt');
    for (var i = 0; i < alle.length; i++) {
      var kopf = alle[i].querySelector('.mo-schritt-titel');
      if (kopf && /^(Masse|Maße|Länge)$/i.test(kopf.textContent.trim())) return alle[i];
    }
    return null;
  }

  /* Wo die Masslinien im Bild liegen - in Prozent der Bildflaeche.

     Die beiden Zeichnungen zeigen dasselbe Gitter unterschiedlich montiert,
     und deshalb misst man auch an unterschiedlichen Kanten:

       Auf der Aussenwand   Die Laschen ragen seitlich HERAUS. Gemessen wird
                            ueber die Laschen - das ist der Befestigungsabstand,
                            nicht die Gitterbreite.
       In der Laibung       Das Gitter sitzt INNEN in der Oeffnung. Gemessen
                            wird die lichte Weite der Laibung.

     Deshalb sind es zwei Wertepaare und nicht eines. Wer hier ein gemeinsames
     Raster nimmt, setzt bei der Laibung die Masslinie auf die Wand statt an
     die Laibungskante - und der Kunde misst falsch.

     Die Werte sind an FG_gerahmt_Aufmass_*_v2.jpg abgegriffen (800 x 880).
     Bei neuen Zeichnungen mit anderem Anschnitt nachmessen. */
  var MASSRAHMEN = {
    'Auf der Außenwand': { x1: 12.5, x2: 87.5, y1:  9.0, y2: 96.0 },
    'In der Laibung':     { x1: 22.0, x2: 78.5, y1: 13.0, y2: 96.5 }
  };

  /* ---------- Rahmen JE BILD   (24.08.2026) -------------------------------

     Die beiden Wertepaare oben sind nur noch der RUECKFALL. Sie stammen von
     einer einzigen Zeichnung, inzwischen liegen elf verschiedene im Shop -
     mit Seitenverhaeltnissen von 0,89 bis 1,12 und ganz unterschiedlichem
     Anschnitt. Ein gemeinsames Raster kann die nicht alle treffen.

     🔴 Was der alte Stand anrichtete, an den Bildern nachgemessen: Die
     Unterkante stand ueberall auf 96 %, das Bauteil endet aber je nach
     Zeichnung bei 72-93 %. Die Hoehenlinie ragte auf jeder Skizze unten in
     die Wand. Bei Aufmass_1 (FB 02/03) lief die senkrechte Linie sogar
     durch die Seitenansicht statt am Balkon entlang.

     Geschluessel wird ueber den DATEINAMEN, nicht ueber das Produkt: Elf
     Bilder tragen 25 Produkte, und ein neues Produkt mit bekanntem Bild
     sitzt dann sofort richtig, ohne dass hier jemand nachpflegt.

     ⚠️ Kommt eine neue Zeichnung dazu, gehoert eine Zeile hierher. Ohne
     Eintrag greift der Rueckfall - der zeichnet, ist aber nicht kalibriert.
     Zum Nachmessen: Prozentraster ueber das Bild legen und ablesen; zwei
     Automatik-Versuche sind an der rauen Wandtextur gescheitert.

     x1/x2 = Befestigungspunkte (bei Aussenwand ueber die Laschen, bei
     Laibung die lichte Weite), y1/y2 = Ober- und Unterkante des Bauteils.
     ⭐ 25.08.2026, Stefans Vorgabe: Die HOEHE ist die GESAMTHOEHE des
     Gelaenders — Rahmen-Unterkante bis Rahmen-Oberkante, NICHT der
     Schraubenabstand. Der Befestigungsabstand bleibt auf den
     Befestigungspunkten, seine Masslinie liegt durch y1 ueber dem
     Gelaender. Die FB-Werte darunter sind darauf neu vermessen: Der
     Querriegel hat scharfe Kanten (Aussenwand FB-07: Zeilen 354-362 und
     1423-1431 von 1500), abgelesen ueber den Anteil metallisch heller
     Pixel im Streifen x 30-70 %. */
  /* Welche Dateinamen schon gemeldet wurden — je einmal reicht. */
  var RAHMEN_GEWARNT = {};

  var RAHMEN_JE_BILD = {
    // --- auf der Aussenwand
    'FG01_Aufmass_Aussenwand_v2':       { x1: 15.0, x2: 87.0, y1: 15.18, y2: 82.43 },
    'FG_ohne_Zier_Aussenwand_v2':       { x1: 15.0, x2: 87.0, y1: 15.18, y2: 82.43 },
    'FG_gerahmt_Aufmass_Aussenwand_v2': { x1: 11.0, x2: 89.0, y1:  9.12, y2: 91.20 },
    // ⭐ v3, am 24.08.2026 neu geliefert: 1936 x 1936, quadratisch.
    //    Am Rasterbild abgelesen — Laschen bei 6,5 / 84,5 %, Rahmen 19 / 84 %.
    //    ⚠️ Das Raster 15/85 aus der Spezifikation trifft es NICHT; solange
    //    das so bleibt, braucht jedes neue Bild seinen eigenen Eintrag.
    /* ⭐ v3 bringt die Bemassung SELBST mit — Linien, Pfeile, leere
       Textfelder. Deshalb `felder` statt x1/x2/y1/y2: Der Konfigurator
       zeichnet dann nichts mehr, er schreibt nur die Zahlen hinein.
       Werte am Bild vermessen (Feld heller als Wand: 216 gegen 199). */
    'FG_gerahmt_Aufmass_Aussenwand_v3': { felder: {
      x: { mx: 45.69, my: 14.00, breite: 47.8, hoehe: 4.2, gedreht: false },
      y: { mx: 90.44, my: 52.62, breite:  4.4, hoehe: 47.8, gedreht: true  }
    } },
    /* ⚠️ Fuer das Laibungsbild sind die Felder noch NICHT vermessen — es
       laeuft weiter mit eigener Bemassung, bis das nachgeholt ist. */
    'FG_gerahmt_Aufmass_Laibung_v3':    { x1: 10.0, x2: 72.0, y1: 24.50, y2: 86.50 },
    'FG_buendig_Aufmass_Aussenwand_v2': { x1:  7.0, x2: 91.0, y1: 14.19, y2: 93.81 },

    /* ⭐ 31.08.2026 - STANGEN (Nova 30/31), FRONTALE Renders.
       Stefan: "nim das frontalbild". Die perspektivischen FG30_v2/FG31_v2
       taugen nicht: dort wandern die Befestigungspunkte ueber die Bildhoehe
       um 1,4-1,7 Prozentpunkte, eine waagerechte Masslinie kann das nicht
       abbilden. Bei den frontalen betraegt die Spanne nur 0,2-0,3 Punkte.
       Abgelesen an Bohrlochmitte ueber Prozentraster und vierfachen Zoom,
       mit Korrekturrunde. */
    'FG30_1_v2': { x1: 14.3, x2: 86.1, y1: 39.0, y2: 53.0 },
    'FG31_1_v3': { x1: 21.4, x2: 78.5, y1: 41.5, y2: 54.5 },

    /* ⭐ 31.08.2026, HERANGEZOOMT. Stefan: "die massbilder ranzoomen".
       In den Rendern oben nahm das Bauteil vertikal nur 14 % der Bildhoehe
       ein - der Rest war Hauswand und Gehweg. Neu zugeschnitten nach der
       Spezifikation: Befestigungspunkte auf 15/85 %, Bauteilkanten auf
       30/70 %, Rand frei fuer die Bemassung. 2,9- bzw. 3,1-fach naeher.

       ⚠️ NACHKALIBRIERT am selben Tag: Die ersten Werte waren vom Original
       auf den Ausschnitt UMGERECHNET und lagen bis 0,7 Punkte daneben - der
       rechte Masspfeil endete sichtbar vor der Schraube. Jetzt am
       ausgelieferten Bild selbst abgelesen. Nach einem Zuschnitt immer neu
       messen, nie umrechnen: der Zoom verstaerkt jeden Ablesefehler. */
    /* ⭐ 01.09.2026, DRITTE Runde — Stefan: „maszpfeil nicht genau".
       Zwei Verfahren am ausgelieferten Bild, beide auf die OBERE Halterreihe:
       Laschenkante+Versatz (197,4 / 1209,3) und Schraubenreflex (199,0 /
       1211,4). 🔴 Die Reihen stehen perspektivisch versetzt — FG-30 rechts
       1211 / 1206 / 1203 px —, ein Wert kann nie alle drei treffen. Die
       senkrechten Hilfslinien enden unter der OBERSTEN Lasche, also gilt die.
       Vorher: x2 85,4 % lag 15,8 px daneben, links der unteren Reihe statt an
       der oberen; der Pfeil endete vor ALLEN drei Schrauben. */
    'FG-30_Aufmass_Aussenwand': { x1: 14.2, x2: 86.5, y1: 30.0, y2: 70.0 },
    'FG-31_Aufmass_Laibung':    { x1: 14.8, x2: 86.1, y1: 30.0, y2: 70.0 },
    /* ---- Fenstergitter: Renderbild statt flacher Zeichnung -------------
       25.08.2026, Stefan: „die gerenderten bilder sollen die aufmaßbilder
       ersetzen" — und dabei „besser die front bilder".

       🔴 Von allen FG-Renderings ist nur EINES frontal: das Galeriebild
       …-314538.jpg von FG 01. Alle uebrigen (auch die Farbebenen
       `Aussenwand_Feuerverzinkt` / `Laibung_Feuerverzinkt`) sind
       perspektivisch — auf einer Schraegansicht sitzen waagerechte
       Masslinien schief. Deshalb ist bisher nur FG 01 Aussenwand umgestellt;
       die restlichen Frontbilder liefert Stefan nach.

       🔴 NACHGEMESSEN am 25.08.2026 — Stefan: „nochmal richtig messen
       strikter intensiver bitte nicht so lala". Die erste Runde war am
       verkleinerten Bild GESCHAETZT und lag bis zu 2,9 Punkte daneben.

       Jetzt an vier Zoom-Ausschnitten des 2000-px-Originals mit
       0,2-%-Raster abgelesen (120 Bildpunkte je Prozent):

         Schraube links   x 12,54 %   (Laschenkante 11,54 %)
         Schraube rechts  x 87,50 %   (Laschenkante 88,50 %)
         Schraubenhoehe   y 20,58 %   (Mittel aus 20,54 und 20,63)
         Staebe oben      y 11,40 %   (die dunkle Sturzkante liegt bei 10,5 %)
         Staebe unten     y 88,90 %   (heller Bereich endet schon bei 86,3 %)

       ⚠️ Die beiden Fallen dieses Bildes: Oben verlaeuft 0,9 Punkte ueber
       dem Stabanfang die Sturzkante, unten 2,6 Punkte ueber dem Stabende
       die Fensterbank. Wer die Helligkeitskante misst statt die Staebe,
       trifft beides Mal daneben. */
    /* ⭐ pktX: WIE WEIT DIE HOEHENLINIE ZUM BAUTEIL LAEUFT  (26.08.2026)

       Stefan: „so wie das nur die roten Linien sauber bis zum bauteil
       ziehen." Die waagerechte Masshilfslinie der Hoehe lief bisher nur
       ein kurzes Stueck um die Masslinie herum und schwebte frei in der
       Wand — sie zeigte auf nichts und kreuzte dabei die senkrechte
       Hilfslinie des Befestigungsabstands. Genau diese Ecke hat Stefan im
       Screenshot als Fehler markiert.

       `pktX` ist das Gegenstueck zu `pktY`: der x-Wert, an dem das Bauteil
       auf HOEHE DER OBER- UND UNTERKANTE endet. Von dort laeuft die Linie
       durch bis ueber die Masslinie.

       🔴 Der Wert haengt an der BAUART, nicht am Modell:
         ungerahmt (Ferro) → rechte Kante des aeussersten STABS
         gerahmt  (Atlas)  → Aussenkante des RAHMENS
       Am 0,5-%-Raster abgelesen, Ober- und Unterkante einzeln; sie stimmen
       je Bild auf 0,1 Punkte ueberein.

       ⚠️ Ohne pktX faellt es auf x2 zurueck — den BEFESTIGUNGSPUNKT. Der
       liegt bei den ungerahmten Gittern rund 15 Punkte weiter aussen als
       das Bauteil auf dieser Hoehe, und genau daher kam der frei
       schwebende Strich. */
    'fenstergitter-ferro-01-verzinkt-fenstergitter-deinmetallbauershop-314538':
                                        { x1: 12.42, x2: 87.42, y1: 11.40, y2: 88.90, pktY: 20.84, pktX: 72.60 },
    /* Weitere Fenstergitter auf Renderbilder umgestellt — je Bild einzeln
       am 0,5-%-Raster vermessen (vier Zoom-Ausschnitte: Stabanfang,
       Stabende, linke und rechte Lasche).

       ⚠️ Die Bilder haben NICHT dieselbe Geometrie, auch wenn die Kamera
       gleich steht: FG 02 hat den Stabanfang bei 7,3 %, FG 01 bei 11,4 %.
       Werte von einem Modell auf ein anderes zu uebertragen geht schief —
       am 25.08. im Kontrollbogen belegt. */
    'fenstergitter-atlas-02-verzinkt-fenstergitter-deinmetallbauershop-513442':
                                        { x1: 12.90, x2: 86.98, y1:  5.30, y2: 88.50, pktY: 15.24, pktX: 85.80 },
    'fenstergitter-ferro-03-verzinkt-fenstergitter-deinmetallbauershop-375807':
                                        { x1: 12.25, x2: 87.30, y1: 11.30, y2: 88.80, pktY: 20.74, pktX: 71.20 },

    /* ⭐⭐ ALLE UEBRIGEN FENSTERGITTER, vermessen am 26.08.2026

       Stefan: „wir können alle Fenstergitter modelle bearbeiten, alle
       bilder liegen bereit." — 🔴 Zehn Produkte trugen laengst ein
       Renderbild im Metafeld, standen aber NICHT in dieser Tabelle und
       liefen deshalb still auf den Rueckfallwerten.

       ⭐ Der Abkuerzer, der acht Messungen gespart hat: die Bilder NUR auf
       ihren Kalibrierkanten vergleichen (Laschen und Rahmenraender, ohne
       das Gittermuster). Wer das ganze Bild vergleicht, sieht nur
       Unterschiede; auf den Kanten fallen sie in saubere Gruppen:

         gerahmt  → Luna 35/36/39/40, Atlas 38/41   Abweichung 0,5–3,1
         Luna 33  = Luna 34                          0,7
         Ferro 29 = Ferro 03                         1,2

       ⚠️ Bei den GERAHMTEN ist y1 nicht direkt messbar — Putz und
       verzinkter Rahmen sind gleich hell. Gemessen wird deshalb unten die
       Rahmenbreite (Innen- gegen Aussenkante, hier 3,0 Punkte) und oben von
       der Innenkante abgezogen. An Atlas 02 gegengeprueft: unten 2,8,
       oben 2,7 — die Methode traegt.

       🔴 Ferro 09 hat Speerspitzen. Stefan am 26.08. entschieden: die Hoehe
       misst MIT Spitzen. y1 liegt deshalb auf der Spitze (11,30) und nicht
       auf der Querstange (29,0). */
    'fenstergitter-ferro-09-verzinkt-fenstergitter-deinmetallbauershop-832603':
                                        /* 🔴 y2 01.09.2026 von 86.50 auf 88.50.
                                           Stefan mit Markierung: „richtig vermessen" —
                                           die Linie endete OBERHALB der Stabenden, der
                                           Kunde misst dann zu wenig. Gemessen ueber
                                           Kantendichte (nicht Helligkeit) und im Bild
                                           gegengeprueft: bis 79 % volle Dichte, 80 % der
                                           Querriegel, 81–88 % die Staebe darunter, ab
                                           89 % faellt es auf null. */
                                        { x1: 12.30, x2: 87.40, y1: 11.30, y2: 88.50, pktY: 29.53, pktX: 72.00 },
    'fenstergitter-ferro-29-verzinkt-fenstergitter-deinmetallbauershop-157216':
                                        { x1: 12.28, x2: 87.38, y1: 11.30, y2: 88.80, pktY: 20.69, pktX: 71.20 },
    /* Luna 33 und 34: Lasche sitzt auf Hoehe der Bauteiloberkante, die
       Hoehen-Hilfslinie trifft sie ohne pktX. */
    'fenstergitter-luna-33-verzinkt-fenstergitter-deinmetallbauershop-821178':
                                        { x1: 12.20, x2: 86.90, y1: 11.20, y2: 88.80, pktY: 11.88 },
    'fenstergitter-luna-34-verzinkt-fenstergitter-deinmetallbauershop-797344':
                                        { x1: 12.20, x2: 86.90, y1: 11.20, y2: 88.80, pktY: 11.88 },
    /* Die sechs gerahmten — gemessen an Atlas 38, auf den Kanten
       deckungsgleich mit den fuenf anderen.

       🔴 27.08.2026, ZWEITER ANLAUF: `y1` steht jetzt auf **5.22**.

       Am Vormittag hatte ich 4.70 auf 7.85 gesetzt — mit der Begruendung,
       „die Helligkeit faellt bei 7,85 % von 214 auf 97". Das war der FALSCHE
       UEBERGANG: Bei 7,85 % beginnt die dunkle FENSTEROEFFNUNG, nicht das
       Bauteil. Die Hoehenlinie startete damit an der Unterkante des oberen
       Riegels statt an dessen Oberkante.

       ⚠️ DIE HELLIGKEIT TRENNT METALL UND PUTZ NICHT — beide liegen bei
       210-215. Nur die Oeffnung ist dunkel, deshalb sprang die Automatik
       dorthin. Was trennt, ist der FARBSTICH: verzinkter Stahl rendert
       blaeulich (B-R > 0), Putz warm (B-R ~ 0). Nachgemessen in drei
       Spaltenbaendern: B-R kippt bei 5,12 % von 0,0 ins Positive, die
       Helligkeit geht von 236 auf 219. Das ist die Bauteiloberkante.

       ⚠️ FG38_2, FG39_2, FG40_2 und FG41_1 sind PALETTENBILDER (PIL-Modus
       „P"). Dort ist B-R durchweg negativ, der Farbstich greift NICHT. Sie
       wurden ueber den Helligkeitsverlauf zugeordnet, der mit luna-36
       deckungsgleich ist (231 bei 5,0 % → 216 bei 6,0 % → Absturz auf 58-66
       bei 8,0 %).

       ⭐ GEGENPROBE, die es von Anfang an gegeben haette: Das Bild
       `…atlas-02-…-513442` derselben Vorlage stand die ganze Zeit auf
       y1 5.30 / pktX 85.80. Zwei Zeilen derselben Vorlage mit 2,5 Punkten
       Unterschied sind ein Alarmzeichen.

       🔴 `pktX` lag bei allen sechs auf 82.90 — das ist die INNENkante des
       rechten Rahmenrohrs. Die Hoehen-Hilfslinie endete damit im Gitterfeld
       statt an der Bauteilkante. Gemessen: Aussenkante bei 85,85-85,98.
       FG35_1 · luna-36 · FG38_2 · FG39_2 · FG40_2 · FG41_1 → alle 5,22. */
    'FG35_1_ece95b28-8525-412a-8685-ff29a0a0d37e':
                                        { x1: 12.90, x2: 86.98, y1:  5.22, y2: 89.00, pktY: 14.90, pktX: 85.98 },
    'fenstergitter-luna-36-verzinkt-fenstergitter-deinmetallbauershop-853471':
                                        { x1: 12.90, x2: 86.98, y1:  5.22, y2: 89.00, pktY: 14.90, pktX: 85.98 },
    'FG38_2':                           { x1: 12.90, x2: 86.98, y1:  5.22, y2: 89.00, pktY: 14.90, pktX: 85.98 },
    'FG39_2':                           { x1: 12.90, x2: 86.98, y1:  5.22, y2: 89.00, pktY: 14.90, pktX: 85.98 },
    'FG40_2':                           { x1: 12.90, x2: 86.98, y1:  5.22, y2: 89.00, pktY: 14.90, pktX: 85.98 },
    'FG41_1':                           { x1: 12.90, x2: 86.98, y1:  5.22, y2: 89.00, pktY: 14.90, pktX: 85.98 },

    /* ⭐⭐ DIE NEUEN LAIBUNGSBILDER  (26.08.2026)

       Bis heute zogen ALLE Fenstergitter fuer die Laibung eine gezeichnete
       Ersatzskizze — `FG_gerahmt_Aufmass_Laibung_v2` allein bei zehn
       Produkten. Jetzt hat jedes Modell seine eigene Aufnahme.

       🔴 Der Dateiname taugte NICHT als Quelle: zu jedem Modell gibt es eine
       frontale und eine schraege Fassung, und mal heisst die frontale
       `Laibung.jpg`, mal `Laibung_1.jpg`. Gemessen an der Oberkante der
       Oeffnung (links gegen rechts): frontal 10,70/10,70, schraeg
       12,20/12,70. Vier von acht waeren nach dem Namen schraeg gewesen.

       ⭐ EIN Wertesatz fuer alle acht: Bei LAIBUNGSMONTAGE sitzt das Gitter
       in der Oeffnung, es gibt keine Laschen auf dem Putz. Bezug ist damit
       die lichte Oeffnung — und die ist in allen acht Bildern dieselbe
       Kameraeinstellung. Nachgemessen: x1 19,35 / x2 80,86 / y1 10,55 bei
       jedem Bild, Spanne ueber alle acht 0,05 Prozentpunkte.

       ⚠️ Kein pktY: Die Befestigung liegt verdeckt im Rahmen, es gibt
       keinen Schraubenkopf zum Anzielen. Kein pktX: das Bauteil reicht auf
       Hoehe y1/y2 bis an x2 heran.

       ⚠️ y2 (Bankoberkante) ist von Hand abgelesen. Die automatische Suche
       nach der ersten Aufhellung findet 80,60 — das ist der untere
       Querstab, nicht die Bank. Bei Atlas 38 sogar 77,15, dort liegen
       waagerechte Staebe. */
    'FG-33_Aufmass_Laibung':            { x1: 19.40, x2: 80.85, y1: 14.55, y2: 85.80 },
    'FG-34_Aufmass_Laibung':            { x1: 19.40, x2: 80.85, y1: 14.60, y2: 85.80 },
    'FG-35_Aufmass_Laibung':            { x1: 19.40, x2: 80.85, y1: 12.75, y2: 87.85 },
    'FG-36_Aufmass_Laibung':            { x1: 19.40, x2: 80.85, y1: 12.95, y2: 87.80 },
    'FG-38_Aufmass_Laibung':            { x1: 19.40, x2: 80.85, y1: 12.95, y2: 87.80 },
    'FG-39_Aufmass_Laibung':            { x1: 19.40, x2: 80.85, y1: 12.95, y2: 87.80 },
    'FG-40_Aufmass_Laibung':            { x1: 19.40, x2: 80.87, y1: 13.27, y2: 87.73 },
    /* ⭐ 27.08.2026 — DREI AUSSENWANDBILDER, exakt nachgeprueft.

       Stefan: „exakt prüfen!" — zu Recht. Meine Meldung „vier Produkte haben
       kein frontales Aussenwand-Render" war an zwei Stellen falsch:

       🔴 FG 20 hat sehr wohl eines. `a_Qap8_FG_2001_20Aussenwand_2_v2.png`
          misst Symmetrie 26,4 — gleichauf mit FG 01 (26,3), das seit Tagen
          als Aufmassbild laeuft. Nebeneinandergestellt sind beide gleich
          frontal. Ich hatte nur nach „FG-20" im Dateinamen gesucht; die Datei
          heisst aber `a_Qap8_…`.
       🔴 FG 20 hat auch Laibungsbilder (18,3 = frontal!) — nur als GRUENE
          Chroma-Master. Als Aufmassbild unbrauchbar, aber der Beweis, dass
          die Kamera dafuer existiert. Aus dem Master liesse sich mit
          [[ablauf-edelstahl-oberflaeche-rechnen]] eine Edelstahlfassung
          rechnen.

       FG 10 (36,1) und FG 11 (31,3) bleiben deutlich schraeger als der
       Massstab 26,3. Stefans Vorgabe ist aber eindeutig: gerenderte Bilder,
       keine flachen Zeichnungen. Deshalb eingesetzt — die Masslinien sitzen
       dort nicht so genau wie bei den frontalen.

       Werte: FG 20 ist UNGERAHMT wie FG 01 — Schrauben am 0,5-%-Raster
       gemessen (12,50 / 87,20, Hoehe 20,70), Oberkante 10,56.
       FG 10 und FG 11 sind GERAHMT und messen dieselbe Oberkante wie
       FG 38-41 (7,88 gegen 7,85) — gleiche Vorlage, gleicher Satz. */
    /* 🔴 KORREKTUR 27.08.2026 — ich hatte das FALSCHE MODELL erwischt.

       `a_Qap8_FG_2001_20Aussenwand_2_v2.png` (Sym 26,4) zeigt ein Gitter mit
       RAUTEN. Das Produkt „Edelstahl Fenstergitter" hat aber SENKRECHTE
       STAEBE MIT UMLAUFENDEM RAHMEN — nachgesehen in seiner Galerie, die
       genau zwei Medien hat. Beinahe waere ein fremdes Gitter als Aufmassbild
       gelandet.

       ⭐ Die Lehre: Vor dem Setzen eines Aufmassbildes IN DIE PRODUKTGALERIE
       schauen. Der Dateiname mit der richtigen Modellnummer beweist nicht,
       dass auch das richtige Bauteil drauf ist.

       Genommen wird jetzt das echte Produktbild. Am 1,0-%-Raster vermessen:
         Schraube links   x 13,60   Hoehe 14,50
         Schraube rechts  x 85,60   Hoehe 15,20   -> pktY 14,85
         Oberkante        y  5,87   Rahmenende y 86,50
         Rahmenkante rechts x 83,30
       ⚠️ Das Bild ist ein FLUX-Render mit Symmetrie 29,2 und nicht ganz
       frontal — links und rechts sitzen die Schrauben 0,7 Punkte
       unterschiedlich hoch. Die Masslinie steht dadurch minimal schief. */
    'FG-20_Aussenwand-1_Edelstahl_matt_FLUX_hell':
                                        { x1: 14.05, x2: 86.00, y1:  5.86, y2: 88.45, pktY: 14.88, pktX: 85.35 },
    'FG-10_Aufmass_Aussenwand_v3':      { x1: 12.90, x2: 86.98, y1:  5.22, y2: 89.00, pktY: 14.90, pktX: 85.98 },
    'FG-11_Aufmass_Aussenwand_v3':      { x1: 12.90, x2: 86.98, y1:  5.22, y2: 89.00, pktY: 14.90, pktX: 85.98 },
    /* FG 15: `FG 15_2.png` — trug keinen Ansichtsnamen und wurde deshalb
       zweimal uebersehen. Stefan: „FG 15 sind alle bilder da!" Im Ordner
       sofort zu sehen: das Gitter sitzt auf dem Putz, Laschen aussen.
       Oberkante 7,88 = gleiche gerahmte Vorlage wie FG 10/11/38-41. */
    'FG-15_Aufmass_Aussenwand_v2':      { x1: 12.90, x2: 86.98, y1:  5.22, y2: 89.00, pktY: 14.90, pktX: 85.98 },

    'FG-41_Aufmass_Laibung':            { x1: 19.40, x2: 80.87, y1: 13.27, y2: 87.73 },
    /* ⭐ NEUE MODELLE VOM 05.10.2026, vermessen am 07.10.2026 (Stefan: „richt bild messen“ —
       die Höhenlinie endete unter dem Gitter, weil die Bilder hier fehlten und der Rückfall galt).
       1500 × 1500 px, Werte an 4x/8x-Ausschnitten mit 5-px-Raster abgelesen, Kanten zusätzlich über
       Helligkeitsprofile (Mittel über 20–40 px):
         Schrauben   = Mitte des Schraubenkopfs (Außenring), obere Reihe
         y1/y2, pktX = AUSSENKANTE des Rahmens. Beim Flachstahl-Rahmen (42/46/55) ist das die
                       schmale helle Stirnfläche (8 px) AUSSERHALB des dunklen Streifens — der
                       dunkle Streifen ist die innere Seitenfläche, nicht die Kante.
       46 und 55 stammen aus derselben Szene (Profile auf den Grauwert gleich) → gleiche Werte.
       ⚠️ `FG-42_Perspektive` ist trotz des Namens das FRONTALE Bild; das als „Aussenwand“ benannte
       ist schräg (beim Anlegen vertauscht) — das Metafeld zeigt seit 07.10. auf das frontale. */
    'FG-37_Aussenwand_verzinkt':        { x1: 12.87, x2: 87.27, y1:  5.17, y2: 89.00, pktY: 14.97, pktX: 86.30 },
    'FG-42_Perspektive':                { x1: 12.67, x2: 87.10, y1:  4.77, y2: 89.30, pktY: 14.98, pktX: 86.37 },
    'FG-46_Aussenwand_verzinkt':        { x1: 15.13, x2: 84.87, y1:  6.50, y2: 89.17, pktY: 14.30, pktX: 83.97 },
    'FG-55_Aussenwand_verzinkt':        { x1: 15.13, x2: 84.87, y1:  6.50, y2: 89.17, pktY: 14.30, pktX: 83.97 },
    'FG-37_Laibung_verzinkt':           { x1: 21.57, x2: 78.60, y1: 12.47, y2: 87.83 },

    /* 🔴 FG-20 EDELSTAHL, LAIBUNG — 27.08.2026 nachgetragen.

       Stefan hatte am Bild zweimal eingekreist: die Hoehenlinie endete unten
       auf der FENSTERBANK statt am Gitter.

       Ursache: Das Bild hatte **gar keinen Eintrag** und fiel damit auf den
       Vorgabewert `'In der Laibung': {x1:22.0, x2:78.5, y1:13.0, y2:96.5}`
       zurueck. `y2 96.5` liegt 11 Punkte unter der Bauteilunterkante — mitten
       auf der Granitbank. Es ist erst am 27.08. als Metafeld gesetzt worden
       (`…FLUX_hell.png?v=1787836414`) und wurde nie kalibriert.

       ⚠️ DER FARBSTICH TAUGT HIER NICHT: Das Glas spiegelt oben den Himmel,
       B-R steigt dort auf +15 — staerker als jede Metallkante. Gemessen wurde
       ueber die HELLIGKEIT, und zwar am 50-%-Uebergang mit linearer
       Interpolation zwischen den beiden Plateaus (1 px = 0,05 %).

       Stefan: „genauer vermessen" — die erste Runde tastete in 0,25-%-Schritten
       ab und lag bei y1 um 3 px daneben. Jetzt je vier bzw. drei unabhaengige
       Baender, Streuung als Guetemass:

         y1  Oberkante oberer Holm   14.036 / 14.046 / 14.068 / 14.067
             -> Mittel 14.054, Streuung 0.013 (0,26 px)
         y2  Unterkante unterer Holm 85.669 / 85.651 / 85.639 / 85.631
             -> Mittel 85.647, Streuung 0.014
         x1  Wandkante links         19.386 / 19.384 / 19.385
             -> Mittel 19.385, Streuung 0.001 (0,02 px)
         x2  Wandkante rechts        80.784 / 80.789 / 80.790
             -> Mittel 80.787, Streuung 0.002

       ⚠️ Beide y-Kanten sind WEICH (Antialiasing plus Schlagschatten, rund
       8 px Verlauf). Der 50-%-Punkt ist dort die belastbare Wahl — ein
       Schwellenwert an der Ober- oder Untergrenze wandert mit der Schwelle.

       ⭐ Die Werte fuegen sich in die Reihe der uebrigen Laibungsbilder
       (x1 19.40, x2 80.85, y1 12.75-14.60, y2 85.80-87.85) — dieselbe Szene,
       dieselbe Kamera. Das ist die beste Gegenprobe. */
    'FG-20_Laibung_Edelstahl_matt_FLUX_hell':
                                        { x1: 19.39, x2: 80.79, y1: 14.05, y2: 85.65 },
    'FG-10_Aufmass_Laibung_v2':         { x1: 19.40, x2: 80.87, y1: 13.27, y2: 87.73 },
    'FG-11_Aufmass_Laibung_v2':         { x1: 19.40, x2: 80.87, y1: 13.27, y2: 87.80 },

    /* ⭐ pktY BEI DEN LAIBUNGSBILDERN  (27.08.2026)

       Stefan hat die senkrechten Hilfslinien der Befestigungsabstand-Linie
       rot markiert: Sie endeten UEBER der Lasche. Ohne `pktY` laufen sie nur
       bis y1 (Bauteiloberkante) — die Schrauben sitzen aber tiefer.

       🔴 Nur bei den UNGERAHMTEN (Ferro) gibt es eine sichtbare Einzellasche;
          am Raster belegt bei FG-01 und FG-03: y 24,0–27,0 %, Mitte 25,50.
       ⚠️ Bei den GERAHMTEN (Atlas/Luna, FG-02 und FG-33…41) laeuft der Rahmen
          durch, eine Lasche ist nicht zu sehen — dort bleibt pktY WEG und der
          Rueckfall auf y1 ist richtig. Nicht raten. */
    /* ⭐ 27.08.2026 — SECHS WEITERE LAIBUNGSBILDER, endlich frontal.

       Stefan: „wir nehmen die gerenderten aufmaßbilder ! strikt merken."
       Bis heute zeigten FG 01, 02, 03, 09, 29 und Atlas 15 in der Laibung
       eine flache Zeichnung, weil die vorhandenen Renders schraeg waren.

       🔴 Der Grund, warum sie nicht gefunden wurden: Sie heissen `…_1.jpg`.
       Von jedem Modell liegen ZWEI Laibungsrenders vor — die Fassung ohne
       Nummer ist perspektivisch (Symmetrie 28,9–31,6), die `_1`-Fassung ist
       FRONTAL (17,1–23,0). Ein Namensfilter findet das nie; es half nur,
       JEDES Bild zu messen.

       ✅ Alle sechs einzeln nachgemessen — sie stammen aus DERSELBEN
       Render-Vorlage wie FG-33…41 und tragen deshalb denselben Satz:
         x1 19,40 · x2 80,85 · y1 10,55   (an allen sechs bestaetigt)
       y2 bleibt 84,70: die Staebe enden auf der Fensterbank. ⚠️ NICHT ueber
       die Helligkeit messen — der dunkle Bereich reicht bis unter die Bank
       und liefert 94–99 % statt 84,7 %. */
    'FG-01_Aufmass_Laibung_v2':         { x1: 19.40, x2: 80.85, y1: 12.60, y2: 87.80, pktY: 25.50 },
    'FG-02_Aufmass_Laibung_v2':         { x1: 19.40, x2: 80.85, y1: 12.95, y2: 87.80 },
    'FG-03_Aufmass_Laibung_v2':         { x1: 19.40, x2: 80.85, y1: 12.60, y2: 87.80, pktY: 25.50 },
    'FG-09_Aufmass_Laibung_v2':         { x1: 19.40, x2: 80.85, y1: 12.65, y2: 87.80 },
    'FG-29_Aufmass_Laibung_v2':         { x1: 19.40, x2: 80.85, y1: 12.55, y2: 88.00 },
    'FG-15_Aufmass_Laibung_v2':         { x1: 19.40, x2: 80.87, y1: 13.27, y2: 87.80 },
    /* ---- Franzoesische Balkone, neue Renders vom 21./22.08.2026 --------
       Eingehaengt am 25.08. Vorher zeigten FB 01, 06, 07 und 08 dieselbe
       Skizze, und bei FB 02/03 stand fuer Aussenwand UND Laibung dasselbe
       Bild. Jetzt hat jedes Modell seine eigene Ansicht. */
    'FB-01_Aufmass_Aussenwand':         { x1: 11.20, x2: 89.00, y1: 23.00, y2: 93.93 },
    'FB-01_Aufmass_Laibung':            { x1: 17.47, x2: 82.40, y1: 25.47, y2: 91.93 },
    'FB-02_Aufmass_Aussenwand':         { x1: 10.67, x2: 89.47, y1: 23.00, y2: 93.93 },
    'FB-02_Aufmass_Laibung':            { x1: 17.47, x2: 82.40, y1: 25.67, y2: 92.00 },
    'FB-03_Aufmass_Aussenwand':         { x1: 13.33, x2: 86.87, y1: 24.33, y2: 94.80 },
    'FB-03_Aufmass_Laibung':            { x1: 17.47, x2: 82.40, y1: 26.27, y2: 94.07 },
    'FB-06_Aufmass_Aussenwand':         { x1: 10.50, x2: 89.30, y1: 22.67, y2: 94.53 },
    'FB-06_Aufmass_Laibung':            { x1: 17.47, x2: 82.40, y1: 25.33, y2: 92.80 },
    'FB-07_Aufmass_Aussenwand':         { x1: 10.50, x2: 89.30, y1: 23.60, y2: 95.40 },
    'FB-07_Aufmass_Laibung':            { x1: 17.47, x2: 82.40, y1: 25.20, y2: 92.60 },
    'FB-08_Aufmass_Aussenwand':         { x1: 10.50, x2: 89.30, y1: 23.93, y2: 95.40 },
    'FB-08_Aufmass_Laibung':            { x1: 17.47, x2: 82.40, y1: 25.47, y2: 92.73 },
    'FB01_Aufmass_Aussenwand_v2':       { x1:  9.0, x2: 91.0, y1:  9.0, y2: 91.0 },
    // 🔴 FB 02/03 nutzen dieses Bild fuer BEIDE Befestigungsarten, und es ist
    //    eine Werkstattzeichnung mit fest eingetragenen Massen (950, 50).
    //    Die Werte hier setzen die Linien wenigstens ans Bauteil.
    'Aufmass_1':                        { x1: 15.0, x2: 78.0, y1: 13.0, y2: 72.0 },
    // --- in der Laibung
    'FG01_Aufmass_Laibung_v2':          { x1: 22.0, x2: 80.0, y1: 14.78, y2: 82.15 },
    'FG_ohne_Zier_Laibung_v2':          { x1: 22.0, x2: 80.0, y1: 14.78, y2: 82.15 },
    'FG_gerahmt_Aufmass_Laibung_v2':    { x1: 20.0, x2: 82.0, y1: 13.28, y2: 91.20 },
    'FG_buendig_Aufmass_Laibung_v2':    { x1: 11.0, x2: 86.0, y1: 17.12, y2: 90.88 },
    'FB01_Aufmass_Laibung_v2':          { x1: 15.0, x2: 85.0, y1: 10.0, y2: 90.0 },

    /* ⭐ Wandhandlauf, 26.08.2026. Das Bild wurde selbst gezeichnet
       (scratchpad/hl/zeichne2.py), deshalb liegen die Kanten auf runden
       Werten und mussten nicht nachgemessen werden — im fertigen JPG
       gegengeprueft: x 10,00/90,00 %, y 50,00/60,24 %.

       Ein Handlauf hat nur EIN Mass. Die Hoehenlinie faellt weg, weil
       masse.y leer bleibt (siehe die Stelle in masslinien()). */
    'FG-HL_Aufmass_Aussenwand':         { x1: 10.0, x2: 90.0, y1: 50.0, y2: 60.0 },

    /* ⭐ Wandhandlauf, CAD-Zeichnung von Stefan (26.08.2026, 2 Halter).
       Bringt die Bemassung selbst mit -> `textNur`, siehe masslinien().
       Gemessen: Rohrenden 5,75 / 94,09 %, Rohr 45,25 .. 56,62 %,
       Textkasten Mitte 49,95 / 23,04 %, Kastenhoehe 15,36 %.
       Stefans Hilfslinien sitzen bei 5,80 und 94,08 % — die Messung am
       Rohr und die eingezeichnete Bemassung decken sich auf 0,05 %. */
    'FG-HL_Aufmass_2Halter':            { x1: 5.75, x2: 94.09, y1: 45.25, y2: 56.62,
                                          textNur: { x: 49.95, y: 23.04, hoehe: 15.36 } },

    /* Dieselbe Zeichnung mit einem dritten Halter in der Mitte — aus der
       2-Halter-Fassung gebaut (scratchpad/hl2/drei2.py), Bemassung und
       Rohrenden unveraendert. Gegengeprueft: Halter bei 13,03 / 49,88 /
       86,81 %, keine Helligkeitsspruenge im Rohr. */
    'FG-HL_Aufmass_3Halter':            { x1: 5.75, x2: 94.09, y1: 45.25, y2: 56.62,
                                          textNur: { x: 49.95, y: 23.04, hoehe: 15.36 } },

    /* Lange Handlaeufe: dieselbe Zeichnung, aber mit BRUCH bei 68 % —
       zwei Schraegstriche und eine Luecke im Rohr, wie in technischen
       Zeichnungen ueblich (Stefan am 26.08.2026).

       ⚠️ Bewusst NICHT die flache 4-Halter-Fassung (1600 x 190): die ist
       im Konfigurator nur 99 px hoch, und die Massschrift schrumpft auf
       die Haelfte. Mit Bruch bleibt das hohe Format und die Zahl lesbar.
       Gebaut in scratchpad/hl2/bruch4.py. */
    'FG-HL_Aufmass_lang':               { x1: 5.75, x2: 94.09, y1: 45.25, y2: 56.62,
                                          textNur: { x: 49.95, y: 23.04, hoehe: 15.36 } },

    /* Mit STOSSSTELLE: eine feine Fuge bei 51,38 % — 1,5 % rechts neben
       dem mittleren Halter (49,88 %). Stefan am 26.08.2026: „50mm neben dem
       mittleren halter“; bezogen auf einen 3-m-Handlauf sind 50 mm rund
       1,5 % der Bildbreite. Farbe aus seiner Vorlage abgenommen (113,113,113).
       `_lang` traegt zusaetzlich den Bruch. */
    'FG-HL_Aufmass_geteilt':            { x1: 5.75, x2: 94.09, y1: 45.25, y2: 56.62,
                                          textNur: { x: 49.95, y: 23.04, hoehe: 15.36 } },
    'FG-HL_Aufmass_geteilt_lang':       { x1: 5.75, x2: 94.09, y1: 45.25, y2: 56.62,
                                          textNur: { x: 49.95, y: 23.04, hoehe: 15.36 } },

    /* Die geteilte Fassung von Stefan (`Handlauf_gerade_v1.26_2.jpg`,
       dezente Stossfuge). Anderes Format — 3268 x 388 statt 853 —, deshalb
       eigene Werte: Hilfslinien 2,48 / 97,74 %, Textkasten zwischen den
       mittleren Linien 42,41 und 57,80 %. */
    'FG-HL_Aufmass_4Halter':            { x1: 2.42, x2: 97.74, y1: 45.20, y2: 56.70,
                                          textNur: { x: 50.11, y: 23.84, hoehe: 16.75 } },

    /* ⭐ Fensterstange Nova 30/31, 26.08.2026. Ebenfalls selbst gezeichnet
       (scratchpad/hl/zeichne_stange.py und _laibung.py).

       🔴 Gemessen wird von BOHRUNG zu BOHRUNG, nicht von Stabende zu
       Stabende — deshalb liegen x1/x2 auf den Bohrungsmitten und die
       Laschen ragen bewusst darueber hinaus (8,0 / 92,0 %). `pktY` fuehrt
       die Hilfslinien bis auf die Bohrungsachse. */
    'FG-ST_Aufmass_Aussenwand':         { x1: 10.0, x2: 90.0, y1: 50.0, y2: 60.0, pktY: 55.0 },
    'FG-ST_Aufmass_Laibung':            { x1: 10.0, x2: 90.0, y1: 50.0, y2: 60.0, pktY: 55.0 }
  };

  /* Holt den Rahmen zum Bild. Der Dateiname kommt aus der Bild-URL - ohne
     Query (`?v=...&width=640`) und ohne Endung. `decodeURIComponent`, weil
     Shopify Umlaute in Dateinamen prozentkodiert ausliefert. */
  function rahmenFuer(bild, art){
    var quelle = String((bild && (bild.currentSrc || bild.src)) || '');
    var name = '';
    try {
      name = decodeURIComponent(quelle.split('?')[0].split('/').pop() || '')
               .replace(/\.[a-z0-9]+$/i, '');
    } catch (e) { name = ''; }

    var treffer = RAHMEN_JE_BILD[name];

    /* ⭐ EINE REGEL STATT NEUN EINTRAEGEN  (26.08.2026)

       Die Wandhandlauf-Zeichnungen heissen `FG-HL_Aufmass_h<Halter>s<Stoesse>`
       und sind aus derselben Vorlage gebaut — Rohrenden, Rohrhoehe und
       Textkasten sitzen bei allen an derselben Stelle. Neun gleichlautende
       Zeilen in der Tabelle waeren nur Abschreibfehler in Wartestellung. */
    if (!treffer && /^FG-HL_Aufmass_h\d+s\d+$/.test(name)) {
      treffer = { x1: 5.75, x2: 94.09, y1: 45.25, y2: 56.62,
                  textNur: { x: 49.95, y: 23.04, hoehe: 15.36 },
                  randmass: { mm: 100, vorsatz: 'ca. ',
                              von: 86.81, bis: 94.09, y: 39.5 } };
    }

    /* 🔴 Ohne Eintrag zeichnen die Masslinien auf Rueckfallwerten und sitzen
       fast sicher daneben. Am 24.08.2026 genau so passiert: `v3` kam neu
       dazu, niemand hat es gemerkt, die Hoehenlinie lag 10 bzw. 12
       Prozentpunkte falsch. Deshalb meldet sich der Konfigurator jetzt —
       einmal je Dateiname, sonst laeuft die Konsole bei jedem Neuzeichnen zu.

       ⚠️ Nur warnen, NICHT die Bemassung weglassen: Ein Kunde soll nicht vor
       einer Skizze ohne Masse stehen, weil wir einen Eintrag vergessen
       haben. Ungenau ist hier besser als gar nicht. */
    if (!treffer && name && !RAHMEN_GEWARNT[name]) {
      RAHMEN_GEWARNT[name] = true;
      if (window.console && console.warn) {
        console.warn('[mo-konfigurator] Aufmassbild ohne Kalibrierung: "' + name +
          '". Die Masslinien laufen auf den Rueckfallwerten und sitzen vermutlich ' +
          'daneben. Eintrag in RAHMEN_JE_BILD ergaenzen — Anleitung in der Memory ' +
          '[[aufmass-rahmen-je-bild]].');
      }
    }

    return treffer || MASSRAHMEN[art] || MASSRAHMEN['Auf der Außenwand'];
  }

  /* Die Beschriftung der Massfelder — aus dem DOM, nicht aus einer Liste.
     Aufbau: <div><label>Befestigungsabstand</label>
               <div class="mo-masse-feld"><input class="mo-massfeld" data-achse="x"></div></div>

     ⚠️ Einmal lesen und merken. `masslinien()` laeuft bei jedem Neuzeichnen;
     ein querySelector darin waere genau die Sorte Kleinvieh, die die
     Produktseite frueher langsam gemacht hat. */
  /* Gibt es zu dieser Achse ueberhaupt ein Massfeld?

     ⚠️ Nur ein `true` wird gemerkt. Liefe die Abfrage einmal, bevor die
     Massfelder im DOM stehen, wuerde ein gemerktes „nein" die Hoehenlinie
     auf Dauer unterdruecken — deshalb wird nur der Erfolg zwischengelegt. */
  var HAT_ACHSE = {};
  function gibtAchse(achse){
    if (HAT_ACHSE[achse]) return true;
    var da = !!document.querySelector('.mo-massfeld[data-achse="' + achse + '"]');
    if (da) HAT_ACHSE[achse] = true;
    return da;
  }

  var ACHSENNAME = {};
  function achsenName(achse){
    /* ⚠️ 31.08.2026: Der Cache muss beim Wechsel der Befestigungsart weg.
       Seit das Label der Art folgt, wuerde die SVG-Bemassung sonst auf dem
       zuerst gelesenen Text stehenbleiben - der Kunde schaltet auf Laibung,
       das Feld heisst neu, die Zeichnung nennt noch den alten Namen. */
    if (ACHSENNAME.__art !== undefined &&
        ACHSENNAME.__art !== window.moBefestigungsArt(null)) {
      for (var k in ACHSENNAME) { if (k !== '__art') delete ACHSENNAME[k]; }
    }
    ACHSENNAME.__art = window.moBefestigungsArt(null);
    if (ACHSENNAME[achse] !== undefined) return ACHSENNAME[achse];
    var name = '';
    var feld = document.querySelector('.mo-massfeld[data-achse="' + achse + '"]');
    if (feld) {
      var block = feld.parentElement && feld.parentElement.parentElement;
      var lab = block && block.querySelector('label');
      if (lab) name = lab.textContent.replace(/\s+/g, ' ').replace(/:\s*$/, '').trim();
    }
    ACHSENNAME[achse] = name;
    return name;
  }

  /* „Befestigungsabstand: 1000 mm" statt nur „1000 mm".
     Ohne Namen im DOM bleibt es bei der nackten Zahl. */
  function mitNamen(achse, wert){
    var name = achsenName(achse);
    return name ? (name + ': ' + zahl(wert)) : zahl(wert);
  }

  function zahl(wert){
    var n = parseFloat(String(wert).replace(',', '.'));
    /* 🔴 DIE EINHEIT KOMMT AUS DEM DOM, NICHT AUS `moEinheit`.

       25.08.2026 gemessen: Umschalter auf cm, Felder zeigten "140 × 105 cm",
       die Skizze aber weiter "1400 mm". Der Grund ist der Gueltigkeitsbereich —
       `moEinheit` steht im IIFE ab Zeile 458, `zahl()` in dem ab Zeile 2607.
       Der `typeof`-Test fiel deshalb IMMER auf 'mm' zurueck, ohne Fehler und
       ohne dass es auffiel.

       Der aktive Knopf traegt die Wahl sichtbar im DOM; localStorage ist der
       Rueckfall, falls die Skizze vor dem Umschalter gezeichnet wird. */
    var e = 'mm';
    try {
      var anKnopf = document.querySelector('.mo-einheit-knopf.mo-an');
      if (anKnopf) e = /cm/i.test(anKnopf.textContent) ? 'cm' : 'mm';
      else if (localStorage.getItem('mo-einheit') === 'cm') e = 'cm';
    } catch (_) {}
    if(!(isFinite(n) && n > 0)) return '… ' + e;
    if(e === 'cm'){
      // masse[] steht immer in mm - fuer die Anzeige umrechnen, eine
      // Nachkommastelle, deutsches Komma.
      var cm = Math.round(n / 10 * 10) / 10;
      return String(cm).replace('.', ',') + ' cm';
    }
    return Math.round(n) + ' mm';
  }

  /* Legt die beiden Masslinien ueber die Zeichnung: Breite unten, Hoehe rechts.
     Sie stehen auch OHNE Eingabe da ("... mm") - dann zeigen sie dem Kunden,
     was ueberhaupt gemessen werden soll. Genau dafuer ist die Skizze da. */
  /* Die Masszeichnung ueber der Skizze - als SVG, nicht als CSS-Striche.

     Warum SVG: Eine Bemassung besteht aus Masshilfslinien, einer Masslinie mit
     Pfeilspitzen an beiden Enden und der Masszahl darueber. Pfeilspitzen sind
     mit Rahmen-Tricks nicht sauber zu bauen, und in einem 250 px breiten Bild
     faellt jede Naeherung auf. Ein SVG zeichnet sie in einem Pfad.

     Der viewBox uebernimmt die ECHTEN Bildmasse (naturalWidth/Height). Damit
     stimmt das Seitenverhaeltnis, und die Pfeilspitzen werden nicht verzerrt -
     bei einem gestreckten viewBox waeren sie schief. Deshalb wird auch erst
     nach dem Laden des Bildes gezeichnet.

     Die Linien liegen in der Hausfarbe #cb4f0a: Die Zeichnungen selbst sind
     grau, ein grauer Massfaden ginge darin unter ([[shop-akzentfarbe]]). */
  var SVGNS = 'http://www.w3.org/2000/svg';

  function svgEl(name, attr){
    var el = document.createElementNS(SVGNS, name);
    for (var k in attr) if (attr.hasOwnProperty(k)) el.setAttribute(k, attr[k]);
    return el;
  }

  function masslinien(kasten, art, masse){
    var bild = kasten.querySelector('img');
    if (!bild) return null;

    // Erst zeichnen, wenn die echten Bildmasse bekannt sind - sonst stimmt der
    // viewBox nicht und die ganze Bemassung sitzt schief.
    if (!bild.naturalWidth) {
      bild.addEventListener('load', function(){ masslinien(kasten, art, masse); }, { once: true });

      /* 🔴 Der Handler allein reicht nicht. Das Bild traegt `loading="lazy"`;
         kommt es aus dem Cache, ist `load` schon durch, bevor die Zeile
         darueber laeuft - dann wartet ein `once`-Handler auf ein Ereignis,
         das nie wieder kommt, und die Skizze bleibt ohne Bemassung stehen.
         Am 24.08.2026 an FB 02 gemessen: Bild geladen, nach 12 s kein SVG.

         `decode()` loest auch bei einem laengst fertigen Bild auf - deshalb
         faengt es genau den Fall, den das Ereignis verpasst. Doppeltes
         Zeichnen schadet nicht, `alt.remove()` raeumt vorher auf. */
      if (bild.decode) {
        bild.decode().then(function(){ masslinien(kasten, art, masse); })
                     .catch(function(){});
      }
      return null;
    }

    var alt = kasten.querySelector('.mo-masslinien');
    if (alt) alt.remove();

    var r = rahmenFuer(bild, art);

    /* 🔴 Bringt das Bild seine Bemassung selbst mit? Dann nur die Zahlen
       setzen — sonst liegt unsere Zeichnung doppelt darueber.
       Stefan am 24.08.: „hier rein" (mit Pfeil auf die leeren Kaesten). */
    if (r && r.felder) {
      return nurZahlen(kasten, bild, r.felder, masse);
    }
    var W = bild.naturalWidth, H = bild.naturalHeight;
    var x1 = W * r.x1 / 100, x2 = W * r.x2 / 100;
    var y1 = H * r.y1 / 100, y2 = H * r.y2 / 100;

    // Alle Staerken haengen an der Bildbreite, nicht an festen Pixeln. Sonst
    // waere dieselbe Zeichnung bei 800 px Vorlage zart und bei 1600 px unsichtbar.
    var s  = W / 800;
    // Angehoben am 24.08.2026 auf Stefans Wunsch („die linien leicht
    // breiter"). Vorher 1,6 / 1,0 — auf der verkleinerten Skizze (240 px
    // mobil) waren die Linien dort zu zart.
    var strich = 2.2 * s;          // Masslinie
    var hilfs  = 1.3 * s;          // Masshilfslinie
    var ueber  = 26 * s;           // wie weit die Masslinie vom Bauteil absteht
    var pfeil  = 9 * s;            // Laenge der Pfeilspitze
    var schrift = 26 * s;

    var svg = svgEl('svg', {
      'class': 'mo-masslinien',
      viewBox: '0 0 ' + W + ' ' + H,
      preserveAspectRatio: 'none',
      'aria-hidden': 'true'          // die Werte stehen in den Massfeldern
    });

    var farbe = '#cb4f0a';

    // ---- Breite: Masslinie OBERHALB des Bauteils ---------------------------
    // 🔴 Stefan am 25.08.2026: "Befestigungsabstand IMMER oben, Höhe IMMER
    //    rechts." Gilt ohne Ausnahme, siehe [[vorgabe-bemassung-lage]].
    /* DIE HILFSLINIE MUSS DEN PUNKT ERREICHEN, AUF DEN SIE ZEIGT.

       25.08.2026, Stefan: „die Linien irgendwie bis zum punkt ziehen" —
       mit Strichen von den Pfeilenden hinunter zu den Laschen.

       Bisher endete die Hilfslinie an der BAUTEILKANTE (y1). Die
       Befestigungspunkte liegen aber tiefer: beim Fenstergitter FG 01 sitzen
       die Laschen auf 19,5 % Bildhoehe, die Gitteroberkante auf 10,5 %. Die
       Linie hing also neun Prozentpunkte ueber dem, was sie bemasst.

       `pktY` in RAHMEN_JE_BILD sagt, wo die Punkte wirklich sitzen. Fehlt die
       Angabe, bleibt es bei der Bauteilkante — die anderen Konfiguratoren
       aendern sich dadurch nicht. */
    /* ⭐ BILDER, DIE IHRE BEMASSUNG SCHON MITBRINGEN  (26.08.2026)

       Stefan hat den Wandhandlauf als CAD-Zeichnung geliefert
       (`Handlauf_gerade_v1.26.jpg`): Masslinie, Hilfslinien und ein LEERER
       Textkasten sind bereits eingezeichnet — sauberer als unser Overlay, und
       sie bleiben auch im Vollbild erhalten.

       Traegt `RAHMEN_JE_BILD` fuer so ein Bild `textNur`, zeichnen wir keine
       Linien mehr, sondern setzen nur die Zahl in den freigelassenen Kasten.
       `textNur` = { x, y, hoehe } in Prozent der Bildmasse.

       Gemessen am Original (3268 x 853): Kastenmitte 49,95 / 23,04 %,
       Kastenhoehe 15,36 % — nach dem Verkleinern auf 1600 px unveraendert. */
    if (r.textNur) {
      var tx = W * (r.textNur.x != null ? r.textNur.x : 50) / 100;
      var ty = H * (r.textNur.y != null ? r.textNur.y : 20) / 100;
      var th = H * (r.textNur.hoehe != null ? r.textNur.hoehe : 12) / 100;
      var t = svgEl('text', {
        x: tx, y: ty, fill: farbe,
        'text-anchor': 'middle', 'dominant-baseline': 'central',
        'font-size': Math.round(th * 0.52), 'font-weight': '700',
        'font-family': 'Montserrat, system-ui, sans-serif'
      });
      t.textContent = mitNamen('x', masse && masse.x);
      svg.appendChild(t);

      /* ⭐ RANDMASS: Abstand vom aeusseren Halter zum Rohrende (26.08.2026)

         Stefan: „kannst du 100mm eintragen „ca. 100mm“ schaltbar in cm.“
         Der Wert steht in `randmass.mm` und laeuft durch `zahl()` — damit
         schaltet er mit dem mm/cm-Knopf mit, ohne dass hier etwas gerechnet
         wird. `zahl()` liest die Einheit aus dem DOM, nicht aus `moEinheit`
         (siehe die Notiz dort: der Gueltigkeitsbereich reicht nicht ueber die
         IIFE-Grenze).

         ⚠️ Der Wert ist eine ANGABE, kein gemessenes Bildmass: Zwischen
         86,81 % (Halterachse) und 94,09 % (Rohrende) liegen im Bild 7,28 %,
         was bei einem 5-m-Handlauf rund 410 mm entspraeche. Die Zeichnung ist
         nicht massstaeblich — deshalb steht „ca.“ davor. */
      if (r.randmass) {
        var rm  = r.randmass;
        var rxa = W * (rm.von != null ? rm.von : 86.81) / 100;
        var rxb = W * (rm.bis != null ? rm.bis : 94.09) / 100;
        var rly = H * (rm.y   != null ? rm.y   : 40.0)  / 100;
        var rro = H * (r.y1   != null ? r.y1   : 45.0)  / 100;
        var rfs = Math.max(9, Math.round(th * 0.30));

        [rxa, rxb].forEach(function (x) {
          svg.appendChild(svgEl('line', {
            x1: x, y1: rly, x2: x, y2: rro,
            stroke: farbe, 'stroke-width': Math.max(1, strich * 0.6)
          }));
        });
        svg.appendChild(svgEl('line', {
          x1: rxa, y1: rly, x2: rxb, y2: rly,
          stroke: farbe, 'stroke-width': Math.max(1, strich * 0.6)
        }));

        var t2 = svgEl('text', {
          x: (rxa + rxb) / 2, y: rly - rfs * 0.75, fill: farbe,
          'text-anchor': 'middle', 'dominant-baseline': 'central',
          'font-size': rfs, 'font-weight': '600',
          'font-family': 'Montserrat, system-ui, sans-serif'
        });
        t2.textContent = (rm.vorsatz || '') + zahl(rm.mm);
        svg.appendChild(t2);
      }

      kasten.insertBefore(svg, kasten.firstChild.nextSibling);
      kaestenNachmessen(svg);
      return svg;
    }

    var yB = Math.max(y1 - ueber, schrift * 0.6);
    var hilfeX = (r.pktY != null && isFinite(r.pktY)) ? H * r.pktY / 100 : y1;
    zeichneMass(svg, {
      x1: x1, y1: yB, x2: x2, y2: yB, waagerecht: true,
      hilfeVon: hilfeX, farbe: farbe, strich: strich, hilfs: hilfs, senkrecht: false,
      pfeil: pfeil, schrift: schrift, text: mitNamen('x', masse && masse.x)
    });

    /* ---- Hoehe: Masslinie rechts neben dem Bauteil ------------------------

       ⭐ DIE HOEHENLINIE STEHT SOFORT DA — auch ohne eingetragenen Wert.

       Stefan am 26.08.2026: „höhe immer sofort schon stehen haben nicht
       erst bei maß eingabe." Vorher zeichnete sie erst, wenn `masse.y`
       gefuellt war: Der Kunde sah oben „Befestigungsabstand: … mm" und
       rechts NICHTS — und damit auch keinen Hinweis, dass die Hoehe
       ueberhaupt gemessen werden soll. `zahl()` setzt bei leerem Wert von
       sich aus „… mm" ein, genau wie bei der Breite.

       🔴 Die alte Bedingung `parseFloat(masse.y) > 0` durfte dabei nicht
       einfach wegfallen — sie schuetzte die onlyX-Konfiguratoren (Stange,
       Handlauf), die GAR KEINE Hoehe haben. Dort waere eine Hoehenlinie
       eine Falschaussage. Der Ersatz fragt deshalb, ob es ueberhaupt ein
       Hoehen-Massfeld gibt: Die Skizze liegt in einer eigenen IIFE und
       kennt die Config nicht (siehe konfigurator-iife-grenzen) — das DOM
       ist das Einzige, was ueber die Grenze traegt. */
    var hatHoehe = gibtAchse('y');
    if (hatHoehe) {
      var xH = Math.min(x2 + ueber, W - schrift * 0.6);
      var hilfeY = (r.pktX != null && isFinite(r.pktX)) ? W * r.pktX / 100 : x2;
      zeichneMass(svg, {
        x1: xH, y1: y1, x2: xH, y2: y2, waagerecht: false,
        hilfeVon: hilfeY, farbe: farbe, strich: strich, hilfs: hilfs, senkrecht: true,
        pfeil: pfeil, schrift: schrift, text: mitNamen('y', masse && masse.y)
      });
    }

    kasten.insertBefore(svg, kasten.firstChild.nextSibling);
    kaestenNachmessen(svg);
    return svg;
  }

  /* ---------- Die Textkaesten exakt auf den Text ziehen ---------------

     Stefan am 24.08.2026: „strikt in die kästen machen." Im Bild stand
     unten „000 mm" — die erste Ziffer lag ausserhalb.

     🔴 Gemessen: Text 129,2 px, Kasten 114,9 px. Die Schaetzung im
     Kastenbau kann das nicht treffen, weil Ziffern breiter sind als die
     Kleinbuchstaben, fuer die der Faktor gedacht war.

     ⭐ `getComputedTextLength()` liefert die echte Breite — aber erst,
     wenn das SVG im DOM haengt. Deshalb laeuft das hier NACH
     `insertBefore`, nicht beim Bauen.

     ⚠️ Ist das SVG unsichtbar (Schritt zugeklappt), liefert die Messung 0.
     Dann bleibt der geschaetzte Kasten stehen, statt auf 0 zu schrumpfen.

     ⚠️ Das `rect` steht IMMER direkt vor seinem `text` (siehe
     zeichneMass): erst Kasten, dann Schrift. Darauf stuetzt sich die
     Zuordnung ueber `previousElementSibling`. */
  function kaestenNachmessen(svg){
    [].forEach.call(svg.querySelectorAll('text'), function(txt){
      var laenge = 0;
      try { laenge = txt.getComputedTextLength(); } catch (e) { return; }
      if (!laenge) return;                       // nicht gerendert
      var feld = txt.previousElementSibling;
      if (!feld || feld.tagName.toLowerCase() !== 'rect') return;
      var schrift = parseFloat(txt.getAttribute('font-size')) || 26;
      var breite  = laenge + schrift * 0.62;     // Luft links und rechts
      var mitte   = parseFloat(txt.getAttribute('x'));
      if (!isFinite(mitte)) return;
      feld.setAttribute('x', mitte - breite / 2);
      feld.setAttribute('width', breite);
    });
  }

  /* Eine einzelne Bemassung: zwei Masshilfslinien, die Masslinie mit
     Pfeilspitzen und die Masszahl. Waagerecht wie senkrecht in einer Funktion -
     der Unterschied sind nur vertauschte Achsen. */
  /* ---------- Nur die Zahlen, das Bild bringt die Zeichnung mit --------

     Fuer Bilder, die Masslinien und leere Textfelder schon enthalten.
     Wir setzen ausschliesslich Text — keine Linien, keine Pfeile, kein
     Kasten. Der Hintergrund ist ja schon da.

     ⚠️ Die Schriftgroesse startet bei 62 % der Feldhoehe und wird von
     `kaestenNachmessen()` verkleinert, falls der Text zu breit ist. */
  function nurZahlen(kasten, bild, felder, masse){
    var alt = kasten.querySelector('.mo-masslinien');
    if (alt) alt.remove();

    var W = bild.naturalWidth, H = bild.naturalHeight;
    var svg = svgEl('svg', {
      'class': 'mo-masslinien',
      viewBox: '0 0 ' + W + ' ' + H,
      preserveAspectRatio: 'none',
      'aria-hidden': 'true'
    });

    [['x', masse && masse.x], ['y', masse && masse.y]].forEach(function(paar){
      var f = felder[paar[0]];
      if (!f) return;
      var mx = W * f.mx / 100, my = H * f.my / 100;
      /* Bei gedrehten Feldern begrenzt die BREITE die Schrifthoehe. */
      var platz = (f.gedreht ? f.breite * W : f.hoehe * H) / 100;
      var attr = {
        x: mx, y: my, fill: '#cb4f0a',
        'text-anchor': 'middle', 'dominant-baseline': 'central',
        'font-size': Math.round(platz * 0.62), 'font-weight': '700',
        'font-family': 'Montserrat, system-ui, sans-serif'
      };
      if (f.gedreht) attr.transform = 'rotate(-90 ' + mx + ' ' + my + ')';
      /* Wie breit darf der Text werden? Gedreht ist es die Feldhoehe. */
      attr['data-mo-platz'] = Math.round((f.gedreht ? f.hoehe * H : f.breite * W) / 100);
      var txt = svgEl('text', attr);
      txt.textContent = mitNamen(paar[0], paar[1]);
      svg.appendChild(txt);
    });

    kasten.insertBefore(svg, kasten.firstChild.nextSibling);
    schriftEinpassen(svg);
    return svg;
  }

  /* Verkleinert die Schrift, bis der Text in sein Feld passt.
     ⚠️ Erst NACH dem Einhaengen — vorher misst der Browser nichts. */
  function schriftEinpassen(svg){
    [].forEach.call(svg.querySelectorAll('text[data-mo-platz]'), function(txt){
      var platz = parseFloat(txt.getAttribute('data-mo-platz'));
      if (!(platz > 0)) return;
      for (var i = 0; i < 12; i++) {
        var breite = 0;
        try { breite = txt.getComputedTextLength(); } catch (e) { return; }
        if (!breite) return;                       // nicht gerendert
        if (breite <= platz * 0.94) break;         // passt, mit etwas Luft
        var jetzt = parseFloat(txt.getAttribute('font-size'));
        if (!(jetzt > 8)) break;                   // kleiner wird unlesbar
        txt.setAttribute('font-size', Math.max(8, Math.floor(jetzt * 0.92)));
      }
    });
  }

  function zeichneMass(svg, o){
    var w = o.waagerecht;

    /* Masshilfslinien: vom Bauteil bis knapp ueber die Masslinie hinaus —
       und ein Stueck UEBER den Messpunkt hinaus ins Bauteil hinein.

       25.08.2026, Stefan: „noch die kleines bischen länger dann top". Endete
       die Linie exakt am Punkt, sah sie aus, als schwebe sie daneben; in
       technischen Zeichnungen steht die Masshilfslinie immer ein Stueck ueber.

       1,6 × Pfeillaenge sind rund 1,5 % der Bildbreite — sichtbar, ohne den
       Blick auf das Bauteil zu stoeren. Die Groesse haengt wie alle anderen
       an der Bildbreite, damit sie bei 800 und 2000 px gleich wirkt. */
    /* 🔴 NUR NACH INNEN ueberstehen, nie nach aussen  (26.08.2026)

       Stefan: „die linien müssen strikt immer am Bauteil enden." Die
       Hilfslinie ragte bisher `pfeil * 0,7` UEBER die Masslinie hinaus —
       an der Laibung gemessen 0,79 % der Bildbreite, also ein sichtbarer
       Stummel frei im Putz. Sie endet jetzt exakt auf der Masslinie.

       ⚠️ Der Ueberstand INS BAUTEIL hinein bleibt (`ueberhang` unten). Der
       ist gewollt — Stefan am 25.08.: „noch die kleines bischen länger dann
       top". Ohne ihn sieht die Hilfslinie aus, als schwebe sie neben dem
       Punkt, den sie bemasst. */
    var ueberhang = o.pfeil * 1.6;
    [w ? o.x1 : o.y1, w ? o.x2 : o.y2].forEach(function (p) {
      svg.appendChild(svgEl('line', w
        ? { x1: p, y1: o.hilfeVon + ueberhang, x2: p, y2: o.y1 }
        : { x1: o.hilfeVon - ueberhang, y1: p, x2: o.x1, y2: p }, {}));
      var l = svg.lastChild;
      l.setAttribute('stroke', o.farbe);
      l.setAttribute('stroke-width', o.hilfs);
      l.setAttribute('opacity', '.55');
    });

    // Die Masslinie selbst.
    var linie = svgEl('line', { x1: o.x1, y1: o.y1, x2: o.x2, y2: o.y2 });
    linie.setAttribute('stroke', o.farbe);
    linie.setAttribute('stroke-width', o.strich);
    svg.appendChild(linie);

    // Pfeilspitzen als gefuellte Dreiecke, nach innen zeigend.
    var p = o.pfeil, b = p * 0.38;
    if (w) {
      svg.appendChild(dreieck([[o.x1, o.y1], [o.x1 + p, o.y1 - b], [o.x1 + p, o.y1 + b]], o.farbe));
      svg.appendChild(dreieck([[o.x2, o.y2], [o.x2 - p, o.y2 - b], [o.x2 - p, o.y2 + b]], o.farbe));
    } else {
      svg.appendChild(dreieck([[o.x1, o.y1], [o.x1 - b, o.y1 + p], [o.x1 + b, o.y1 + p]], o.farbe));
      svg.appendChild(dreieck([[o.x2, o.y2], [o.x2 - b, o.y2 - p], [o.x2 + b, o.y2 - p]], o.farbe));
    }

    // Die Masszahl auf einem hellen Feld, damit sie ueber der Linie lesbar
    // bleibt. Ein Rechteck dahinter statt eines Randes am Text: Text-Outlines
    // rendern in Firefox anders als in Chrome.
    var mx = (o.x1 + o.x2) / 2, my = (o.y1 + o.y2) / 2;
    // ⚠️ Nur die VORLAEUFIGE Breite. Der Faktor 0,56 galt fuer
    // Kleinbuchstaben; bei Ziffern misst „1000 mm" in Montserrat 700
    // tatsaechlich das 0,71-fache. Deshalb 0,62 als Rueckfall — und
    // `kaestenNachmessen()` korrigiert gleich darauf exakt.
    var breite = o.text.length * o.schrift * 0.62 + o.schrift * 0.6;
    var hoehe  = o.schrift * 1.25;
    /* 🔴 Der senkrechte Kasten wird GEDREHT. Mit dem Namen davor ist er rund
       350 px breit — waagerecht gelegt liefe er quer ueber das Gitter und
       verdeckte es. Gedreht laeuft er daneben entlang, wie in technischen
       Zeichnungen.
       ⚠️ Rechteck und Text drehen um DENSELBEN Punkt, sonst wandern sie
       auseinander. */
    var drehung = o.senkrecht ? ('rotate(-90 ' + mx + ' ' + my + ')') : null;

    var feldAttr = {
      x: mx - breite / 2, y: my - hoehe / 2,
      width: breite, height: hoehe, rx: hoehe * 0.22,
      fill: '#fff', stroke: o.farbe, 'stroke-width': o.hilfs
    };
    if (drehung) feldAttr.transform = drehung;
    var feld = svgEl('rect', feldAttr);
    svg.appendChild(feld);

    var textAttr = {
      x: mx, y: my, fill: o.farbe,
      'text-anchor': 'middle', 'dominant-baseline': 'central',
      'font-size': o.schrift, 'font-weight': '700',
      'font-family': 'Montserrat, system-ui, sans-serif'
    };
    if (drehung) textAttr.transform = drehung;
    var t = svgEl('text', textAttr);
    t.textContent = o.text;
    svg.appendChild(t);
  }

  function dreieck(punkte, farbe){
    var el = svgEl('polygon', {
      points: punkte.map(function (p) { return p[0] + ',' + p[1]; }).join(' '),
      fill: farbe
    });
    return el;
  }

  /* DIE PRODUKTGALERIE FOLGT DER BEFESTIGUNGSART.

     25.08.2026, Stefan: „hier muss sich noch die Galerie wechseln bei alles
     FB". Wer „In der Laibung" waehlt, sah links weiter das Bild der
     Aussenwand-Montage.

     Gesucht wird ueber den DATEINAMEN des Miniaturbilds, nicht ueber eine
     Position: Die Medienreihenfolge ist je Produkt gepflegt und aendert sich.
     Genommen wird das ERSTE passende Medium — bei den Balkonen ist das die
     Schraegansicht, die ohnehin an Position 1 steht.

     Geklickt wird das Miniaturbild statt `setActiveMedia()` aufzurufen: Der
     Theme-Handler erledigt damit alles Weitere und bleibt heil, wenn eCom
     Orbit die Methode einmal umbenennt. */
  var GALERIE_ART = null;

  /* ⭐ 01.09.2026 — DER DATEINAME TAUGT NICHT ALS MASSSTAB.

     `custom.befestigung_bild_aussenwand` / `_laibung` zeigt auf das Bild, das
     im Konfigurator als Befestigungskachel steht — und das ist per Definition
     die Schraegansicht. Diese Zuordnung ist gepflegt; die Dateinamen sind es
     nicht. Bei FG-20 ist `_Aussenwand` schraeg, `_Laibung` aber frontal.

     Geliefert wird der Dateiname OHNE Endung, damit `?width=`-Varianten
     nichts ausmachen. */
  function befestigungsBildDatei(art){
    var tr = document.querySelector('[data-mo-metafelder]');
    if (!tr) return '';
    var u = /laibung/i.test(art) ? (tr.dataset.befestigungBildLaibung || '')
                                 : (tr.dataset.befestigungBildAussenwand || '');
    if (!u) return '';
    return String(u).split('/').pop().split('?')[0].replace(/\.[a-z0-9]+$/i, '');
  }

  function galerieAufBefestigung(art){
    // Beim ERSTEN Durchlauf nur merken. Sonst klickt der Konfigurator schon
    // beim Aufbau in die Galerie und scrollt sie unter dem Kunden weg.
    if (GALERIE_ART === null) { GALERIE_ART = art; return; }
    if (GALERIE_ART === art) return;
    GALERIE_ART = art;

    var laibung = /laibung/i.test(art);
    var thumbs = document.querySelectorAll('.thumbnail-list__item .thumbnail');

    /* DIE SCHRAEGANSICHT HAT VORRANG.

       25.08.2026, Stefan: „hier bitte auch perspektive ansicht nehmen". Bei
       der Aussenwand lag die Schraegansicht ohnehin an Medienposition 1 und
       wurde getroffen; bei der Laibung steht die Frontansicht davor, sodass
       der Umschalter dort flach zeigte. Beide Ansichten sollen perspektivisch
       sein — deshalb ZWEI Durchlaeufe: erst „_schraeg" suchen, dann jedes
       passende Bild als Rueckfall. */
    var soll = befestigungsBildDatei(art);      // aus dem Metafeld: die Schraege
    var treffer = null, ersatz = null;
    for (var i = 0; i < thumbs.length; i++) {
      var im = thumbs[i].querySelector('img');
      var name = im ? String(im.getAttribute('src') || '').split('/').pop().split('?')[0] : '';
      if (!name) continue;
      var stamm = name.replace(/\.[a-z0-9]+$/i, '');
      /* Vorrang 1: das Metafeld. EXAKT vergleichen — `FG-20_Laibung` ist ein
         Praefix von `FG-20_Laibung-1`, ein Praefixtest traefe das falsche. */
      if (soll && stamm === soll) { treffer = thumbs[i]; break; }
      var passt = laibung ? /laibung/i.test(name)
                          : /aussenwand|außenwand/i.test(name);
      if (!passt) continue;
      /* Vorrang 2: das Wort im Namen (so bei den franzoesischen Balkonen). */
      if (/schraeg|schräg|perspekt/i.test(name)) { treffer = thumbs[i]; break; }
      if (!ersatz) ersatz = thumbs[i];
    }
    var ziel = treffer || ersatz;
    if (ziel && ziel.getAttribute('aria-current') !== 'true') ziel.click();
  }

  /* ⭐ BEMASSTE GESAMTZEICHNUNG  (26.08.2026)

     Stefan wollte unter der Skizze „eine gesamtzeichung in klein“ — eine
     technische Strichzeichnung mit allen Massen: Gesamtlaenge, Randabstaende
     und die Halterabstaende dazwischen.

     Sie ist RECHNERISCH, kein Bild: Halterzahl und Stoesse stehen im Namen der
     Aufmasszeichnung (`FG-HL_Aufmass_h6s2`), die Laenge kommt aus dem Massfeld.

         Abstand = (Laenge − 2 × Randabstand) / (Halter − 1)

     Bei 4.600 mm mit 6 Haltern und 100 mm Rand: (4600 − 200) / 5 = 880 mm.

     ⚠️ Die inneren Felder werden als EINE Sammelbemassung geschrieben
     („5 × 880 mm“) — sieben einzelne Zahlen nebeneinander liest bei 838 px
     Anzeige niemand mehr. So macht man es auf Werkstattzeichnungen auch. */
  function gesamtzeichnung(koerper, masse) {
    var alt = koerper.querySelector('.mo-gesamt');
    var wz = document.querySelector('[data-mo-konfigurator]');
    var name = wz ? (wz.getAttribute('data-mo-skizzenbild') || '') : '';

    /* ⭐ EINE ZEICHNUNG STATT ZWEI  (26.08.2026)

       Stefan: „hier gesamt zeichnung aber in der optik von oben das wir oben
       nicht mehr brauchen.“ — Beide zeigten dasselbe Bild, die untere nur mit
       mehr Massen. Die obere Skizze wird deshalb stillgelegt, sobald eine
       Gesamtzeichnung entsteht.

       ⚠️ Sie bleibt im DOM, weil sie zwei Aufgaben behaelt: Sie liefert die
       Bildadresse samt `naturalWidth`, und ihr SVG ist die Bemassung fuer das
       Vollbild. Entfernt man sie, verliert der Handlauf die Lupe. */
    var skizze = koerper.querySelector('.mo-skizze');
    var m = name.match(/h(\d+)s(\d+)$/);
    var L = parseFloat(masse && masse.x) || 0;
    var oben = skizze && skizze.querySelector('img');
    if (!m || !(L > 0) || !oben) {
      if (alt) alt.remove();
      if (skizze) skizze.classList.remove('mo-skizze-still');
      return;
    }

    var halter = parseInt(m[1], 10);
    var rand = 100;
    var felder = Math.max(1, halter - 1);
    var abstand = Math.round((L - 2 * rand) / felder);

    /* ⭐ DIESELBE OPTIK WIE OBEN  (26.08.2026)

       Stefan: „bekommen wir das untere in der Optik von oben hin?“ — also
       Putzwand, Rohr und Halter statt grauer Balken. Das Bild wird deshalb per
       <image> in das SVG gelegt und die Massketten darueber gezeichnet.

       ⚠️ Die Massketten muessen an den ECHTEN Bildpositionen haengen, nicht
       an einer eigenen Rechnung: Die Halter sitzen im Bild gleichmaessig
       zwischen 13,04 % und 86,86 %, die Rohrenden bei 5,75 und 94,09 %. */
    var BILD_L = 13.04, BILD_R = 86.86, ENDE_L = 5.75, ENDE_R = 94.09;

    var W = 1000;
    if (!oben.naturalWidth) {
      oben.addEventListener('load', function () {
        gesamtzeichnung(koerper, masse);
      }, { once: true });
    }
    var bhRoh = Math.round(W * (oben.naturalHeight || 366) / (oben.naturalWidth || 1400));

    /* ⭐ GRÖSSER DARSTELLEN: strecken und den toten Rand abschneiden

       Stefan am 26.08.: „die zeichnung größentechnisch besser gesamt
       dastellen“. Der Handlauf nutzt im Bild schon 88 % der BREITE
       (5,75 % bis 94,09 %) — breiter geht nur, wenn die Rohrenden
       wegfallen. Der Hebel ist deshalb die Höhe: Das Bild wird auf 130 %
       gezogen und oben/unten beschnitten. Der Handlauf wird dadurch rund
       30 % kräftiger, die Zeichnung bleibt aber kompakt.

       🔴 Die Grenzen sind an den Bildern GEMESSEN, nicht geschätzt
       (26.08.2026, alle neun Zeichnungen identisch):
         rote Bemaßung   15,31 % bis 32,78 %  → oben höchstens 12 % weg
         Halter/Rosetten 57,89 % bis 93,54 %  → unten höchstens  6 % weg
       Wer hier dreht, schneidet sonst den Maßkasten oder die Rosetten an. */
    var STRECK = 1.30, AB_OBEN = 12, AB_UNTEN = 4;
    var bh    = Math.round(bhRoh * STRECK);
    var yb    = -Math.round(bh * AB_OBEN / 100);
    var sicht = Math.round(bh * (100 - AB_OBEN - AB_UNTEN) / 100);

    /* ⚠️ MOBIL SIND VIEWBOX-EINHEITEN WINZIG.

       Das SVG ist 1000 Einheiten breit und wird auf die Spaltenbreite
       gestaucht: 838 px am Rechner (Faktor 0,84), aber nur ~303 px auf einem
       375er-Handy (Faktor 0,30). Schriftgroesse 14 waere dort **4,2 px** und
       damit unlesbar. Die Groessen haengen deshalb an der Anzeigebreite —
       nicht an einer CSS-Regel, weil der Platzbedarf unten mitgerechnet wird. */
    var eng   = window.matchMedia && window.matchMedia('(max-width:749px)').matches;
    var fsRnd = eng ? 34 : 14;
    var fsMit = eng ? 38 : 16;

    /* Masskette unter dem Bild. ⚠️ Der Abstand haengt an der Schriftgroesse:
       mobil ragt die Sammelbemassung sonst in den unteren Bildrand hinein,
       und der Randmasstext unter der Linie faellt aus dem viewBox heraus. */
    var KY = sicht + (eng ? 60 : 34);
    var H  = KY + fsRnd + 12;
    var O  = '#cb4f0a';

    var svg = svgEl('svg', { viewBox: '0 0 ' + W + ' ' + H,
      'class': 'mo-gesamt-svg', 'aria-hidden': 'true' });
    var bild = svgEl('image', { x: 0, y: yb, width: W, height: bh,
      preserveAspectRatio: 'none' });
    bild.setAttributeNS('http://www.w3.org/1999/xlink', 'href',
      oben.currentSrc || oben.src);
    bild.setAttribute('href', oben.currentSrc || oben.src);
    svg.appendChild(bild);

    function linie(x1, y1, x2, y2, breit) {
      svg.appendChild(svgEl('line', { x1: x1, y1: y1, x2: x2, y2: y2,
        stroke: O, 'stroke-width': breit || 1.4 }));
    }
    function text(s, x, y, gr, anker) {
      var t = svgEl('text', { x: x, y: y, fill: O, 'text-anchor': anker || 'middle',
        'dominant-baseline': 'central', 'font-size': gr, 'font-weight': '700',
        'font-family': 'Montserrat, system-ui, sans-serif' });
      t.textContent = s; svg.appendChild(t); return t;
    }
    function pfeile(x1, x2, y) {
      [[x1, 1], [x2, -1]].forEach(function (p) {
        svg.appendChild(svgEl('polygon', { fill: O, points:
          p[0] + ',' + y + ' ' + (p[0] + p[1]*8) + ',' + (y-3.4) + ' ' +
          (p[0] + p[1]*8) + ',' + (y+3.4) }));
      });
    }

    /* Das Bild bringt die obere Massline und einen LEEREN Kasten mit
       (siehe `textNur` in RAHMEN_JE_BILD). Der bleibt sonst leer. */
    var tx = W * 49.95 / 100, ty = yb + bh * 23.04 / 100, th = bh * 15.36 / 100;
    text(mitNamen('x', masse && masse.x), tx, ty,
         Math.round(th * 0.52 * (eng ? 1.55 : 1)));

    var xs = [];
    for (var i = 0; i < halter; i++) {
      xs.push(W * (BILD_L + (BILD_R - BILD_L) * (halter > 1 ? i/(halter-1) : 0)) / 100);
    }
    var xL = W * ENDE_L / 100, xR = W * ENDE_R / 100;

    /* Fuehrungslinien von den Haltern und Rohrenden herunter */
    [xL, xR].forEach(function (x) { linie(x, sicht - 6, x, KY + 8, 0.9); });
    xs.forEach(function (x) { linie(x, sicht - 10, x, KY + 8, 0.9); });

    /* ⭐ DIE RANDMASSE STEHEN UNTER DER LINIE, die Sammelbemassung darueber.

       So duerfen sie ueber ihr Feld hinausragen, ohne mit ihr zu kollidieren —
       und nur deshalb passt „ca. 100 mm“ hinein. Das Feld ist bloss
       73 Einheiten breit (5,75 % bis 13,04 %), der Text braucht rund 86
       Einheiten am Rechner und 200 auf dem Handy.

       ⚠️ Das „ca.“ ist Absicht: Zwischen Halterachse und Rohrende liegen im
       Bild 7,28 %, bei 5 m waeren das rund 410 mm. Die Zeichnung ist NICHT
       massstaeblich (siehe die Notiz an `randmass` in masslinien()). */
    function randfeld(x1, x2) {
      linie(x1, KY, x2, KY, 1.5);
      if (x2 - x1 > 20) pfeile(x1, x2, KY);
      var s = 'ca. ' + zahl(rand);
      var halb = s.length * fsRnd * 0.62 / 2;
      var mitte = (x1 + x2) / 2;
      /* Ragt er ueber den SVG-Rand? Dann buendig an den Rand ruecken. */
      if (mitte - halb < 2)        text(s, 2,     KY + fsRnd, fsRnd, 'start');
      else if (mitte + halb > 998) text(s, 998,   KY + fsRnd, fsRnd, 'end');
      else                         text(s, mitte, KY + fsRnd, fsRnd);
    }
    randfeld(xL, xs[0]);
    randfeld(xs[halter-1], xR);

    if (halter > 1) {
      linie(xs[0], KY, xs[halter-1], KY, 1.5);
      pfeile(xs[0], xs[halter-1], KY);
      text(felder + ' × ' + zahl(abstand), (xs[0] + xs[halter-1])/2,
           KY - fsMit, fsMit);
    }
    linie(xL, KY - 7, xL, KY + 7, 1.2);
    linie(xR, KY - 7, xR, KY + 7, 1.2);

    var kasten = alt || document.createElement('figure');
    kasten.className = 'mo-gesamt';
    kasten.textContent = '';
    kasten.appendChild(svg);
    var bu = document.createElement('figcaption');
    bu.textContent = 'So messen Sie — Halter gleichmäßig verteilt, '
                   + 'zum Vergrößern klicken';
    kasten.appendChild(bu);

    if (!alt) {
      /* Die Lupe der stillgelegten Skizze uebernehmen: Gezeigt wird das grosse
         Bild mit IHRER Bemassung, nicht dieses SVG — dessen viewBox ist wegen
         der Masskette hoeher als das Bild und laege schief darueber. */
      kasten.style.cursor = 'zoom-in';
      kasten.addEventListener('click', function () {
        var s  = koerper.querySelector('.mo-skizze');
        var im = s && s.querySelector('img');
        if (im && window.moVollbild) {
          window.moVollbild.zeigen(im.currentSrc || im.src,
            'Aufmaß: Wandhandlauf', s.querySelector('svg'));
        }
      });
      koerper.appendChild(kasten);
    }
    if (skizze) skizze.classList.add('mo-skizze-still');
  }

  /* Holt assets/mo-hl-skizze.js nach, sobald eine Config sie braucht.
     Laeuft genau einmal; wer waehrend des Ladens zeichnen will, bekommt
     `false` und wird vom onload-Rueckruf nachgezogen. */
  var HL_LAEDT = false;
  function hlSkizzeHolen(fertig){
    if (window.MO_HL_SKIZZE) { if (fertig) fertig(); return; }
    if (HL_LAEDT) return;
    HL_LAEDT = true;
    var wz = document.querySelector('[data-mo-konfigurator]');
    var js = (wz && wz.getAttribute('data-js-url')) || '';
    if (!js) { HL_LAEDT = false; return; }
    var s = document.createElement('script');
    /* 🔴 Den ?v=-Stempel NICHT von mo-konfigurator.js uebernehmen: er aendert
       sich nicht, wenn nur die Skizzendatei neu ist - die CDN liefert dann eine
       veraltete Fassung. Am 26.08.2026 gemessen: alter Stempel -> Schrift 26,
       frischer Stempel -> Schrift 22. Der Stempel der CONFIG-Datei passt, denn
       config und Skizze gehoeren zum selben Konfigurator und werden zusammen
       gepflegt. */
    var cfg = (wz && wz.getAttribute('data-config-url')) || '';
    var stempel = (cfg.split('?')[1] || '').split('&')
                    .filter(function(p){ return /^v=/.test(p); })[0] || '';
    s.src = js.split('?')[0].replace(/mo-konfigurator\.js/, 'mo-hl-skizze.js') +
            (stempel ? '?' + stempel : '');
    s.onload  = function(){ if (fertig) fertig(); };
    s.onerror = function(){ HL_LAEDT = false;
      console.error('[mo-konfigurator] mo-hl-skizze.js nicht erreichbar'); };
    document.body.appendChild(s);
  }

  /* ⭐ Motor-Patch 6 (23.09.2026): DIE TREPPE ZEICHNET WIEDER.
     Am 01.09. kam aus 2.09.3.1 nur der Zweig `handlauf-v3` herueber; die
     Treppe fiel seitdem in die Wandhandlauf-Skizze (Stefan: „keine
     Vorschau"). Nachlader und Zeichner unten sind WORTGLEICH aus der BETA
     (Theme-Spiegel `beta-generatoren`), ergaenzt um die raeumliche Ansicht. */

  /* Holt assets/mo-treppe-skizze.js nach — dieselbe Mechanik wie beim
     Wandhandlauf, nur eine andere Datei. Der ?v=-Stempel kommt wieder von der
     CONFIG, nicht von mo-konfigurator.js: sonst liefert die CDN eine veraltete
     Zeichnung, wenn nur die Skizze neu ist. */
  var TR_LAEDT = false;
  var TR3_LAEDT = false;
  var D3_CSS = false;
  function treppeSkizzeHolen(fertig){
    if (window.MO_TREPPE_SKIZZE) { if (fertig) fertig(); return; }
    if (TR_LAEDT) return;
    TR_LAEDT = true;
    var wz = document.querySelector('[data-mo-konfigurator]');
    var js = (wz && wz.getAttribute('data-js-url')) || '';
    if (!js) { TR_LAEDT = false; return; }
    var cfg = (wz && wz.getAttribute('data-config-url')) || '';
    var stempel = (cfg.split('?')[1] || '').split('&')
                    .filter(function(p){ return /^v=/.test(p); })[0] || '';
    var sc = document.createElement('script');
    sc.src = js.split('?')[0].replace(/mo-konfigurator\.js/, 'mo-treppe-skizze.js') +
             (stempel ? '?' + stempel : '');
    sc.onload  = function(){ if (fertig) fertig(); };
    sc.onerror = function(){ TR_LAEDT = false;
      console.error('[mo-konfigurator] mo-treppe-skizze.js nicht erreichbar'); };
    document.body.appendChild(sc);
  }

  /* ⭐ mo-3d-ansicht.css laedt seit dem CSS-Schnitt vom 01.09.2026 niemand —
     sie holt sich die raeumliche Ansicht jetzt selbst, genau einmal. Ohne sie
     setzt `mo-hl-3d.js` keine einzige Farbe: jede Flaeche waere schwarz.
     ⚠️ Stempel wie bei den Zeichnungen von der CONFIG: Wer nur das CSS
     aendert, laedt die Config mit hoch. */
  function d3CssHolen(){
    if (D3_CSS) return;
    var wz = document.querySelector('[data-mo-konfigurator]');
    var js = (wz && wz.getAttribute('data-js-url')) || '';
    if (!js) return;
    D3_CSS = true;
    var cfg = (wz && wz.getAttribute('data-config-url')) || '';
    var stempel = (cfg.split('?')[1] || '').split('&')
                    .filter(function(p){ return /^v=/.test(p); })[0] || '';
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = js.split('?')[0].replace(/mo-konfigurator\.js/, 'mo-3d-ansicht.css') +
             (stempel ? '?' + stempel : '');
    document.head.appendChild(l);
  }

  /* Zeichnet die Treppe. Rueckgabe wie hlSkizze: true, wenn ein SVG steht. */
  function treppeSkizze(kasten, koerper){
    if (!window.MO_TREPPE_SKIZZE) {
      treppeSkizzeHolen(function(){ treppeSkizze(kasten, koerper); });
      return false;
    }
    var wz = document.querySelector('[data-mo-konfigurator]');
    var roh = wz && wz.getAttribute('data-mo-skizze-werte');
    if (!roh) return false;
    var w;
    try { w = JSON.parse(roh); } catch (e) { return false; }

    /* ⭐ Hervorgehoben wird, was DIESER Schritt abfragt — Stefans Ansage vom
       24.08.: die Bemassung gehoert dorthin, wo die Masse eingetragen werden.
       Die Optionsnamen stehen als `data-mo-opt` an den Feldern; die Skizze
       uebersetzt sie selbst in ihre Masskuerzel. */
    var namen = [];
    if (koerper) {
      Array.prototype.forEach.call(koerper.querySelectorAll('[data-mo-opt]'), function(e){
        var n = e.getAttribute('data-mo-opt');
        if (n) namen.push(n);
      });
    }
    var betont = [];
    try { betont = window.MO_TREPPE_SKIZZE.kuerzelAus(namen.join(',')) || []; }
    catch (e) { betont = []; }

    /* Auf schmalen Anzeigen nur die Masse dieses Schrittes bemassen — acht
       Masse sind bei rund 230 px nicht mehr lesbar. */
    /* ⭐ 03.10.2026 (INP, Teil 2): Ein Kasten, den `zeichne()` stehen liess,
       gilt als frisch gebaut (SK_WIE_NEU, siehe einsetzen). Ein frischer Kasten
       wird losgeloest gezeichnet und misst 0 — also nie „schmal". Genau das
       muss auch der stehende liefern, sonst saehe die Zeichnung nach dem Klick
       anders aus als bisher. */
    var schmal = false;
    if (!SK_WIE_NEU) {
      try { schmal = (kasten.getBoundingClientRect().width || 999) < 320; } catch (e) {}
    }

    /* ⭐ 03.10.2026 (INP, Teil 2): Steht die Zeichnung schon mit genau diesen
       Eingaben im Kasten, bleibt sie stehen — sonst hiesse jeder Klick ~50
       SVG-Knoten raus und rein (samt Feldankern), ohne dass sich ein Strich
       aendert. Der Schluessel enthaelt alles, was die Zeichnung liest: Werte,
       Betonung, Breite, den Zustand (Wandlaenge, Handlaufenden), Feldschalter
       und Bauform. */
    var trBf = document.querySelector('[data-mo-treppe-bauform]');
    var trZs;
    try { trZs = JSON.stringify((window.MO_HL && window.MO_HL.zustand) || {}); }
    catch (e) { trZs = String(Math.random()); }
    var trSchluessel = roh + '|' + betont.join(',') + '|' + schmal + '|' + trZs + '|' +
      (wz.getAttribute('data-mo-felder-weg') || '') + '|' +
      (trBf ? ['verlauf', 'oben', 'unten'].map(function (k) {
        return trBf.getAttribute('data-mo-tr-' + k); }).join(',') : '');

    /* 🔴 Nur ein DIREKTES Kind-SVG ersetzen: Lupe und raeumliche Ansicht tragen
       ebenfalls SVGs, nur tiefer. (Die BETA nahm das erste SVG ueberhaupt.) */
    var alt = kasten.querySelector(':scope > svg');
    if (!(alt && kasten.__moTrSchluessel === trSchluessel)) {
      kasten.__moTrSchluessel = '';
      if (alt && alt.parentNode) alt.parentNode.removeChild(alt);
      var svg;
      try { svg = window.MO_TREPPE_SKIZZE.zeichne(w, betont, schmal); }
      catch (e) { console.error('[mo-konfigurator] Treppen-Skizze:', e); return false; }
      if (!svg) return false;
      kasten.insertBefore(svg, kasten.firstChild);

      /* Die Plausibilitaetspruefung der Skizze: Passen Stufenzahl, A und B zur
         eingetragenen Treppenlaenge? Das kann kein Preisfeld pruefen. */
      try {
        var hin = window.MO_TREPPE_SKIZZE.pruefe(w);
        var alt2 = kasten.querySelector(':scope > .mo-sk-hinweis');
        if (alt2) alt2.parentNode.removeChild(alt2);
        if (hin) {
          var p = document.createElement('p');
          p.className = 'mo-sk-hinweis';
          p.textContent = hin;
          /* Direkt hinter die Zeichnung — dort steht er im frischen Kasten
             (der ist beim Zeichnen sonst leer). Angehaengt landete er im
             stehenden Kasten unter Lupe und Bildunterschrift. */
          kasten.insertBefore(p, svg.nextSibling);
        }
      } catch (e) {}
      kasten.__moTrSchluessel = trSchluessel;
    }

    /* ⭐ RAEUMLICHE ANSICHT unter der Bemassung — wie beim Wandhandlauf.
       Erst den Kasten, dann die Datei, dann `starten()` (Henne-Ei-Falle der
       Feldschicht). Gesucht wird IM Kasten: Der alte Kasten kann noch im
       Dokument stehen, wenn der neue schon gezeichnet wird. */
    if (wz && wz.getAttribute('data-mo-3d') === 'ja') {
      d3CssHolen();
      var ziel3 = kasten.querySelector('#mo-treppe-3d');
      if (!ziel3) {
        ziel3 = document.createElement('div');
        ziel3.id = 'mo-treppe-3d';
        ziel3.className = 'mo-3d';
        kasten.appendChild(ziel3);
      }
      if (window.MO_TREPPE_3D && window.MO_TREPPE_3D.starten) {
        setTimeout(function(){
          try { window.MO_TREPPE_3D.starten(); } catch (e) {}
        }, 0);
      } else if (!TR3_LAEDT) {
        TR3_LAEDT = true;
        var js3 = (wz.getAttribute('data-js-url')) || '';
        var cfg3 = (wz.getAttribute('data-config-url')) || '';
        var st3 = (cfg3.split('?')[1] || '').split('&')
                    .filter(function(p){ return /^v=/.test(p); })[0] || '';
        if (js3) {
          var sc3 = document.createElement('script');
          sc3.src = js3.split('?')[0].replace(/mo-konfigurator\.js/, 'mo-treppe-3d.js') +
                    (st3 ? '?' + st3 : '');
          sc3.onload = function(){
            try { window.MO_TREPPE_3D && window.MO_TREPPE_3D.starten(); }
            catch (e) { console.error('[mo-konfigurator] Treppe 3D:', e); }
          };
          sc3.onerror = function(){ TR3_LAEDT = false;
            console.error('[mo-konfigurator] mo-treppe-3d.js nicht erreichbar'); };
          document.body.appendChild(sc3);
        } else { TR3_LAEDT = false; }
      }
    }
    /* ⭐ 03.10.2026 (INP, Teil 2): Im frischen Kasten steht zuerst die
       Zeichnung, dann der Hinweis, dann das Raumbild — Lupe und
       Bildunterschrift haengt einsetzen() erst danach an. Beim Seitenaufruf
       kommt die Zeichnung aber nachgeladen, und Raumbild und Hinweis landen
       HINTER der Bildunterschrift. Bisher raeumte der erste Klick das mit dem
       Neubau auf; bleibt der Kasten stehen, muss es hier geschehen. */
    if (SK_WIE_NEU) {
      var vor = null;
      [kasten.querySelector(':scope > svg'), kasten.querySelector(':scope > .mo-sk-hinweis'),
       kasten.querySelector(':scope > #mo-treppe-3d')].forEach(function (e) {
        if (!e) return;
        var platz = vor ? vor.nextSibling : kasten.firstChild;
        if (e !== platz) kasten.insertBefore(e, platz);
        vor = e;
      });
    }
    return true;
  }

  /* Holt assets/mo-hl-skizze-v3.js nach. Gleiche Mechanik wie bei den beiden
     anderen Zeichnungen; der ?v=-Stempel kommt wieder von der CONFIG. */
  var V3_LAEDT = false;
  var HLF_LAEDT = false;
  var HLT_LAEDT = false;   // Motor-Patch 7: Stufenkopplung mo-hl-treppe.js
  var D3_LAEDT = false;
  /* 🔴 Der Grossmodus MUSS ausserhalb der Zeichnung liegen. Der Renderer baut
     `#mo-schritte` bei jeder Eingabe neu — die `figure` ist danach ein anderes
     Element. Am Kasten gemerkt, spraenge die Zeichnung beim ersten getippten
     Zeichen zurueck auf klein, also genau dann, wenn im Grossen eingegeben
     wird. Hier ueberlebt der Zustand jeden Neubau; der Kasten liest ihn. */
  var SK_GROSS = false;
  /* 03.10.2026 (INP, Teil 2): true, solange einsetzen() einen Treppen-Kasten
     auffrischt, den zeichne() stehen liess — er soll aussehen wie frisch gebaut. */
  var SK_WIE_NEU = false;

  /* ⭐ Vergroessern heisst NICHT abbilden. Es ist dieselbe Zeichnung, nur
     formatfuellend — samt Eingabefeldern, Verrechnung und Preis. Ein
     serialisiertes SVG waere ein Bild, und in ein Bild tippt niemand. */
  function skizzeGross(an) {
    SK_GROSS = !!an;
    var k = document.querySelector('.mo-schritt-koerper.mo-mit-skizze > .mo-skizze');
    if (k) k.classList.toggle('mo-skizze-gross', SK_GROSS);
    /* Am <html>, damit die Seite darunter nicht mitscrollt — und damit die
       Massenheitswahl mitkommt, die ausserhalb der Zeichnung sitzt. */
    document.documentElement.classList.toggle('mo-skizze-gross-an', SK_GROSS);
    var lupe = k && k.querySelector('.mo-sk-lupe');
    if (lupe) {
      var txt = SK_GROSS ? 'Zeichnung verkleinern' : 'Zeichnung vergr\u00f6\u00dfern';
      lupe.setAttribute('aria-label', txt);
      lupe.title = txt;
    }
    /* 🔴 Die Felder kennen ihre Lage aus `getScreenCTM()` der ALTEN Groesse.
       Ohne dieses Nachziehen stehen sie nach dem Umschalten irgendwo.
       Zweimal: einmal sofort, einmal nach dem Umbruch — `position:fixed`
       aendert das Layout, und die erste Messung faellt noch in die alte Lage. */
    try {
      if (window.MO_HL_FELDER_V3) {
        window.MO_HL_FELDER_V3.angleichen();
        setTimeout(function () {
          try { window.MO_HL_FELDER_V3.angleichen(); } catch (e) {}
        }, 60);
      }
    } catch (e) {}
  }

  /* Einmal am Dokument, nicht am Kasten: Der Kasten wird staendig neu gebaut,
     und jeder Neubau haengte sonst einen weiteren Horcher an. */
  document.addEventListener('keydown', function (ev) {
    if (SK_GROSS && (ev.key === 'Escape' || ev.keyCode === 27)) skizzeGross(false);
  });
  function v3SkizzeHolen(fertig){
    if (window.MO_HL_SKIZZE_V3) { if (fertig) fertig(); return; }
    if (V3_LAEDT) return;
    V3_LAEDT = true;
    var wz = document.querySelector('[data-mo-konfigurator]');
    var js = (wz && wz.getAttribute('data-js-url')) || '';
    if (!js) { V3_LAEDT = false; return; }
    var cfg = (wz && wz.getAttribute('data-config-url')) || '';
    var stempel = (cfg.split('?')[1] || '').split('&')
                    .filter(function(p){ return /^v=/.test(p); })[0] || '';
    var sc = document.createElement('script');
    sc.src = js.split('?')[0].replace(/mo-konfigurator\.js/, 'mo-hl-skizze-v3.js') +
             (stempel ? '?' + stempel : '');
    sc.onload  = function(){ if (fertig) fertig(); };
    sc.onerror = function(){ V3_LAEDT = false;
      console.error('[mo-konfigurator] mo-hl-skizze-v3.js nicht erreichbar'); };
    document.body.appendChild(sc);
  }

  /* 🔴 Andere Signatur als die beiden anderen Zeichnungen: `zeichne(ziel, daten)`
     schreibt IN das Ziel, statt ein SVG zurueckzugeben. Der Kasten wird deshalb
     vorher geleert — aber nur vom SVG, die Bildunterschrift bleibt. */
  function v3Skizze(kasten, koerper){
    if (!window.MO_HL_SKIZZE_V3) {
      v3SkizzeHolen(function(){ v3Skizze(kasten, koerper); });
      return false;
    }
    var wz = document.querySelector('[data-mo-konfigurator]');
    var roh = wz && wz.getAttribute('data-mo-skizze-werte');
    if (!roh) return false;
    var w;
    try { w = JSON.parse(roh); } catch (e) { return false; }
    if (w.winkel == null) delete w.winkel;   // dann gilt die Vorgabe der Zeichnung

    /* Die Feldschicht kommt nach, sobald diese Zeichnung laeuft. Sie haengt
       sich selbst an die Skizze und horcht auf `mo:hl`. */
    if (!window.MO_HL_FELDER_V3 && !HLF_LAEDT) {
      HLF_LAEDT = true;
      var jsF = (wz && wz.getAttribute('data-js-url')) || '';
      var cfgF = (wz && wz.getAttribute('data-config-url')) || '';
      var stF = (cfgF.split('?')[1] || '').split('&')
                  .filter(function(p){ return /^v=/.test(p); })[0] || '';
      if (jsF) {
        var scF = document.createElement('script');
        scF.src = jsF.split('?')[0].replace(/mo-konfigurator\.js/, 'mo-hl-felder.js') +
                  (stF ? '?' + stF : '');
        /* 🔴 HENNE UND EI: Die Schicht haengt sich an `DOMContentLoaded` und
           `mo:hl`. Beim Nachladen ist DOMContentLoaded laengst vorbei, und das
           naechste `mo:hl` kommt erst beim naechsten Zeichnen — das aber nur,
           wenn der Kunde etwas aendert. Ohne diesen Anstoss blieben die Felder
           aus, bis jemand zufaellig etwas anfasst (am 31.08. gemessen: alle
           Bausteine geladen, 0 Felder). */
        scF.onload = function(){
          try { window.MO_HL_FELDER_V3 && window.MO_HL_FELDER_V3.angleichen(); }
          catch (e) { console.error('[mo-konfigurator] Feldschicht:', e); }
        };
        scF.onerror = function(){ HLF_LAEDT = false;
          console.error('[mo-konfigurator] mo-hl-felder.js nicht erreichbar'); };
        document.body.appendChild(scF);
      } else { HLF_LAEDT = false; }
    } else if (window.MO_HL_FELDER_V3) {
      /* Schon da: Die Zeichnung ist gleich ein anderes Element, also nach dem
         Neuaufbau neu ausrichten. */
      setTimeout(function(){
        try { window.MO_HL_FELDER_V3.angleichen(); } catch (e) {}
      }, 0);
    }

    /* ⭐ Motor-Patch 7 (30.09.2026): DIE TREPPE RECHNET MIT.
       `mo-hl-treppe.js` koppelt Stufenzahl, Stufenhoehe, Auftritt und Neigung
       mit Mass D (D = n * hypot(A, B)). Die Datei lag seit dem 31.08. im Theme,
       aber NIEMAND lud sie: `MO_HL_TREPPE` blieb leer, und nach D = 350 stand
       im Warenkorb weiter "Anzahl Stufen=6" (Stefan, 30.09.2026, LIVE 2.10.11).
       Gleiche Mechanik wie die Feldschicht darueber: ?v=-Stempel der CONFIG,
       im onload EINMAL anstossen — der erste Lauf merkt sich nur den Stand,
       danach haelt der `mo:hl`-Horcher der Datei die Kopplung wach.
       Wer die Kopplung aendert, laedt die Config mit hoch (Stempel). */
    if (!window.MO_HL_TREPPE && !HLT_LAEDT) {
      HLT_LAEDT = true;
      var jsT = (wz && wz.getAttribute('data-js-url')) || '';
      var cfgT = (wz && wz.getAttribute('data-config-url')) || '';
      var stT = (cfgT.split('?')[1] || '').split('&')
                  .filter(function(p){ return /^v=/.test(p); })[0] || '';
      if (jsT) {
        var scT = document.createElement('script');
        scT.src = jsT.split('?')[0].replace('mo-konfigurator.js', 'mo-hl-treppe.js') +
                  (stT ? '?' + stT : '');
        scT.onload = function(){
          try { window.MO_HL_TREPPE && window.MO_HL_TREPPE.koppeln(); }
          catch (e) { console.error('[mo-konfigurator] Stufenkopplung:', e); }
        };
        scT.onerror = function(){ HLT_LAEDT = false;
          console.error('[mo-konfigurator] mo-hl-treppe.js nicht erreichbar'); };
        document.body.appendChild(scT);
      } else { HLT_LAEDT = false; }
    }

    /* 🔴 03.10.2026: nur DIREKTE Kinder — vorher traf `svg` auch das Symbol im
       Lupenknopf und das Raumbild; beim Auffrischen (Tippen in „Anmerkungen")
       verschwand die Lupe bis zum naechsten Neubau. Die Zeichnung legt Hinweis,
       SVG und Bildunterschrift als direkte Kinder ab (mo-hl-skizze-v3.js). */
    Array.prototype.slice.call(kasten.querySelectorAll(':scope > svg, :scope > .mo-sk-hinweis, :scope > .mo-sk-bu'))
      .forEach(function(e){ if (e.parentNode) e.parentNode.removeChild(e); });
    var behaelter = document.createElement('div');
    try { window.MO_HL_SKIZZE_V3.zeichne(behaelter, w); }
    catch (e) { console.error('[mo-konfigurator] Wandhandlauf-Skizze:', e); return false; }
    if (!behaelter.firstChild) return false;
    /* ⭐ RAEUMLICHE ANSICHT unter der Bemassung. Sie rechnet echte
       3D-Geometrie in Millimetern und projiziert selbst — bewusst ohne
       three.js: das waeren 1,1 MB, und ein SVG laesst sich bemassen, drucken
       und in die Bestellung legen.

       🔴 Der Kasten muss STEHEN, bevor die Datei laedt: Sie sucht ihn beim
       Start ueber die feste Kennung und prallt sonst wirkungslos ab. Deshalb
       erst anlegen, dann nachladen, dann `starten()` — dieselbe Henne-Ei-Falle
       wie bei der Feldschicht. */
    var wz3 = document.querySelector('[data-mo-konfigurator]');
    if (wz3 && wz3.getAttribute('data-mo-3d') === 'ja') {
      d3CssHolen();   // Motor-Patch 6: sonst laedt niemand das 3D-CSS
      var ziel3 = document.getElementById('mo-handlauf-3d');
      if (!ziel3) {
        ziel3 = document.createElement('div');
        ziel3.id = 'mo-handlauf-3d';
        ziel3.className = 'mo-3d';
        kasten.appendChild(ziel3);
      }
      if (window.MO_HL_3D) {
        setTimeout(function(){
          try { window.MO_HL_3D.aktualisieren(); } catch (e) {}
        }, 0);
      } else if (!D3_LAEDT) {
        D3_LAEDT = true;
        var js3 = (wz3.getAttribute('data-js-url')) || '';
        var cfg3 = (wz3.getAttribute('data-config-url')) || '';
        var st3 = (cfg3.split('?')[1] || '').split('&')
                    .filter(function(p){ return /^v=/.test(p); })[0] || '';
        if (js3) {
          var sc3 = document.createElement('script');
          sc3.src = js3.split('?')[0].replace(/mo-konfigurator\.js/, 'mo-hl-3d.js') +
                    (st3 ? '?' + st3 : '');
          sc3.onload = function(){
            try { window.MO_HL_3D && window.MO_HL_3D.starten(); }
            catch (e) { console.error('[mo-konfigurator] 3D-Ansicht:', e); }
          };
          sc3.onerror = function(){ D3_LAEDT = false;
            console.error('[mo-konfigurator] mo-hl-3d.js nicht erreichbar'); };
          document.body.appendChild(sc3);
        } else { D3_LAEDT = false; }
      }
    }

    /* Vor die Bildunterschrift haengen, damit die Reihenfolge stimmt. */
    while (behaelter.firstChild) kasten.insertBefore(behaelter.firstChild, kasten.firstChild);
    return true;
  }

  /* ⭐ Gezaehlt wird, was der Kunde SIEHT — nicht, was im DOM steht.
     Am Wandhandlauf stehen sechs `.mo-massfeld` im Markup, sichtbar ist
     keines: `felderVerbergen: true` blendet sie aus, weil die Zahlen in der
     Zeichnung selbst stehen. Mit der reinen DOM-Zaehlung blieb der Koerper
     zweispaltig und liesz links 398 px leer (Stefan am 01.09.2026 am Bild:
     „was ist das da"), waehrend dieselbe Zeichnung im BETA 718 px breit ist.

     ⚠️ `offsetParent` statt `getBoundingClientRect()`: Letzteres erzwingt
     eine Layout-Neuberechnung, und diese Stelle laeuft bei JEDER Eingabe. */
  function massfelderSichtbar(koerper){
    if (!koerper) return 0;
    var n = 0, f = koerper.querySelectorAll('.mo-massfeld');
    for (var i = 0; i < f.length; i++) if (f[i].offsetParent !== null) n++;
    return n;
  }
  /* Breit ist die Zeichnung, wenn hoechstens EIN Massfeld sichtbar bleibt.
     🔴 Das Attribut wird ZUERST gefragt: Die Klasse wird gesetzt, bevor der
     Kasten eingehaengt ist — je nach Zeitpunkt melden die Felder dann noch
     eine Hoehe, und die Zaehlung allein waere unzuverlaessig. Steht das
     Attribut auf "ja", ist ohnehin keines zu sehen. */
  function skizzeBreitNoetig(koerper){
    /* 🔴 NUR der ausdrueckliche Schalter zaehlt, NICHT die gemessene
       Sichtbarkeit. Ein zugeklappter Schritt macht seine Felder ebenfalls
       unsichtbar — mit `massfelderSichtbar()` kam dort 0 heraus, und die
       Zeichnung wurde auch beim Fenstergitter formatfuellend: 718 statt
       250 px (Stefan am 01.09.2026 am Bild: „auch gross“).

       `felderVerbergen` aus der Config meint genau das Richtige: Die Felder
       sind DAUERHAFT weg, weil die Masze in der Zeichnung selbst stehen.
       Sonst bleibt es bei der urspruenglichen Zaehlung. */
    var wz = document.querySelector('[data-mo-konfigurator]');
    if (wz && wz.getAttribute('data-mo-felder-weg') === 'ja') return true;
    return koerper ? koerper.querySelectorAll('.mo-massfeld').length <= 1 : true;
  }


  function hlSkizze(kasten, koerper){
    if (!kasten) return false;
    /* ⭐ Drei Zeichnungen, eine Weiche. Alles danach — Vollbild,
       Bildunterschrift, Layoutklassen — gilt fuer alle drei. Aus 2.09.3.1
       geholt (01.09.2026), Rest der Funktion unveraendert. */
    var wzA = document.querySelector('[data-mo-konfigurator]');
    var artA = wzA ? (wzA.getAttribute('data-mo-skizze-zeichnen') || '') : '';
    if (artA === 'handlauf-v3') return v3Skizze(kasten, koerper);
    /* Motor-Patch 6: die Treppe hat ihre eigene Zeichnung (wie in 2.09.3.1). */
    if (artA === 'treppe') return treppeSkizze(kasten, koerper);
    if (!window.MO_HL_SKIZZE) {
      /* Noch nicht da: nachladen und danach genau diesen Kasten fuellen. */
      hlSkizzeHolen(function(){ hlSkizze(kasten, koerper); });
      return false;
    }
    var wz = document.querySelector('[data-mo-konfigurator]');
    var L  = parseFloat(wz && wz.getAttribute('data-mo-skizze-mass')) || 0;
    if (!(L > 0)) return false;
    var gr = parseFloat(wz && wz.getAttribute('data-mo-skizze-groesse')) || 100;
    /* Ein Massfeld -> die Skizze steht unter den Feldern und ist breit
       (gemessen 838 px), sonst daneben und schmal. Dieselbe Zaehlung wie beim
       Foto-Zweig. */
    var einMass = skizzeBreitNoetig(koerper);
    var alt = kasten.querySelector('svg');
    if (alt && alt.parentNode) alt.parentNode.removeChild(alt);
    var svg;
    try {
      /* 🔴 27.08.2026: Das Attribut, aus dem die Einheit hier bisher kam,
         wird NIRGENDS gesetzt (0 Treffer fuer setAttribute) — die Skizze
         bekam deshalb IMMER 'mm'. Stefan: „cm schaltet nicht um": Eingabe
         450 cm, die Skizze zeigte 4500 mm.

         Das ist derselbe Fehler wie am 25.08. bei den Fenstergittern (siehe
         den Kommentar vor `zahl()`): `moEinheit` liegt in einer ANDEREN IIFE
         und ist hier nicht sichtbar. Dort wurde er ueber den aktiven Knopf
         geloest — nur die Handlauf-Skizze wurde nie nachgezogen.

         Jetzt dieselbe Quelle: der aktive Knopf traegt die Wahl sichtbar im
         DOM, localStorage ist der Rueckfall, falls die Skizze vor dem
         Umschalter gezeichnet wird. */
      var hlEinheit = 'mm';
      try {
        var hlKnopf = document.querySelector('.mo-einheit-knopf.mo-an');
        if (hlKnopf) hlEinheit = /cm/i.test(hlKnopf.textContent) ? 'cm' : 'mm';
        else if (localStorage.getItem('mo-einheit') === 'cm') hlEinheit = 'cm';
      } catch (_) {}

      svg = window.MO_HL_SKIZZE.zeichne({
        laenge: L, groesse: gr,
        breite: einMass ? 838 : 303,
        einheit: hlEinheit
      });
    } catch (e) { console.error('[mo-konfigurator] Handlauf-Skizze:', e); return false; }
    if (!svg) return false;
    kasten.insertBefore(svg, kasten.firstChild);
    try { window.MO_HL_SKIZZE.kaestenNachmessen(svg); } catch (e) {}
    return true;
  }

  function einsetzen(zustand, url, masse) {
    var schritt = masseSchritt();
    if (!schritt) return;
    var koerper = schritt.querySelector('.mo-schritt-koerper');
    if (!koerper) return;

    /* ⚠️ Doppelter Boden: Die Skizze darf NUR in die Konfigurator-Huelle.
       Landet sie woanders — etwa in der Galerie —, faellt es dem Kunden sofort
       auf und uns erst spaet. */
    var wurzel = document.querySelector('.mo-huelle');
    if (wurzel && !wurzel.contains(koerper)) return;

    var art = window.moBefestigungsArt(zustand);
    galerieAufBefestigung(art);

    // Steht die Skizze schon: nur die Zahlen auffrischen. Sie aendern sich bei
    // jedem Tastendruck im Massfeld - das Bild dabei neu zu setzen hiesse, es
    // bei jeder Ziffer erneut zu holen.
    /* 🔴 Traegt die Config `skizzeZeichnen`, wird gezeichnet statt geladen.
       Dann gibt es kein <img>, keine Bildstaffel und keine Kalibrierung. */
    var wzz = document.querySelector('[data-mo-konfigurator]');
    var gezArt = wzz ? (wzz.getAttribute('data-mo-skizze-zeichnen') || '') : '';

    var da = koerper.querySelector('.mo-skizze');
    if (da) {
      /* ⭐ 03.10.2026 (INP, Teil 2): Hat `zeichne()` diesen Koerper stehen
         lassen (nur Treppe, `__moWieNeu`), muss danach dasselbe dastehen wie
         bei einem frisch gebauten: dort wird losgeloest gezeichnet (nie
         „schmal") und danach `moSkizzeFussHtml()` gerufen. */
      var wieNeu = !!koerper.__moWieNeu;
      koerper.__moWieNeu = false;
      /* Beim gezeichneten SVG aendert sich mit jeder Ziffer auch Halter- und
         Stosslage — anders als beim Foto genuegt Auffrischen der Masslinien
         nicht, es muss neu gezeichnet werden. Kostet kein Bildladen. */
      if (gezArt) {
        SK_WIE_NEU = wieNeu;
        try { hlSkizze(da, koerper); } finally { SK_WIE_NEU = false; }
        if (wieNeu) moSkizzeFussHtml(koerper);
        return;
      }
      masslinien(da, art, masse); gesamtzeichnung(koerper, masse); return;
    }

    if (!gezArt && !url) return;

    /* ⭐ Steht die Skizze UNTER dem Mass? Das haengt daran, ob es ein zweites
       Massfeld gibt — gezaehlt im DOM, weil diese IIFE die Config nicht kennt
       (siehe konfigurator-iife-grenzen). Bestimmt Layout UND Bildbreite. */
    var einMass = skizzeBreitNoetig(koerper);

    /* ⭐ Andere Zeichnung je nach Laenge — der Dateiname kommt ueber das
       Attribut `data-mo-skizzenbild` (gesetzt in skizzenbildNachfuehren()).
       Getauscht wird NUR der Dateiname, Pfad und Groessenangabe bleiben.
       Der `?v=`-Stempel gehoert zum alten Bild und muss weg, sonst liefert die
       CDN eine veraltete Fassung. */
    var wz = document.querySelector('[data-mo-konfigurator]');
    var wunsch = wz ? (wz.getAttribute('data-mo-skizzenbild') || '') : '';
    if (wunsch) {
      var teile = String(url).split('?');
      var pfad  = teile[0].replace(/\/files\/[^/]+?(\.[a-z0-9]+)$/i,
                                  '/files/' + wunsch + '$1');
      var frage = (teile[1] || '').split('&')
                    .filter(function(p){ return p && !/^v=/.test(p); }).join('&');
      url = pfad + (frage ? '?' + frage : '');
    }

    var kasten = document.createElement('figure');
    kasten.className = 'mo-skizze';

    /* Gezeichnete Fassung: SVG einhaengen, Bildunterschrift und Vollbild
       wie gehabt — dann unten weiter beim gemeinsamen Teil. */
    if (gezArt) {
      hlSkizze(kasten, koerper);
      /* ⭐ Vergroessern laesst sich in der Config abschalten
         (`skizzeZeichnen.vollbild: false`) — bei 718 x 620 px ist die
         Zeichnung ohnehin gross, und wo Eingabefelder darin sitzen, ist ein
         zweites, totes Abbild eher verwirrend als hilfreich. */
      var wzV = document.querySelector('[data-mo-konfigurator]');
      var vollAus = wzV && wzV.getAttribute('data-mo-vollbild') === 'aus';
      if (!vollAus) {
        /* ⭐ LUPE OBEN RECHTS — Stefans Vorschlag vom 31.08.2026. Sie ersetzt
           den Klick auf die ganze Flaeche, und das ist mehr als Geschmack:
           Solange die Flaeche selbst das Vollbild oeffnet, oeffnet auch jeder
           Griff daneben eines. Die Flaeche gehoert jetzt dem Eingeben, das
           Vergroessern einem eigenen Knopf.

           Bewusst ein `<button>`: Er ist mit der Tastatur erreichbar und sagt
           Vorlesegeraeten, was er tut. Ein `<div>` mit Klick-Horcher waere
           kuerzer und fuer einen Teil der Kunden unbedienbar. */
        var lupe = document.createElement('button');
        lupe.type = 'button';
        lupe.className = 'mo-sk-lupe';
        lupe.setAttribute('aria-label', 'Zeichnung vergr\u00f6\u00dfern');
        lupe.title = 'Zeichnung vergr\u00f6\u00dfern';
        lupe.innerHTML =
          '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
          '<circle cx="10.5" cy="10.5" r="6.5"/>' +
          '<path d="M15.4 15.4 21 21"/>' +
          '<path class="mo-sk-lupe-plus" d="M10.5 7.8v5.4M7.8 10.5h5.4"/>' +
          '</svg>';
        lupe.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          skizzeGross(!SK_GROSS);
        });
        kasten.appendChild(lupe);
        /* Der Grossmodus ueberlebt den Neubau des Schrittbereichs — der neue
           Kasten muss ihn beim Bauen wieder annehmen. Ohne das spraenge die
           Zeichnung bei der ersten Eingabe zurueck auf klein. */
        if (SK_GROSS) kasten.classList.add('mo-skizze-gross');
      }
      var textG = document.createElement('figcaption');
      /* 03.09.2026: „So messen Sie" war die Ueberschrift des Anleitungsblocks
         IM Bild — der ist weg (doppelt zum Akkordeon darueber, siehe
         mo-hl-skizze.css). Sein einziger eigener Satz war der Bedienhinweis;
         der steht jetzt hier, mit 12 px statt 7,3 px im Bild. */
      textG.textContent = vollAus
        ? 'Ma\u00dfe direkt in der Zeichnung eintragen'
        : 'Zahlen antippen und \u00e4ndern \u2014 zum Vergr\u00f6\u00dfern klicken';
      kasten.appendChild(textG);

      /* ⭐ DIE AUSFUEHRLICHE ANLEITUNG UNTER die Zeichnung, aufklappbar.

         Stefan am 01.09.2026: „besser mit einem mehr anzeigen machen oder
         vergroessern?" — Vergroessern geht nicht: Der Platz in der Zeichnung
         ist ein Dreieck, das nach unten zulaeuft; mehr Hoehe heisst
         Ueberlappung mit Mass D.

         `<details>` kann der Browser von selbst: kein Zustand, kein Skript,
         mit der Tastatur bedienbar, und der Text skaliert mit der Schrift des
         Shops statt mit der viewBox. In der Zeichnung bleibt nur der Satz, auf
         den es ankommt — dass man die Zahlen dort antippt. */
      if (gezArt === 'handlauf-v3') {
        var hilfe = document.createElement('details');
        hilfe.className = 'mo-sk-hilfe';
        var hKopf = document.createElement('summary');
        hKopf.textContent = 'Wie messe ich richtig?';
        hilfe.appendChild(hKopf);
        var hListe = document.createElement('ol');
        [['Stufen z\u00e4hlen',
          'Alle Trittfl\u00e4chen, von unten bis oben.'],
         ['Eine Stufe messen',
          'H\u00f6he und Auftritt \u2014 eine gen\u00fcgt, die \u00fcbrigen sind gleich.'],
         ['Ma\u00df C eintragen',
          'Das waagerechte St\u00fcck am Ende, ab dem Knick gemessen.']
        ].forEach(function (p) {
          var li = document.createElement('li');
          var b = document.createElement('strong');
          b.textContent = p[0];
          li.appendChild(b);
          li.appendChild(document.createTextNode(' \u2014 ' + p[1]));
          hListe.appendChild(li);
        });
        hilfe.appendChild(hListe);
        var hSchluss = document.createElement('p');
        hSchluss.appendChild(document.createTextNode('Die '));
        var hB = document.createElement('strong');
        hB.textContent = 'Hauptl\u00e4nge D';
        hSchluss.appendChild(hB);
        hSchluss.appendChild(document.createTextNode(
          ' rechnen wir aus Ihren Stufen \u2014 und umgekehrt: Wer D kennt, ' +
          'bekommt die Stufenzahl. Gerechnete Werte stehen gestrichelt und ' +
          'lassen sich \u00fcberschreiben.'));
        hilfe.appendChild(hSchluss);
        kasten.appendChild(hilfe);
      }
      /* Einhaengen wie im Foto-Zweig - dieselben zwei Klassen, damit das
         Theme-CSS greift. Kein masslinien()/gesamtzeichnung(): das SVG
         bringt seine Bemassung selbst mit. */
      koerper.classList.add('mo-mit-skizze');
      koerper.classList.toggle('mo-skizze-breit', skizzeBreitNoetig(koerper));
      koerper.appendChild(kasten);
      /* ⭐ Stefan am 03.09.2026: „das runter". Der Foto-Zweig haengt den
         Kontaktkasten seit dem 02.09. unter die Zeichnung — hier fehlte das,
         weshalb er beim Handlauf zwischen Eingabe und Skizze stehen blieb
         (gemessen: Kasten ab 664 px, Skizze erst ab 968 px). */
      moKontaktUeberBreite(koerper, true);
      moSkizzeFussHtml(koerper);
      return;
    }

    var bild = document.createElement('img');
    /* Die Skizze wird 250 px breit gezeigt (mobil bis 320). 640 deckt beides
       mit Retina-Reserve ab; ohne Angabe kam sie in voller Groesse.

       ⚠️ Steht sie UNTER dem Mass (ein Massfeld), ist sie ueber 800 px breit —
       gemessen 838 px am 26.08.2026. Die Adresse aus dem Traeger traegt
       `width=800` und wuerde hochskaliert; deshalb wird die Breite hier
       einmalig ersetzt. Das ist die einzige Stelle, an der die Adresse
       umgeschrieben werden darf. */
    var breite = einMass ? 1400 : 640;
    /* ⭐ 03.09.2026: BILDSTAFFEL STATT EINER FESTEN BREITE.

       Die 1400 stimmen nur auf dem Desktop. Auf dem Handy steht dieselbe
       breite Skizze in 304 px (375er Viewport, an FG 30 gemessen); bei
       doppelter Pixeldichte braucht sie 608 — geladen wurden 1400, das
       2,3-Fache, weil `src` allein dem Browser keine Wahl laesst. `srcset`
       bietet vier Stufen an, `sizes` nennt die Anzeigebreite; der Browser
       nimmt die kleinste Stufe, die bei seiner Pixeldichte reicht. Die CDN
       rechnet jede `width=` selbst. `src` bleibt als Rueckfall wie bisher.

       ⚠️ Dieselbe Umschreibung wie bei `src` — die Regel darueber gilt
       weiter: NUR hier wird die Adresse angefasst. Alles, was sie spaeter
       LIEST (rahmenFuer, gesamtzeichnung, die Lupe), greift ueber
       `currentSrc` zu und bekommt damit die gewaehlte Stufe; der
       Galerie-Tausch holt seine Adresse aus den Produktmedien, nicht von
       diesem Bild. srcset und sizes VOR src setzen, sonst laedt der
       Browser erst das Rueckfallbild und dann noch einmal die Stufe. */
    var mitBreite = function (w) {
      return /[?&]width=/.test(url)
        ? url.replace(/([?&]width=)\d+/, '$1' + w)
        : url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    };
    /* Breit unter den Feldern: Handy volle Breite minus Rand (304 von 375
       gemessen), Desktop 838 px. Daneben: mobil 240 px (order:-1-Regel im
       CSS), Desktop hoechstens 250 px (Spalte minmax(190px, 250px)). */
    bild.setAttribute('sizes', einMass
      ? '(max-width:749px) calc(100vw - 70px), 838px'
      : '(max-width:749px) 240px, 250px');
    bild.setAttribute('srcset', [480, 640, 960, 1400].map(function (w) {
      return mitBreite(w) + ' ' + w + 'w';
    }).join(', '));
    bild.src = /[?&]width=/.test(url)
             ? (einMass ? url.replace(/([?&]width=)\d+/, '$1' + breite) : url)
             : url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + breite;
    bild.alt = 'Aufmaß-Skizze: ' + window.moBefestigungsArt(zustand);
    bild.loading = 'lazy';
    bild.decoding = 'async';
    /* ⭐ 02.10.2026: PLATZ FUER DIE SKIZZE, BEVOR SIE GELADEN IST.

       Ohne width/height war das Bild bis zum Laden 0 px hoch. Mobil steht die
       Skizze UEBER den Feldern (order:-1, 240 px breit) - kam sie an, rutschten
       die Massfelder um 238 px nach unten. Wer in dem Moment tippte, traf das
       Bild und oeffnete das Vollbild statt des Feldes (Kaufweg-Test 02.10.2026,
       FG 01, FG 38 und FB 01 mobil: „Feld wanderte 238 px“, LIVE wie Arbeitstheme).

       50 von 55 Aufmassbildern im Shop sind quadratisch (alle Produkte am
       02.10.2026 nachgemessen). Die 5 breiten gehoeren zu Produkten mit EINEM
       Massfeld (einMass: Stangen Nova 30/31, Wandhandlauf) - dort steht die
       Skizze UNTER dem Feld und schiebt nichts, darum dort keine Vorgabe.
       Das CSS (`.mo-skizze img{width:100%;height:auto}`) macht aus den beiden
       Attributen nur das Seitenverhaeltnis; die Groesse bestimmt weiter das CSS.
       Ist ein Bild doch nicht quadratisch, gilt nach dem Laden sein echtes
       Verhaeltnis - nicht schlechter als vorher. naturalWidth/-Height, die
       masslinien() liest, aendern sich dadurch nicht. */
    if (!einMass) { bild.width = 640; bild.height = 640; }

    // Die Zeichnung ist im Konfigurator 250 px breit - fuer die Masslinien
    // reicht das, fuer die Einzelheiten der Befestigung nicht. Ein Klick
    // zeigt sie gross.
    bild.style.cursor = 'zoom-in';
    kasten.addEventListener('click', function(){
      /* Adresse beim KLICK lesen, nicht die vom Anlegen: Nach einem Wechsel
         der Befestigungsart zeigte das Vollbild sonst die alte Zeichnung.
         Und das Mass-SVG mitgeben — Stefan am 24.08.: „im großbild auch
         anzeigen". */
      var aktuell = kasten.querySelector('img');
      window.moVollbild.zeigen(
        (aktuell && (aktuell.currentSrc || aktuell.src)) || url,
        'Aufma\u00df: ' + art,
        kasten.querySelector('svg')
      );
    });

    /* ⚠️ Die Befestigungsart nur nennen, wenn es sie GIBT.

       Der Wandhandlauf hat keinen Schritt „Befestigungsart" — unter seiner
       Skizze stand trotzdem „So messen Sie auf der Außenwand", weil der
       Rueckfall greift. Gepruft wird am DOM, nicht am Zustand: `zustand`
       ist auch dann leer, wenn der Kunde nur noch nichts gewaehlt hat. */
    var hatArt = !!document.querySelector('[data-option="Befestigung"], .mo-schritt [data-feld="Befestigung"]') ||
                 Object.prototype.hasOwnProperty.call(zustand || {}, 'Befestigung');
    var text = document.createElement('figcaption');
    text.textContent = hatArt
      ? ('So messen Sie ' +
         (window.moBefestigungsArt(zustand) === 'In der Laibung' ? 'in der Laibung' : 'auf der Außenwand') +
         ' — zum Vergrößern klicken')
      : 'So messen Sie — zum Vergrößern klicken';

    kasten.appendChild(bild);
    kasten.appendChild(text);

    /* Der Koerper wird zweispaltig: Felder links, Skizze rechts. Die Klasse
       sitzt am Koerper, damit das Layout nur in diesem einen Schritt gilt.

       ⭐ Stefan am 26.08.2026: „skizze groß unter das maß". Bei EINEM Massfeld
       (Stange, Handlauf) bleibt neben den Feldern so viel Luft, dass die
       Skizze rechts verloren aussieht — dann steht sie darunter, ueber die
       volle Breite. Gezaehlt wird im DOM: die Skizze liegt in einer eigenen
       IIFE und kennt `onlyX` aus der Config nicht
       (siehe konfigurator-iife-grenzen). */
    koerper.classList.add('mo-mit-skizze');
    koerper.classList.toggle('mo-skizze-breit', einMass);
    koerper.appendChild(kasten);
    /* ⭐ Stefan am 02.09.2026: „das kompakter über die länge auch unter
       das aufmaßbild.“ Steht die Skizze DANEBEN, endete der Kontaktkasten
       an der Feldspalte und liess rechts unter dem Bild einen leeren
       Absatz.
       ⭐ Stefan am 03.09.2026: „ambesten ueberall nach unten?“ — jetzt auch
       bei breiter Skizze. Auf dem Handy stand der Kasten sonst ZWISCHEN
       Eingabe und Zeichnung und schob das Aufmassbild um 286 px nach unten;
       gerade die Zeichnung erklaert aber, was zu messen ist. */
    moKontaktUeberBreite(koerper, true);
    masslinien(kasten, art, masse);
    gesamtzeichnung(koerper, masse);
  }

  /* Haengt den Kontaktkasten zwischen Option und Schrittkoerper um.

     `unten = true`  -> aus der Option in den Koerper, ueber beide Spalten
     `unten = false` -> zurueck in die Option, rechts neben die Eingabe

     🔴 Beide Richtungen sind noetig. Beim Wechsel der Befestigungsart wird
     neu gezeichnet; steht die Skizze dann breit, muss der Kasten zurueck —
     sonst bliebe er unten haengen und die Option daneben leer. */
  /* Die Fusszeile der Zeichnung noch einmal als HTML unter das Bild.
     Im SVG steht sie in Zeichnungseinheiten und schrumpft mit: auf dem Handy
     bleiben 8,7 px („abgewickelte Laenge …") und 6,8 px („Treppe: Steigung
     …"). Groesser stellen geht nicht — die Zeile ist schon 279 von 304 px
     breit, und SVG-Text bricht nicht um. Als HTML darf er das.
     Welche Fassung sichtbar ist, entscheidet allein das CSS. */
  function moSkizzeFussHtml(koerper){
    if (!koerper) return;
    var fig = koerper.querySelector('.mo-skizze');
    if (!fig) return;
    /* 🔴 03.10.2026: nur der EIGENE Absatz (direktes Kind der figure). Vorher
       traf `.mo-sk-fuss` auch die gleichnamige Zeile IN der Treppen-Zeichnung
       („Steigung … · Füllung · Höhe …") und loeschte sie — beim Seitenaufruf
       stand sie da, nach dem ersten Klick nicht mehr. */
    var alt = fig.querySelector(':scope > .mo-sk-fuss');
    if (alt) alt.parentNode.removeChild(alt);
    var svg = fig.querySelector('svg');
    if (!svg) return;
    var zeilen = [];
    /* Reihenfolge wie im Bild: erst die Zusammenfassung, dann die Steigung. */
    ['.mo-sk-gesamt', '.mo-sk-steigung'].forEach(function (wahl) {
      var t = svg.querySelector(wahl);
      var s = t && (t.textContent || '').replace(/\s+/g, ' ').trim();
      if (s) zeilen.push(s);
    });
    if (!zeilen.length) return;
    var p = document.createElement('p');
    p.className = 'mo-sk-fuss';
    /* Kein aria-hidden: Auf dem Desktop ist der Absatz per CSS weg, mobil
       traegt er die Angabe allein — beides soll vorgelesen werden koennen. */
    p.textContent = zeilen.join(' · ');
    /* Direkt unter die Zeichnung, nicht ans Ende der figure: Dort stehen
       Bildunterschrift und Hilfe-Akkordeon, und die Angabe geriete hinter
       beide. Sie beschreibt das Bauteil und gehoert ans Bild. */
    var cap = fig.querySelector('figcaption');
    if (cap) fig.insertBefore(p, cap); else fig.appendChild(p);
  }

  function moKontaktUeberBreite(koerper, unten){
    if (!koerper) return;
    var opt = koerper.querySelector('.mo-opt');
    var kk  = koerper.querySelector('.mo-kontakt');
    if (!kk || !opt) { koerper.classList.remove('mo-kk-unten'); return; }
    if (unten) {
      if (kk.parentNode !== koerper) koerper.appendChild(kk);
      kk.className = 'mo-kontakt mo-kontakt-flach';
      koerper.classList.add('mo-kk-unten');
      /* 🔴 `mo-opt-neben` haelt eine zweite Spalte FUER DEN KASTEN frei.
         Ist er weggehaengt, bliebe sie leer und die Felder waeren grundlos
         schmaler — genau davor warnt der Patch vom 02.09. selbst. */
      opt.classList.remove('mo-opt-neben');
    } else {
      if (kk.parentNode !== opt) opt.appendChild(kk);
      kk.className = 'mo-kontakt';
      koerper.classList.remove('mo-kk-unten');
      opt.classList.add('mo-opt-neben');
    }
  }

  /* ======================================================================
     DIE AUFMASSZEICHNUNG IN DER GROSSEN VORSCHAU

     Wer ins Massfeld tippt, will sehen, WAS er da misst - und zwar gross, nicht
     in der 250 px breiten Skizze daneben. Solange ein Massfeld den Fokus hat,
     zeigt das Galeriebild deshalb die Zeichnung samt Masslinien; danach kehrt
     das vorherige Bild zurueck.

     Es gab das schon einmal fuer LPO (custom.js, Block "AUFMASSBILD IN DIE
     KLEBENDE VORSCHAU" v2.0.0) - das haengt aber an `.cl-po--preview-sticky`
     und greift ohne LPO nicht mehr.

     Drei Lehren aus jenem Bau sind hier uebernommen ([[aufmassbild-in-vorschau]]):

       1. NICHTS AUS DEM FLUSS NEHMEN. Der erste Anlauf blendete damals die
          kleine Skizze aus - das nahm 225 px aus dem Fluss, alles darunter
          rutschte hoch, und genau das sah Stefan als "Sprung". Hier wird nur
          das BILD getauscht, kein Element versteckt oder eingefuegt.
       2. KEIN SCROLL-AUSGLEICH. Der ist keine Loesung, sondern ein zweiter
          Sprung.
       3. NICHTS GROSSSCHALTEN. Wie gross die Vorschau steht, entscheidet der
          Kunde.

     Der Tausch laeuft ueber `src` am vorhandenen Galeriebild, das Original
     wird vorher weggeschrieben. Ein eigenes Deckelbild waere sauberer, wenn
     eine App das Bild staendig neu setzt - der Eigenbau tut das nicht.
     ====================================================================== */
  (function aufmassInVorschau(){
    var GROSS = null, MERKER = null, LAGE = null;

    /* Dieselbe Kandidatenliste wie bildSuchen() der Farbvorschau.

       `.is-active` waere naheliegend, trifft aber nicht: Die Theme-Galerie
       laesst die Klasse am ersten Eintrag stehen, auch wenn die Farbvorschau
       dessen src laengst getauscht hat. Am 22.08.2026 gemessen - der Griff
       nach `.is-active` fand ein anderes Bild als das sichtbare. */
    function galeriebild(){
      var kandidaten = [
        '.product__media-wrapper .product__media-item:first-child img',
        '.product__media-wrapper .product__media img',
        '.product__media-list .product__media-item:first-child img'
      ];
      /* 🔴 28.08.2026: NUR SICHTBARE BILDER. Die Produktseite traegt ZWEI
         Galerie-Huellen (Desktop/Mobil); `querySelector` liefert immer die
         erste, und die misst je nach Layout 0 x 0. Live an FB 07 gemessen:
         zwei Treffer, das erste unsichtbar. Die Bemassung landete darin —
         sichtbar wurde nichts.

         ⚠️ Nicht ueber `offsetParent` pruefen: Ein Bild in einem Slider mit
         `transform` hat einen offsetParent und misst trotzdem 0. Die
         Rechteckgroesse ist das verlaessliche Mass. */
      for (var i = 0; i < kandidaten.length; i++) {
        var alle = document.querySelectorAll(kandidaten[i]);
        for (var j = 0; j < alle.length; j++) {
          /* 🔴 DAS KLEBENDE PRODUKTBILD IST KEIN GALERIEBILD.

             `.product-sticky-image` ist die Leiste, die beim Scrollen oben
             einrastet. Beim Herunterscrollen misst sie **1905 x 76** — flach
             und seitenbreit. Legt man den Vorschaukasten dort hinein, wird das
             Mass-SVG durch `height:auto` **1905 x 1905** und ragt 1829 px ueber
             die Seite: die Bemassung laeuft quer ueber den Fliesstext.

             Genau das hatte Stefan am 28.08.2026 im Bild — und es war
             derselbe Fehler wie die verschwundene Galerie-Vorschau: die
             normale Galerie war weggescrollt (0 x 0), das klebende Bild das
             einzige "sichtbare". */
          if (alle[j].closest('.product-sticky-image')) continue;
          var r = alle[j].getBoundingClientRect();
          if (r.width > 1 && r.height > 1) return alle[j];
        }
      }
      /* Nichts Sichtbares gefunden: lieber das erste als gar keins — dann
         bleibt das Verhalten wie vorher, statt ganz auszufallen. */
      for (var k = 0; k < kandidaten.length; k++) {
        var e = document.querySelector(kandidaten[k]);
        if (e) return e;
      }
      return null;
    }

    function zeigen(url, art, masse){
      var bild = galeriebild();
      if (!bild || !url) return;

      if (MERKER === null) {
        // srcset MUSS mit weg - sonst gewinnt es gegen src und das alte Bild
        // bleibt stehen. Dieselbe Falle wie bei der Farbvorschau.
        MERKER = { src: bild.src, srcset: bild.getAttribute('srcset') || '' };
      }
      bild.removeAttribute('srcset');
      bild.src = url;
      GROSS = bild;

      /* Die Farbvorschau anhalten, solange die Zeichnung liegt.

       Beide Bloecke tauschen dasselbe <img>. Ohne die Sperre passierte
       folgendes: Fokus ins Massfeld -> Zeichnung erscheint -> die naechste
       Eingabe feuert mo:konfig -> die Farbvorschau setzt ihr Farbbild zurueck
       -> die Zeichnung ist nach der ersten Ziffer wieder weg. */
      window.moKonfig.bildGesperrt = true;

      /* Die Masslinien darueber - dieselbe Zeichenfunktion wie bei der kleinen
         Skizze, damit beide gleich aussehen.

         masslinien() braucht ein <img>, um an naturalWidth/Height zu kommen -
         daraus entsteht der viewBox. Hier liegt das Bild aber schon in der
         Galerie, also legt der Kasten ein unsichtbares Zweitbild derselben
         Adresse an. Es kostet keine zweite Anfrage: Der Browser hat sie eben
         geladen und nimmt sie aus dem Cache. */
      /* 🔴 ALLE alten Kaesten wegraeumen, nicht nur den gemerkten.

         Das Theme KLONT die Galerie in die klebende Leiste
         (`.product-sticky-image`) — und nimmt unseren Vorschaukasten mit.
         `LAGE` kennt diesen Klon nicht, er blieb also liegen. Im Kleber
         (1905 x 76) wird das Mass-SVG durch `height:auto` 1905 x 1905 und
         ragt quer ueber die Seite.

         Am 28.08.2026 gemessen: 15 von 38 Messpunkten trugen einen Kasten im
         Kleber, 8 davon mit einem 1905-px-SVG. Nach dem Aufraeumen: keiner. */
      document.querySelectorAll('.mo-vorschau-mass').forEach(function (alt) { alt.remove(); });
      LAGE = null;

      /* 🔴 EINE REGEL, DIE IMMER GILT — gegen den Theme-Klon.

         Das Theme klont die Galerie in `.product-sticky-image` (die klebende
         Leiste) und nimmt unseren Kasten mit. Der Klon entsteht SPAETER als
         jedes Aufraeumen, JS allein bekommt ihn nicht zuverlaessig weg:
         nach dem Aufraeumen blieben 3 von 38 Messpunkten uebrig.

         Im Kleber misst der Kasten 1905 x 76; das SVG wird durch `height:auto`
         1905 x 1905 und laeuft quer ueber die Seite.

         ⚠️ Der erste Versuch stand in `stilEinhaengen()` der mo-vorschau-IIFE
         — die wird auf der Produktseite NIE aufgerufen, gemessen am 28.08.
         (`document.getElementById('mo-vorschau-stil')` blieb null). Deshalb
         steht die Regel jetzt HIER, wo der Kasten wirklich entsteht.

         ⚠️ Inline im Dokument, nicht in `mo-konfigurator.css`: Eine externe
         Datei kann fehlen — siehe [[vollbild-ohne-css-ueber-der-seite]]. */
      if (!document.getElementById('mo-kleber-stil')) {
        var kst = document.createElement('style');
        kst.id = 'mo-kleber-stil';
        kst.textContent = '.product-sticky-image .mo-vorschau-mass{display:none!important}';
        document.head.appendChild(kst);
      }

      var huelle = bild.parentElement;
      if (!huelle) return;
      if (getComputedStyle(huelle).position === 'static') huelle.style.position = 'relative';

      var kasten = document.createElement('div');
      kasten.className = 'mo-vorschau-mass';
      var mass = document.createElement('img');
      mass.src = url;
      mass.alt = '';
      mass.hidden = true;
      kasten.appendChild(mass);
      huelle.appendChild(kasten);
      masslinien(kasten, art, masse);
      LAGE = kasten;
    }

    function zurueck(){
      if (GROSS && MERKER) {
        GROSS.src = MERKER.src;
        if (MERKER.srcset) GROSS.setAttribute('srcset', MERKER.srcset);
      }
      // Auch hier ALLE — der Theme-Klon in der klebenden Leiste ist `LAGE` nicht bekannt.
      document.querySelectorAll('.mo-vorschau-mass').forEach(function (alt) { alt.remove(); });
      LAGE = null;
      GROSS = null; MERKER = null;
      window.moKonfig.bildGesperrt = false;
    }

    var LETZTER = { art: null, masse: null };

    /* ⭐ 27.08.2026: DIE ZEICHNUNG HAENGT NICHT MEHR ALLEIN AM FOKUS.

       Stefan: „prüfen alle konfiguratoren bei +- drücken muss auch das
       aufmaßbild kommen" und „mm / cm in allen konfis prüfen das das
       maßbild bleibt".

       Bisher war der EINZIGE Ausloeser `focusin` auf dem Massfeld. Damit
       scheiterten zwei Bedienwege, die gar nicht ueber die Tastatur laufen:

         · **+ und −**  `stellen()` setzt nur `feld.value` und fokussiert
           nichts — die Zeichnung kam also nie. Lag sie schon, riss der Klick
           sie sogar WEG: der Knopf nimmt den Fokus, `focusout` feuert,
           `zurueck()` raeumt ab. Wer die Masse ueber die Knoepfe einstellt,
           bekam die Bemassung damit nie zu sehen.
         · **mm/cm**    Der Umschalter ruft `zeichne()`, und das baut das
           ganze Formular neu. Das fokussierte Feld existiert danach nicht
           mehr, der Fokus faellt auf <body> — dieselbe Abraeumkette.

       🔴 NICHT ueber `feld.focus()` in `stellen()` geloest: Auf dem Handy
          poppt dann bei jedem Tipper die Zahlentastatur auf. Genau dort sind
          die Knoepfe aber der eigentliche Nutzen (siehe `schrittKnopf`).
          Deshalb horcht die Vorschau selbst auf den Klick.

       Die Zeichnung liegt jetzt, solange der Kunde IRGENDWO am Massblock
       arbeitet, und geht weg, sobald er woanders hinfasst. */

    /* Massfeld, Schrittknopf und Einheitenumschalter zaehlen als „am Mass".
       Ueber `closest`, nicht ueber die Klasse am Ziel selbst: Der Klick kann
       den Textknoten IM Knopf treffen. */
    function amMass(el){
      if (!el || !el.closest) return false;
      return !!(el.closest('.mo-masse-feld') || el.closest('.mo-einheit-wahl'));
    }

    /* Die Zeig-Logik, vorher inline im focusin-Zuhoerer. Beide Ausloeser —
       Fokus und Knopfdruck — muessen dieselben Ausnahmen beachten, sonst
       greift eine davon nur auf dem einen Weg. */
    function zeigenJetzt(){
      /* ⭐ NICHT ins Galeriebild, wenn die Skizze ohnehin GROSS darunter steht.

         Stefan am 26.08.2026, am Screenshot der Fensterstange: „fixen". Beim
         Klick ins Massfeld sprang die Zeichnung zusaetzlich ins grosse
         Produktbild — zweimal dieselbe Skizze auf einem Bildschirm. Beim
         Breitformat (1400 × 420) kommt dazu, dass der quadratische
         Galerierahmen sie auf einen schmalen Streifen mit viel Leerraum
         zusammendrueckt.

         Bei Fenstergittern und Balkonen bleibt die Vorschau: dort ist die
         Skizze rechts nur 250 px breit, das Galeriebild zeigt sie gross. */
      if (document.querySelector('.mo-schritt-koerper.mo-skizze-breit')) return;

      /* 🔴 Und auch dann nicht, wenn die Skizze noch GAR NICHT steht.
         Die Klausel darueber prueft eine Klasse, die erst existiert, wenn
         schon ein Mass eingetragen ist. Beim ERSTEN Klick ins leere Feld
         war sie nicht da - und das Aufmassbild sprang ins Galeriebild.
         Stefan am 26.08.2026 am Handlauf: 'das nicht ... wenn massfeld
         klicke kommt das'.
         Ein einziges Massfeld heisst: die Skizze steht ohnehin breit unter
         den Feldern (Handlauf, Stangen). Fenstergitter und Balkone haben
         zwei Felder und behalten die Galerie-Vorschau. */
      if (document.querySelectorAll('.mo-massfeld').length <= 1) return;

      var art = LETZTER.art || 'Auf der Au\u00dfenwand';
      var quelle = bilder()[art];
      if (quelle) { zeigen(quelle, art, LETZTER.masse); return; }
      medienLaden().then(function (medien) {
        zeigen(medien[art] || medien['Auf der Au\u00dfenwand'], art, LETZTER.masse);
      });
    }

    // Auf den Fokus im Massfeld reagieren. focusin/focusout blubbern, deshalb
    // reicht ein Zuhoerer am Dokument - die Felder werden bei jedem Zeichnen
    // neu gebaut, ein direkt angehaengter waere danach weg.
    document.addEventListener('focusin', function (ev) {
      var f = ev.target;
      if (!f.classList || !f.classList.contains('mo-massfeld')) return;
      zeigenJetzt();
    });

    /* + / − und mm/cm.

       ⚠️ REIHENFOLGE: Dieser Zuhoerer sitzt am Dokument und ist damit SPAETER
       dran als der `onclick` am Knopf selbst. Beim Einheitenwechsel hat
       `zeichne()` also schon gelaufen und `nurPreisNeu()` sein `mo:konfig`
       gemeldet — `LETZTER` traegt den frischen Stand. Andersherum zeichneten
       wir die Masszahlen von vor dem Klick. */
    document.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      if (!t.closest('.mo-massfeld-knopf') && !t.closest('.mo-einheit-knopf')) return;
      zeigenJetzt();
    });

    document.addEventListener('focusout', function (ev) {
      var f = ev.target;
      if (!f.classList || !f.classList.contains('mo-massfeld')) return;
      // Erst im naechsten Durchgang pruefen: Beim Sprung von Breite zu Hoehe
      // feuert focusout VOR dem focusin des zweiten Feldes - ohne die Pause
      // flackerte das Bild zwischen beiden Feldern.
      setTimeout(function () {
        var a = document.activeElement;
        if (a && a.classList && a.classList.contains('mo-massfeld')) return;
        // ⭐ Der Griff zum + oder zum cm-Knopf ist kein Verlassen des Masses.
        if (amMass(a)) return;
        zurueck();
      }, 0);
    });

    /* Aufraeumen, wenn der Kunde den Massblock verlaesst.

       Noetig, SEIT der Knopfdruck die Zeichnung auch ohne Fokus im Feld
       auslegt: Ohne Fokus gibt es kein `focusout`, und die Zeichnung bliebe
       sonst liegen, bis der Kunde die Seite neu laedt.

       `pointerdown` statt `click`: Es feuert VOR dem Fokuswechsel und auch
       dann, wenn das Ziel gar nicht fokussierbar ist — ein Klick auf ein
       Galeriebild etwa loest weder focus noch click auf einem Bedienelement
       aus. */
    document.addEventListener('pointerdown', function (ev) {
      if (!GROSS && !LAGE) return;        // es liegt ohnehin nichts
      if (amMass(ev.target)) return;      // am Massblock -> liegen lassen
      zurueck();
    });

    // Die Masszahlen mitfuehren, solange die Zeichnung oben liegt.
    window.moKonfig.horchen(function (ev) {
      if (!ev.detail) return;
      LETZTER.art = (ev.detail.zustand || {})['Befestigung'] || 'Auf der Au\u00dfenwand';
      LETZTER.masse = ev.detail.masse || {};
      if (LAGE) masslinien(LAGE, LETZTER.art, LETZTER.masse);
    });
  })();

  window.moKonfig.horchen(function (ev) {
    if (!ev.detail || !ev.detail.zustand) return;
    var zustand = ev.detail.zustand;
    var art = window.moBefestigungsArt(zustand);

    var masse = ev.detail.masse || {};

    /* REIHENFOLGE DER QUELLEN: METAFELD STICHT, MEDIEN FANGEN AUF.
       So festgelegt von Stefan am 22.08.2026 - dieselbe Kette wie bei den
       Befestigungsbildern, damit ein Produkt gezielt uebersteuert werden kann.

       ACHTUNG BEIM PFLEGEN: Das Metafeld gewinnt auch dann, wenn es auf die
       Zeichnung eines anderen Modells zeigt. Genau das lag am Testprodukt vor
       - dort stand `FG01_Aufmass_*` (ungerahmt, mit Rauten) an einem Produkt
       mit gerahmtem Gitter. Ein falsch gefuelltes Metafeld faellt nicht auf,
       ein leeres dagegen greift sauber auf die Produktmedien durch. Im Zweifel
       also leeren statt raten. */
    /* 🔴 Die GEZEICHNETE Skizze braucht ueberhaupt kein Bild. Ohne diese
       Weiche kaeme sie nie zustande: unten wird nur bei vorhandener Bild-URL
       eingesetzt, und der Handlauf hat gar keine Aufmassbilder in den
       Produktmedien - nur drei Produktfotos. Gemessen am 26.08.2026. */
    var wzz = document.querySelector('[data-mo-konfigurator]');
    if (wzz && wzz.getAttribute('data-mo-skizze-zeichnen')) {
      einsetzen(zustand, '', masse); return;
    }

    var direkt = bilder()[art];
    if (direkt) { einsetzen(zustand, direkt, masse); return; }

    medienLaden().then(function (medien) {
      var url = medien[art] || medien['Auf der Außenwand'] ||
                bilder()['Auf der Außenwand'];
      /* 🔴 31.08.2026: Hier stand `if (url)` OHNE `else`. Fand die Kette
         nichts, passierte GAR NICHTS - kein Platzhalter, keine Meldung, keine
         Konsolenzeile. Von aussen ist ein leerer Kasten dann nicht von
         "Skizze abgeschaltet" zu unterscheiden. Genau so lag das Testprodukt
         `fenstergitter-nova-30-1-stk-verzinkt-test` da: kein `aufmass_bild_*`
         und kein Medium mit "Aufmass" im Namen - beide Netze durchgefallen.
         Kein sichtbarer Fehlertext, das saehe der Kunde; aber eine Spur fuer
         den, der sucht. */
      if (url) {
        einsetzen(zustand, url, masse);
      } else {
        console.warn('[mo-konfigurator] Keine Aufmass-Skizze fuer "' + art +
          '": weder Metafeld `custom.aufmass_bild_*` noch ein Produktmedium ' +
          'mit "Aufmass" im Dateinamen oder alt-Text. Der Kasten bleibt leer.');
      }
    });
  });
})();

/* ##########################################################################
   SCHRITTLEISTE AM SEITENKOPF

   Nachgebaut nach LPOs klebender Leiste: "Schritt 5 von 5", Fortschrittspunkte,
   der laufende Preis und ein "Weiter"-Knopf.

   🔴 WARUM NEU UND NICHT WIEDERVERWENDET:
   In `custom.js` steckt bereits eine solche Leiste — sie haengt aber an
   `.cl-po--wrapper` und den uebrigen LPO-Klassen (41 Treffer auf
   `cl-po--option` allein). Ohne LPO greift dort nichts. Am 22.08.2026 geprueft.

   Die Leiste haengt sich an `document.body`, nicht in den Konfigurator —
   `zeichne()` raeumt dessen Inhalt bei jedem Klick aus, sie waere sonst weg.
   ########################################################################## */
(function () {
  'use strict';

  var WURZEL = document.querySelector('[data-mo-konfigurator]');
  if (!WURZEL) return;

  var leiste = null, punkte = null, zaehler = null, preis = null, knopf = null;

  function bauen() {
    if (leiste) return;
    leiste = document.createElement('div');
    leiste.className = 'mo-sl';
    leiste.setAttribute('hidden', '');

    zaehler = document.createElement('span');
    zaehler.className = 'mo-sl-zaehler';

    punkte = document.createElement('div');
    punkte.className = 'mo-sl-punkte';

    preis = document.createElement('span');
    preis.className = 'mo-sl-preis';

    knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'mo-sl-knopf';
    knopf.textContent = 'Weiter ›';
    knopf.addEventListener('click', weiter);

    leiste.appendChild(zaehler);
    leiste.appendChild(punkte);
    leiste.appendChild(preis);
    leiste.appendChild(knopf);
    document.body.appendChild(leiste);
  }

  // Springt zum ersten Schritt, der noch nicht erledigt ist — sonst zum
  // Kaufknopf. Genau das erwartet man von "Weiter".
  // ⭐ Der Knopf hat zwei Gesichter, wie LPOs Leiste:
  // solange etwas fehlt "Weiter ›", sobald alles steht "In den Warenkorb".
  // Damit ersetzt diese eine Leiste die Sticky-Leiste des Themes — die kostet
  // 6.982 Byte Uebertragung (3.322 HTML + 3.660 Bild) und 31 DOM-Knoten,
  // unsere 0 Byte und 9 Knoten. Am 22.08.2026 gemessen.
  function weiter() {
    var kauf = document.getElementById('mo-kaufen');
    var fertig = kauf && !kauf.disabled;

    if (fertig) { kauf.click(); return; }

    var offen = document.querySelector('.mo-schritt:not(.mo-kfertig)');
    var ziel = offen || kauf || WURZEL;
    if (offen && offen.classList.contains('mo-zu')) {
      var kopf = offen.querySelector('.mo-schritt-kopf');
      if (kopf) kopf.click();
    }
    ziel.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function auffrischen() {
    bauen();
    var schritte = Array.from(document.querySelectorAll('.mo-schritt'));
    if (!schritte.length) { leiste.setAttribute('hidden', ''); return; }

    /* 25.09.2026: Der Zaehler nennt den ersten OFFENEN Schritt. Bis dahin stand
       hier „erledigte + 1“ — mit vorbelegten Schritten 3 und 4 hiess es
       „Schritt 4 von 4“, waehrend Schritt 2 (Masse) noch offen war. */
    var offenBei = -1;
    schritte.some(function (s, i) {
      if (s.classList.contains('mo-kfertig')) return false;
      offenBei = i; return true;
    });
    zaehler.textContent = 'Schritt ' + (offenBei < 0 ? schritte.length : offenBei + 1) +
      ' von ' + schritte.length;

    // Punkte neu aufbauen — bei fuenf Schritten ist das billiger als Vergleichen.
    punkte.textContent = '';
    schritte.forEach(function (s, i) {
      var p = document.createElement('span');
      var ok = s.classList.contains('mo-kfertig');
      p.className = 'mo-sl-punkt' + (ok ? ' mo-sl-punkt-an' : '');
      p.textContent = ok ? '✓' : String(i + 1);
      p.title = (s.querySelector('.mo-schritt-titel') || {}).textContent || '';
      // Klick springt zum Schritt und klappt ihn auf.
      p.addEventListener('click', function () {
        if (s.classList.contains('mo-zu')) {
          var k = s.querySelector('.mo-schritt-kopf'); if (k) k.click();
        }
        s.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      punkte.appendChild(p);
    });

    var g = document.getElementById('mo-gesamt');
    var txt = g ? g.textContent.trim() : '';
    preis.textContent = (txt && txt !== '–') ? txt : '';

    var kauf = document.getElementById('mo-kaufen');
    var bereit = kauf && !kauf.disabled;
    knopf.textContent = bereit ? 'In den Warenkorb' : 'Weiter ›';
    knopf.className = 'mo-sl-knopf' + (bereit ? ' mo-sl-kaufen' : '');

    // Die Leiste zeigt sich erst, wenn der Konfigurator aus dem Blick ist.
    sichtbarkeit();
  }

  /* ⭐ 25.09.2026 — DER SEITENKOPF WEICHT, SOLANGE DIE LEISTE STEHT.
     Stefan (Handy-Screenshot): „das ist sehr überlagert“. Gemessen in 2.10.2:
     Seitenkopf sticky 0–94 px (Handy) bzw. 0–83 (Desktop), die Leiste fixed
     0–53 bzw. 0–60 DARUEBER — vom Kopf lugte nur die untere Haelfte mit dem
     halben Logo hervor, Suche und Warenkorb lagen ohnehin unter der Leiste.
     Mobil hing darunter die Bildvorschau (102–194), durch die 8-px-Fuge
     schauten die Massfelder. Zusammen 194 von 812 px.
     Jetzt: Kopf per transform nach oben weg, die Leiste steht allein oben,
     die Vorschau buendig darunter. Der Kopf kommt zurueck, sobald die Leiste
     geht (ober- oder unterhalb des Konfigurators).
     ⚠️ Das Theme selbst versteckt den Kopf nie: StickyHeader.hide() setzt
     `shopify-section-header-hidden1` (Tippfehler, keine Regel dazu). */
  function kopfStil() {
    if (document.getElementById('mo-sl-kopf-stil')) return;
    var s = document.createElement('style');
    s.id = 'mo-sl-kopf-stil';
    s.textContent =
      '#shopify-section-header{transition:transform .2s ease}' +
      'html.mo-sl-an #shopify-section-header{transform:translateY(-100%);pointer-events:none}';
    document.head.appendChild(s);
  }

  function sichtbarkeit() {
    if (!leiste) return;
    var r = WURZEL.getBoundingClientRect();
    // Solange der Kopf des Konfigurators oben im Bild steht, braucht es die
    // Leiste nicht — sie wuerde nur doppeln.
    var zeigen = r.top < 0 && r.bottom > 120;
    /* 03.10.2026 (INP): Laeuft bei JEDEM Scroll-Ereignis. Nur anfassen, was sich
       aendert — jedes Setzen ist eine Mutation, die Pixel-Skript und Clarity
       mitverarbeiten, auch wenn der Wert derselbe bleibt. */
    if (leiste.hasAttribute('hidden') === zeigen) {
      if (zeigen) leiste.removeAttribute('hidden');
      else leiste.setAttribute('hidden', '');
    }

    // Kopf weicht (siehe kopfStil) — und die Bildvorschau rueckt nach.
    var html = document.documentElement;
    if (html.classList.contains('mo-sl-an') !== zeigen) {
      kopfStil();
      html.classList.toggle('mo-sl-an', zeigen);
      try {
        document.dispatchEvent(new CustomEvent('mo:leiste', { detail: { an: zeigen } }));
      } catch (e) {}
    }

    // Nur EINE klebende Leiste. Die des Themes weicht, solange unsere steht —
    // sie zeigt dieselben Angaben, kostet aber Bild und 31 Knoten.
    var themeLeiste = document.querySelector('product-sticky-form');
    var themeSoll = zeigen ? 'none' : '';
    if (themeLeiste && themeLeiste.style.display !== themeSoll) themeLeiste.style.display = themeSoll;
  }

  /* ⭐ 03.10.2026 (INP Treppen, Berta): NICHT mehr synchron, sondern einmal je Bild.
     Gemessen (inp_profil.mjs + inp_baum.mjs, Handy 4x CPU, TRG 02): `melden()`
     feuert MITTEN in `zeichne()`, und hier las `sichtbarkeit()` sofort
     getBoundingClientRect — der Browser musste Stil und Layout der eben neu
     gebauten Schritte auf der Stelle rechnen (16–21 ms je Neubau; nach einer
     Masseingabe baut der Motor zweimal), und fuer das Bild danach noch einmal.
     Jetzt im requestAnimationFrame: eine Messung je Bild, mit dem fertigen
     Stand. Der Zeitgeber ist nur der Notnagel fuer Ansichten, in denen rAF
     ausbleibt (Hintergrundreiter, Vorschaufenster — siehe baldTun in
     mo-hl-felder.js). Beim Scrollen ebenso: hoechstens einmal je Bild statt bei
     jedem Ereignis. Die Leiste erscheint damit hoechstens ein Bild spaeter. */
  var geplant = 0;       // 0 nichts, 1 nur sichtbarkeit, 2 auffrischen (samt sichtbarkeit)
  var planNr = 0;
  function planen(stufe) {
    if (geplant >= stufe) return;
    var schonBestellt = geplant > 0;
    geplant = stufe;
    if (schonBestellt) return;       // der bestellte Lauf nimmt die hoehere Stufe mit
    var nr = ++planNr;
    var einmal = function () {
      if (nr !== planNr || !geplant) return;
      var s = geplant;
      geplant = 0;
      if (s === 2) auffrischen(); else sichtbarkeit();
    };
    if (window.requestAnimationFrame) window.requestAnimationFrame(einmal);
    setTimeout(einmal, 250);
  }

  window.moKonfig.horchen(function () { planen(2); });
  window.addEventListener('scroll', function () { planen(1); }, { passive: true });
  window.addEventListener('resize', function () { planen(1); }, { passive: true });
})();

/* ##########################################################################
   HOVER-LUPE AUF DEN KACHELN

   Faehrt die Maus ueber eine Kachel, erscheint das Bild gross daneben.
   Welche Kacheln das koennen, sagt die Config: `imgTooltip: true`. Der
   Kachel-Zeichner haengt dafuer `data-mo-gross` mit der grossen Adresse an.

   ⭐ EIN Lupenelement fuer alle Kacheln, per Ereignisdelegation an der Wurzel.
   Bei 22 Kacheln waeren sonst 44 Zuhoerer noetig — und `zeichne()` baut den
   Schrittkoerper bei jedem Klick neu auf, jeder direkt angehaengte Zuhoerer
   waere danach weg.

   🔴 NUR MIT ECHTER MAUS. Auf dem Handy gibt es kein Ueberfliegen; dort
   loeste `mouseenter` beim Tippen aus und die Lupe verdeckte die Auswahl.
   `matchMedia('(hover: hover)')` trennt beides sauber — nicht ueber die
   Bildschirmbreite gehen, ein Tablet mit Maus faellt sonst durchs Raster.

   ⚠️ Die shopweite Bildlupe aus custom.js bleibt aussen vor: Der Kachel-
   Zeichner setzt `data-mo-lupe-aus` ans Raster. Ohne das oeffnete ein Klick
   gleichzeitig die Auswahl und das Vollbild.
   ########################################################################## */
(function () {
  'use strict';

  var WURZEL = document.querySelector('[data-mo-konfigurator]');
  if (!WURZEL) return;
  /* 🔴 24.08.2026, Stefan: "das hoverbild weg machen auf dem Desktop."
     Damit ist die Kachel-Hovervorschau (.mo-kzoom) AUS. Die Lupe unten links
     in der Kachel bleibt davon unberuehrt - sie ist ein eigenes Element mit
     eigenem Klick-Handler und der einzige Weg auf dem Handy.
     Zum Zurueckholen: MO_KACHEL_HOVERBILD auf true. */
  var MO_KACHEL_HOVERBILD = false;
  if (!MO_KACHEL_HOVERBILD) return;

  if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;

  var lupe = null, bild = null, offen = null;

  function bauen() {
    if (lupe) return;
    lupe = document.createElement('div');
    lupe.className = 'mo-kzoom';
    lupe.setAttribute('aria-hidden', 'true');   // reine Sehhilfe, kein Inhalt
    bild = document.createElement('img');
    bild.alt = '';
    bild.decoding = 'async';
    lupe.appendChild(bild);
    document.body.appendChild(lupe);
  }

  /* Setzt die Lupe neben die Kachel — bevorzugt rechts, sonst links, und nie
     ueber den Rand hinaus. Ohne diese Pruefung klebt sie am Bildschirmrand
     halb ausserhalb, sobald eine Kachel in der letzten Spalte steht. */
  function platzieren(k) {
    var r = k.getBoundingClientRect();
    var lr = lupe.getBoundingClientRect();
    var luft = 12;
    var x = r.right + luft;
    if (x + lr.width > window.innerWidth - 8) x = r.left - lr.width - luft;
    if (x < 8) x = 8;
    var y = r.top + r.height / 2 - lr.height / 2;
    if (y < 8) y = 8;
    if (y + lr.height > window.innerHeight - 8) y = window.innerHeight - lr.height - 8;
    lupe.style.left = Math.round(x) + 'px';
    lupe.style.top  = Math.round(y) + 'px';
  }

  function zeigen(k) {
    var url = k.getAttribute('data-mo-gross');
    if (!url || offen === k) return;
    bauen();
    offen = k;
    // Erst nach dem Laden einblenden. Sonst blitzt bei der ersten Kachel ein
    // leerer Kasten auf, und `platzieren` rechnet mit Hoehe 0.
    bild.onload = function () {
      if (offen !== k) return;          // Maus ist inzwischen weitergezogen
      lupe.classList.add('mo-kzoom-an');
      platzieren(k);
    };
    bild.src = url;
    if (bild.complete && bild.naturalWidth) bild.onload();
  }

  function verstecken() {
    offen = null;
    if (lupe) lupe.classList.remove('mo-kzoom-an');
  }

  WURZEL.addEventListener('mouseover', function (ev) {
    var k = ev.target.closest ? ev.target.closest('.mo-kachel[data-mo-gross]') : null;
    if (k) zeigen(k); else verstecken();
  });
  WURZEL.addEventListener('mouseleave', verstecken);
  // Beim Klick weg: der Schrittkoerper wird neu gezeichnet, die Kachel unter
  // dem Zeiger ist danach ein anderes Element.
  WURZEL.addEventListener('click', verstecken);
  window.addEventListener('scroll', verstecken, { passive: true });
})();


/* ##########################################################################
   PFEILE AM GROSSEN GALERIEBILD

   Das Theme zeigt am Desktop keine - der Slider ist als reiner Handy-Slider
   angelegt, und in der Miniaturansicht gibt es auch nichts zu scrollen: Nur
   das aktive Bild steht im Fluss, die uebrigen auf display:none.

   Diese Pfeile schalten deshalb die MINIATUREN weiter. Ein Klick auf die
   naechste Miniatur ist genau der Weg, den die Galerie ohnehin kennt - damit
   bleiben Zaehler, aria-Zustaende und die Lightbox in Takt, ohne dass wir
   Dawns Slider nachbauen muessten.

   ⚠️ NICHT an die Live-Vorschau geraten: Die tauscht das `src` des ERSTEN
   Galeriebildes ([[eigenbau-konfigurator-stand]]). Unsere Pfeile fassen nur
   die Miniaturen an, nie das grosse Bild selbst - sonst kaempfen beide um
   dieselbe Anzeige.
   ########################################################################## */
(function galeriePfeile(){
  'use strict';

  var huelle = document.querySelector('.product__media-wrapper .main-product-slider') ||
               document.querySelector('.product__media-wrapper media-gallery');
  if (!huelle) return;

  function miniaturen(){
    // Nur die sichtbaren: Der Galeriefilter blendet die Farbebenen aus, und
    // ausgeblendete Miniaturen duerfen nicht mitgezaehlt werden - sonst
    // laufen die Pfeile ins Leere.
    return [...document.querySelectorAll('.thumbnail-list__item')]
      .filter(function(m){ return m.getBoundingClientRect().width > 0; });
  }

  function aktiv(liste){
    for (var i = 0; i < liste.length; i++) {
      var k = liste[i].querySelector('.thumbnail');
      if (k && k.getAttribute('aria-current') === 'true') return i;
    }
    return 0;
  }

  function blaettern(richtung){
    var liste = miniaturen();
    if (liste.length < 2) return;
    var i = aktiv(liste) + richtung;
    // Umlaufen statt anschlagen - bei acht Bildern will niemand
    // zurueckklicken, um vom letzten zum ersten zu kommen.
    if (i < 0) i = liste.length - 1;
    if (i >= liste.length) i = 0;
    var ziel = liste[i].querySelector('.thumbnail');
    if (!ziel) return;
    ziel.click();

    /* Die angesteuerte Miniatur ins Sichtfeld holen.

       Seit die Miniaturen in EINER scrollbaren Reihe stehen, liegen bei acht
       Bildern nur fuenf im Blick. Ohne diesen Nachzug blaettert das grosse Bild
       weiter, waehrend die markierte Miniatur unsichtbar bleibt - der Kunde
       sieht dann nicht, wo er gerade ist.

       `inline: 'nearest'` scrollt nur so weit wie noetig; `block: 'nearest'`
       verhindert, dass die SEITE mitspringt, nur um die Reihe mittig zu
       stellen. */
    if (liste[i].scrollIntoView) {
      liste[i].scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
    }
  }

  function knopf(zeichen, richtung, name){
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mo-gal-pfeil mo-gal-pfeil-' + name;
    b.setAttribute('aria-label', name === 'vor' ? 'N\u00e4chstes Bild' : 'Vorheriges Bild');
    b.textContent = zeichen;
    b.addEventListener('click', function(ev){
      ev.preventDefault(); ev.stopPropagation();   // nicht die Lightbox oeffnen
      blaettern(richtung);
    });
    return b;
  }

  function aufbauen(){
    if (huelle.querySelector('.mo-gal-pfeil')) return;
    if (miniaturen().length < 2) return;          // ein Bild braucht keine Pfeile
    if (getComputedStyle(huelle).position === 'static') huelle.style.position = 'relative';
    huelle.appendChild(knopf('\u2039', -1, 'zurueck'));
    huelle.appendChild(knopf('\u203a',  1, 'vor'));
  }

  // Die Miniaturen stehen im Liquid, sind also sofort da. Der Aufruf im
  // naechsten Durchgang faengt nur den Fall ab, dass eine App sie nachreicht.
  aufbauen();
  requestAnimationFrame(aufbauen);
})();


/* Der Block "Preisaufstellung unter die Galerie" ist am 23.08.2026 wieder
   ausgebaut worden - siehe den Kommentar in main-product.liquid. */



/* ==========================================================================
   MOBILE MITLAUFENDE VORSCHAU   (24.08.2026)

   Stefan: "mobil wieder das Vorschau bild machen ... mit groesser kleiner +."

   Das Problem, gemessen: Die Galerie steht im HTML VOR dem Konfigurator
   (Byte 309.408 gegen 393.517). Mobil heisst das: Wer zum Konfigurieren
   scrollt, hat sein Gitter nicht mehr im Blick - er waehlt Farbe und
   Befestigung blind.

   Diese Leiste klebt oben und zeigt dasselbe Bild wie das grosse Galeriebild.
   Sie erscheint erst, wenn die Galerie oben aus dem Bild gescrollt ist - vorher
   waere sie eine Dublette.

   ⭐ NUR MOBIL. Auf dem Desktop steht die Galerie links neben dem Konfigurator
   und bleibt beim Scrollen ohnehin sichtbar.

   ZUM ABSCHALTEN: MO_MOBILE_VORSCHAU auf false.
   ========================================================================== */
(function () {
  'use strict';

  var MO_MOBILE_VORSCHAU = true;
  if (!MO_MOBILE_VORSCHAU) return;

  /* ⭐ LPOS MASSE, nicht erfundene. Am 19.08.2026 an
     `.cl-po--preview-sticht.mobile` gemessen: klein **81**, gross per "+"
     **319**. Zwei Stufen, keine drei - der Kunde soll umschalten, nicht
     dosieren. Klein ist die Vorgabe: Sie zeigt Farbe und Befestigungsart und
     kostet nur 81 px vom Bildschirm. */
  var STUFEN = [81, 319];
  var stufe = 0;
  try {
    var gemerkt = parseInt(localStorage.getItem('mo-vorschau-stufe'), 10);
    if (gemerkt >= 0 && gemerkt < STUFEN.length) stufe = gemerkt;
  } catch (e) {}

  var leiste = null, bild = null, kleiner = null, groesser = null;
  var quelle = null;          // das grosse Galeriebild
  var beobachter = null;

  function mobil() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  /* Das Galeriebild, das die Vorschau spiegelt - dasselbe, das der
     Vorschau-Block weiter oben tauscht. */
  function galeriebild() {
    /* 🔴 Dieselbe Falle wie in der Aufmass-Vorschau (28.08.2026): Es gibt
       ZWEI Galerie-Huellen, `querySelector` nimmt die erste, und die misst je
       nach Layout 0 x 0. Die Farbvorschau tauschte damit ein unsichtbares
       Bild — der Kunde sah die gewaehlte Farbe nicht. */
    var kandidaten = [
      '.product__media-wrapper .product__media-item:first-child img',
      '.product__media-wrapper .product__media img'
    ];
    for (var i = 0; i < kandidaten.length; i++) {
      var alle = document.querySelectorAll(kandidaten[i]);
      for (var j = 0; j < alle.length; j++) {
        // Das klebende Produktbild ist keine Galerie - siehe oben.
        if (alle[j].closest('.product-sticky-image')) continue;
        var r = alle[j].getBoundingClientRect();
        if (r.width > 1 && r.height > 1) return alle[j];
      }
    }
    return document.querySelector(kandidaten[0]) || document.querySelector(kandidaten[1]);
  }

  function stilEinhaengen() {
    if (document.getElementById('mo-vorschau-stil')) return;
    var s = document.createElement('style');
    s.id = 'mo-vorschau-stil';
    s.textContent =
      /* 🔴 DER THEME-KLON IN DER KLEBENDEN LEISTE.

         Das Theme klont die Galerie in `.product-sticky-image` — samt unserem
         Vorschaukasten. Der Klon entsteht SPAETER als unser Aufraeumen (beim
         Scrollen), JS allein bekommt ihn also nicht zuverlaessig weg: nach dem
         Aufraeumen blieben 3 von 38 Messpunkten uebrig.

         Im Kleber misst der Kasten 1905 x 76; das Mass-SVG wird durch
         `height:auto` 1905 x 1905 und ragt quer ueber die Seite. Diese Regel
         gilt IMMER, egal wann der Klon entsteht.

         ⚠️ Steht bewusst HIER im per JS eingehaengten <style> und nicht in
         `mo-konfigurator.css`: Eine externe Datei kann fehlen, und dann liegt
         die Bemassung wieder ueber der Seite — genau der Fehler vom 27.08.
         (siehe [[vollbild-ohne-css-ueber-der-seite]]). */
      '.product-sticky-image .mo-vorschau-mass{display:none!important}' +
      /* ⭐ VOLLE BREITE wie bei LPO. Eine schwebende Box rechts verdeckt den
         Inhalt; eine Leiste ueber die ganze Breite macht ihm Platz - und die
         Schrittleiste rueckt darunter (--mo-vorschau-unten). */
      '.mo-mv{position:fixed;z-index:58;inset-inline:0;' +
        'display:none;align-items:center;justify-content:center;gap:10px;' +
        'padding:5px 8px;' +
        'background:#fff;border-bottom:1px solid #e3e6ea;' +
        'box-shadow:0 2px 10px rgba(0,0,0,.10)}' +
      '.mo-mv.mo-mv-an{display:flex}' +
      /* Solange das Menue offen ist, tritt die Leiste zurueck. */
      '.mo-mv.mo-mv-still{display:none !important}' +
      '.mo-mv img{display:block;width:auto;max-width:76%;border-radius:4px;' +
        'background:#f5f6f8;object-fit:contain}' +
      '.mo-mv-knoepfe{display:flex;flex-direction:column;gap:5px;flex:0 0 auto}' +
      /* 🔴 32 px ist die Untergrenze, die hier vertretbar ist: Die Leiste soll
         das Bild nicht ueberragen. Fuer Bedienelemente gilt sonst 44 px
         (WCAG 2.5.8) - deshalb bekommen sie ein grosszuegiges Klickfeld ueber
         ::before, ohne optisch zu wachsen. */
      '.mo-mv-knopf{position:relative;width:32px;height:32px;padding:0;' +
        'border:1px solid #d5dae0;border-radius:6px;background:#fff;' +
        'color:#2f3a45;font:600 18px/1 inherit;cursor:pointer}' +
      '.mo-mv-knopf::before{content:"";position:absolute;inset:-6px}' +
      '.mo-mv-knopf:disabled{opacity:.35;cursor:default}' +
      '.mo-mv-knopf:not(:disabled):hover{border-color:#cb4f0a;color:#cb4f0a}' +
      '@media (min-width:750px){.mo-mv{display:none !important}}';
    document.head.appendChild(s);
  }

  /* Die Leiste haengt unter der klebenden Schrittleiste, wenn es sie gibt.
     Deren Hoehe steht erst zur Laufzeit fest - sie traegt Zaehler, Punkte und
     Knopf und waechst mit der Schriftgroesse. */
  function obenSetzen() {
    if (!leiste) return;
    var oben = 0;
    /* ⭐ 25.09.2026: Kopf und Schrittleiste stehen nicht mehr UEBEREINANDER,
       sondern abwechselnd — steht die Leiste (html.mo-sl-an), ist der Kopf
       weggeschoben. Die Vorschau haengt buendig unter der Leiste; die alte
       8-px-Fuge zeigte die Massfelder dahinter. Ueber die KLASSE entschieden,
       nicht ueber das Rechteck des Kopfes: waehrend der Verschiebung (0,2 s)
       meldet er noch die alte Lage.
       🔴 Ohne Leiste zaehlt der Kopf weiter (sticky, 94 px) — ohne ihn lag die
       Vorschau frueher ueber Suche, Konto und Warenkorb. */
    var sl = document.querySelector('.mo-sl');
    if (sl && !sl.hidden && document.documentElement.classList.contains('mo-sl-an')) {
      /* 🔴 04.10.2026 (iPhone, Berta): offsetHeight statt
         getBoundingClientRect().bottom. Am iPhone stand die Vorschau bei
         top 0 statt 53 px, die Leiste (z-index 60 ueber 58) deckte ihre obere
         Haelfte samt „+“ zu (Stefans Screenshot 03.10., 23:42). WebKit fuehrt
         fixed-Elemente waehrend des Wischens erst im Stillstand nach — mitten
         in der Geste meldet ihr Rechteck die Leiste um die gescrollte Strecke
         zu hoch, die Unterkante <= 0. Die Leiste steht per CSS fest bei top:0
         und transform:none (beides !important): ihre Unterkante IST ihre Hoehe. */
      oben = sl.offsetHeight;
    } else {
      var kopf = document.querySelector('#shopify-section-header');
      if (kopf) {
        var ks = getComputedStyle(kopf);
        if (ks.position === 'sticky' || ks.position === 'fixed') {
          oben = kopf.getBoundingClientRect().height;
        }
      }
    }
    leiste.style.top = Math.max(0, Math.round(oben)) + 'px';
  }

  function groesseSetzen() {
    bild.style.height = STUFEN[stufe] + 'px';
    kleiner.disabled = (stufe === 0);
    groesser.disabled = (stufe === STUFEN.length - 1);
    try { localStorage.setItem('mo-vorschau-stufe', String(stufe)); } catch (e) {}
    unterkanteMelden();
  }

  /* ⭐ Dasselbe Verfahren wie zu LPO-Zeiten: Die Leiste findet ihren Platz
     durch MESSEN, nicht durch eine gepflegte Zahl. Wer die Vorschauhoehe
     aendert, muss so an keiner zweiten Stelle nachziehen. */
  /* 🔴 03.10.2026 (INP Treppen, Berta): Die Variable steht an <html> und wird
     VERERBT — jedes Schreiben zwang den Browser, den Stil aller ~2.000 Elemente
     neu zu rechnen (am Handy 55–175 ms, gemessen mit inp_profil.mjs). Gelesen
     wird sie nur unter `html.mo-leiste-oben` (custom.css, Testschalter
     `?leiste=oben`), und diese Klasse setzt seit dem Rueckbau des Schalters
     niemand mehr. Deshalb: nur mit Testschalter, und nur bei neuem Wert. */
  var untenGemeldet = null;
  function unterkanteMelden() {
    var html = document.documentElement;
    if (!html.classList.contains('mo-leiste-oben')) {
      if (untenGemeldet !== null) {
        html.style.removeProperty('--mo-vorschau-unten');
        untenGemeldet = null;
      }
      return;
    }
    var unten = leiste.classList.contains('mo-mv-an')
      ? Math.round(leiste.getBoundingClientRect().bottom) : 0;
    if (unten === untenGemeldet) return;
    untenGemeldet = unten;
    html.style.setProperty('--mo-vorschau-unten', unten + 'px');
  }

  function bildNachziehen() {
    if (!quelle || !bild) return;
    var src = quelle.getAttribute('src') || '';
    if (!src) return;
    /* Eigene, kleine Breite - das grosse Bild kommt mit width=713, hier
       genuegen 400 fuer 200 px Anzeige bei doppelter Pixeldichte. */
    var u = /[?&]width=/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=400')
                                   : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=400';
    if (bild.getAttribute('src') !== u) bild.setAttribute('src', u);
  }

  function bauen() {
    if (leiste) return;
    stilEinhaengen();
    leiste = document.createElement('div');
    leiste.className = 'mo-mv';
    leiste.setAttribute('aria-hidden', 'true');   // Sehhilfe, kein Inhalt

    bild = document.createElement('img');
    bild.alt = '';
    bild.decoding = 'async';
    bild.loading = 'lazy';

    var kn = document.createElement('div');
    kn.className = 'mo-mv-knoepfe';
    groesser = knopf('+', function () { if (stufe < STUFEN.length - 1) { stufe++; groesseSetzen(); } });
    kleiner  = knopf('−', function () { if (stufe > 0) { stufe--; groesseSetzen(); } });
    kn.appendChild(groesser);
    kn.appendChild(kleiner);

    leiste.appendChild(bild);
    leiste.appendChild(kn);
    document.body.appendChild(leiste);
    groesseSetzen();
    bildNachziehen();
  }

  function knopf(zeichen, tun) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mo-mv-knopf';
    b.setAttribute('aria-label', zeichen === '+' ? 'Vorschau größer' : 'Vorschau kleiner');
    b.textContent = zeichen;
    b.addEventListener('click', tun);
    return b;
  }

  function zeigen(ja) {
    if (!leiste) return;
    if (ja) { obenSetzen(); leiste.classList.add('mo-mv-an'); }
    else leiste.classList.remove('mo-mv-an');
    unterkanteMelden();
  }

  /* ⭐ 25.09.2026: Die Vorschau gehoert zur Schrittleiste. Sie zeigt sich nur,
     solange der Kunde im Konfigurator arbeitet (Leiste steht, html.mo-sl-an)
     UND das Galeriebild aus dem Blick ist. Vorher stand sie ueberall, wo das
     Galeriebild fehlte — auch unterhalb des Konfigurators bei Beschreibung
     und FAQ, dort mit dem Seitenkopf zusammen 186 px. Seiten ohne Schritte
     behalten die alte Regel (nur das Galeriebild entscheidet). */
  var bildWeg = false;
  function abgleichen() {
    var mitLeiste = !!document.querySelector('.mo-schritt');
    zeigen(bildWeg && (!mitLeiste || document.documentElement.classList.contains('mo-sl-an')));
  }

  function start() {
    if (!mobil()) return;
    quelle = galeriebild();
    if (!quelle) return;               // ohne Galeriebild gibt es nichts zu spiegeln
    bauen();

    /* ⭐ IntersectionObserver statt scroll-Handler: Er meldet nur die Wechsel
       und liest kein Layout - ein scroll-Handler wuerde bei jedem Pixel
       feuern und `getBoundingClientRect` aufrufen. Genau das ist der Posten,
       der die Produktseite frueher 11 Sekunden CPU gekostet hat. */
    beobachter = new IntersectionObserver(function (eintraege) {
      bildWeg = !eintraege[0].isIntersecting;
      abgleichen();
    }, { threshold: 0 });
    beobachter.observe(quelle);

    /* Das Bild folgt dem grossen Galeriebild. Nur das Attribut `src`, kein
       subtree - der Vorschau-Block weiter oben ist der einzige, der es setzt. */
    new MutationObserver(bildNachziehen)
      .observe(quelle, { attributes: true, attributeFilter: ['src'] });

    /* 🔴 Menue offen -> Leiste zurueck. Gemessen: Menue und Seitenkopf liegen
       beide auf z-index 3, die Leiste auf 58 - sie deckte den ersten
       Menuepunkt zu. Ein kleinerer z-index hilft nicht, denn unter 3 waere
       sie auch unter dem Kopf und damit im Normalfall unsichtbar.
       Dawn baut das Menue als <details>; `toggle` ist der billigste
       verlaessliche Ausloeser. */
    [].forEach.call(document.querySelectorAll('details'), function (d) {
      if (!d.querySelector('.menu-drawer')) return;      // nur das Hauptmenue
      d.addEventListener('toggle', function () {
        leiste.classList.toggle('mo-mv-still', d.open);
        unterkanteMelden();
      });
    });
  }

  /* Kommt oder geht die Schrittleiste, folgt die Vorschau (siehe abgleichen). */
  document.addEventListener('mo:leiste', function () { if (leiste) abgleichen(); });

  /* Beim Wechsel Handy <-> Desktop aufraeumen bzw. nachziehen. */
  if (window.matchMedia) {
    var mq = window.matchMedia('(max-width: 749px)');
    var beiWechsel = function () {
      if (mq.matches) { start(); }
      else if (leiste) { zeigen(false); }
    };
    if (mq.addEventListener) mq.addEventListener('change', beiWechsel);
    else if (mq.addListener) mq.addListener(beiWechsel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ======================================================================
   🔴🔴 DER KLEBENDE KAUFKNOPF DES THEMES VERKAUFT AM KONFIGURATOR VORBEI

   Am 26.08.2026 an Ferro 01 gemessen, vollstaendig konfiguriert
   (1600 x 1500, Laschen, Feuerverzinkt):

     Klick auf `#mo-kaufen`            ->  462,89 EUR, 5 Eigenschaften
     Klick auf `.product-sticky-submit` ->  188,00 EUR, NULL Eigenschaften

   Das sind 274,89 EUR Verlust je Bestellung - ohne jede Manipulation, nur
   durch Klick auf den auffaelligen orangenen Knopf oben. Und die Werkstatt
   bekommt eine Bestellung ohne Mass, ohne Farbe, ohne Befestigung.

   Der Theme-Standardknopf `.product-form__submit` ist beim Konfigurator-Umbau
   korrekt auf `display:none` gesetzt worden - der KLEBENDE wurde uebersehen.
   Er liegt in `shopify-section-header`, gehoert zu keinem Formular und traegt
   `type="submit"`.

   ⭐ Statt ihn zu verstecken, wird er umgeleitet: Er ist auf dem Handy der
   Knopf, den der Kunde sieht. Abgefangen wird in der CAPTURE-Phase, damit die
   Theme-Handler gar nicht erst drankommen.

   ⚠️ Nur auf Konfiguratorseiten. Ohne `[data-mo-konfigurator]` steigt der
   Block sofort aus, damit normale Produkte unberuehrt bleiben.
   ====================================================================== */
(function(){
  if (!document.querySelector('[data-mo-konfigurator]')) return;

  document.addEventListener('click', function(ev){
    var ziel = ev.target;
    if (!ziel || !ziel.closest) return;
    var kleber = ziel.closest('.product-sticky-submit');
    if (!kleber) return;

    var echt = document.getElementById('mo-kaufen');
    if (!echt) return;                     // Konfigurator noch nicht da: Theme machen lassen

    ev.preventDefault();
    ev.stopPropagation();
    if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();

    /* ⚠️ EIN KLICK AUF EINEN GESPERRTEN KNOPF LOEST KEINEN HANDLER AUS.
       Fehlt das Mass, ist `#mo-kaufen` disabled - `click()` liefe ins Leere und
       der Kunde staende wieder vor einem stummen Knopf. Dann statt dessen zur
       Preisuebersicht scrollen: Dort steht seit dem 26.08. der Klartextgrund
       („Befestigungsabstand fehlt", „Hoehe hoechstens 2200 mm"). */
    if (echt.disabled) {
      echt.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    echt.click();                          // derselbe Weg wie unten - samt Pflichtpruefung
  }, true);
})();


/* ======================================================================
   🔴🔴 DER KLEBENDE KAUFKNOPF WIRD GESPERRT, SOLANGE NICHT GEKAUFT WERDEN KANN

   Ergaenzt den Umleitungsblock darueber. Der leitet den Klick zwar um, aber:

     1. Er steigt aus, solange `#mo-kaufen` fehlt („Konfigurator noch nicht
        da: Theme machen lassen"). Der klebende Knopf steht jedoch SOFORT im
        HTML, der Konfigurator entsteht erst nach dem Laden der Config. Wer in
        diesem Fenster klickt, kauft am Konfigurator vorbei — Variantenpreis,
        keine Eigenschaften. Am 26.08.2026 gemessen: 274,89 EUR Verlust.
     2. Der Knopf sah immer aktiv aus.

   Beides hier behoben: sofort sperren, danach den Zustand von `#mo-kaufen`
   spiegeln. Nur auf Konfiguratorseiten.
   ====================================================================== */
function klebeknopfSpiegeln(sperren){
  var kn = document.querySelectorAll('.product-sticky-submit');
  for (var i = 0; i < kn.length; i++) {
    var k = kn[i];
    if (k.disabled === sperren) continue;      // nichts zu tun, kein Layout-Anstoss
    k.disabled = !!sperren;
    /* Das Theme gestaltet ueber `[disabled]` — zusaetzlich eine eigene Klasse,
       falls eine Regel den Zustand ueberschreibt. */
    if (sperren) k.classList.add('mo-kauf-gesperrt');
    else k.classList.remove('mo-kauf-gesperrt');
    k.setAttribute('aria-disabled', sperren ? 'true' : 'false');
  }
}

(function(){
  if (!document.querySelector('[data-mo-konfigurator]')) return;

  /* Sofort zu — bevor der Motor ueberhaupt gerechnet hat. Erst wenn eine
     vollstaendige Konfiguration vorliegt, macht `rechne()` wieder auf. */
  klebeknopfSpiegeln(true);

  /* Der klebende Balken wird vom Theme erst beim Scrollen aufgebaut. Neue
     Knoepfe bekommen denselben Zustand wie `#mo-kaufen`. */
  var beo = new MutationObserver(function(){
    var echt = document.getElementById('mo-kaufen');
    klebeknopfSpiegeln(echt ? echt.disabled : true);
  });
  beo.observe(document.body, { childList: true, subtree: true });
})();
